import { defaultI18nConfig, getEventEmitterBinder, Logger, uaTool, patchConfig as patchConfig$1, EvtEmitter, DrmKeySystems, commonTool, KernelFactory, KERNEL_NAME, videoTool, VIDEO_STATE, END_STATE, lsTool, PLAY_MODE, PLAY_EVENT, VERSION, urlTool, jsonTool, domTool, SimpleDefer, netTool, getLogCache, clearLogCache, KernelProxy, onceDecorator, destroyProtectDecorator, TpCoreError, stepTimerClassDecorator, checkVolumeValidWithMessage, t, i18nConfig, requireModule, cookieTool, CODEC, logMethodCallDecoratorCreator, performanceCostDecoratorCreator, getEventTargetBinder, ResizeObserver, ReferenceReport, kernelEvtBus, preloadEvtBus, StepTimer, PRELOAD_TYPE, VIDEO_CODEC, CONTAINER_FORMAT, AUDIO_CODEC, mountGlobal } from '@tencent/thumbplayer-core';
export { AUDIO_CODEC, CONTAINER_FORMAT, END_STATE, EvtEmitter, KERNEL_NAME, PLAY_EVENT, PLAY_MODE, PRELOAD_TYPE, StepTimer, VIDEO_CODEC, VIDEO_STATE, i18nConfig, kernelEvtBus, preloadEvtBus, t } from '@tencent/thumbplayer-core';
import { _ as _$6 } from '@swc/helpers/_/_assert_this_initialized';
import { _ as _$e } from '@swc/helpers/_/_async_to_generator';
import { _ as _$1 } from '@swc/helpers/_/_class_call_check';
import { _ } from '@swc/helpers/_/_create_class';
import { _ as _$2 } from '@swc/helpers/_/_define_property';
import { _ as _$g } from '@swc/helpers/_/_get';
import { _ as _$h } from '@swc/helpers/_/_get_prototype_of';
import { _ as _$4 } from '@swc/helpers/_/_inherits';
import { _ as _$7 } from '@swc/helpers/_/_instanceof';
import { _ as _$b } from '@swc/helpers/_/_object_spread';
import { _ as _$c } from '@swc/helpers/_/_object_spread_props';
import { _ as _$8 } from '@swc/helpers/_/_to_consumable_array';
import { _ as _$5 } from '@swc/helpers/_/_create_super';
import { _ as _$i } from '@swc/helpers/_/_ts_decorate';
import { _ as _$f } from '@swc/helpers/_/_ts_generator';
import { _ as _$j } from '@swc/helpers/_/_ts_metadata';
import { _ as _$d } from '@swc/helpers/_/_wrap_native_super';
import { _ as _$a } from '@swc/helpers/_/_construct';
import { _ as _$9 } from '@swc/helpers/_/_sliced_to_array';
import { _ as _$3 } from '@swc/helpers/_/_type_of';

var h5playerI18nConfig = {
    // Getinfo 错误
    ERROR_GETINFO_PLUGIN_MISSING: '没有找到获取视频信息插件',
    ERROR_GETINFO_INNER: '视频获取途中出现问题，请检查网络状况',
    /** 网络错误 */ ERROR_GETINFO_NET: '视频获取途中出现问题，请检查网络状况',
    /** 网络超时 */ ERROR_GETINFO_TIMEOUT: '获取视频信息超时，请检查网络状况',
    /** 解析错误 */ ERROR_GETINFO_PARSE: '视频获取途中出现问题，请检查网络状况',
    /** 后台下发的错误默认文案或者无法解析 */ ERROR_GETINFO_CODE: '获取视频信息错误',
    // plugins/base.ts
    ERROR_UNOFFICIAL_PLUGIN_NEEDS_URL: '您所传入的插件不是官方插件，必须提供 url',
    // PlayTimeLimiter: 传入保护点配置时，校验失败的提示
    ERROR_PLAY_LIMIT_EMPTY_CONFIG: '配置不能为空',
    ERROR_PLAY_LIMIT_POINTS_BOTH_EMPTY: 'startPoint / endPoint 配置不能同时为空',
    ERROR_PLAY_LIMIT_START_TIME_BELOW_ZERO: 'startPoint.value 值不能小于 0',
    ERROR_PLAY_LIMIT_END_TIME_BELOW_START_TIME: 'endPoint.value 值不能小于 startPoint.value',
    ERROR_URL_INVALID: '地址不合法',
    // 自动播放相关
    ERROR_AUTOPLAY_FAILED_BROWSER: '浏览器不允许自动播放',
    ERROR_AUTOPLAY_FAILED_CONFIG: '传入配置不允许静音自动播放'
};
defaultI18nConfig.h5player = h5playerI18nConfig;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_throttle = throttle;

/** 广告插件名 */ var AD_PLUGIN_NAME = '__thumbplayer-ad';
var AdType;
/** 广告类型 */ (function(AdType) {
    AdType["PRE"] = "preAd";
    AdType["ZT"] = "ZT";
    AdType["POST"] = "postAd";
})(AdType || (AdType = {}));
/** 广告节点是否有广告的一些状态 */ var AD_LOAD_STATUS = {
    /** 非空订单，此时需要播放广告 */ OK: 'ok',
    /** 空单，但这里跟广告插件约定，仍然需要调用playAd播放广告! */ EMPTY_OK: 'emptyOk',
    /** 未找到广告订单，此时无广告，直接跳过广告节点 */ NO_ORDER_ERR: 'noOrderErr',
    /** 创建某种广告类型时的其他错误，此时无广告，直接跳过广告节点 */ CREATE_AD_ERR: 'createAdErr',
    /** 请求getinfo拿不到广告订单 */ NO_ADINFO: 'noAdinfo',
    /** 调用广告插件的setAdInfo失败 */ SET_ADINFO_ERR: 'setAdInfoErr',
    /** 其他跳过广告的情况 */ OTHER_SKIP: 'skip'
};
/** 是否前后贴广告类型 */ function isPreOrPostAd(data) {
    return [
        "preAd",
        "postAd"
    ].indexOf(data.adType) !== -1;
}

/** 用局部变量保存广告插件实例 */ var adPluginMap = {};
function setAdPlugin(instanceId, plugin) {
    adPluginMap[instanceId] = plugin;
}
function getAdPlugin(instanceId) {
    return adPluginMap[instanceId];
}
/**
 * 从广告插件获取最终的广告请求参数
 * @param instanceId 播放器实例id
 * @param customParams 用户自定参数
 * @returns 最终的广告请求参数
 */ function getAdReqParams(instanceId, customParams) {
    var adPlugin = getAdPlugin(instanceId);
    if (!adPlugin || typeof adPlugin.getAdParams !== 'function' || !(customParams === null || customParams === void 0 ? void 0 : customParams.adType) || !(customParams === null || customParams === void 0 ? void 0 : customParams.vid)) {
        // 没有vid, adType返回空
        return {};
    }
    try {
        return adPlugin.getAdParams(customParams);
    } catch (e) {
        return {};
    }
}

var H5_EXT_EVENT;
(function(H5_EXT_EVENT) {
    /** 广告倒计时 */ H5_EXT_EVENT["AD_COUNTDOWN_CHANGE"] = "AD_COUNTDOWN_CHANGE";
    /** 是否显示loading动画 */ H5_EXT_EVENT["SET_LOADING"] = "SET_LOADING";
    /** 合并接口开始请求 */ H5_EXT_EVENT["PROXY_HTTP_START"] = "PROXY_HTTP_START";
    /** 合并接口结束请求（仅返回结果的时刻，并未解析） */ H5_EXT_EVENT["PROXY_HTTP_REQ_END"] = "PROXY_HTTP_REQ_END";
    /** 合并接口结束请求 */ H5_EXT_EVENT["PROXY_HTTP_END"] = "PROXY_HTTP_END";
    /** getinfo请求开始 */ H5_EXT_EVENT["GETINFO_START"] = "GETINFO_START";
    /** getinfo接口返回 */ H5_EXT_EVENT["GETINFO_OVER"] = "GETINFO_OVER";
    /**
   * getinfo接口返回
   * 注意：区别于`GETINFO_OVER`事件。`GETINFO_OVER`事件一定是当前正在播放的session派发出来的。但是`GETINFO_RESULT`事件可能派发
   * 在预加载的播放流程中，例如解析m3u8字符串和url映射关系的逻辑需要此事件
   */ H5_EXT_EVENT["GETINFO_RESULT"] = "GETINFO_RESULT";
    /** 切换播放id */ H5_EXT_EVENT["VID_CHANGE"] = "VID_CHANGE";
    /** 播放器销毁 */ H5_EXT_EVENT["DESTROY"] = "DESTROY";
    /** 数据中心字段更新 */ H5_EXT_EVENT["DATASET_UPDATE"] = "data-set:update";
    /** 数据中心state-map字段更新 */ H5_EXT_EVENT["DATASET_STATE_UPDATE"] = "data-set:stateUpdate";
    /** 播放级别的重试（腾讯视频点播直播的重试，会重新请求后台） */ H5_EXT_EVENT["RETRY_PLAY"] = "retryPlay";
    /** 播放级别的重试成功（重新恢复播放） */ H5_EXT_EVENT["RETRY_PLAY_SUCC"] = "retryPlaySucc";
    /** 因为浏览器限制而自动静音播放 */ H5_EXT_EVENT["AUTOPLAY_IN_MUTED"] = "autoplayInMuted";
    /** 自动播放失败，可能是浏览器策略导致完全无法自动播放，或是 config 配置不允许尝试静音自动播放 */ H5_EXT_EVENT["AUTOPLAY_FAILED"] = "autoplayFailed";
    /** 节点开始预加载 */ H5_EXT_EVENT["FLOW_NODE_PRELOAD"] = "FLOW_NODE_PRELOAD";
    /** 进入节点流程（可能还未开始播放，例如预加载了但是还在loading过程中） */ H5_EXT_EVENT["FLOW_NODE_START"] = "FLOW_NODE_START";
    /** 当前节点结束/出错后，进入下一节点 */ H5_EXT_EVENT["FLOW_NODE_END"] = "FLOW_NODE_END";
    /** 中断当前流程 */ H5_EXT_EVENT["FLOW_NODE_ABORT"] = "FLOW_NODE_ABORT";
    /** 播放数据统计 */ H5_EXT_EVENT["STATS_CHANGE"] = "STATS_CHANGE";
    /** 广告或者正片首次起播 */ H5_EXT_EVENT["SESSION_FIRST_PLAYING"] = "SESSION_FIRST_PLAYING";
})(H5_EXT_EVENT || (H5_EXT_EVENT = {}));

var H5_PLAY_EVENT;
(function(H5_PLAY_EVENT) {
    /** 单次播放会话开始 在load/play时开始 */ H5_PLAY_EVENT["PLAY_SESSION_START"] = "PLAY_SESSION_START";
    // 广告事件（相对于整个广告生命周期，不区分分片）
    /** 请求广告信息开始 */ H5_PLAY_EVENT["AD_REQ_INFO_START"] = "AD_REQ_INFO_START";
    /** 广告信息返回成功/失败 */ H5_PLAY_EVENT["AD_REQ_INFO_END"] = "AD_REQ_INFO_END";
    /** 请求广告素材开始 */ H5_PLAY_EVENT["AD_REQ_ASSETS_START"] = "AD_REQ_ASSETS_START";
    /** 广告自动播放被拦截 */ H5_PLAY_EVENT["AD_AUTOPLAY_BLOCKED"] = "AD_AUTOPLAY_BLOCKED";
    /** 广告开始播放 */ H5_PLAY_EVENT["AD_PLAYING"] = "AD_PLAYING";
    /** 广告音量变化 */ H5_PLAY_EVENT["AD_VOLUME_CHANGE"] = "AD_VOLUME_CHANGE";
    /** 广告素材加载完成 */ H5_PLAY_EVENT["AD_ASSETS_LOADED"] = "AD_ASSETS_LOADED";
    /** 广告播放暂停 */ H5_PLAY_EVENT["AD_PAUSE"] = "AD_PAUSE";
    /** 广告恢复播放 */ H5_PLAY_EVENT["AD_RESUME"] = "AD_RESUME";
    /** 广告播放完成/失败	 */ H5_PLAY_EVENT["AD_END"] = "AD_END";
    H5_PLAY_EVENT["AD_TIME_UPDATE"] = "AD_TIME_UPDATE";
    /** 请求正片信息开始 */ H5_PLAY_EVENT["VIDEO_REQ_INFO_START"] = "VIDEO_REQ_INFO_START";
    /** 请求正片信息结束，成功/失败 */ H5_PLAY_EVENT["VIDEO_REQ_INFO_END"] = "VIDEO_REQ_INFO_END";
    /** 开始加载正片 */ H5_PLAY_EVENT["VIDEO_LOAD_START"] = "VIDEO_LOAD_START";
    /** 正片数据加载中 */ H5_PLAY_EVENT["VIDEO_LOAD_PROGRESS"] = "VIDEO_LOAD_PROGRESS";
    /** 正片时长变化 */ H5_PLAY_EVENT["VIDEO_DURATION_CHANGE"] = "VIDEO_DURATION_CHANGE";
    /** 正片信息变化 */ H5_PLAY_EVENT["VIDEO_METADATA_CHANGE"] = "VIDEO_METADATA_CHANGE";
    /** 正片播放进度变化 */ H5_PLAY_EVENT["VIDEO_TIMEUPDATE"] = "VIDEO_TIMEUPDATE";
    /** 正片音量变化 */ H5_PLAY_EVENT["VIDEO_VOLUME_CHANGE"] = "VIDEO_VOLUME_CHANGE";
    /** 正片倍速变化 */ H5_PLAY_EVENT["VIDEO_RATE_CHANGE"] = "VIDEO_RATE_CHANGE";
    /** 正片可以播放 */ H5_PLAY_EVENT["VIDEO_CANPLAY"] = "VIDEO_CANPLAY";
    /** 正片开始播放 */ H5_PLAY_EVENT["VIDEO_PLAYING"] = "VIDEO_PLAYING";
    /** 正片自动播放被拦截 */ H5_PLAY_EVENT["VIDEO_AUTOPLAY_BLOCKED"] = "VIDEO_AUTOPLAY_BLOCKED";
    /** 正片暂停播放 */ H5_PLAY_EVENT["VIDEO_PAUSE"] = "VIDEO_PAUSE";
    /** 正片缓冲中 */ H5_PLAY_EVENT["VIDEO_BUFFERING"] = "VIDEO_BUFFERING";
    /** 正片跳转中 */ H5_PLAY_EVENT["VIDEO_SEEKING"] = "VIDEO_SEEKING";
    /** 正片跳转结束 */ H5_PLAY_EVENT["VIDEO_SEEKED"] = "VIDEO_SEEKED";
    /** 正片切换清晰度开始 */ H5_PLAY_EVENT["VIDEO_SETLEVEL_START"] = "VIDEO_SETLEVEL_START";
    /** 正片切换清晰度结束 */ H5_PLAY_EVENT["VIDEO_SETLEVEL_END"] = "VIDEO_SETLEVEL_END";
    /** 视频分辨率发生变化 */ H5_PLAY_EVENT["VIDEO_RESIZE"] = "VIDEO_RESIZE";
    /** 正片播放结束 */ H5_PLAY_EVENT["VIDEO_END"] = "VIDEO_END";
    /** 单次播放会话结束 */ H5_PLAY_EVENT["PLAY_SESSION_END"] = "PLAY_SESSION_END";
})(H5_PLAY_EVENT || (H5_PLAY_EVENT = {}));

/**
 * @deprecated
 * 老的代码从@tencent/thumbplayer-plugin-map导出了`OFFICIAL_PLUGIN`和`PLUGIN_MAP`两个枚举，这个会导致循环依赖，而且逻辑上没啥用了。
 */ var OFFICIAL_PLUGIN = {};
var PLUGIN_MAP = {};
var H5PauseType;
(function(H5PauseType) {
    H5PauseType["USER_CLICK"] = "user-click";
    /** 通过接口调用的pause */ H5PauseType["CALL_BY_API"] = "call-by-api";
    /** 点击播放器蒙层暂停 */ H5PauseType["CLICK_MASK"] = "click-mask";
})(H5PauseType || (H5PauseType = {}));
var AutoPlayPolicy;
(function(AutoPlayPolicy) {
    /** 当自动播放被浏览器阻止以后，尝试静音播放 */ AutoPlayPolicy["IN_MUTED"] = "autoPlayInMuted";
    /** 自动播放一定需要用户手势 */ AutoPlayPolicy["USER_GESTURE"] = "autoPlayRequireByUserGesture";
})(AutoPlayPolicy || (AutoPlayPolicy = {}));
var PictureDirection;
(function(PictureDirection) {
    PictureDirection["NORMAL"] = "normal";
    PictureDirection["VERTICAL"] = "vertical";
    PictureDirection["HORIZON"] = "horizon";
})(PictureDirection || (PictureDirection = {}));
var VideoLoopMode;
(function(VideoLoopMode) {
    VideoLoopMode["native"] = "native";
    VideoLoopMode["replay"] = "replay";
})(VideoLoopMode || (VideoLoopMode = {}));

/**
 * 自动播放重试逻辑
 * 当收到 Core 的自动播放被阻止事件时，根据配置来执行静音自动播放重试策略
 * 并抛出对应的自动播放事件（静音自动播放起播 / 自动播放失败）
 */ var AutoPlayLogics = /*#__PURE__*/ function() {
    function AutoPlayLogics(player) {
        var _this = this;
        _$1(this, AutoPlayLogics);
        _$2(this, "player", void 0);
        _$2(this, "hasRetried", false);
        _$2(this, "logger", void 0);
        _$2(this, "adBlockTimer", void 0);
        /** 进行静音起播重试前的静音状态，当自动播放失败时一起带出去，以便外部有手势操作时，顺便恢复到静音前的状态 */ _$2(this, "mutedBefore", false);
        _$2(this, "onPlaySessionStart", function() {
            _this.mutedBefore = _this.player.muted;
            _this.hasRetried = false;
            _this.cancelRetryCallback();
        });
        _$2(this, "onAdAutoPlayBlocked", function() {
            clearTimeout(_this.adBlockTimer);
            // 因为广告节点内部是在play后监听到blocked时回退到preload状态的，执行时机比这里慢 所以setTimeout延迟一下
            _this.adBlockTimer = setTimeout(function() {
                _this.onAutoPlayBlocked();
            });
        });
        /**
   * 当自动播放被阻止时，进行重试 / 抛出失败事件
   */ _$2(this, "onAutoPlayBlocked", function() {
            // 如果策略允许静音重试起播，且没有重试过，则开始重试静音起播
            if (_this.allowRetry) {
                _this.hasRetried = true;
                // 设置播放器 & 广告静音
                _this.player.muted = true;
                try {
                    var _getAdPlugin;
                    (_getAdPlugin = getAdPlugin(_this.player.config.instanceId)) === null || _getAdPlugin === void 0 ? void 0 : _getAdPlugin.setAdVolume(0);
                } catch (e) {
                    _this.logger.error('call @adPlugin.setAdVolume()', e);
                }
                // 重试起播
                _this.player.play();
                _this.logger.log('@onAutoPlayBlocked(), using AUTOPLAY_IN_MUTE policy...');
                // 添加事件监听，当真的起播的时候，抛出静音起播事件
                _this.player.once(H5_PLAY_EVENT.VIDEO_PLAYING, _this.onVideoPlayingOnMuteRetry);
                _this.player.once(H5_PLAY_EVENT.AD_PLAYING, _this.onVideoPlayingOnMuteRetry);
                return;
            }
            // 否则，一定需要用户手势才能够起播，抛出失败事件
            var blockedByBrowser = _this.shouldMuteRetry;
            var reason = blockedByBrowser ? h5playerI18nConfig.ERROR_AUTOPLAY_FAILED_BROWSER : h5playerI18nConfig.ERROR_AUTOPLAY_FAILED_CONFIG;
            _this.player.pluginMsg.emit(H5_EXT_EVENT.AUTOPLAY_FAILED, {
                mutedBefore: _this.mutedBefore,
                blockedByBrowser: blockedByBrowser,
                reason: reason
            });
            _this.logger.warn("@onAutoPlayBlocked(), autoplay failed: ".concat(reason));
            // 取消掉事件监听
            _this.cancelRetryCallback();
        });
        /**
   * 使用静音策略重试自动播放成功
   */ _$2(this, "onVideoPlayingOnMuteRetry", function() {
            _this.logger.log('@onVideoPlayingOnMuteRetry(), AUTOPLAY_IN_MUTE retry successfully.');
            var muted = _this.player.muted;
            // 重试成功了，还需要额外判断下当前静音状态，防止重试中有用户手势介入
            // 比如 BLOCK->PLAYING 期间用户点了静音按钮给取消掉了
            if (muted) {
                _this.player.pluginMsg.emit(H5_EXT_EVENT.AUTOPLAY_IN_MUTED, {
                    muted: muted,
                    mutedBefore: _this.mutedBefore
                });
            }
            // 函数被调用有两个入口，这里任意一个入口触发后，要把另一个入口的监听器取消掉
            _this.cancelRetryCallback();
        });
        this.player = player;
        this.logger = new Logger(player.config.instanceId, 'AutoPlayLogics');
        this.logger.log('autoplay logics call @constructor()');
        this.bindEvents(true);
    }
    _(AutoPlayLogics, [
        {
            key: "shouldMuteRetry",
            get: /**
   * 当前播放器配置下，是否允许进行静音自动播放重试
   */ function get() {
                var _this_player_config = this.player.config, autoPlayPolicy = _this_player_config.autoPlayPolicy, autoPlayInMute = _this_player_config.autoPlayInMute;
                return autoPlayInMute || autoPlayPolicy === AutoPlayPolicy.IN_MUTED;
            }
        },
        {
            key: "allowRetry",
            get: /**
   * 是否允许进行静音起播重试
   */ function get() {
                return this.shouldMuteRetry && !this.hasRetried;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                // 把 this.player 作为 destroy 标记
                if (!this.player) return;
                this.logger.log('autoplay logics call @destroy()');
                clearTimeout(this.adBlockTimer);
                this.cancelRetryCallback();
                this.bindEvents(false);
                this.player = null;
            }
        },
        {
            key: "bindEvents",
            value: function bindEvents() {
                var isBind = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var binder = getEventEmitterBinder(this.player, isBind);
                binder(H5_PLAY_EVENT.PLAY_SESSION_START, this.onPlaySessionStart);
                binder(H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED, this.onAdAutoPlayBlocked);
                binder(H5_PLAY_EVENT.VIDEO_AUTOPLAY_BLOCKED, this.onAutoPlayBlocked);
            }
        },
        {
            key: "cancelRetryCallback",
            value: /**
   * 取消对静音自动播放成功的监听器
   */ function cancelRetryCallback() {
                this.player.off(H5_PLAY_EVENT.VIDEO_PLAYING, this.onVideoPlayingOnMuteRetry);
                this.player.off(H5_PLAY_EVENT.AD_PLAYING, this.onVideoPlayingOnMuteRetry);
            }
        }
    ]);
    return AutoPlayLogics;
}();

var e={"demux2fmp4":"1.39.6","hls.js":"1.39.6","flv.js":"1.39.6","wasm":"1.39.6","webrtc":"1.39.6"};

var defaultH5PlayerConfig = {
    enableQAreporter: true,
    // 重试的默认配置
    maxRetryGetinfoTimes: 3,
    maxRetryGetinfoTimesInVodSession: 10,
    maxRetryGetinfoTimesInLiveSession: 30,
    autoLoadKernelVerMap: e,
    /** 移动端默认使用单video组件，即广告、正片都使用同一个video组件 */ useSingleVideoElement: uaTool.mobile,
    // 移动端由于一般是单video组件实现播放，并且下载组件在移动端默认不写缓存，因此在移动端关闭预加载
    enablePreload: !uaTool.mobile
};
/**
 * 某些配置项本来由更底层的core来赋值，但是起播前 / 停止播放时并不存在core。
 * 因此一定要补齐h5player和core需要的某些配置项，这样做的目的是为了保证h5player和core的配置项完全一致。
 */ function patchConfig(config) {
    // 补齐h5player本身的默认配置项
    Object.keys(defaultH5PlayerConfig).forEach(function(key) {
        if (typeof config[key] === 'undefined') {
            config[key] = defaultH5PlayerConfig[key];
        }
    });
    // 补齐core播放器的默认配置项。这里补齐以后，core层并不会重新覆盖，因为有空值合并判断。
    // 这样可以保证h5player和core使用的是同一份配置项，并且完全一致
    config = patchConfig$1(config);
    // 这个比较特殊，可以是string也可以是HTMLElement，为了保持和core的配置值一致，这里先统一修改为HTMLElement，core也会直接使用
    config.container = typeof config.container === 'string' ? document.querySelector(config.container) : config.container;
    return config;
}

var ErrorCode;
(function(ErrorCode) {
    ErrorCode["SUC"] = "0";
    /** 未知错误 */ ErrorCode["UNKNOWN"] = "70040000";
    /** 广告结束出错的默认错误码 */ ErrorCode["AD_END_DEFAULT_FAIL"] = "70040002";
    /** 广告信息请求出错的默认错误码 */ ErrorCode["AD_REQ_INFO_DEFAULT_FAIL"] = "70040003";
    /** 没有getinfo插件 */ ErrorCode["GETINFO_PLUGIN_MISSING"] = "70040001";
    // getinfo过程中的错误码
    ErrorCode["GETINFO_NET"] = "70014001";
    ErrorCode["GETINFO_TIMEOUT"] = "70014003";
    ErrorCode["GETINFO_PARSE"] = "70014004";
    ErrorCode["GETINFO_INNER"] = "70014005";
    /** 直出数据不可用 */ ErrorCode["SRV_DATA_INVAILD"] = "70014006";
    /** 腾讯视频点播服务返回错误时的错误码前缀 */ ErrorCode["GETINFO_SERVER_CODE_PREFIX"] = "70013";
    /** 腾讯视频直播服务返回错误时的错误码前缀 */ ErrorCode["GETINFO_LIVE_SERVER_CODE_PREFIX"] = "70023";
    /** 腾讯视频融合直播服务返回错误时的错误码前缀 */ ErrorCode["GETINFO_UNIFIED_LIVE_SERVER_CODE_PREFIX"] = "70033";
    /** 1080P未付费 */ ErrorCode["UNPAIED_1080P"] = "70013091.0";
})(ErrorCode || (ErrorCode = {}));
var ErrorMsg;
(function(ErrorMsg) {
    ErrorMsg["GETINFO_PLUGIN_MISSING"] = "没有找到获取视频信息插件";
    ErrorMsg["GETINFO_INNER"] = "获取视频信息内部错误";
    /** 网络错误 */ ErrorMsg["GETINFO_NET"] = "无法获取视频信息";
    /** 网络超时 */ ErrorMsg["GETINFO_TIMEOUT"] = "获取视频信息超时";
    /** 解析错误 */ ErrorMsg["GETINFO_PARSE"] = "视频信息无法解析";
    /** 后台下发的错误码 */ ErrorMsg["GETINFO_CODE"] = "播放后台返回错误";
})(ErrorMsg || (ErrorMsg = {}));

var FlowNodeState;
(function(FlowNodeState) {
    FlowNodeState["IDLE"] = "idle";
    FlowNodeState["PRELOADING"] = "preloading";
    FlowNodeState["PRELOADED"] = "preloaded";
    FlowNodeState["STARTED"] = "started";
    FlowNodeState["PAUSED"] = "paused";
    FlowNodeState["STOPPED"] = "stopped";
})(FlowNodeState || (FlowNodeState = {}));
var FlowNodeName;
(function(FlowNodeName) {
    FlowNodeName["GET_INFO"] = "GetVideoInfoFlowNode";
    FlowNodeName["PLAY_AD"] = "AdFlowNode";
    FlowNodeName["PLAY_VIDEO"] = "VideoFlowNode";
})(FlowNodeName || (FlowNodeName = {}));
var FlowNodeEvt;
(function(FlowNodeEvt) {
    FlowNodeEvt["STATE_CHANGE"] = "stateChange";
    FlowNodeEvt["ABORT"] = "abort";
    /** 节点彻底结束，通知下一个节点开始或者流程结束 */ FlowNodeEvt["ENDED"] = "ended";
    FlowNodeEvt["TRIGGER_PRELOAD_NEXT"] = "triggerPreloadNext";
    FlowNodeEvt["RETRY_PLAY"] = "retryPlay";
    FlowNodeEvt["RETRY_PLAY_SUCC"] = "retryPlaySucc";
})(FlowNodeEvt || (FlowNodeEvt = {}));
var FlowManagerEvt;
(function(FlowManagerEvt) {
    /** 流程结束 */ FlowManagerEvt["FLOW_OVER"] = "over";
})(FlowManagerEvt || (FlowManagerEvt = {}));
var _obj$3;
/**
 * 状态图参考docs/flow-node-state.png
 */ var FlowNodeStateTransitionMap = (_obj$3 = {}, _$2(_obj$3, "idle", [
    "preloading",
    "stopped"
]), _$2(_obj$3, "preloading", [
    "idle",
    "preloaded",
    "stopped"
]), _$2(_obj$3, "preloaded", [
    "started",
    "stopped",
    "idle"
]), _$2(_obj$3, "started", [
    "paused",
    "stopped"
]), _$2(_obj$3, "paused", [
    "started",
    "stopped"
]), _$2(_obj$3, "stopped", []), _obj$3);

/** core: 插件map局部变量，对外提供存取方法 */ var pluginStorage = {};
var pluginExists = function(name) {
    return Object.prototype.hasOwnProperty.call(pluginStorage, name);
};
var getPlugin = function(name) {
    return pluginExists(name) ? pluginStorage[name] : undefined;
};
/** 把插件添加到map里 */ function registerPlugin(name, plugin) {
    if (typeof name !== 'string') {
        throw new Error('Illegal plugin name, "'.concat(name, '", must be a string, was ').concat(typeof name === "undefined" ? "undefined" : _$3(name), "."));
    }
    if (typeof plugin !== 'function') {
        throw new Error('Illegal plugin for "'.concat(name, '", must be a function, was ').concat(typeof plugin === "undefined" ? "undefined" : _$3(plugin), "."));
    }
    if (pluginExists(name)) {
        console.warn('A plugin named "'.concat(name, '" already exists. You may want to avoid re-registering plugins!'));
        return;
    }
    pluginStorage[name] = plugin;
    return plugin;
}
/** 注销插件 */ function deregisterPlugin(name) {
    if (pluginExists(name)) delete pluginStorage[name];
}
/** 获取部分插件map */ function getPlugins() {
    var names = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Object.keys(pluginStorage);
    var result;
    names.forEach(function(name) {
        var plugin = getPlugin(name);
        if (plugin) {
            result = result || {};
            result[name] = plugin;
        }
    });
    return result;
}

/** 基类中定义的钩子都用这个字符串开头 */ var methodPrefix = 'hook';
/** 目前提供的钩子 */ var playHooks = Object.values(H5_PLAY_EVENT);
/**
 * 插件基类，初始化前后在player上提供事件
 */ var Plugin = /*#__PURE__*/ function _target(EvtEmitter) {
    _$4(Plugin, EvtEmitter);
    var _super = _$5(Plugin);
    function Plugin(player, config, extra) {
        _$1(this, Plugin);
        var _this;
        _this = _super.call(this);
        _$2(_$6(_this), "player", void 0);
        _$2(_$6(_this), "config", void 0);
        /** 插件监听内部事件 */ _$2(_$6(_this), "msg", void 0);
        /** logger, _是为了兼容其他可能已经定义了logger的插件 */ // eslint-disable-next-line @typescript-eslint/naming-convention
        _$2(_$6(_this), "logger_", void 0);
        /** 存放钩子回调函数 */ _$2(_$6(_this), "hookMap", void 0);
        _this.player = player;
        _this.config = config;
        _this.hookMap = {};
        if ((_$7(this, Plugin) ? this.constructor : void 0) === Plugin) {
            throw new Error('Plugin must be sub-classed; not directly instantiated.');
        }
        _this.logger_ = new Logger(player.config.instanceId, _this.constructor.pluginName);
        var msg = (extra || {}).msg;
        _this.msg = msg;
        _this.registerHook();
        return _this;
    }
    _(Plugin, [
        {
            key: "log",
            value: // 日志方法: 注意如果锁了低版本的core，部分方法可能不存在
            function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_logger__log;
                var _this_logger__log1, _this_logger_;
                (_this_logger__log1 = (_this_logger_ = this.logger_).log) === null || _this_logger__log1 === void 0 ? void 0 : (_this_logger__log = _this_logger__log1).call.apply(_this_logger__log, [
                    _this_logger_
                ].concat(_$8(args)));
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_logger__warn;
                var _this_logger__warn1, _this_logger_;
                (_this_logger__warn1 = (_this_logger_ = this.logger_).warn) === null || _this_logger__warn1 === void 0 ? void 0 : (_this_logger__warn = _this_logger__warn1).call.apply(_this_logger__warn, [
                    _this_logger_
                ].concat(_$8(args)));
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_logger__error;
                var _this_logger__error1, _this_logger_;
                (_this_logger__error1 = (_this_logger_ = this.logger_).error) === null || _this_logger__error1 === void 0 ? void 0 : (_this_logger__error = _this_logger__error1).call.apply(_this_logger__error, [
                    _this_logger_
                ].concat(_$8(args)));
            }
        },
        {
            key: "debug",
            value: function debug() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_logger__debug;
                var _this_logger__debug1, _this_logger_;
                (_this_logger__debug1 = (_this_logger_ = this.logger_).debug) === null || _this_logger__debug1 === void 0 ? void 0 : (_this_logger__debug = _this_logger__debug1).call.apply(_this_logger__debug, [
                    _this_logger_
                ].concat(_$8(args)));
            }
        },
        {
            key: "info",
            value: function info() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_logger__info;
                var _this_logger__info1, _this_logger_;
                (_this_logger__info1 = (_this_logger_ = this.logger_).info) === null || _this_logger__info1 === void 0 ? void 0 : (_this_logger__info = _this_logger__info1).call.apply(_this_logger__info, [
                    _this_logger_
                ].concat(_$8(args)));
            }
        },
        {
            key: "hasPlugin",
            value: /** 判断播放器是否包含(已注册)某个插件 */ function hasPlugin(name) {
                return !!pluginExists(name);
            }
        },
        {
            key: "destroy",
            value: /** 移除事件，删除播放器上的插件实例 */ function destroy() {
                var _player_plugins;
                var player = this.player;
                var name = this.name;
                if ((_player_plugins = player.plugins) === null || _player_plugins === void 0 ? void 0 : _player_plugins[name]) {
                    delete player.plugins[name];
                }
                this.unRegisterHook();
                this.hookMap = null;
                this.player = null;
                this.removeAllListeners();
            }
        },
        {
            key: "hookPlaySessionStart",
            value: function hookPlaySessionStart(_param) {}
        },
        {
            key: "hookAdReqInfoStart",
            value: // ad hook
            function hookAdReqInfoStart(_param) {}
        },
        {
            key: "hookAdReqInfoEnd",
            value: function hookAdReqInfoEnd(_param) {}
        },
        {
            key: "hookAdReqAssetsStart",
            value: function hookAdReqAssetsStart(_param) {}
        },
        {
            key: "hookAdAutoplayBlocked",
            value: function hookAdAutoplayBlocked(_param) {}
        },
        {
            key: "hookAdPlaying",
            value: function hookAdPlaying(_param) {}
        },
        {
            key: "hookAdVolumeChange",
            value: function hookAdVolumeChange(_param) {}
        },
        {
            key: "hookAdAssetsLoaded",
            value: function hookAdAssetsLoaded(_param) {}
        },
        {
            key: "hookAdPause",
            value: function hookAdPause(_param) {}
        },
        {
            key: "hookAdResume",
            value: function hookAdResume(_param) {}
        },
        {
            key: "hookAdEnd",
            value: function hookAdEnd(_param) {}
        },
        {
            key: "hookAdTimeUpdate",
            value: function hookAdTimeUpdate(_param) {}
        },
        {
            key: "hookVideoReqInfoStart",
            value: // video hook
            function hookVideoReqInfoStart(_param) {}
        },
        {
            key: "hookVideoReqInfoEnd",
            value: function hookVideoReqInfoEnd(_param) {}
        },
        {
            key: "hookVideoLoadStart",
            value: function hookVideoLoadStart(_param) {}
        },
        {
            key: "hookVideoMetadataChange",
            value: function hookVideoMetadataChange(_param) {}
        },
        {
            key: "hookVideoLoadProgress",
            value: function hookVideoLoadProgress(_param) {}
        },
        {
            key: "hookVideoDurationChange",
            value: function hookVideoDurationChange(_param) {}
        },
        {
            key: "hookVideoTimeupdate",
            value: function hookVideoTimeupdate(_param) {}
        },
        {
            key: "hookVideoVolumeChange",
            value: function hookVideoVolumeChange(_param) {}
        },
        {
            key: "hookVideoResize",
            value: function hookVideoResize(_param) {}
        },
        {
            key: "hookVideoRateChange",
            value: function hookVideoRateChange(_param) {}
        },
        {
            key: "hookVideoCanplay",
            value: function hookVideoCanplay(_param) {}
        },
        {
            key: "hookVideoPlaying",
            value: function hookVideoPlaying(_param) {}
        },
        {
            key: "hookVideoAutoplayBlocked",
            value: function hookVideoAutoplayBlocked(_param) {}
        },
        {
            key: "hookVideoPause",
            value: function hookVideoPause(_param) {}
        },
        {
            key: "hookVideoBuffering",
            value: function hookVideoBuffering(_param) {}
        },
        {
            key: "hookVideoSeeking",
            value: function hookVideoSeeking(_param) {}
        },
        {
            key: "hookVideoSeeked",
            value: function hookVideoSeeked(_param) {}
        },
        {
            key: "hookVideoSetlevelStart",
            value: function hookVideoSetlevelStart(_param) {}
        },
        {
            key: "hookVideoSetlevelEnd",
            value: function hookVideoSetlevelEnd(_param) {}
        },
        {
            key: "hookVideoEnd",
            value: function hookVideoEnd(_param) {}
        },
        {
            key: "hookPlaySessionEnd",
            value: function hookPlaySessionEnd(_param) {}
        },
        {
            key: "registerHook",
            value: function registerHook() {
                var _this = this;
                playHooks.forEach(function(hook) {
                    var methodName = getHookMethodName(hook);
                    // 这里必须用匿名函数，因为执行基类构造函数时子类属性还没挂载
                    _this.hookMap[hook] = function(evtParam) {
                        var _this_methodName, _this1;
                        return (_this_methodName = (_this1 = _this)[methodName]) === null || _this_methodName === void 0 ? void 0 : _this_methodName.call(_this1, evtParam.data);
                    };
                    _this.player.on(hook, _this.hookMap[hook]);
                });
            }
        },
        {
            key: "unRegisterHook",
            value: function unRegisterHook() {
                var _this = this;
                playHooks.forEach(function(hook) {
                    if (!_this.hookMap[hook]) return;
                    _this.player.off(hook, _this.hookMap[hook]);
                });
            }
        }
    ]);
    return Plugin;
}(EvtEmitter);
/** 版本号，暂时保留 */ // codecc扫描无法通过，但是是历史存量已无法修改
// eslint-disable-next-line @typescript-eslint/naming-convention
_$2(Plugin, "VERSION", '');
/** 插件名 */ _$2(Plugin, "pluginName", '');
/**
 * 是否是函数插件（非继承Plugin实现）
 */ function isFunctionPlugin(plugin) {
    var p = typeof plugin === 'string' ? getPlugin(plugin) : plugin;
    return typeof p === 'function' && !Object.prototype.isPrototypeOf.call(Plugin.prototype, p.prototype);
}
function createPluginFactory(name, pluginFunction) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        args[_key - 2] = arguments[_key];
    }
    var _args = _$9(args, 1), player = _args[0];
    var instance;
    if (isFunctionPlugin(pluginFunction)) {
        // 函数插件,绑定this到player
        instance = pluginFunction.apply(player, args);
    } else {
        // 类插件
        var pluginClass = pluginFunction;
        // 动态增加name属性，销毁时用到
        pluginClass.prototype.name = name;
        // eslint-disable-next-line new-cap
        instance = _$a(pluginClass, _$8(args));
    }
    if (instance) {
        // 函数插件可能没有返回 此时不需要挂载plugins
        player.plugins[name] = instance;
    }
    return instance;
}
/** 从事件名转换得到hook方法名 */ function getHookMethodName(hook) {
    // PLAY_SESSION_START->hookPlaySessionStart
    return methodPrefix + hook.toLowerCase().replace(/^[a-z]/, function(v) {
        return v.toUpperCase();
    }).replace(/_[a-z]/g, function(v) {
        return v[1].toUpperCase();
    });
}

/**
 * @fileoverview 定义VideoReq插件
 */ function isVideoId(id) {
    return typeof id === 'string' || typeof id === 'number';
}
/**
 * drm类型，这里是getinfo返回的drm类型（点直播是对齐的）
 */ var DRM_TYPE = {
    NONE: 0,
    CHACHA: 3,
    FAIR_PLAY: 4,
    WIDEVINE: 5,
    ChinaDRM: 6,
    PLAYREADY: 8
};
/**
 * drm请求类型，这个为请求getinfo后台的类型
 */ var DRM_VALUE = {
    NONE: 0,
    CHACHA: 8,
    FAIR_PLAY: 16,
    WIDEVINE: 32,
    PLAYREADY: 0x100
};

var DataEvents;
(function(DataEvents) {
    /** 数据更新 */ DataEvents["UPDATE"] = "data-set:update";
    DataEvents["STATE_UPDATE"] = "data-set:stateUpdate";
})(DataEvents || (DataEvents = {}));
var DataState;
(function(DataState) {
    DataState["INIT"] = "PLAYER:init";
    DataState["SESSION_START"] = "PLAYER:session_start";
    DataState["SESSION_END"] = "PLAYER:session_end";
    DataState["GET_INFO"] = "PLAYER:getinfo";
    /** CDN重定向请求开始 */ DataState["GET_INFO_START"] = "PLAYER:getinfo_start";
    /** CDN重定向请求结束 */ DataState["GET_INFO_END"] = "PLAYER:getinfo_end";
    DataState["SUBTITLE"] = "PLAYER:subtitle";
    /** 字幕加载开始 */ DataState["SUBTITLE_START"] = "PLAYER:subtitle_start";
    /** 字幕加载结束 */ DataState["SUBTITLE_END"] = "PLAYER:subtitle_end";
    /** 视频文件加载开始 */ DataState["LOAD_START"] = "PLAYER:load_start";
    /** 视频文件加载结束 */ DataState["LOAD_END"] = "PLAYER:load_end";
    DataState["LOAD"] = "PLAYER:load";
    DataState["BUFFER"] = "PLAYER:buffer";
    /** 二次缓冲开始 */ DataState["BUFFER_START"] = "PLAYER:buffer_start";
    /** 二次缓冲结束 */ DataState["BUFFER_END"] = "PLAYER:buffer_end";
    DataState["SEEK"] = "PLAYER:seek";
    /** seek事件开始 */ DataState["SEEK_START"] = "PLAYER:seek_start";
    /** seek事件结束 */ DataState["SEEK_END"] = "PLAYER:seek_end";
    /** 用户拖拽开始 */ DataState["USER_SEEK_START"] = "PLAYER:user_seek_start";
    /** 用户拖拽结束 */ DataState["USER_SEEK_END"] = "PLAYER:user_seek_end";
    /** 视频播放结束（code=0） */ DataState["END"] = "PLAYER:end";
    /** 视频播放出错（非致命，各类重试逻辑写入） */ DataState["ERROR"] = "PLAYER:error";
    /** 视频播放出错 （致命，视频播放结束） */ DataState["FATAL_ERROR"] = "PLAYER:fatal_error";
    /** 首次开播 */ DataState["FIRST_PLAY"] = "PLAYER:firstPlay";
    /** 播放器进入IDLE状态 */ DataState["IDLE"] = "PLAYER:idle";
    /** 播放器进入播放状态 */ DataState["PLAYING"] = "PLAYER:playing";
    DataState["SET_LEVEL"] = "PLAYER:setLevel";
    /** 内核层切换清晰度开始 */ DataState["SET_LEVEL_START"] = "PLAYER:setLevel_start";
    /** 内核层切换清晰度结束 */ DataState["SET_LEVEL_END"] = "PLAYER:setLevel_end";
    DataState["PAUSE"] = "PLAYER:pause";
    /** 播放器进入暂停状态 */ DataState["PAUSE_START"] = "PLAYER:pause_start";
    /** 播放器结束暂停状态 */ DataState["PAUSE_END"] = "PLAYER:pause_end";
    /** 设定倍速 */ DataState["SET_RATE"] = "PLAYER:setRate";
    /** 进行后备地址重试 */ DataState["RETRY_BACKURL"] = "PLAYER:retryBackUrl";
    /** 进行播放级别重试 */ DataState["RETRY_PLAY"] = "PLAYER:retryPlay";
    /** 自动播放被阻止 */ DataState["AUTO_PLAY_BLOCKED"] = "PLAYER:autoplayBlocked";
    /** 编码降级 */ DataState["CODEC_DEGRADE"] = "PLAYER:codecDegrade";
    /** 用户是否打开了devTools面板 */ DataState["DT_OPEN"] = "PLAYER:dtOpen";
})(DataState || (DataState = {}));
var LogType;
(function(LogType) {
    /** 用户操作 */ LogType["USER_ACTION"] = "log:userAction";
    /** 插件行为 */ LogType["PLUGIN_ACTION"] = "log:pluginAction";
    /** 播放内核事件/状态流转 */ LogType["CORE_EVENT"] = "log:coreEvent";
    /** 外部API调用 */ LogType["API_INVOKE"] = "log:apiInvoke";
    /** （默认）未分类 */ LogType["UNCATEGORIZED"] = "log:uncategorized";
})(LogType || (LogType = {}));
var BufferReason;
(function(BufferReason) {
    BufferReason[BufferReason["NETWORK_UNSTABLE"] = 1400027] = "NETWORK_UNSTABLE";
    BufferReason[BufferReason["PARALLEL_DOWNLOAD"] = 1400028] = "PARALLEL_DOWNLOAD";
    BufferReason[BufferReason["CDN_NO_CONNECTION"] = 1400007] = "CDN_NO_CONNECTION";
    BufferReason[BufferReason["CDN_URL_SWITCH_SUCCESS"] = 1400029] = "CDN_URL_SWITCH_SUCCESS";
    BufferReason[BufferReason["CDN_SLOW"] = 1400030] = "CDN_SLOW";
    BufferReason[BufferReason["CDN_URL_SWITCH_UNSUCCESS"] = 1400031] = "CDN_URL_SWITCH_UNSUCCESS";
    BufferReason[BufferReason["CDN_TIMEOUT"] = 1400026] = "CDN_TIMEOUT";
    BufferReason[BufferReason["CDN_TIMEOUT_URL_SWITCH"] = 1400032] = "CDN_TIMEOUT_URL_SWITCH";
    BufferReason[BufferReason["BYTERATE_ERROR"] = 1400033] = "BYTERATE_ERROR";
    BufferReason[BufferReason["DOWNLOAD_TOO_SHORT"] = 1400034] = "DOWNLOAD_TOO_SHORT";
    BufferReason[BufferReason["P2P_UPLOAD_SLOW"] = 1400035] = "P2P_UPLOAD_SLOW";
    BufferReason[BufferReason["DEFAULT"] = 0] = "DEFAULT";
})(BufferReason || (BufferReason = {}));
var LocalKey;
(function(LocalKey) {
    LocalKey["GUID"] = "thumbplayer-h5-guid";
    LocalKey["VOLUME"] = "thumbplayer-h5-volume";
    LocalKey["MUTED"] = "thumbplayer-h5-volume:muted";
})(LocalKey || (LocalKey = {}));
var PersistedUserSettings;
(function(PersistedUserSettings) {
    /** 清晰度 */ PersistedUserSettings["definition"] = "user-setting:definition";
    /** 音量 */ PersistedUserSettings["volume"] = "user-setting:volume";
    /** 倍速 */ PersistedUserSettings["playbackRate"] = "user-setting:playbackRate";
    /** 字幕 */ PersistedUserSettings["subtitle"] = "user-setting:subtitle";
    /** 音轨（hls独有） */ PersistedUserSettings["audioTrack"] = "user-setting:audioTrack";
    /** 用户编码偏好 */ PersistedUserSettings["preferCodec"] = "user-setting:preferCodec";
})(PersistedUserSettings || (PersistedUserSettings = {}));
/** 数据中心默认收集的公共字段 */ var DEFAULT_KEY = {
    // 登录态相关
    logintype: '',
    hh_ip: '',
    hc_main_login: '',
    hc_vuserid: '',
    hc_openid: '',
    hc_appid: '',
    hc_access_token: '',
    hc_vuession: '',
    qimeiH38: '',
    qimeiQ36: '',
    vip: 0,
    /** codec名称,参考vod-getinfo/enums::VideoType的值 */ codec: '',
    /** codec的id,参考vod-getinfo/enums::VideoType的键 */ codecId: 0,
    freetype: 0,
    // 设备相关
    videoCapability: '',
    mobile: 0,
    guid: '',
    ua: '',
    uip: '',
    device: '',
    resolution: '',
    osver: '',
    // SDK相关
    p2pver: '',
    appVer: '',
    /** 带灰度版本号的播放器版本号 */ grayPlayerver: '',
    playerver: '',
    playertype: 0,
    playercore: '',
    confid: '',
    // 播放环境相关
    downloadkit: 0,
    online: 1,
    p2p: 0,
    sstrength: 0,
    network: 0,
    /** 测试id */ testid: 0,
    /** 当前播放内核 */ curcore: '',
    /** 环境内可用的播放内核 */ curcorever: '',
    // 下载组件相关
    speed: 0,
    quic: 0,
    // 播放相关
    /** 平台号 */ platform: '',
    /** 播放流水号，日志的凭证，表示单次播放 */ flowid: '',
    /** 视频id，点播的vid/直播的cnlid */ vid: '',
    /** 专辑号coverid */ cid: '',
    /** 点播视频栏目ID */ columnId: '',
    /** 直播的节目id */ livepid: '',
    /** 互动剧id */ interactid: '',
    /** 当前页面的url */ url: '',
    /** 当前页面的referrer */ referrer: '',
    /** 当前页面的顶级url */ topUrl: '',
    /** 是否启用加密播放 */ drm: 0,
    /** 实际播放中的drm类型 */ drmtype: 0,
    // getinfo返回相关
    /** 视频的清晰度编号 */ fmt: 0,
    /** 重定向服务返回的cdn id */ cdnid: 0,
    /** 重定向服务返回的视频文件格式 */ dltype: '',
    /** 视频的码率 */ rate: 0,
    /** 视频的分片数 */ clip: 0,
    /** 视频状态码 */ status: 0,
    /** 视频时长 */ duration: 0,
    /** 视频是否命中预加载 */ isPreload: 0,
    /** 视频类型 */ type: 0,
    cdnuip: '',
    cdnip: '',
    // 其他信息
    ptag: '',
    sdtfrom: '',
    authfrom: '',
    // 播放器插件间共享的状态信息
    currentDefnList: [],
    currentDefn: '',
    currentAudioTrack: 0,
    currentAudioTrackList: [],
    currentSubtitle: '',
    currentSubtitleList: [],
    /** 一个session中的缓冲次数 */ sessionBufferCount: 0,
    /** 一个session中的备份url重试次数 */ sessionRetryBackUrlCount: 0,
    /** 一个session中的播放级别重试次数 */ sessionRetryPlayCount: 0,
    ckeytime: -1,
    ckeydg: 0,
    /** 是否有检测到“坏人”调试过 */ deved: 0,
    deviceScore: 0,
    /** 屏幕信息 (TEE使用）*/ TEE_screen: {},
    /** 是否使用的直出数据 */ isUseSrvData: false,
    /** 直出数据是否非法 */ isSrvDataInvaild: false,
    /** 伪直播pid */ fakeLivePid: '',
    /** 伪直播chid */ fakeLiveChid: '',
    /** 腾讯视频频道 id */ categoryType: -1,
    /**
   * 弹幕开启状态
   * -1: 无弹幕组件或未设置此 key
   * 0: 关闭
   * 1: 开启
   */ dmkState: -1,
    /**
   * 专供 v 站点播排查弹幕占用率问题使用，由弹幕组件更新到 dataset
   * 弹幕渲染状态
   * -1: 无弹幕组件或未设置此 key
   * 0: css 模式
   * 1: cocos 模式
   */ dmkEngine: -1,
    /**
   * 在本次播放 Session 中，弹幕是否已经因为丢帧而产生降级，需要结合 dmkEngine 判断
   * 重新开始新的播放 Session 时会重置
   *
   * 0: 未降级
   * 1: 前置判断需要降级
   * 2: 弹幕丢帧需要降级
   * 3: video 标签丢帧需要弹幕降级
   */ dmkDegraded: 0
};
/** 数据中心的key映射 */ var COMMON_DATA_KEY = {};
Object.keys(DEFAULT_KEY).forEach(function(key) {
    return COMMON_DATA_KEY[key] = key;
});

var FreezeKey = 'thumbplayer-h5-dataset';
var _obj$2;
var KeySystemToDrmType = (_obj$2 = {}, _$2(_obj$2, DrmKeySystems.Widevine, DRM_TYPE.WIDEVINE), _$2(_obj$2, DrmKeySystems.FairPlay, DRM_TYPE.FAIR_PLAY), _$2(_obj$2, DrmKeySystems.FairPlayWebKit, DRM_TYPE.FAIR_PLAY), _$2(_obj$2, "none", DRM_TYPE.NONE), _obj$2);
/** 部分具有特征和特殊含义的配置项上报ID */ var confIdMap = {
    default: 0,
    /** hls内核渐进式加载 */ hlsProgressive: 1,
    /** hls内核预加载分片 */ hlsFragPrefetch: 2
};
/**
 * thumbplayer-h5 内置数据中心插件
 *
 * 插件提供设备信息，自动记录的step上报信息和播放信息，提供外部接口调取和设定数据
 */ var DataSet = /*#__PURE__*/ function(Plugin) {
    _$4(DataSet, Plugin);
    var _super = _$5(DataSet);
    function DataSet(player, config, extra) {
        _$1(this, DataSet);
        var _this;
        _this = _super.call(this, player, config, extra);
        _$2(_$6(_this), "player", void 0);
        /** 公共包头以及vinfo信息等 */ _$2(_$6(_this), "commonMap", void 0);
        /** 播放器事件记录 */ _$2(_$6(_this), "stateMap", void 0);
        /** 是否在seeking过程 */ _$2(_$6(_this), "isSeeking", void 0);
        /** 是否正在缓冲 */ _$2(_$6(_this), "isBuffering", void 0);
        /** 是否正在切换清晰度 */ _$2(_$6(_this), "isSettingLevel", void 0);
        /** 是否正在加载 */ _$2(_$6(_this), "isLoading", void 0);
        /** 播放事件时间戳 */ _$2(_$6(_this), "lastPlay", void 0);
        /** 用户播放时长 */ _$2(_$6(_this), "playDuration", void 0);
        /** 用于累计timeupdate的时长，每来一次timeupdate */ _$2(_$6(_this), "prevPlayTimeS", void 0);
        /** 累计一个session内的总缓冲次数 */ _$2(_$6(_this), "sessionBufferCount", void 0);
        /** 累计一个session中的url重试次数 */ _$2(_$6(_this), "sessionRetryBackUrlCount", void 0);
        /** 累计一个session中的播放级别重试次数 */ _$2(_$6(_this), "sessionRetryPlayCount", void 0);
        /** commonMap freeze字段 */ _$2(_$6(_this), "commonMapFreeze", void 0);
        /** stateMap freeze字段 */ _$2(_$6(_this), "stateMapFreeze", void 0);
        /** 是否是直播 */ _$2(_$6(_this), "isLive", void 0);
        /** 是否在播放广告 */ _$2(_$6(_this), "isAdPlaying", void 0);
        /** eventId map */ _$2(_$6(_this), "evtIdMap", void 0);
        /**
   * 设定字段值，如果有传入freezeKey则尝试冻结
   * @param key 字段key
   * @param value 字段值
   * @param freezeKey 冻结字段的key
   * @return boolean
   */ _$2(_$6(_this), "writeCommon", void 0);
        /**
   * 设定字段值，如果有传入freezeKey则尝试冻结
   * @param key 字段key
   * @param value 字段值，这里会补全ftime，name，eventId，stats包
   * @param freezeKey 冻结字段的key
   * @return boolean
   */ _$2(_$6(_this), "writeState", void 0);
        /** 播放器被关闭时，立刻返回最终结果 */ _$2(_$6(_this), "onClose", void 0);
        /** 获取当前的stats，用户播放时长，visualStats */ _$2(_$6(_this), "getStats", void 0);
        /**
   * 生成新的flowid
   */ _$2(_$6(_this), "generateFlowId", void 0);
        /** 生成新的eventId */ _$2(_$6(_this), "generateEvtId", void 0);
        _$2(_$6(_this), "getStartEventData", void 0);
        /**
   * 清空当前正在进行的seek和buffer
   */ _$2(_$6(_this), "resetState", void 0);
        _$2(_$6(_this), "finalCleanup", void 0);
        /**
   * 自动播放被拦截
   */ _$2(_$6(_this), "onAutoplayBlocked", void 0);
        /**
   * 前贴广告播放中
   */ _$2(_$6(_this), "onAdPlaying", void 0);
        /**
   * 前贴广告播放结束
   */ _$2(_$6(_this), "onAdEnd", void 0);
        /**
   * 播放器加载失败进行地址重试时的回调
   */ _$2(_$6(_this), "onRetryLoad", void 0);
        _$2(_$6(_this), "onRetryPlay", void 0);
        /**
   * 播放器状态切换为buffering时的回调
   *
   * 1.如果上一个buffer还未结束则跳过（如果buffer之后pause）
   */ _$2(_$6(_this), "onBuffering", void 0);
        /**
   * 播放器状态切换为loadStart时的回调
   *
   * 1.清空正在发生的buffer和seek事件
   * 2.设定当前播放器内核
   * 3.如果播放器下一个状态为canplay则标记load结束
   */ _$2(_$6(_this), "onLoadStart", void 0);
        /**
   * 播放器状态切换为End时的回调, 这里是正常播放结束，如果报错不会走到end状态
   *
   * 1.统计本次播放内的seek和buffer事件
   * 2.统计本次播放时用户的播放时长
   *
   */ _$2(_$6(_this), "onEnd", void 0);
        /**
   * 播放器状态切换为idle时的回调，一般是播放结束END后或报错后
   * 这里需要注意，如果外部拦截error执行重试操作，播放器都会进入idle状态再重新开播，但是日志和上报都应该被认为是同次播放
   */ _$2(_$6(_this), "onIdle", void 0);
        /**
   * 播放器状态切换为seeking时的回调
   *
   * 1.如果正在seek则标记seek为结束并开始下一次seek
   * 2.如果正在buffer则抛弃这次buffer
   */ _$2(_$6(_this), "onSeeking", void 0);
        /**
   * 播放器状态切换为seeked时的回调
   *
   * 1.如果正在seek则标记seek为结束
   */ _$2(_$6(_this), "onSeeked", void 0);
        /**
   * 播放器状态切换为pause时的回调
   */ _$2(_$6(_this), "onPause", void 0);
        /**
   * 播放器状态切换为playing时的回调
   *
   * 1.更新播放开始的时间戳
   */ _$2(_$6(_this), "onPlaying", void 0);
        /**
   * 播放器状态切换为canplay时的回调
   *
   * 1. 如果有正在进行的buffer则标记buffer为结束
   */ _$2(_$6(_this), "onCanPlay", void 0);
        _$2(_$6(_this), "onCodecDegrade", void 0);
        /**
   * 播放器开始切换清晰度时的监听回调
   *
   * 1.如果有正在进行的seek事件，标记seek结束
   * 2.清空正在进行的buffer事件
   */ _$2(_$6(_this), "onSetLevelStart", void 0);
        /**
   * 播放器结束清晰度切换时的监听回调
   */ _$2(_$6(_this), "onSetLevelEnd", void 0);
        /**
   * 播放器报错时的回调
   *
   * 更新报错前播放器最后的状态，
   * ！！注意这里stats已经无法取值了，需要从error的videoinfo上获取
   */ _$2(_$6(_this), "onError", void 0);
        /**
   * 播放器DURATION变更的监听回调
   *
   * 更新播放器视频时长
   */ _$2(_$6(_this), "onDurationChange", void 0);
        /**
   * 播放器FIRST_PLAYING变更的监听回调
   *
   * 记录首播时间
   */ _$2(_$6(_this), "onFirstPlay", void 0);
        /**
   * 播放器PLAY_TIME变更的监听回调
   *
   * 更新用户真实播放时长
   */ _$2(_$6(_this), "onTimeChange", void 0);
        /** 播放器VIDEO_STATE变更的监听回调 */ _$2(_$6(_this), "onStateChange", void 0);
        /** 倍速切换 */ _$2(_$6(_this), "onRateChange", void 0);
        /** GETINFO开始 */ _$2(_$6(_this), "onVideoReqInfoStart", void 0);
        /** GETINFO结束 */ _$2(_$6(_this), "onVideoReqInfoEnd", void 0);
        _$2(_$6(_this), "onFlowNodeStart", void 0);
        /** play session开始，生成flowid */ _$2(_$6(_this), "onPlaySessionStart", void 0);
        _$2(_$6(_this), "onPlaySessionEnd", void 0);
        /** AD */ /**
   * 获取GUID，如果localStorage没有GUID则生成新的GUID
   */ _$2(_$6(_this), "getGUID", void 0);
        /** 标签是否可见，1:可见，0:不可见，-1:未知 */ _$2(_$6(_this), "isTabFocused", void 0);
        /** 播放器容器元素是否在屏幕内 */ _$2(_$6(_this), "isPlayerInViewport", void 0);
        _this.player = player;
        _this.isSeeking = false;
        _this.isBuffering = false;
        _this.isSettingLevel = false;
        _this.isLoading = false;
        _this.lastPlay = 0;
        _this.playDuration = 0;
        _this.prevPlayTimeS = 0;
        _this.sessionBufferCount = 0;
        _this.sessionRetryBackUrlCount = 0;
        _this.sessionRetryPlayCount = 0;
        _this.commonMapFreeze = {};
        _this.stateMapFreeze = {};
        _this.isLive = false;
        _this.isAdPlaying = false;
        _this.evtIdMap = {};
        _this.writeCommon = function(key, value, freezeKey) {
            var oldVal = _this.commonMap[key];
            _this.commonMap[key] = value;
            if (!DataSet.canUseProxy) {
                _this.emit(DataEvents.UPDATE, {
                    key: key,
                    oldVal: oldVal,
                    newVal: value
                });
            }
            if (freezeKey) return _this.freeze('common', key, freezeKey);
            return false;
        };
        _this.writeState = function(key, value, freezeKey) {
            var type = value.type || LogType.UNCATEGORIZED;
            var oldVal = _this.stateMap[key];
            var prevStateData = _this.getStartEventData(key);
            _this.stateMap[key] = _$b(_$c(_$b({}, type === LogType.CORE_EVENT ? _this.stats : {}), {
                type: type,
                ftime: +new Date(),
                name: key,
                eventId: _this.generateEvtId()
            }), value);
            if (!DataSet.canUseProxy && _this.commonMap[COMMON_DATA_KEY.flowid]) {
                _this.emit(DataEvents.STATE_UPDATE, {
                    key: key,
                    oldVal: oldVal,
                    newVal: _this.stateMap[key],
                    startEvent: prevStateData
                });
            }
            if (freezeKey) return _this.freeze('state', key, freezeKey);
            return false;
        };
        _this.onClose = function() {
            var now = +new Date();
            return {
                code: ErrorCode.SUC,
                playDuration: _this.playDuration,
                ftime: now
            };
        };
        _this.getStats = function() {
            return _$b({
                playDuration: _this.playDuration
            }, _this.stats, _this.visualStats);
        };
        _this.generateFlowId = function() {
            return commonTool.createGUID(32);
        };
        _this.generateEvtId = function() {
            return commonTool.createGUID(8);
        };
        _this.getStartEventData = function(eventName) {
            var _obj;
            var eventMap = (_obj = {}, _$2(_obj, DataState.SEEK_END, _this.stateMap[DataState.SEEK_START]), _$2(_obj, DataState.BUFFER_END, _this.stateMap[DataState.BUFFER_START]), _$2(_obj, DataState.LOAD_END, _this.stateMap[DataState.LOAD_START]), _$2(_obj, DataState.SET_LEVEL_END, _this.stateMap[DataState.SET_LEVEL_START]), _$2(_obj, DataState.PAUSE_END, _this.stateMap[DataState.PAUSE_START]), _$2(_obj, DataState.GET_INFO_END, _this.stateMap[DataState.GET_INFO_START]), _obj);
            return eventMap[eventName];
        };
        _this.resetState = function() {
            _this.isBuffering = false;
            _this.isSeeking = false;
            _this.isSettingLevel = false;
        };
        _this.finalCleanup = function(now, videoInfo) {
            var _config_backupUrls;
            var error = videoInfo.error, loadingUrl = videoInfo.loadingUrl, _$config = videoInfo.config;
            var _config_backupUrls_findIndex;
            var urlIdx = (_config_backupUrls_findIndex = _$config === null || _$config === void 0 ? void 0 : (_config_backupUrls = _$config.backupUrls) === null || _config_backupUrls === void 0 ? void 0 : _config_backupUrls.findIndex(function(i) {
                return i === loadingUrl;
            })) !== null && _config_backupUrls_findIndex !== void 0 ? _config_backupUrls_findIndex : -1;
            if (_this.isSeeking) {
                _this.writeState(DataState.SEEK_END, {
                    currentUrl: loadingUrl,
                    urlIndex: urlIdx,
                    type: LogType.CORE_EVENT,
                    ftime: now,
                    error: error,
                    code: (error === null || error === void 0 ? void 0 : error.code) || ErrorCode.SUC,
                    name: DataState.SEEK_END,
                    eventId: _this.evtIdMap[DataState.SEEK_START]
                });
                _this.isSeeking = false;
            }
            if (_this.isBuffering) {
                _this.writeState(DataState.BUFFER_END, {
                    currentUrl: loadingUrl,
                    urlIndex: urlIdx,
                    type: LogType.CORE_EVENT,
                    ftime: now,
                    code: (error === null || error === void 0 ? void 0 : error.code) || ErrorCode.SUC,
                    error: error,
                    name: DataState.BUFFER_END,
                    eventId: _this.evtIdMap[DataState.BUFFER_START]
                });
                _this.isBuffering = false;
            }
            if (_this.isSettingLevel) {
                _this.isSettingLevel = false;
                _this.writeState(DataState.SET_LEVEL_END, {
                    currentUrl: loadingUrl,
                    urlIndex: urlIdx,
                    type: LogType.CORE_EVENT,
                    ftime: now,
                    code: (error === null || error === void 0 ? void 0 : error.code) || ErrorCode.SUC,
                    error: error,
                    name: DataState.SET_LEVEL_END,
                    eventId: _this.evtIdMap[DataState.SET_LEVEL_START]
                });
            }
            if (_this.isLoading) {
                _this.isLoading = false;
                _this.writeState(DataState.LOAD_END, {
                    type: LogType.CORE_EVENT,
                    currentUrl: loadingUrl,
                    urlIndex: urlIdx,
                    ftime: now,
                    error: error,
                    code: (error === null || error === void 0 ? void 0 : error.code) || ErrorCode.SUC,
                    name: DataState.LOAD_END,
                    eventId: _this.evtIdMap[DataState.LOAD_START]
                });
            }
            _this.isAdPlaying = false;
        };
        _this.onAutoplayBlocked = function() {
            _this.writeState(DataState.AUTO_PLAY_BLOCKED, {
                type: LogType.CORE_EVENT,
                name: DataState.AUTO_PLAY_BLOCKED,
                eventId: _this.generateEvtId(),
                ftime: +new Date()
            });
        };
        _this.onAdPlaying = function(evt) {
            if (evt.data.adType !== AdType.PRE) return;
            _this.isAdPlaying = true;
        };
        _this.onAdEnd = function(evt) {
            if (evt.data.adType !== AdType.PRE) return;
            _this.isAdPlaying = false;
        };
        _this.onRetryLoad = function(evt) {
            var data = evt.data;
            var prevUrl = data.prevUrl, curUrl = data.curUrl, _data_error = data.error, error = _data_error === void 0 ? {} : _data_error;
            _this.writeState(DataState.RETRY_BACKURL, {
                type: LogType.CORE_EVENT,
                name: DataState.RETRY_BACKURL,
                eventId: _this.generateEvtId(),
                prevUrl: prevUrl,
                currentUrl: curUrl,
                ftime: +new Date(),
                error: error,
                code: error === null || error === void 0 ? void 0 : error.code
            });
            // 累计url重试缓冲次数
            _this.sessionRetryBackUrlCount++;
            _this.writeCommon(COMMON_DATA_KEY.sessionRetryBackUrlCount, _this.sessionRetryBackUrlCount);
        };
        _this.onRetryPlay = function(evt) {
            var data = evt.data;
            var _data_retryTimes = data.retryTimes, retryTimes = _data_retryTimes === void 0 ? 0 : _data_retryTimes;
            _this.writeState(DataState.RETRY_PLAY, {
                type: LogType.CORE_EVENT,
                name: DataState.RETRY_PLAY,
                eventId: _this.generateEvtId(),
                ftime: +new Date(),
                ext: {
                    retryTimes: retryTimes
                }
            });
            // 累计播放级别重试次数
            _this.sessionRetryPlayCount++;
            _this.writeCommon(COMMON_DATA_KEY.sessionRetryPlayCount, _this.sessionRetryPlayCount);
            if (data.degradeReason > 0) {
                // 大于0代表降级
                _this.onCodecDegrade(evt);
            }
        };
        _this.onBuffering = function(data) {
            // 如果正在缓冲则跳过
            if (_this.isBuffering) return;
            _this.isBuffering = true;
            var eventId = _this.generateEvtId();
            _this.evtIdMap[DataState.BUFFER_START] = eventId;
            _this.writeState(DataState.BUFFER_START, {
                type: LogType.CORE_EVENT,
                name: DataState.BUFFER_START,
                eventId: eventId,
                prevState: data.old,
                ftime: +new Date()
            });
            // 累计缓冲次数
            _this.sessionBufferCount++;
            _this.writeCommon(COMMON_DATA_KEY.sessionBufferCount, _this.sessionBufferCount);
        };
        _this.onLoadStart = function(data) {
            var _data_videoInfo, _KernelFactory_getKernelByName, _currentConfig_drmConfig, _this_player_corePlayer_kernel_getP2P, _this_player_corePlayer_kernel, _this_player_corePlayer, _p2pController_getVersion;
            _this.resetState();
            var currentConfig = (_data_videoInfo = data.videoInfo) === null || _data_videoInfo === void 0 ? void 0 : _data_videoInfo.config;
            var now = +new Date();
            _this.writeCommon(COMMON_DATA_KEY.curcore, _this.player.kernelName);
            var kernelVersion = (_KernelFactory_getKernelByName = KernelFactory.getKernelByName(_this.player.kernelName)) === null || _KernelFactory_getKernelByName === void 0 ? void 0 : _KernelFactory_getKernelByName.VERSION;
            _this.writeCommon(COMMON_DATA_KEY.curcorever, kernelVersion);
            _this.writeCommon(COMMON_DATA_KEY.drmtype, KeySystemToDrmType[((_currentConfig_drmConfig = currentConfig.drmConfig) === null || _currentConfig_drmConfig === void 0 ? void 0 : _currentConfig_drmConfig.keySystem) || 'none']);
            _this.writeCommon(COMMON_DATA_KEY.playertype, _this.player.kernelName === KERNEL_NAME.ORIGIN ? '0' : '1');
            var p2pController = (_this_player_corePlayer = _this.player.corePlayer) === null || _this_player_corePlayer === void 0 ? void 0 : (_this_player_corePlayer_kernel = _this_player_corePlayer.kernel) === null || _this_player_corePlayer_kernel === void 0 ? void 0 : (_this_player_corePlayer_kernel_getP2P = _this_player_corePlayer_kernel.getP2P) === null || _this_player_corePlayer_kernel_getP2P === void 0 ? void 0 : _this_player_corePlayer_kernel_getP2P.call(_this_player_corePlayer_kernel);
            var _p2pController_getVersion1;
            _this.writeCommon(COMMON_DATA_KEY.p2pver, (_p2pController_getVersion1 = p2pController === null || p2pController === void 0 ? void 0 : (_p2pController_getVersion = p2pController.getVersion) === null || _p2pController_getVersion === void 0 ? void 0 : _p2pController_getVersion.call(p2pController)) !== null && _p2pController_getVersion1 !== void 0 ? _p2pController_getVersion1 : 0);
            // 如果没有下载组件 则不上报p2p
            _this.writeCommon(COMMON_DATA_KEY.p2p, p2pController ? '1' : '0');
            // 如果是hls内核，又没有p2p组件，上报一个特殊的配置id
            if (_this.player.kernelName === KERNEL_NAME.HLS_JS && !p2pController) {
                var _this_player_config_enableP2P;
                var enableP2P = +((_this_player_config_enableP2P = _this.player.config.enableP2P) !== null && _this_player_config_enableP2P !== void 0 ? _this_player_config_enableP2P : 2);
                var p2pConfig = +!!_this.player.currentVideoInfo.config.p2pConfig;
                _this.writeCommon(COMMON_DATA_KEY.confid, "7003".concat(enableP2P).concat(p2pConfig));
            }
            _this.isLoading = true;
            var eventId = _this.generateEvtId();
            _this.evtIdMap[DataState.LOAD_START] = eventId;
            _this.writeState(DataState.LOAD_START, {
                type: LogType.CORE_EVENT,
                eventId: eventId,
                name: DataState.LOAD_START,
                ftime: now
            });
        };
        _this.onEnd = function() {
            _this.writeState(DataState.END, {
                type: LogType.CORE_EVENT,
                name: DataState.END,
                eventId: _this.generateEvtId(),
                ftime: +new Date(),
                ext: {
                    playDuration: _this.playDuration
                },
                code: ErrorCode.SUC
            });
        };
        _this.onIdle = function() {};
        _this.onSeeking = function(data) {
            var time = +new Date();
            if (_this.isSeeking) {
                var _this_stateMap_DATA_STATE_SEEK_START_ext, _this_stateMap_DATA_STATE_SEEK_START;
                _this.writeState(DataState.SEEK_END, {
                    type: LogType.CORE_EVENT,
                    name: DataState.SEEK_END,
                    ftime: time,
                    eventId: _this.evtIdMap[DataState.SEEK_START],
                    ext: {
                        isUserSeek: ((_this_stateMap_DATA_STATE_SEEK_START = _this.stateMap[DataState.SEEK_START]) === null || _this_stateMap_DATA_STATE_SEEK_START === void 0 ? void 0 : (_this_stateMap_DATA_STATE_SEEK_START_ext = _this_stateMap_DATA_STATE_SEEK_START.ext) === null || _this_stateMap_DATA_STATE_SEEK_START_ext === void 0 ? void 0 : _this_stateMap_DATA_STATE_SEEK_START_ext.isUserSeek) || false
                    }
                });
            }
            // 直播状态下buffer不可以被抛弃
            if (!_this.isLive) _this.resetState();
            _this.isSeeking = true;
            var eventId = _this.generateEvtId();
            _this.evtIdMap[DataState.SEEK_START] = eventId;
            _this.writeState(DataState.SEEK_START, {
                type: LogType.CORE_EVENT,
                ftime: time,
                name: DataState.SEEK_START,
                eventId: eventId,
                ext: {
                    inBufferedRange: videoTool.checkTimeInBuffer(data.seekingTime, _this.player.videoBuffered),
                    isUserSeek: data.isUserSeek
                }
            });
        };
        _this.onSeeked = function(data) {
            if (!_this.isSeeking) return;
            _this.isSeeking = false;
            _this.writeState(DataState.SEEK_END, {
                type: LogType.CORE_EVENT,
                eventId: _this.evtIdMap[DataState.SEEK_START],
                ftime: +new Date(),
                name: DataState.SEEK_END,
                ext: {
                    isUserSeek: data.isUserSeek
                },
                code: ErrorCode.SUC
            });
        };
        _this.onPause = function(data) {
            var pauseType = data.pauseType;
            var eventId = _this.generateEvtId();
            _this.evtIdMap[DataState.PAUSE_START] = eventId;
            _this.writeState(DataState.PAUSE_START, {
                type: LogType.CORE_EVENT,
                ftime: +new Date(),
                name: DataState.PAUSE_START,
                eventId: eventId,
                pauseType: pauseType
            });
        };
        _this.onPlaying = function() {
            var now = +new Date();
            if (_this.isBuffering) {
                // hls相关的缓冲信息
                _this.writeState(DataState.BUFFER_END, {
                    type: LogType.CORE_EVENT,
                    name: DataState.BUFFER_END,
                    ftime: now,
                    eventId: _this.evtIdMap[DataState.BUFFER_START]
                });
                _this.isBuffering = false;
            }
            _this.lastPlay = now;
            if (_this.evtIdMap[DataState.PAUSE_START]) {
                _this.writeState(DataState.PAUSE_END, {
                    type: LogType.CORE_EVENT,
                    name: DataState.PAUSE_END,
                    eventId: _this.evtIdMap[DataState.PAUSE_START],
                    ftime: now,
                    code: ErrorCode.SUC
                });
                delete _this.evtIdMap[DataState.PAUSE_START];
            }
        };
        _this.onCanPlay = function(data) {
            if (!_this.isLoading) return;
            var now = +new Date();
            _this.writeState(DataState.LOAD_END, {
                type: LogType.CORE_EVENT,
                ftime: now,
                name: DataState.LOAD_END,
                eventId: _this.evtIdMap[DataState.LOAD_START],
                code: ErrorCode.SUC,
                ext: {
                    isAdPlaying: _this.isAdPlaying
                },
                isContiguous: data.isContiguous
            });
            _this.isLoading = false;
        };
        _this.onCodecDegrade = function(evt) {
            var now = +new Date();
            var _evt_data_degradeReason;
            _this.writeState(DataState.CODEC_DEGRADE, {
                type: LogType.CORE_EVENT,
                ftime: now,
                name: DataState.CODEC_DEGRADE,
                code: (_evt_data_degradeReason = evt.data.degradeReason) !== null && _evt_data_degradeReason !== void 0 ? _evt_data_degradeReason : ErrorCode.SUC
            });
        };
        _this.onSetLevelStart = function(evt) {
            var time = +new Date();
            if (_this.isSeeking) {
                _this.isSeeking = false;
                _this.writeState(DataState.SEEK_END, {
                    type: LogType.CORE_EVENT,
                    name: DataState.SEEK_END,
                    ftime: time,
                    eventId: _this.evtIdMap[DataState.SEEK_START]
                });
            }
            _this.resetState();
            _this.isSettingLevel = true;
            var eventId = _this.generateEvtId();
            _this.evtIdMap[DataState.SET_LEVEL_START] = eventId;
            _this.writeState(DataState.SET_LEVEL_START, {
                type: LogType.CORE_EVENT,
                ftime: time,
                eventId: eventId,
                name: DataState.SET_LEVEL_START,
                ext: {
                    defn: _this.commonMap.currentDefn,
                    mode: evt.data.mode
                }
            });
        };
        _this.onSetLevelEnd = function(evt) {
            var _evt_data = evt.data, data = _evt_data === void 0 ? {} : _evt_data;
            var videoInfo = data.videoInfo;
            var error = (videoInfo || {}).error;
            _this.isSettingLevel = false;
            // 切清晰度可能切换内核
            _this.writeCommon(COMMON_DATA_KEY.curcore, _this.player.kernelName);
            _this.writeState(DataState.SET_LEVEL_END, {
                type: LogType.CORE_EVENT,
                name: DataState.SET_LEVEL_END,
                ftime: +new Date(),
                eventId: _this.evtIdMap[DataState.SET_LEVEL_START],
                error: error,
                code: (error === null || error === void 0 ? void 0 : error.code) || ErrorCode.SUC
            });
        };
        _this.onError = function(evt) {
            var _config_backupUrls;
            var data = evt.data;
            var videoInfo = (data || {}).videoInfo;
            var _ref = videoInfo || {}, error = _ref.error, state = _ref.state, currentFragSn = _ref.currentFragSn, currentFragUrl = _ref.currentFragUrl, loadingUrl = _ref.loadingUrl, _$config = _ref.config;
            var now = +new Date();
            var _config_backupUrls_findIndex;
            _this.writeState(DataState.ERROR, {
                currentUrl: loadingUrl,
                urlIndex: (_config_backupUrls_findIndex = _$config === null || _$config === void 0 ? void 0 : (_config_backupUrls = _$config.backupUrls) === null || _config_backupUrls === void 0 ? void 0 : _config_backupUrls.findIndex(function(i) {
                    return i === loadingUrl;
                })) !== null && _config_backupUrls_findIndex !== void 0 ? _config_backupUrls_findIndex : -1,
                type: LogType.CORE_EVENT,
                name: DataState.ERROR,
                eventId: _this.generateEvtId(),
                fragUrl: currentFragUrl,
                ext: {
                    fragSn: currentFragSn
                },
                code: error.code,
                error: error,
                ftime: now,
                prevState: state
            });
            _this.finalCleanup(now, videoInfo);
        };
        _this.onDurationChange = function(evt) {
            var _evt_data = evt.data, data = _evt_data === void 0 ? {} : _evt_data;
            var videoInfo = data.videoInfo;
            var _ref = videoInfo || {}, _ref_duration = _ref.duration, duration = _ref_duration === void 0 ? 0 : _ref_duration;
            _this.commonMap.duration = duration;
        };
        _this.onFirstPlay = function(param) {
            var data = param.data;
            var now = +new Date();
            _this.writeState(DataState.FIRST_PLAY, {
                type: LogType.CORE_EVENT,
                name: DataState.FIRST_PLAY,
                ftime: now,
                eventId: _this.generateEvtId(),
                isContiguous: data.isContiguous
            });
        };
        _this.onTimeChange = function() {
            var timeS = Math.floor(_this.player.playtime);
            if (!timeS) return;
            if (timeS === _this.prevPlayTimeS) return;
            _this.prevPlayTimeS = timeS;
            if (!_this.playDuration) _this.playDuration = 0;
            _this.playDuration += 1;
        };
        _this.onStateChange = function(evt) {
            var data = evt.data;
            var newState = data.new;
            var _obj;
            var stateHandlerMap = (_obj = {}, _$2(_obj, VIDEO_STATE.BUFFERING, _this.onBuffering), _$2(_obj, VIDEO_STATE.LOAD_START, _this.onLoadStart), _$2(_obj, VIDEO_STATE.END, _this.onEnd), _$2(_obj, VIDEO_STATE.IDLE, _this.onIdle), // 用户拖拽才会被记录，监听CTRL_EVENT.MOUSE_DOWN处理
            _$2(_obj, VIDEO_STATE.SEEKING, _this.onSeeking), _$2(_obj, VIDEO_STATE.SEEKED, _this.onSeeked), _$2(_obj, VIDEO_STATE.PAUSE, _this.onPause), _$2(_obj, VIDEO_STATE.PLAYING, _this.onPlaying), _$2(_obj, VIDEO_STATE.CANPLAY, _this.onCanPlay), _obj);
            if (stateHandlerMap[newState]) {
                stateHandlerMap[newState](data);
            }
        };
        _this.onRateChange = function() {
            _this.writeState(DataState.SET_RATE, {
                type: LogType.CORE_EVENT,
                name: DataState.SET_RATE,
                eventId: _this.generateEvtId(),
                ftime: +new Date()
            });
        };
        _this.onVideoReqInfoStart = function() {
            _this.videoReqInfoStart();
        };
        _this.onVideoReqInfoEnd = function(evt) {
            var data = evt.data;
            _this.videoReqInfoEnd(data);
        };
        _this.onFlowNodeStart = function(param) {
            var data = param.data;
            var name = data.name, isContiguous = data.isContiguous;
            // 进入追加的正片节点
            var isContiguousVideoNode = name === FlowNodeName.PLAY_VIDEO && isContiguous;
            if (!isContiguousVideoNode) {
                return;
            }
            // 上一个videoNode的结束
            _this.sessionEnd({
                code: ErrorCode.SUC,
                endState: END_STATE.NORMAL,
                curFlowNodeName: FlowNodeName.PLAY_VIDEO,
                isContiguous: true
            });
            // 说明：目前无法做到不同的session同时上报，并且伪直播的追加节点是预加载ok以后才会跳转过来的，因此追加节点在首缓前的事件都是手动补上去的
            // 本次开播的videoNode的init、getinfo
            _this.sessionStart({
                isPreload: true,
                playItem: data.playItem,
                flowid: data.flowid,
                isContiguous: true
            });
            _this.videoReqInfoStart(true);
            _this.videoReqInfoEnd({
                code: ErrorCode.SUC,
                data: {},
                isContiguous: true
            });
        };
        _this.onPlaySessionStart = function(param) {
            var data = param.data;
            _this.sessionStart(data);
        };
        _this.onPlaySessionEnd = function(evt) {
            var data = evt.data;
            _this.sessionEnd(data);
        };
        _this.getGUID = function() {
            var lsGuid = lsTool.getData(LocalKey.GUID);
            if (lsGuid) {
                return lsGuid;
            }
            var newGuid = commonTool.createGUID(32);
            lsTool.setData(LocalKey.GUID, newGuid);
            return newGuid;
        };
        _this.isTabFocused = function() {
            var hiddenTags = [
                'hidden',
                'msHidden',
                'webkitHidden'
            ];
            var tag = hiddenTags.find(function(i) {
                return typeof document[i] !== 'undefined';
            });
            if (tag) {
                return document[tag] ? 0 : 1;
            }
            return -1;
        };
        _this.isPlayerInViewport = function() {
            var container = _this.player.container;
            if (!container.offsetParent) return 0;
            var rect = container.getBoundingClientRect();
            var windowHeight = window.innerHeight || document.documentElement.clientHeight;
            var windowWidth = window.innerWidth || document.documentElement.clientWidth;
            var vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
            var horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;
            return +(vertInView && horInView);
        };
        // 拦截commonMap的设定，如果成功设定则对外广播update事件并携带新旧值
        _this.commonMap = DataSet.canUseProxy ? new Proxy({}, {
            get: function(target, key, receiver) {
                return Reflect.get(target, key, receiver);
            },
            set: function(target, key, value, receiver) {
                if (typeof key !== 'string') return false;
                if (_this.commonMapFreeze[key]) return false;
                var oldVal = Reflect.get(target, key, receiver);
                var res = Reflect.set(target, key, value, receiver);
                if (oldVal !== value) {
                    _this.emit(DataEvents.UPDATE, {
                        key: key,
                        oldVal: oldVal,
                        newVal: value
                    });
                }
                return res;
            }
        }) : {};
        // 拦截stateMap的设定，如果成功设定则对外广播state update事件并携带新旧值
        _this.stateMap = DataSet.canUseProxy ? new Proxy({}, {
            get: function(target, key, receiver) {
                return Reflect.get(target, key, receiver);
            },
            set: function(target, key, value, receiver) {
                if (typeof key !== 'string') return false;
                if (_this.stateMapFreeze[key]) return false;
                var oldVal = Reflect.get(target, key, receiver);
                var res = Reflect.set(target, key, value, receiver);
                // 只有flowid生成后才广播事件
                if (_this.commonMap[COMMON_DATA_KEY.flowid]) {
                    _this.emit(DataEvents.STATE_UPDATE, {
                        key: key,
                        oldVal: oldVal,
                        newVal: value,
                        startEvent: _this.getStartEventData(key),
                        startEventData: _this.getStartEventData(key)
                    });
                }
                return res;
            }
        }) : {};
        _this.isLive = _this.player.config.type === PLAY_MODE.LIVE;
        _this.logLocalData();
        _this.setEnv();
        _this.collectBaseInfo();
        _this.collectVideoCapability();
        _this.persistUserSetting();
        return _this;
    }
    _(DataSet, [
        {
            key: "stats",
            get: /** 播放器的播控参数 */ function get() {
                var _currentVideoInfo_config_backupUrls, _currentVideoInfo_config, _currentVideoInfo_qualityInfo, _currentVideoInfo_qualityInfo1;
                var _this_player = this.player, playbackRate = _this_player.playbackRate, volume = _this_player.volume, played = _this_player.played, playtime = _this_player.playtime, currentVideoInfo = _this_player.currentVideoInfo;
                var _currentVideoInfo_config_backupUrls_findIndex, _currentVideoInfo_qualityInfo_frameDroppedInPercentage, _currentVideoInfo_qualityInfo_averageDecodeTimeInMs;
                return {
                    volume: volume,
                    playbackRate: playbackRate,
                    played: played,
                    playtime: playtime,
                    urlIndex: (_currentVideoInfo_config_backupUrls_findIndex = currentVideoInfo === null || currentVideoInfo === void 0 ? void 0 : (_currentVideoInfo_config = currentVideoInfo.config) === null || _currentVideoInfo_config === void 0 ? void 0 : (_currentVideoInfo_config_backupUrls = _currentVideoInfo_config.backupUrls) === null || _currentVideoInfo_config_backupUrls === void 0 ? void 0 : _currentVideoInfo_config_backupUrls.findIndex(function(i) {
                        return i === currentVideoInfo.loadingUrl;
                    })) !== null && _currentVideoInfo_config_backupUrls_findIndex !== void 0 ? _currentVideoInfo_config_backupUrls_findIndex : -1,
                    frameDroppedInPercentage: (_currentVideoInfo_qualityInfo_frameDroppedInPercentage = currentVideoInfo === null || currentVideoInfo === void 0 ? void 0 : (_currentVideoInfo_qualityInfo = currentVideoInfo.qualityInfo) === null || _currentVideoInfo_qualityInfo === void 0 ? void 0 : _currentVideoInfo_qualityInfo.frameDroppedInPercentage) !== null && _currentVideoInfo_qualityInfo_frameDroppedInPercentage !== void 0 ? _currentVideoInfo_qualityInfo_frameDroppedInPercentage : -1,
                    averageDecodeTimeInMs: (_currentVideoInfo_qualityInfo_averageDecodeTimeInMs = currentVideoInfo === null || currentVideoInfo === void 0 ? void 0 : (_currentVideoInfo_qualityInfo1 = currentVideoInfo.qualityInfo) === null || _currentVideoInfo_qualityInfo1 === void 0 ? void 0 : _currentVideoInfo_qualityInfo1.averageDecodeTimeInMs) !== null && _currentVideoInfo_qualityInfo_averageDecodeTimeInMs !== void 0 ? _currentVideoInfo_qualityInfo_averageDecodeTimeInMs : -1,
                    currentUrl: currentVideoInfo === null || currentVideoInfo === void 0 ? void 0 : currentVideoInfo.loadingUrl,
                    paused: this.paused,
                    fragUrl: currentVideoInfo === null || currentVideoInfo === void 0 ? void 0 : currentVideoInfo.currentFragUrl
                };
            }
        },
        {
            key: "visualStats",
            get: /** 播放器的视觉信息 */ function get() {
                var isTabFocused = this.isTabFocused();
                var isPlayerInViewport = this.isPlayerInViewport();
                return {
                    isTabFocused: isTabFocused,
                    isPlayerInViewport: isPlayerInViewport
                };
            }
        },
        {
            key: "paused",
            get: /** 是否为暂停状态 */ function get() {
                var _this_player_currentVideoElement, _this_player;
                return (_this_player = this.player) === null || _this_player === void 0 ? void 0 : (_this_player_currentVideoElement = _this_player.currentVideoElement) === null || _this_player_currentVideoElement === void 0 ? void 0 : _this_player_currentVideoElement.paused;
            }
        },
        {
            key: "defrost",
            value: /**
   * 解冻指定字段，需要传入冻结字段时的secret
   * @param target 目标字段集
   * @param key 需要解冻的字段值
   * @param secret 冻结字段时传入的secret用于校验
   * @return boolean true时为解冻成功；false时为解冻失败
   */ function defrost(target, key) {
                var secret = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'secret';
                switch(target){
                    case 'state':
                        if (this.stateMapFreeze[key] === secret) {
                            delete this.stateMapFreeze[key];
                            return true;
                        }
                        return false;
                    case 'common':
                        if (this.commonMapFreeze[key] === secret) {
                            delete this.commonMapFreeze[key];
                            return true;
                        }
                        return false;
                }
            }
        },
        {
            key: "freeze",
            value: /**
   * 冻结指定字段，无法冻结已经冻结的字段；secret可以用于解冻时的校验
   * @param target 目标字段集
   * @param key 需要冻结的字段值
   * @param secret 冻结校验的key
   * @return boolean true时为冻结成功；false时为冻结失败
   */ function freeze(target, key) {
                var secret = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'secret';
                switch(target){
                    case 'state':
                        if (this.stateMapFreeze[key]) {
                            this.player.log("".concat(key, "已锁定"));
                            return false;
                        }
                        this.stateMapFreeze[key] = secret;
                        return true;
                    case 'common':
                        if (this.commonMapFreeze[key]) {
                            this.player.log("".concat(key, "已锁定"));
                            return false;
                        }
                        this.commonMapFreeze[key] = secret;
                        return true;
                    default:
                        return false;
                }
            }
        },
        {
            key: "logLocalData",
            value: /** 打印用户本地缓存 */ function logLocalData() {
                var lsArr = Object.keys(LocalKey).map(function(k) {
                    return "{".concat(k, ": ").concat(lsTool.getData(LocalKey[k]), "}");
                });
                this.log("local data, ".concat(lsArr));
            }
        },
        {
            key: "setEnv",
            value: function setEnv() {
                var _this = this;
                // 监听播放器state change
                this.player.on(PLAY_EVENT.STATE_CHANGE, this.onStateChange);
                // 首播记录
                this.player.on(PLAY_EVENT.FIRST_PLAYING, this.onFirstPlay);
                // 时间更新 (不同浏览器间隔不同，这里throttle一下每秒触发一次)
                this.player.on(PLAY_EVENT.TIME_UPDATE, this.onTimeChange);
                // 长度更新
                this.player.on(PLAY_EVENT.DURATION_CHANGE, this.onDurationChange);
                // 报错
                this.player.on(PLAY_EVENT.ERROR, this.onError);
                // 清晰度切换开始
                this.player.on(PLAY_EVENT.SETLEVEL_START, this.onSetLevelStart);
                // 清晰度切换结束/报错
                this.player.on(PLAY_EVENT.SETLEVEL_OVER, this.onSetLevelEnd);
                // 倍速切换
                this.player.on(PLAY_EVENT.RATE_CHANGE, this.onRateChange);
                // 地址重试
                this.player.on(PLAY_EVENT.RETRY_BACKURL, this.onRetryLoad);
                // 自动播放被拦截
                this.player.on(PLAY_EVENT.AUTOPLAY_BLOCKED, this.onAutoplayBlocked);
                // 前贴广告
                this.player.on(H5_PLAY_EVENT.AD_PLAYING, this.onAdPlaying);
                this.player.on(H5_PLAY_EVENT.AD_END, this.onAdEnd);
                // GETINFO
                this.player.on(H5_PLAY_EVENT.VIDEO_REQ_INFO_START, this.onVideoReqInfoStart);
                this.player.on(H5_PLAY_EVENT.VIDEO_REQ_INFO_END, this.onVideoReqInfoEnd);
                // play session变更
                this.player.on(H5_PLAY_EVENT.PLAY_SESSION_START, this.onPlaySessionStart);
                this.player.on(H5_PLAY_EVENT.PLAY_SESSION_END, this.onPlaySessionEnd);
                if (this.player.isFakeLive) {
                    // 伪直播监听这个事件，是为了在每次追加的vid开始播放时，上报上次vid的结束、本次vid的init、getinfo等。
                    this.msg.on(H5_EXT_EVENT.FLOW_NODE_START, this.onFlowNodeStart);
                }
                this.player.on(H5_PLAY_EVENT.VIDEO_REQ_INFO_END, function(param) {
                    var data = param.data;
                    if (data.code === ErrorCode.SUC) return;
                    var output = data.data;
                    var code = ((output === null || output === void 0 ? void 0 : output.error) || {}).code;
                    _this.writeState(DataState.ERROR, {
                        eventId: _this.generateEvtId(),
                        type: LogType.CORE_EVENT,
                        name: DataState.ERROR,
                        code: code,
                        ftime: (output === null || output === void 0 ? void 0 : output.endTime) || +new Date()
                    });
                });
                this.msg.on(H5_EXT_EVENT.RETRY_PLAY, this.onRetryPlay);
            }
        },
        {
            key: "collectBaseInfo",
            value: /**
   * 设定公共字段并屏蔽部分字段的setter
   */ function collectBaseInfo() {
                var os = uaTool.os, mobile = uaTool.mobile;
                // 移动端
                this.writeCommon(COMMON_DATA_KEY.mobile, mobile ? 1 : 0, FreezeKey);
                // online
                this.writeCommon(COMMON_DATA_KEY.online, 1, FreezeKey);
                // 分辨率
                this.writeCommon(COMMON_DATA_KEY.resolution, "".concat(screen.width, "*").concat(screen.height, "*").concat(window.devicePixelRatio || 1), FreezeKey);
                // ua
                this.writeCommon(COMMON_DATA_KEY.ua, navigator.userAgent.replace(/,/g, '\\,'), FreezeKey);
                // osver
                this.writeCommon(COMMON_DATA_KEY.osver, "".concat(os.osName, " ").concat(os.version), FreezeKey);
                // playertype - 0 系统 1自研，起播前默认为origin
                this.writeCommon(COMMON_DATA_KEY.playertype, 0);
                // 播放器内核信息
                this.writeCommon(COMMON_DATA_KEY.confid, confIdMap.default);
                this.writeCommon(COMMON_DATA_KEY.playercore, Object.keys(KernelFactory.kernelMap).join(','), FreezeKey);
                // 播放器版本号
                this.writeCommon(COMMON_DATA_KEY.playerver, VERSION);
                this.writeCommon(COMMON_DATA_KEY.speed, 0);
                this.writeCommon(COMMON_DATA_KEY.drm, 0);
                // 播放页信息
                this.writeCommon(COMMON_DATA_KEY.url, location.href, FreezeKey);
                this.writeCommon(COMMON_DATA_KEY.topUrl, urlTool.getTopFrameUrl(), FreezeKey);
                this.writeCommon(COMMON_DATA_KEY.referrer, document.referrer, FreezeKey);
                // 设备标识
                this.writeCommon(COMMON_DATA_KEY.guid, this.getGUID());
            }
        },
        {
            key: "collectVideoCapability",
            value: /** 收集播放能力支持的情况 */ function collectVideoCapability() {
                try {
                    var hardware = {
                        concurrency: navigator.hardwareConcurrency
                    };
                    var nativeCodecSupport = {
                        av1: +videoTool.supportAV1(),
                        hevc: +videoTool.supportHevc(),
                        dolby: +videoTool.isDolbyVisionSupported()
                    };
                    var nativeFormatSupport = {
                        hls: +videoTool.supportVideoFormat().includes('hls')
                    };
                    var hdrSupportLevel = videoTool.isHDRSupported();
                    // 这里直接做转译，避免上报插件引用的时候出现逗号转译的问题
                    var res = jsonTool.safelyStringify({
                        codec: nativeCodecSupport,
                        format: nativeFormatSupport,
                        hdr: hdrSupportLevel,
                        hw: hardware,
                        wasm: +videoTool.isWasmSupported(),
                        mse: +videoTool.supportMSE()
                    }).replace(/,/g, '\\,');
                    this.writeCommon(COMMON_DATA_KEY.videoCapability, res);
                    this.log("device capability info: ".concat(res));
                } catch (e) {
                // 这里因为部分能力检测可能抛出异常，我们统一处理
                }
            }
        },
        {
            key: "persistUserSetting",
            value: /** 将用户的部分配置持久化 */ function persistUserSetting() {
                var _this = this;
                var keysToSave = {};
                var config = this.player.config;
                var disableUserSettingCache = config.disableUserSettingCache, modeSuffix = config.type;
                var isKeyShouldBeIgnored = function(key) {
                    var _disableUserSettingCache_indexOf;
                    return (disableUserSettingCache === null || disableUserSettingCache === void 0 ? void 0 : (_disableUserSettingCache_indexOf = disableUserSettingCache.indexOf) === null || _disableUserSettingCache_indexOf === void 0 ? void 0 : _disableUserSettingCache_indexOf.call(disableUserSettingCache, key)) > -1;
                };
                DataSet.SETTING_CONFIG.forEach(function(settingConfig) {
                    var dsKey = settingConfig.dsKey, lsKey = settingConfig.lsKey, oldDsKey = settingConfig.oldDsKey;
                    var lsKeyWithPrefix = "".concat(lsKey, "_").concat(modeSuffix);
                    if (isKeyShouldBeIgnored(dsKey)) return;
                    // 对旧版本的ds key禁用做一下兼容
                    if (oldDsKey && isKeyShouldBeIgnored(oldDsKey)) return;
                    keysToSave[dsKey] = lsKeyWithPrefix;
                    var cache = lsTool.getData(lsKeyWithPrefix);
                    if (!cache) return;
                    if (dsKey) {
                        _this.log("read cache, ".concat(dsKey, "=").concat(cache));
                        _this.writeCommon(dsKey, cache);
                    }
                });
                this.msg.on(H5_EXT_EVENT.DATASET_UPDATE, function(e) {
                    var data = e.data;
                    var newVal = data.newVal, key = data.key;
                    if (!keysToSave[key]) return;
                    lsTool.setData(keysToSave[key], newVal);
                });
            }
        },
        {
            key: "removeUserSetting",
            value: function removeUserSetting(key) {
                var _this = this;
                var keysToRemove = typeof key === 'string' ? [
                    key
                ] : key;
                keysToRemove.forEach(function(key) {
                    _this.writeCommon(key, '');
                });
            }
        },
        {
            key: "videoReqInfoStart",
            value: function videoReqInfoStart(isContiguous) {
                var evtId = this.generateEvtId();
                this.evtIdMap[DataState.GET_INFO_START] = evtId;
                this.writeState(DataState.GET_INFO_START, {
                    type: LogType.CORE_EVENT,
                    name: DataState.GET_INFO_START,
                    eventId: evtId,
                    ftime: +new Date(),
                    isContiguous: isContiguous
                });
            }
        },
        {
            key: "videoReqInfoEnd",
            value: function videoReqInfoEnd(data) {
                var _data_data;
                var code = data.code, tmp = data.data, resData = tmp === void 0 ? {} : tmp;
                // 如果重新请求了getinfo，那么备份地址重试清零
                this.sessionRetryBackUrlCount = 0;
                if (!this.evtIdMap[DataState.GET_INFO_START]) return;
                var vitem = null;
                try {
                    var _resData_resData_vl, _resData_resData;
                    // 这里不能直接从parseData中拿vitem，因为如果是0秒试看，parseData为空，但是后台也会返回cid等信息。
                    vitem = (_resData_resData = resData.resData) === null || _resData_resData === void 0 ? void 0 : (_resData_resData_vl = _resData_resData.vl) === null || _resData_resData_vl === void 0 ? void 0 : _resData_resData_vl.vi[0];
                } catch (e) {}
                if (this.player.isFakeLive && vitem) {
                    // 伪直播场景用一个previd计算出来的vid请求后台，拿到结果以后才知道第一个播放的vid是什么。（追加节点补上的事件没有parseData数据，进不来）
                    // （这个数据在数据中心的更新只能在这里，之前打算写在getinfo事件后kvController中更新，不太行，因为预加载的getinfo会覆盖当前vid）
                    this.writeCommon(COMMON_DATA_KEY.vid, vitem.vid);
                    this.writeCommon(COMMON_DATA_KEY.cid, vitem.cid);
                }
                this.writeState(DataState.GET_INFO_END, {
                    type: LogType.CORE_EVENT,
                    name: DataState.GET_INFO_END,
                    code: code,
                    ext: {
                        reqBody: urlTool.object2string(resData.reqParams || {}, '&'),
                        reqPath: resData.reqPath || '',
                        retryCount: resData.alreadyRetryCount || 0
                    },
                    error: resData.error || {},
                    eventId: this.evtIdMap[DataState.GET_INFO_START],
                    ftime: ((_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.endTime) || +new Date(),
                    isContiguous: data.isContiguous
                });
            }
        },
        {
            key: "sessionStart",
            value: function sessionStart(data) {
                this.writeCommon(COMMON_DATA_KEY.flowid, data.flowid);
                this.writeCommon(COMMON_DATA_KEY.isPreload, Number(data.isPreload));
                this.writeCommon(COMMON_DATA_KEY.vid, isVideoId(data.playItem) ? data.playItem : '');
                // 起播后重置上次播放 session 中设置的弹幕降级字段
                this.writeCommon(COMMON_DATA_KEY.dmkDegraded, 0);
                // 此时开始上报init
                this.emit(DataEvents.STATE_UPDATE, {
                    key: DataState.INIT,
                    oldVal: undefined,
                    newVal: this.stateMap[DataState.INIT],
                    startEvent: undefined
                });
                this.writeState(DataState.SESSION_START, {
                    eventId: this.generateEvtId(),
                    type: LogType.CORE_EVENT,
                    name: DataState.SESSION_START,
                    ftime: +new Date(),
                    isContiguous: data.isContiguous
                });
            }
        },
        {
            key: "sessionEnd",
            value: function sessionEnd(data) {
                var code = data.code;
                var payload = code === ErrorCode.SUC ? _$b({}, this.stateMap[DataState.END]) : _$b({}, this.stateMap[DataState.ERROR]);
                if (code !== ErrorCode.SUC) {
                    // 报错的情况下移除本地的音轨缓存
                    this.removeUserSetting([
                        PersistedUserSettings.audioTrack
                    ]);
                }
                this.writeState(DataState.SESSION_END, _$c(_$b({}, payload), {
                    code: code,
                    eventId: this.generateEvtId(),
                    name: DataState.SESSION_END,
                    type: LogType.CORE_EVENT,
                    ftime: +new Date(),
                    isContiguous: data.isContiguous
                }));
                this.playDuration = 0;
                this.prevPlayTimeS = 0;
                this.sessionBufferCount = 0;
                this.sessionRetryBackUrlCount = 0;
                this.sessionRetryPlayCount = 0;
            }
        }
    ]);
    return DataSet;
}(_$d(Plugin));
_$2(DataSet, "pluginName", 'dataset');
// codecc扫描无法通过，但是历史原因无法更改了
// eslint-disable-next-line @typescript-eslint/naming-convention
_$2(DataSet, "UserSettingKeyPrefix", '__thumbplayer_setting_');
// eslint-disable-next-line @typescript-eslint/naming-convention
_$2(DataSet, "SETTING_CONFIG", [
    {
        oldDsKey: COMMON_DATA_KEY.currentDefn,
        dsKey: PersistedUserSettings.definition,
        lsKey: "".concat(DataSet.UserSettingKeyPrefix, "_definition")
    },
    {
        oldDsKey: COMMON_DATA_KEY.currentSubtitle,
        dsKey: PersistedUserSettings.subtitle,
        lsKey: "".concat(DataSet.UserSettingKeyPrefix, "_subtitle")
    },
    {
        oldDsKey: COMMON_DATA_KEY.currentAudioTrack,
        dsKey: PersistedUserSettings.audioTrack,
        lsKey: "".concat(DataSet.UserSettingKeyPrefix, "_audioTrack")
    },
    {
        dsKey: PersistedUserSettings.volume,
        lsKey: "".concat(DataSet.UserSettingKeyPrefix, "_volume")
    },
    {
        dsKey: PersistedUserSettings.playbackRate,
        lsKey: "".concat(DataSet.UserSettingKeyPrefix, "_playbackRate")
    },
    {
        dsKey: PersistedUserSettings.preferCodec,
        lsKey: "".concat(DataSet.UserSettingKeyPrefix, "_preferCodec")
    }
]);
_$2(DataSet, "canUseProxy", typeof window.Proxy !== 'undefined');

var _obj$1;
/** 从PLAY_EVENT代理事件 */ var evtTransformMap = (_obj$1 = {}, _$2(_obj$1, PLAY_EVENT.DURATION_CHANGE, {
    evt: H5_PLAY_EVENT.VIDEO_DURATION_CHANGE,
    getParam: function(info) {
        return {
            duration: info.videoInfo.duration
        };
    }
}), _$2(_obj$1, PLAY_EVENT.METADATA_CHANGE, {
    evt: H5_PLAY_EVENT.VIDEO_METADATA_CHANGE,
    getParam: function(info) {
        return {
            width: info.videoInfo.videoWidth,
            height: info.videoInfo.videoHeight
        };
    }
}), _$2(_obj$1, PLAY_EVENT.VIDEO_BUFFER_CHANGE, {
    evt: H5_PLAY_EVENT.VIDEO_LOAD_PROGRESS,
    getParam: function(info) {
        return {
            bufferRange: info.bufferRange
        };
    }
}), _$2(_obj$1, PLAY_EVENT.TIME_UPDATE, {
    evt: H5_PLAY_EVENT.VIDEO_TIMEUPDATE,
    getParam: function(info) {
        return {
            playtime: info.videoInfo.playtime
        };
    }
}), _$2(_obj$1, PLAY_EVENT.VOLUME_CHANGE, {
    evt: H5_PLAY_EVENT.VIDEO_VOLUME_CHANGE,
    getParam: function(info) {
        return {
            volume: info.volume
        };
    }
}), _$2(_obj$1, PLAY_EVENT.RATE_CHANGE, {
    evt: H5_PLAY_EVENT.VIDEO_RATE_CHANGE,
    getParam: function(param) {
        var rate = param.playbackRate;
        return {
            rate: rate
        };
    }
}), _$2(_obj$1, PLAY_EVENT.VIDEO_RESIZE, {
    evt: H5_PLAY_EVENT.VIDEO_RESIZE,
    getParam: function(info) {
        return {
            videoWidth: info.videoInfo.videoWidth,
            videoHeight: info.videoInfo.videoHeight
        };
    }
}), _$2(_obj$1, PLAY_EVENT.AUTOPLAY_BLOCKED, {
    evt: H5_PLAY_EVENT.VIDEO_AUTOPLAY_BLOCKED,
    getParam: function() {}
}), _obj$1);
/** 广告插件需要广播的播放器事件 */ var AD_EVTS_EMIT_ON_PLAYER = [
    H5_PLAY_EVENT.AD_REQ_INFO_START,
    H5_PLAY_EVENT.AD_REQ_INFO_END,
    H5_PLAY_EVENT.AD_REQ_ASSETS_START,
    H5_PLAY_EVENT.AD_ASSETS_LOADED,
    H5_PLAY_EVENT.AD_END,
    H5_PLAY_EVENT.AD_PLAYING,
    H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED,
    H5_PLAY_EVENT.AD_PAUSE,
    H5_PLAY_EVENT.AD_RESUME,
    H5_PLAY_EVENT.AD_TIME_UPDATE,
    H5_PLAY_EVENT.AD_VOLUME_CHANGE
];
/** 广告插件需要广播的插件事件 */ var AD_EVTS_EMIT_ON_PLUGIN = [
    H5_EXT_EVENT.AD_COUNTDOWN_CHANGE
];
/**
 * 广告事件转发时，派发的数据中的字段转义表。
 *
 * 例如广告插件发过来的事件和数据为：AD_COUNTDOWN_CHANGE: { p0: 'preAd', p1: 105, p2: 'LD', p3: '1'}
 * 如果转义表为:{ p0: 'adType', p1: 'countdown' }
 * 因此我们转发事件为: AD_COUNTDOWN_CHANGE: { adType: 'preAd', countdown: 105 }
 */ var AD_EVT_DATA_KEY_MAP = _$2({}, H5_EXT_EVENT.AD_COUNTDOWN_CHANGE, {
    adType: 'adType',
    countdown: 'countdown'
});
/** 代理广告插件上指定的事件，当动态替换广告插件时 需要重新调用此方法 */ function proxyAdEvent(adEvents, instanceId, emitter) {
    var adPlugin = getAdPlugin(instanceId);
    if (!adPlugin) return;
    adEvents.forEach(function(evt) {
        adPlugin.on(evt, function(param) {
            var data = param.data;
            var emitData = void 0;
            var emitDataKeyMap = AD_EVT_DATA_KEY_MAP[evt];
            if (emitDataKeyMap) {
                // 如果有字段映射关系，筛选/转义字段后转发
                emitData = {};
                Object.keys(emitDataKeyMap).forEach(function(k) {
                    emitData[emitDataKeyMap[k]] = data[k];
                });
            } else {
                // 否则直接转发
                emitData = data;
            }
            emitter.emit(evt, emitData);
        });
    });
}
var _obj1;
/** core的状态直接转发的为H5_PLAY_EVENT的事件 */ var coreStateToPlayerEvtMap = (_obj1 = {}, _$2(_obj1, VIDEO_STATE.LOAD_START, H5_PLAY_EVENT.VIDEO_LOAD_START), _$2(_obj1, VIDEO_STATE.CANPLAY, H5_PLAY_EVENT.VIDEO_CANPLAY), _$2(_obj1, VIDEO_STATE.BUFFERING, H5_PLAY_EVENT.VIDEO_BUFFERING), _$2(_obj1, VIDEO_STATE.SEEKING, H5_PLAY_EVENT.VIDEO_SEEKING), _$2(_obj1, VIDEO_STATE.SEEKED, H5_PLAY_EVENT.VIDEO_SEEKED), _obj1);

/** 播放器全屏状态枚举 */ var FullScreenMode;
(function(FullScreenMode) {
    /** CSS 全屏，也称伪全屏，使用样式将播放器 DOM 撑满屏幕，移动端兼容性好 */ FullScreenMode["FAKE_FULLSCREEN"] = "fakeFullscreen";
    /** 文档全屏或 Video 全屏，浏览器提供的系统级全屏 API，PC + iOS 默认使用规则 */ FullScreenMode["FULL_SCREEN"] = "fullscreen";
})(FullScreenMode || (FullScreenMode = {}));

/**
 * 设置容器 CSS 填充满 viewport，并设置 z-index 保持在屏幕最顶部
 * !注意：如果父级元素使用了会创建层叠上下文 / containing block 的属性，则会导致此方法失效
 * ! 常见有:
 * ! position: fixed / sticky（创建层级上下文，全屏后 z-index 盖不住父级的兄弟元素）
 * ! transform / perspective / filter （修改了 containing block，大小受限）
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
 * @param container 容器元素
 * @param isEnter 进入 / 取消
 */ function requestFakeFullScreen(container) {
    var isEnter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    // 先检查 class 的样式是否注入
    {
        domTool.insertStyle(styleStr, STYLE_TAG);
    }
    // 设置对应的 CSS 全屏 className
    container.classList.toggle(FAKE_FULLSCREEN_CLASS, isEnter);
}
/**
 * 判断是否处于 CSS 全屏中
 * @param container 全屏容器
 */ function isFakeFullscreen(container) {
    return container.classList.contains(FAKE_FULLSCREEN_CLASS);
}
/** CSS 全屏类 */ var FAKE_FULLSCREEN_CLASS = 'thumbplayer-fake-fullscreen';
/** style 标签的 data-tag 属性 */ var STYLE_TAG = 'thumbplayer-fake-fullscreen-style';
/** CSS 全屏的样式 */ var styleStr = /* css */ "\n.".concat(FAKE_FULLSCREEN_CLASS, " {\n  position: fixed !important;\n  top: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  z-index: 9999 !important;\n}\n");

/**
 * DOM 全屏方法，主要应用于 PC / 平板
 * @param container 进入全屏的 DOM 容器
 * @param isEnter 进入 / 退出全屏，true -> 进入，false -> 退出
 */ function requestElFullScreen(container) {
    var isEnter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    // 1. 传入的容器必须是 Element，否则 reject
    if (!_$7(container, HTMLElement)) {
        return Promise.reject('requestElFullScreen: container is not an element');
    }
    // 2. 获取对应的进入 / 退出全屏方法
    var getEnterFn = function(ele) {
        var _this;
        return (_this = ele.requestFullscreen || ele.mozRequestFullScreen || ele.webkitRequestFullscreen || ele.webkitRequestFullScreen || ele.msRequestFullscreen) === null || _this === void 0 ? void 0 : _this.bind(ele);
    };
    var getExitFn = function(ele) {
        var _this;
        return (_this = ele.cancelFullScreen || ele.mozCancelFullScreen || ele.webkitCancelFullScreen || ele.exitFullscreen || ele.webkitExitFullscreen || ele.msExitFullscreen) === null || _this === void 0 ? void 0 : _this.bind(ele);
    };
    var enterFn = getEnterFn(container) || getEnterFn(document);
    var exitFn = getExitFn(container) || getExitFn(document);
    var fn = isEnter ? enterFn : exitFn;
    // 3. 尝试调用进入 / 退出全屏方法，并返回对应 Promise
    try {
        return Promise.resolve(fn());
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Video 进入 / 退出全屏，用于 iOS 移动端拉起系统播放器全屏
 * 原因是 HTMLElement 缺少 requestFullScreen 方法
 * @param video video 标签
 */ function requestVideoFullScreen(video) {
    return _requestVideoFullScreen.apply(this, arguments);
}
function _requestVideoFullScreen() {
    _requestVideoFullScreen = _$e(function(video) {
        var isEnter, enterFullScreenFn, fn;
        var _arguments = arguments;
        return _$f(this, function(_state) {
            isEnter = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true;
            if (!video || !_$7(video, HTMLVideoElement)) {
                throw new Error('videoRequestFullScreen: video is not an VideoElement');
            }
            enterFullScreenFn = video.requestFullscreen || video.webkitEnterFullscreen || video.webkitRequestFullScreen;
            fn = isEnter ? enterFullScreenFn : video.webkitExitFullscreen;
            if (!fn) {
                throw new Error('Video Fullscreen API is not supported.');
            }
            return [
                2,
                fn.call(video)
            ];
        });
    });
    return _requestVideoFullScreen.apply(this, arguments);
}
/**
 * 检查是否进入 DOM 全屏
 * @param container 被全屏的 DOM 元素
 */ function isElFullScreen(container) {
    if (!container) return false;
    var doc = document;
    var isFull = doc.fullscreen || doc.mozFullScreen || doc.webkitIsFullScreen || doc.msFullscreenElement;
    if (!isFull) return false;
    var el = doc.fullscreenElement || doc.webkitFullscreenElement || doc.mozFullScreenElement || doc.msFullscreenElement;
    return el === container || el === document;
}
function isVideoFullScreen(video) {
    if (!video) return false;
    // 这个属性是最精确的，优先使用，iOS 9+ 支持
    // https://developer.apple.com/documentation/webkitjs/htmlvideoelement/1631913-webkitpresentationmode
    if (video.webkitPresentationMode !== undefined) {
        return video.webkitPresentationMode === 'fullscreen';
    }
    // iOS 4+ 支持的 API，不过有上面 case 覆盖，基本不会走到这里了
    // https://developer.apple.com/documentation/webkitjs/htmlvideoelement/1630493-webkitdisplayingfullscreen
    // 这里有个 bug: 当全屏模式下，点击 Safari / iOS webkit 下的小窗播放，此时 `webkitDisplayingFullscreen` 仍然是 `true`
    // 所以如果在 iOS / macOS Safari 下，webkitDisplayingFullscreen 属性为 true 且不在小窗模式下，才认定为是真的在全屏
    return video.webkitDisplayingFullscreen && !isEnterPipInApple(video);
}
/**
 * 检测是否在 iOS 或 macOS Safari 下进入了画中画模式
 * 用于兼容 iOS / macOS 这类 webkit 内核上，先进入全屏，在进入小窗播放时，`video.webkitDisplayingFullscreen` 仍然为 `true`
 * @param video - 原生 Video 标签
 */ function isEnterPipInApple(video) {
    // 如果不是 iOS 设备或者不是 macOS 的 Safari，则返回 false
    if (!(uaTool.os.ios || uaTool.browser.safari)) {
        return false;
    }
    // 判断是否进入小窗模式播放
    return document.pictureInPictureEnabled && document.pictureInPictureElement === video;
}

var VIDEO_FULLSCREEN_TAG = 'fullscreen_handler';
var fullscreenEvents = [
    'webkitfullscreenchange',
    'mozfullscreenchange',
    'fullscreenchange',
    'MSFullscreenChange'
];
var FullScreenLogics = /*#__PURE__*/ function() {
    function FullScreenLogics(player, container) {
        var _this = this;
        _$1(this, FullScreenLogics);
        _$2(this, "player", void 0);
        /** 元素全屏 / 伪全屏元素 */ _$2(this, "container", void 0);
        _$2(this, "logger", void 0);
        _$2(this, "lastTriggeredFullscreenEvt", void 0);
        /** 当前全屏状态 */ _$2(this, "curState", void 0);
        /** 即将进入的全屏状态 */ _$2(this, "nextState", void 0);
        /**
   * 是否在 fs -> ffs 这种 case 下，内部流程是 fs -> null -> ffs
   * 这种情况下 fs -> null 完成后，不对外派发 FULLSCREEN_MODE_CHANGE 事件
   *
   * 需要这个变量的原因是这种元素全屏由事件驱动，无法同步判断 ignoreEvt 状态
   * 而伪全屏只是设置 CSS，可以在 doRequestFullscreen 内直接判断 isRecursive 参数
   */ _$2(this, "ignoreFSEvt", void 0);
        /**
   * 当 loadStart 后，播放器会选择内核创建 video。这时，监听 video 的全屏事件
   * 在全屏产生时，转发全屏事件
   */ _$2(this, "onVideoLoadStart", void 0);
        /**
   * 播放结束时，检查如果处于 iOS 下的系统全屏，则退出全屏状态
   * 这么做是要防止用户通过系统全屏下的播控按钮重新起播或者 seek，造成播放器事件派发、各个插件的状态错误
   *
   * 伪全屏则无所谓，因为伪全屏的播控是播放器提供的
   */ _$2(this, "onPlaySessionEnd", void 0);
        /**
   * 处理系统全屏事件，在播放器上补发对应的全屏变更事件
   */ _$2(this, "fullscreenChangeHandler", void 0);
        /**
   * 处理全屏事件，特殊处理 Safari 16.4
   */ _$2(this, "fullscreenChangeDesktop", void 0);
        this.player = player;
        this.curState = null;
        this.nextState = null;
        this.ignoreFSEvt = false;
        this.onVideoLoadStart = function() {
            var videoElements = _this.player.videoElements;
            videoElements.forEach(function(video) {
                // 检查是否非 wasm 内核，且是否添加过事件监听，如果没有，开始添加全屏的事件监听
                if (_$7(video, HTMLVideoElement) && !video.dataset[VIDEO_FULLSCREEN_TAG]) {
                    _this.bindVideoElFullscreenEvt(video, true);
                }
            });
        };
        this.onPlaySessionEnd = function() {
            var _this_player_config = _this.player.config, _this_player_config_loop = _this_player_config.loop, loop = _this_player_config_loop === void 0 ? false : _this_player_config_loop;
            if (uaTool.mobile && _this.fullscreenMode === FullScreenMode.FULL_SCREEN && !loop) {
                _this.doRequestFullScreen(false, FullScreenMode.FULL_SCREEN);
            }
        };
        this.fullscreenChangeHandler = function() {
            var fullscreenMode = _this.fullscreenMode;
            _this.player.emit(PLAY_EVENT.FULLSCREEN_CHANGE, {
                isEnter: fullscreenMode === FullScreenMode.FULL_SCREEN,
                mode: FullScreenMode.FULL_SCREEN
            });
            if (!_this.ignoreFSEvt) {
                _this.emitFsModeChangeEvt();
            }
            _this.ignoreFSEvt = false;
        };
        this.fullscreenChangeDesktop = function(event) {
            var currTriggeredEvt = event.type;
            var lastTriggeredFullscreenEvt = _this.lastTriggeredFullscreenEvt;
            // Safari 16.4 版本下，有可能会同时触发 webkitfullscreenchange 和 fullscreenchange
            // 这里判断下，如果间隔触发的全屏事件事件名都不一样，则仅派发第一次事件，忽略第二次 fullscreen 事件
            if (lastTriggeredFullscreenEvt && lastTriggeredFullscreenEvt !== currTriggeredEvt) {
                return;
            }
            _this.lastTriggeredFullscreenEvt = currTriggeredEvt;
            _this.fullscreenChangeHandler();
        };
        this.logger = new Logger(player.config.instanceId, 'FullscreenLogics');
        this.container = container || player.container;
        this.listenFullScreenEvts(true);
    }
    _(FullScreenLogics, [
        {
            key: "fullscreenMode",
            get: /**
   * 当前的全屏模式
   * 全屏 / CSS 全屏 / null -> 非全屏
   */ function get() {
                var container = this.container;
                // 如果播到 SessionEnd，player.currentVideoElement = null，这里取 videoElements 的第一个元素作为 video
                // 因为基本上只有 iOS 能走到这，而 iOS 下只会创建一个 video 标签
                var videoEl = this.player.currentVideoElement || this.player.videoElements[0];
                if (isFakeFullscreen(container)) {
                    return FullScreenMode.FAKE_FULLSCREEN;
                }
                if (isElFullScreen(container) || _$7(videoEl, HTMLVideoElement) && isVideoFullScreen(videoEl)) {
                    return FullScreenMode.FULL_SCREEN;
                }
                return null;
            }
        },
        {
            key: "requestFullScreen",
            value: /**
   * 进入 / 退出全屏状态
   * @param isEnter 是否进入全屏，true 进入全屏，false 退出全屏
   * @param mode 指定全屏模式，分为系统全屏和 CSS 全屏。默认情况下会自动判断
   */ function requestFullScreen() {
                var isEnter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, mode = arguments.length > 1 ? arguments[1] : void 0;
                var _this = this;
                return _$e(function() {
                    return _$f(this, function(_state) {
                        return [
                            2,
                            _this.doRequestFullScreen(isEnter, mode, false)
                        ];
                    });
                })();
            }
        },
        {
            key: "doRequestFullScreen",
            value: /**
   * 实际执行全屏切换的逻辑，内部 API，不对外暴露
   * @param isRecursive 是否为递归调用，设置为 true 时，本次调用不抛 FULLSCREEN_MODE_CHANGE 事件
   */ function doRequestFullScreen() {
                var isEnter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, mode = arguments.length > 1 ? arguments[1] : void 0, isRecursive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                var _this = this;
                return _$e(function() {
                    var container, currentMode, _this_player, currentVideoElement, videoElements, requestMode, videoTag, err1;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                container = _this.container, currentMode = _this.fullscreenMode;
                                _this_player = _this.player, currentVideoElement = _this_player.currentVideoElement, videoElements = _this_player.config.videoElements;
                                // 如果没有强制指定全屏模式，则使用内置规则指定一个全屏模式
                                requestMode = _this.getFullScreenMode(mode);
                                // 不理会非法的调用行为
                                if (_this.isIllegalRequest(isEnter, requestMode, currentMode)) {
                                    return [
                                        2
                                    ];
                                }
                                // 设置 curState / nextState 和 ignoreFsEvt 这三个状态
                                _this.setInternalStates(isEnter, requestMode, isRecursive);
                                // 处理伪全屏 <--> 元素全屏切换的 case，先退出当前全屏模式，再进入另一种全屏模式
                                // 非法的 case 已经被上面逻辑过滤掉了
                                // 再额外判断下 isRecursive 保险一些，保证只递归调用一次
                                if (!isRecursive && isEnter && currentMode) {
                                    _this.doRequestFullScreen(false, currentMode, true);
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    ,
                                    8
                                ]);
                                // 伪全屏，调用全屏方法并抛出事件
                                if (requestMode === FullScreenMode.FAKE_FULLSCREEN) {
                                    requestFakeFullScreen(container, isEnter);
                                    // 只有伪全屏直接发出事件，其他事件由 DOM / video 的原生事件捕获后发出
                                    _this.player.emit(PLAY_EVENT.FULLSCREEN_CHANGE, {
                                        isEnter: isEnter,
                                        mode: requestMode
                                    });
                                    // 不是递归调用时，才抛 FULLSCREEN_MODE_CHANGE 事件
                                    if (!isRecursive) {
                                        _this.emitFsModeChangeEvt();
                                    }
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    requestElFullScreen(container, isEnter)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                _state.sent();
                                // 基本上只有 iOS 系统才能走到这
                                // 这里如果播放到 SessionEnd，currentVideoElement 会是 null
                                // iOS 下只创建一个 Video，因此用 videoElements[0] 来获取播放器下的 video 标签
                                videoTag = currentVideoElement || videoElements[0];
                                // 错误直接外抛上层 try-catch
                                return [
                                    4,
                                    requestVideoFullScreen(videoTag, isEnter)
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                err1 = _state.sent();
                                // 如果全屏报错，捕获打个 log，再外抛
                                _this.logger.error("@FullscreenLogics.requestFullScreen, isEnter=".concat(isEnter, ", mode=").concat(requestMode, ", err=").concat(err1));
                                throw err1;
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.listenFullScreenEvts(false);
            }
        },
        {
            key: "getFullScreenMode",
            value: /**
   * 指定全屏模式
   * @param mode 强制指定全屏模式
   */ function getFullScreenMode(mode) {
                if (mode) {
                    // 强制指定直接返回
                    return mode;
                }
                // 内置规则： PC / iOS 使用系统全屏，其他移动端都使用伪全屏
                return !uaTool.mobile || uaTool.os.ios ? FullScreenMode.FULL_SCREEN : FullScreenMode.FAKE_FULLSCREEN;
            }
        },
        {
            key: "listenFullScreenEvts",
            value: /**
   * DOM 全屏和 video 全屏变更由对应元素抛出，这里捕获并在播放器实例上抛出 FULLSCREEN_CHANGE 事件
   * @param isBind 监听 / 取消监听
   */ function listenFullScreenEvts() {
                var _this = this;
                var isBind = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var docBinder = isBind ? document.addEventListener.bind(document) : document.removeEventListener.bind(document);
                var playerBinder = isBind ? this.player.on.bind(this.player) : this.player.off.bind(this.player);
                playerBinder(H5_PLAY_EVENT.VIDEO_LOAD_START, this.onVideoLoadStart);
                playerBinder(H5_PLAY_EVENT.PLAY_SESSION_END, this.onPlaySessionEnd);
                // 监听 DOM 全屏的对应事件
                fullscreenEvents.forEach(function(evtName) {
                    docBinder(evtName, _this.fullscreenChangeDesktop);
                });
                // 如果是取消监听，尝试取消对 video 全屏事件的监听
                if (!isBind) {
                    var _this_player_videoElements;
                    (_this_player_videoElements = this.player.videoElements) === null || _this_player_videoElements === void 0 ? void 0 : _this_player_videoElements.forEach(function(video) {
                        if (!_$7(video, HTMLVideoElement)) return;
                        _this.bindVideoElFullscreenEvt(video, false);
                    });
                }
            }
        },
        {
            key: "bindVideoElFullscreenEvt",
            value: /**
   * 绑定 / 解绑 Video 标签发出的全屏事件，仅在 iOS 系统下才会调用
   */ function bindVideoElFullscreenEvt(video, isBind) {
                var videoBinder = isBind ? video.addEventListener.bind(video) : video.removeEventListener.bind(video);
                videoBinder('webkitendfullscreen', this.fullscreenChangeHandler);
                videoBinder('webkitbeginfullscreen', this.fullscreenChangeHandler);
                if (isBind) {
                    // 如果是绑定事件监听器，则在 dataset 上添加一个标记，确保只监听一次
                    video.dataset[VIDEO_FULLSCREEN_TAG] = String(true);
                } else {
                    // 否则，移除这个标记
                    delete video.dataset[VIDEO_FULLSCREEN_TAG];
                }
            }
        },
        {
            key: "emitFsModeChangeEvt",
            value: /**
   * 抛出 FULLSCREEN_MODE_CHANGE 事件，有别于 FULLSCREEN_CHANGE 事件
   * 消费 curState / nextState 并更新到切换全屏后的状态
   */ function emitFsModeChangeEvt() {
                var _this = this, curState = _this.curState, nextState = _this.nextState;
                this.player.emit(PLAY_EVENT.FULLSCREEN_MODE_CHANGE, {
                    lastState: curState,
                    curState: nextState
                });
                this.curState = nextState;
                this.nextState = null;
            }
        },
        {
            key: "isIllegalRequest",
            value: /**
   * 判断 requestFullscreen 传入的参数在当前状态下是否为非法请求
   * @param isEnter 进入全屏状态
   * @param requestMode 请求进入的全屏模式
   * @param currentMode 当前的全屏模式
   */ function isIllegalRequest(isEnter, requestMode, currentMode) {
                return !isEnter && !currentMode // 非全屏模式下请求退出全屏
                 || !isEnter && currentMode !== requestMode // 伪全屏请求退出元素全屏，或元素全屏退出伪全屏
                 || isEnter && currentMode && currentMode === requestMode; // 伪全屏还请求伪全屏，或元素全屏下还请求元素全屏
            }
        },
        {
            key: "setInternalStates",
            value: /**
   * 设置 curState / nextState 和 ignoreFsEvt 这三个状态
   * 供 emitFsModeChangeEvt 函数消费
   */ function setInternalStates(isEnter, requestMode, isRecursive) {
                // 非递归调用，才去设置 state 状态供 emitFsModeChangeEvt 使用
                // 因为递归调用不抛事件，不消费这个值，且会把非递归调用设置的状态给冲掉
                if (!isRecursive) {
                    this.curState = this.fullscreenMode;
                    this.nextState = isEnter ? requestMode : null;
                    return;
                }
                // 处理 el 全屏 -> 伪全屏的 case，内部状态变化为 fs -> null -> ffs
                // 这里设置标记让 fs -> null 的过程不抛出 FULLSCREEN_MODE_CHANGE 事件
                if (!isEnter && this.curState === FullScreenMode.FULL_SCREEN) {
                    this.ignoreFSEvt = true;
                }
            }
        }
    ]);
    return FullScreenLogics;
}();

var ReportSource;
(function(ReportSource) {
    ReportSource["WHITE_LIST"] = "white";
})(ReportSource || (ReportSource = {}));
var WhiteListReportHook;
(function(WhiteListReportHook) {
    /** PLAY_SESSION_Start 上报 */ WhiteListReportHook[WhiteListReportHook["PLAY_SESSION_START"] = 0] = "PLAY_SESSION_START";
    /** PLAY_SESSION_END 上报 */ WhiteListReportHook[WhiteListReportHook["PLAY_SESSION_END"] = 1] = "PLAY_SESSION_END";
})(WhiteListReportHook || (WhiteListReportHook = {}));
var WhiteListReportType;
(function(WhiteListReportType) {
    /** 上报当前 flowid 对应日志 */ WhiteListReportType[WhiteListReportType["Single"] = 0] = "Single";
    /** 上报全量日志 */ WhiteListReportType[WhiteListReportType["Full"] = 1] = "Full";
})(WhiteListReportType || (WhiteListReportType = {}));
var DEFAULT_REPORT_OPTIONS = {
    downloadOnFailed: false,
    reportSource: 'API_CALL',
    onlyCurrent: true
};

var StorageError = /*#__PURE__*/ function(Error1) {
    _$4(StorageError, Error1);
    var _super = _$5(StorageError);
    function StorageError() {
        _$1(this, StorageError);
        return _super.apply(this, arguments);
    }
    return StorageError;
}(_$d(Error));
/**
 * 初始化 iframe storage 失败
 */ var StorageInitError = /*#__PURE__*/ function(StorageError) {
    _$4(StorageInitError, StorageError);
    var _super = _$5(StorageInitError);
    function StorageInitError() {
        _$1(this, StorageInitError);
        return _super.apply(this, arguments);
    }
    return StorageInitError;
}(StorageError);

/**
 * 通信消息列表
 */ var BridgeMessageName;
(function(BridgeMessageName) {
    /** indexedDB 初始化失败 */ BridgeMessageName["STORAGE_INIT_FAILED"] = "storageInitFailed";
    /** indexedDB 就绪 */ BridgeMessageName["STORAGE_READY"] = "storageReady";
    /** 请求存储日志数据 */ BridgeMessageName["REQUEST_STORE_LOG"] = "requestStoreLog";
    /** 存储日志成功 */ BridgeMessageName["STORE_LOG_SUCCESS"] = "storeLogSuccess";
    /** 存储日志失败 */ BridgeMessageName["STORE_LOG_FAILED"] = "storeLogFailed";
    /** 请求上报所有日志 */ BridgeMessageName["REQUEST_REPORT_LOG"] = "requestReportLog";
    /** 上报日志成功 */ BridgeMessageName["REPORT_LOG_SUCCESS"] = "reportLogSuccess";
    /** 上报日志失败 */ BridgeMessageName["REPORT_LOG_FAILED"] = "reportLogFailed";
    /** 上报进度回报 */ BridgeMessageName["REPORT_PROGRESS"] = "reportProgress";
    /** 请求下载日志 */ BridgeMessageName["REQUEST_DOWNLOAD_LOG"] = "requestDownloadLog";
})(BridgeMessageName || (BridgeMessageName = {}));
/**
 * iframe 插入到 DOM 上的类名
 */ var REMOTE_STORAGE_CLASS_NAME = 'thumbplayer-remote-storage-bridge';
/** iframe 默认超时时间 10 秒 */ var DEFAULT_IFRAME_TIMEOUT = 10 * 1000;
/** 上报接口可能比较慢，这里设置 30 秒超时 */ var REPORT_TIMEOUT = 30 * 1000;

/** 定义基础通信方法和协议 */ var MessageBridge = /*#__PURE__*/ function() {
    function MessageBridge(sender, receiver) {
        var _this = this;
        _$1(this, MessageBridge);
        _$2(this, "sender", void 0);
        _$2(this, "receiver", void 0);
        /** 使用 on 方法添加的回调函数存储 */ _$2(this, "callbackMap", void 0);
        /** 如果已被执行 destroy ，则不再监听 iframe 回调 */ _$2(this, "hasDestroy", void 0);
        _$2(this, "onReceiverMessage", void 0);
        this.sender = sender;
        this.receiver = receiver;
        this.callbackMap = {};
        this.hasDestroy = false;
        this.onReceiverMessage = function(event) {
            _this.receiverMessageHandler(event);
        };
        this.sender.addEventListener('message', this.onReceiverMessage);
    }
    _(MessageBridge, [
        {
            key: "postMessage",
            value: /**
   * 向 receiver 发送消息
   */ function postMessage(message) {
                if (this.hasDestroy) throw new Error('Cannot exec postMessage after destroy');
                this.receiver.postMessage(message, '*');
            }
        },
        {
            key: "on",
            value: function on(name, callback) {
                if (this.hasDestroy) return;
                if (!this.callbackMap[name]) {
                    this.callbackMap[name] = [];
                }
                this.callbackMap[name].push(callback);
            }
        },
        {
            key: "off",
            value: function off(name, callback) {
                if (this.hasDestroy) return;
                var callbackList = this.callbackMap[name];
                if (!(callbackList === null || callbackList === void 0 ? void 0 : callbackList.length)) return;
                var index = callbackList.indexOf(callback);
                if (index === -1) return;
                callbackList.splice(index, 1);
            }
        },
        {
            key: "destroy",
            value: /** 销毁 Bridge，移除所有监听 */ function destroy() {
                var _this_sender;
                this.hasDestroy = true;
                (_this_sender = this.sender) === null || _this_sender === void 0 ? void 0 : _this_sender.removeEventListener('message', this.onReceiverMessage);
                this.sender = null;
                this.receiver = null;
                this.callbackMap = null;
            }
        },
        {
            key: "receiverMessageHandler",
            value: /**
   * sender.onmessage 回调函数，过滤出请求的响应数据并操作 simpleDefer.resolve / reject
   * @param event message 事件实例
   */ function receiverMessageHandler(event) {
                var _this = this;
                var _this_callbackMap_message_name;
                if (!this.isBridgeMessage(event.data) || this.hasDestroy) return;
                var message = event.data;
                (_this_callbackMap_message_name = this.callbackMap[message.name]) === null || _this_callbackMap_message_name === void 0 ? void 0 : _this_callbackMap_message_name.forEach(function(cb) {
                    cb(message, _this.postMessage.bind(_this));
                });
            }
        },
        {
            key: "isBridgeMessage",
            value: function isBridgeMessage(data) {
                return (typeof data === "undefined" ? "undefined" : _$3(data)) === 'object' && typeof (data === null || data === void 0 ? void 0 : data.name) === 'string' && typeof (data === null || data === void 0 ? void 0 : data.instanceId) === 'string';
            }
        }
    ]);
    return MessageBridge;
}();

/**
 * 基于 iframe 的远程 indexedDB 存储，多次 new 情况下会保持 iframe 的单例复用
 */ var RemoteStorageBridge = /*#__PURE__*/ function(MessageBridge) {
    _$4(RemoteStorageBridge, MessageBridge);
    var _super = _$5(RemoteStorageBridge);
    function RemoteStorageBridge(url, instanceId) {
        var timeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : DEFAULT_IFRAME_TIMEOUT;
        _$1(this, RemoteStorageBridge);
        var _this;
        _this = _super.call(this, self, RemoteStorageBridge.getIframe(url, timeout).contentWindow);
        _$2(_$6(_this), "instanceId", void 0);
        _$2(_$6(_this), "timeout", void 0);
        _this.instanceId = instanceId;
        _this.timeout = timeout;
        RemoteStorageBridge.instanceCount += 1;
        return _this;
    }
    _(RemoteStorageBridge, [
        {
            key: "storeLogs",
            value: /**
   * 请求 iframe 页面存储日志数据
   */ function storeLogs(data) {
                var _this = this;
                return _$e(function() {
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    RemoteStorageBridge.storageDefer.promise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.postMessagePromise({
                                        message: {
                                            name: BridgeMessageName.REQUEST_STORE_LOG,
                                            instanceId: _this.instanceId,
                                            data: data
                                        },
                                        resolveMessageName: BridgeMessageName.STORE_LOG_SUCCESS,
                                        rejectMessageName: BridgeMessageName.STORE_LOG_FAILED
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "report",
            value: /**
   * 请求 iframe 页面上报
   */ function report(reportExt, onProgress) {
                var _this = this;
                return _$e(function() {
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    RemoteStorageBridge.storageDefer.promise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this.postMessagePromise({
                                        message: {
                                            name: BridgeMessageName.REQUEST_REPORT_LOG,
                                            instanceId: _this.instanceId,
                                            data: reportExt
                                        },
                                        resolveMessageName: BridgeMessageName.REPORT_LOG_SUCCESS,
                                        rejectMessageName: BridgeMessageName.REPORT_LOG_FAILED,
                                        progressMessageName: BridgeMessageName.REPORT_PROGRESS,
                                        onProgress: onProgress,
                                        timeout: REPORT_TIMEOUT
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "downloadLogs",
            value: /**
   * 请求 iframe ，下载日志到本地
   */ function downloadLogs() {
                var _this = this;
                return _$e(function() {
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    RemoteStorageBridge.storageDefer.promise
                                ];
                            case 1:
                                _state.sent();
                                _this.postMessage({
                                    instanceId: _this.instanceId,
                                    name: BridgeMessageName.REQUEST_DOWNLOAD_LOG
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "postMessagePromise",
            value: /** Promisify postMessage 接口，当对应消息返回时，分别 resolve / reject */ function postMessagePromise(param) {
                var _this = this;
                var message = param.message, resolveMessageName = param.resolveMessageName, rejectMessageName = param.rejectMessageName, progressMessageName = param.progressMessageName, _param_timeout = param.timeout, timeout = _param_timeout === void 0 ? this.timeout : _param_timeout, onProgress = param.onProgress;
                return new Promise(function(resolve, reject) {
                    var _this1 = _this;
                    var instanceId = message.instanceId;
                    var setResponseTimeout = function() {
                        return setTimeout(function() {
                            reject(new Error("PostMessage response timeout: ".concat(message.name, " / ").concat(message.instanceId)));
                            bindEvent(false);
                        }, timeout);
                    };
                    // 响应超时定时器
                    var timer = setResponseTimeout();
                    var bindEvent = function() {
                        var isBind = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                        var binder = isBind ? _this1.on.bind(_this1) : _this1.off.bind(_this1);
                        binder(progressMessageName, progressHandler);
                        binder(rejectMessageName, rejectHandler);
                        binder(resolveMessageName, resolveHandler);
                        if (isBind) return;
                        clearTimeout(timer);
                    };
                    // 如果收到对应的 Progress 事件，则刷新超时定时器，并触发对应的 onProgress 回调
                    var progressHandler = function(message) {
                        clearTimeout(timer);
                        timer = setResponseTimeout();
                        onProgress === null || onProgress === void 0 ? void 0 : onProgress(message.data.progress);
                    };
                    var rejectHandler = function(message) {
                        if (instanceId !== message.instanceId) return;
                        reject(message.data);
                        bindEvent(false);
                    };
                    var resolveHandler = function(message) {
                        if (instanceId !== message.instanceId) return;
                        resolve(message.data);
                        bindEvent(false);
                    };
                    bindEvent(true);
                    _this.postMessage(message);
                });
            }
        },
        {
            key: "destroy",
            value: /** destroy 一个 bridge 实例时，引用计数 -1，引用归零时销毁 iframe */ function destroy() {
                RemoteStorageBridge.instanceCount -= 1;
                if (RemoteStorageBridge.instanceCount <= 0) {
                    var _RemoteStorageBridge_iframeEl;
                    clearTimeout(RemoteStorageBridge.rejectTimeout);
                    RemoteStorageBridge.rejectTimeout = null;
                    (_RemoteStorageBridge_iframeEl = RemoteStorageBridge.iframeEl) === null || _RemoteStorageBridge_iframeEl === void 0 ? void 0 : _RemoteStorageBridge_iframeEl.remove();
                    RemoteStorageBridge.iframeEl = null;
                    RemoteStorageBridge.instanceCount = 0;
                    RemoteStorageBridge.storageDefer = new SimpleDefer();
                }
                _$g(_$h(RemoteStorageBridge.prototype), "destroy", this).call(this);
            }
        },
        {
            key: "receiverMessageHandler",
            value: /**
   * 继承基类方法，实现 iframe 等待 ready 逻辑
   */ function receiverMessageHandler(event) {
                if (!this.isBridgeMessage(event.data)) return;
                if (event.data.name === BridgeMessageName.STORAGE_READY) {
                    RemoteStorageBridge.storageDefer.resolve();
                    clearTimeout(RemoteStorageBridge.rejectTimeout);
                    return;
                }
                _$g(_$h(RemoteStorageBridge.prototype), "receiverMessageHandler", this).call(this, event);
            }
        }
    ], [
        {
            key: "getIframe",
            value: /** 创建 / 复用通信 Iframe 元素 */ function getIframe(url) {
                var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_IFRAME_TIMEOUT;
                if (RemoteStorageBridge.iframeEl) return RemoteStorageBridge.iframeEl;
                var iframeEl = document.createElement('iframe');
                iframeEl.src = url;
                document.body.append(iframeEl);
                iframeEl.style.display = 'none';
                iframeEl.classList.add(REMOTE_STORAGE_CLASS_NAME);
                RemoteStorageBridge.iframeEl = iframeEl;
                RemoteStorageBridge.rejectTimeout = window.setTimeout(function() {
                    RemoteStorageBridge.storageDefer.reject(new Error('IFrame wait timeout'));
                }, timeout);
                return iframeEl;
            }
        }
    ]);
    return RemoteStorageBridge;
}(MessageBridge);
/** iframe 上的 db 是否已准备好 */ _$2(RemoteStorageBridge, "storageDefer", new SimpleDefer());
/** iframe 元素，多实例情况下复用该标签，不重复创建 */ _$2(RemoteStorageBridge, "iframeEl", void 0);
/** iframe 的引用计数，每次 construct 时 +1， destroy -1，引用归零时，destroy 时移除 iframe 实例 */ _$2(RemoteStorageBridge, "instanceCount", 0);
/** 超时定时器，超时后将 defer.reject() */ _$2(RemoteStorageBridge, "rejectTimeout", void 0);

/**
 * 延迟 iframe 加载到起播后或播放出错导致的结束
 */ var offlineLogLazyLoadStrategy = function(player) {
    var defer = new SimpleDefer();
    var cb = function() {
        defer.resolve();
    };
    // 默认情况下播放 广告 / 正片 / 播放结束（防止失败），resolve 来开始加载 iframe
    player.once(H5_PLAY_EVENT.AD_PLAYING, cb);
    player.once(H5_PLAY_EVENT.VIDEO_PLAYING, cb);
    player.once(H5_PLAY_EVENT.PLAY_SESSION_END, cb);
    return defer;
};
/** 立即加载 Iframe */ var offlineLogEagerLoadStrategy = function() {
    var defer = new SimpleDefer();
    defer.resolve();
    return defer;
};

var PageWatcher = /*#__PURE__*/ function(EvtEmitter) {
    _$4(PageWatcher, EvtEmitter);
    var _super = _$5(PageWatcher);
    function PageWatcher() {
        _$1(this, PageWatcher);
        var _this;
        _this = _super.call(this);
        _$2(_$6(_this), "pageLeaveTimeStamp", void 0);
        _$2(_$6(_this), "pageUnloadTimeStamp", void 0);
        _$2(_$6(_this), "emitPageLeave", function() {
            if (document.visibilityState !== 'hidden') return;
            if (Date.now() - _this.pageLeaveTimeStamp <= PageWatcher.throttleGap) {
                return;
            }
            _this.pageLeaveTimeStamp = Date.now();
            _this.emit("pageLeave");
        });
        _$2(_$6(_this), "emitPageUnload", function() {
            if (Date.now() - _this.pageUnloadTimeStamp <= PageWatcher.throttleGap) {
                return;
            }
            _this.pageUnloadTimeStamp = Date.now();
            _this.emit("unload");
        });
        _this.setPageLeave();
        _this.setPageUnload();
        return _this;
    }
    _(PageWatcher, [
        {
            key: "setPageLeave",
            value: function setPageLeave() {
                window.addEventListener('pagehide', this.emitPageLeave);
                document.addEventListener('visibilitychange', this.emitPageLeave);
            }
        },
        {
            key: "setPageUnload",
            value: function setPageUnload() {
                window.addEventListener('beforeunload', this.emitPageUnload);
                window.addEventListener('unload', this.emitPageUnload);
            }
        }
    ]);
    return PageWatcher;
}(EvtEmitter);
_$2(PageWatcher, "throttleGap", 10);
var PageWatcherEvent;
(function(PageWatcherEvent) {
    PageWatcherEvent["PageLeave"] = "pageLeave";
    PageWatcherEvent["UNLOAD"] = "unload";
})(PageWatcherEvent || (PageWatcherEvent = {}));
var singleton = new PageWatcher();
var PageWatcher$1 = {
    instance: singleton,
    PageWatcherEvent: PageWatcherEvent
};

var WHITE_LIST_URL = 'https://v.qq.com/cache/wuji/object?appid=tenvideo_offline_log&schemaid=whiteListV2&schemakey=97c0ff59f25543e282072b75e4c287f7&otype=jsonp';
var cbIndex = 0;
/**
 * 拉取白名单
 * @param platform 平台号
 */ function fetchWhiteList(platform) {
    var timeout = 3000;
    var cbIndexRange = 200;
    var cb = 'offline_log';
    var params = encodeURIComponent('platform=["'.concat(platform, '"]&enable=true'));
    var requestUrl = "".concat(WHITE_LIST_URL, "&filter=").concat(params);
    cbIndex += 1;
    return netTool.jsonp(requestUrl, {
        name: cb + cbIndex % cbIndexRange,
        timeout: timeout
    });
}

var sha256$1 = {exports: {}};

var convertHex = {exports: {}};

(function (module) {
!function(globals) {

var convertHex = {
  bytesToHex: function(bytes) {
    /*if (typeof bytes.byteLength != 'undefined') {
      var newBytes = []

      if (typeof bytes.buffer != 'undefined')
        bytes = new DataView(bytes.buffer)
      else
        bytes = new DataView(bytes)

      for (var i = 0; i < bytes.byteLength; ++i) {
        newBytes.push(bytes.getUint8(i))
      }
      bytes = newBytes
    }*/
    return arrBytesToHex(bytes)
  },
  hexToBytes: function(hex) {
    if (hex.length % 2 === 1) throw new Error("hexToBytes can't have a string with an odd number of characters.")
    if (hex.indexOf('0x') === 0) hex = hex.slice(2);
    return hex.match(/../g).map(function(x) { return parseInt(x,16) })
  }
};


// PRIVATE

function arrBytesToHex(bytes) {
  return bytes.map(function(x) { return padLeft(x.toString(16),2) }).join('')
}

function padLeft(orig, len) {
  if (orig.length > len) return orig
  return Array(len - orig.length + 1).join('0') + orig
}


if (module.exports) { //CommonJS
  module.exports = convertHex;
} else {
  globals.convertHex = convertHex;
}

}(commonjsGlobal);
}(convertHex));

var convertString = {exports: {}};

(function (module) {
!function(globals) {

var convertString = {
  bytesToString: function(bytes) {
    return bytes.map(function(x){ return String.fromCharCode(x) }).join('')
  },
  stringToBytes: function(str) {
    return str.split('').map(function(x) { return x.charCodeAt(0) })
  }
};

//http://hossa.in/2012/07/20/utf-8-in-javascript.html
convertString.UTF8 = {
   bytesToString: function(bytes) {
    return decodeURIComponent(escape(convertString.bytesToString(bytes)))
  },
  stringToBytes: function(str) {
   return convertString.stringToBytes(unescape(encodeURIComponent(str)))
  }
};

if (module.exports) { //CommonJS
  module.exports = convertString;
} else {
  globals.convertString = convertString;
}

}(commonjsGlobal);
}(convertString));

(function (module) {
!function(globals) {

var _imports = {};

if (module.exports) { //CommonJS
  _imports.bytesToHex = convertHex.exports.bytesToHex;
  _imports.convertString = convertString.exports;
  module.exports = sha256;
} else {
  _imports.bytesToHex = globals.convertHex.bytesToHex;
  _imports.convertString = globals.convertString;
  globals.sha256 = sha256;
}

/*
CryptoJS v3.1.2
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/

// Initialization round constants tables
var K = [];

// Compute constants
!function () {
  function isPrime(n) {
    var sqrtN = Math.sqrt(n);
    for (var factor = 2; factor <= sqrtN; factor++) {
      if (!(n % factor)) return false
    }

    return true
  }

  function getFractionalBits(n) {
    return ((n - (n | 0)) * 0x100000000) | 0
  }

  var n = 2;
  var nPrime = 0;
  while (nPrime < 64) {
    if (isPrime(n)) {
      K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
      nPrime++;
    }

    n++;
  }
}();

var bytesToWords = function (bytes) {
  var words = [];
  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
    words[b >>> 5] |= bytes[i] << (24 - b % 32);
  }
  return words
};

var wordsToBytes = function (words) {
  var bytes = [];
  for (var b = 0; b < words.length * 32; b += 8) {
    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
  }
  return bytes
};

// Reusable object
var W = [];

var processBlock = function (H, M, offset) {
  // Working variables
  var a = H[0], b = H[1], c = H[2], d = H[3];
  var e = H[4], f = H[5], g = H[6], h = H[7];

    // Computation
  for (var i = 0; i < 64; i++) {
    if (i < 16) {
      W[i] = M[offset + i] | 0;
    } else {
      var gamma0x = W[i - 15];
      var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
                    ((gamma0x << 14) | (gamma0x >>> 18)) ^
                    (gamma0x >>> 3);

      var gamma1x = W[i - 2];
      var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
                    ((gamma1x << 13) | (gamma1x >>> 19)) ^
                    (gamma1x >>> 10);

      W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
    }

    var ch  = (e & f) ^ (~e & g);
    var maj = (a & b) ^ (a & c) ^ (b & c);

    var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
    var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

    var t1 = h + sigma1 + ch + K[i] + W[i];
    var t2 = sigma0 + maj;

    h = g;
    g = f;
    f = e;
    e = (d + t1) | 0;
    d = c;
    c = b;
    b = a;
    a = (t1 + t2) | 0;
  }

  // Intermediate hash value
  H[0] = (H[0] + a) | 0;
  H[1] = (H[1] + b) | 0;
  H[2] = (H[2] + c) | 0;
  H[3] = (H[3] + d) | 0;
  H[4] = (H[4] + e) | 0;
  H[5] = (H[5] + f) | 0;
  H[6] = (H[6] + g) | 0;
  H[7] = (H[7] + h) | 0;
};

function sha256(message, options) {  if (message.constructor === String) {
    message = _imports.convertString.UTF8.stringToBytes(message);
  }

  var H =[ 0x6A09E667, 0xBB67AE85, 0x3C6EF372, 0xA54FF53A,
           0x510E527F, 0x9B05688C, 0x1F83D9AB, 0x5BE0CD19 ];

  var m = bytesToWords(message);
  var l = message.length * 8;

  m[l >> 5] |= 0x80 << (24 - l % 32);
  m[((l + 64 >> 9) << 4) + 15] = l;

  for (var i=0 ; i<m.length; i += 16) {
    processBlock(H, m, i);
  }

  var digestbytes = wordsToBytes(H);
  return options && options.asBytes ? digestbytes :
         options && options.asString ? _imports.convertString.bytesToString(digestbytes) :
         _imports.bytesToHex(digestbytes)
}

sha256.x2 = function(message, options) {
  return sha256(sha256(message, { asBytes:true }), options)
};

}(commonjsGlobal);
}(sha256$1));

var sha256 = sha256$1.exports;

function validateWhiteListItem(item, commonKv) {
    var condEnc = item.condEnc;
    var keys = Object.keys(condEnc);
    return keys.every(function(conditionKey) {
        var valueToValid = condEnc[conditionKey];
        // 如果是数组，则遍历数组校验
        if (Array.isArray(valueToValid)) {
            return valueToValid.some(function(value) {
                return validateValue(value, commonKv[conditionKey]);
            });
        }
        // 否则校验值
        return validateValue(valueToValid, commonKv[conditionKey]);
    });
}
function isRegCondition(value) {
    return (typeof value === "undefined" ? "undefined" : _$3(value)) === 'object' && 'regStr' in value;
}
/**
 * 校验具体 key-value 是否和 播放器中同名属性值相等，如果 value 值为 string，则对比 sha256 后的计算值
 * @param conditionValue 校验值
 * @param playerValue 播放器上的实际值
 */ function validateValue(conditionValue, playerValue) {
    try {
        // 先处理正则配置，创建正则匹配校验值
        if (isRegCondition(conditionValue)) {
            var _conditionValue_flags = conditionValue.flags, flags = _conditionValue_flags === void 0 ? 'i' : _conditionValue_flags, regStr = conditionValue.regStr;
            return new RegExp(regStr, flags).test(String(playerValue));
        }
        // 如果是 string 类型，则判断下 sha256 值
        if (typeof conditionValue === 'string' && typeof playerValue === 'string') {
            return conditionValue === sha256(playerValue);
        }
        // 否则直接对比
        return conditionValue === playerValue;
    } catch (_err) {
        // 匹配失败，返回 false
        return false;
    }
}

/**
 * 离线日志插件，用于收集播放产生的 Logger 日志并按需上报至管理台
 */ var OfflineLogPlugin = /*#__PURE__*/ function(Plugin) {
    _$4(OfflineLogPlugin, Plugin);
    var _super = _$5(OfflineLogPlugin);
    function OfflineLogPlugin(player, opts, extra) {
        _$1(this, OfflineLogPlugin);
        var _this;
        _this = _super.call(this, player, opts, extra);
        _$2(_$6(_this), "config", void 0);
        /** iframe 抽象的 iframeBridge */ _$2(_$6(_this), "remoteStorage", void 0);
        /** 页面监听器，在页面即将销毁、页面切换 tab 时存储日志 */ _$2(_$6(_this), "pageWatcher", PageWatcher$1.instance);
        /** 日志输出 Logger 实例 */ _$2(_$6(_this), "logger", void 0);
        /** 轮询读取 Logger 时间 */ _$2(_$6(_this), "pollTimer", void 0);
        /** 日志索引数据变更情况，存在变更后，下次轮询存储变更信息 */ _$2(_$6(_this), "logInfoChange", {});
        /** 标志插件是否已执行 destroy 方法，因为 destroy 方法是异步的，所以不能拿 this.player 标志 */ _$2(_$6(_this), "isDestroy", false);
        /** 外部允许加载存储 iframe 且 iframe 已经准备好的 defer */ _$2(_$6(_this), "storageDefer", new SimpleDefer());
        _$2(_$6(_this), "onPageLeave", function() {
            _this.storeLogs();
        });
        var _this1 = _$6(_this);
        /**
   * 获取日志数据变更，并通知 iframe 写入到 indexedDB 中
   * @param ext 存储扩展字段
   */ _$2(_$6(_this), "storeLogs", function() {
            var _ref = _$e(function(ext) {
                var instanceId, cache, messageData, shouldStore, err;
                return _$f(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            instanceId = _this1.instanceId;
                            // 若前置为异步操作，则可能在 storeLogs 时，插件已经销毁，此时不执行任何操作
                            if (!instanceId) return [
                                2
                            ];
                            cache = getLogCache(instanceId);
                            messageData = {
                                logs: cache,
                                info: _this1.logInfoChange,
                                ext: ext
                            };
                            // 有变更，才通知 iframe 存储
                            shouldStore = ext || messageData.logs.length || Boolean(Object.keys(_this1.logInfoChange).length);
                            clearLogCache(instanceId);
                            _this1.logInfoChange = {};
                            if (!shouldStore) return [
                                2
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                _this1.storageDefer.promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                _this1.remoteStorage.storeLogs(messageData)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 4:
                            err = _state.sent();
                            // iframe storage 在初始化阶段就失败掉了，这种情况下静默失败
                            if (_$7(err, StorageInitError)) {
                                return [
                                    2
                                ];
                            }
                            // 留下异常日志
                            _this1.logger.error("OfflineLog storeLogs failed: ".concat(err));
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(ext) {
                return _ref.apply(this, arguments);
            };
        }());
        _$2(_$6(_this), "onPlayerError", function(evt) {
            var _evt_data_videoInfo_error, _evt_data_videoInfo, _evt_data;
            _this.logInfoChange.code = (_evt_data = evt.data) === null || _evt_data === void 0 ? void 0 : (_evt_data_videoInfo = _evt_data.videoInfo) === null || _evt_data_videoInfo === void 0 ? void 0 : (_evt_data_videoInfo_error = _evt_data_videoInfo.error) === null || _evt_data_videoInfo_error === void 0 ? void 0 : _evt_data_videoInfo_error.code;
            _this.storeLogs();
        });
        _this.config = _$b({}, DEFAULT_CONFIG, opts || {}, _this.player.config.offlineConfig);
        _this.logger = new Logger(_this.instanceId, OfflineLogPlugin.pluginName);
        _this.initStorage();
        _this.logEnvInfo();
        _this.setPageWatcher();
        _this.setPlayerEvt();
        _this.checkWhiteList();
        return _this;
    }
    _(OfflineLogPlugin, [
        {
            key: "destroy",
            value: function destroy() {
                var _this = this;
                var _this1 = this, _superprop_get_destroy = function() {
                    return _$g(_$h(OfflineLogPlugin.prototype), "destroy", _this);
                };
                return _$e(function() {
                    var _this_remoteStorage;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    ,
                                    2,
                                    3
                                ]);
                                _this1.isDestroy = true;
                                _this1.setPollLogger(false);
                                _this1.setPageWatcher(false);
                                _this1.setPlayerEvt(false);
                                // 尝试在销毁前写入最后一些日志
                                return [
                                    4,
                                    _this1.storeLogs({
                                        clearContentCache: true
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                (_this_remoteStorage = _this1.remoteStorage) === null || _this_remoteStorage === void 0 ? void 0 : _this_remoteStorage.destroy();
                                // 这里无论 defer 状态如何，reject 一下
                                _this1.storageDefer.reject();
                                _superprop_get_destroy().call(_this1);
                                return [
                                    7
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "report",
            value: /**
   * 上报离线日志
   * @deprecated 粒度太粗，建议使用 reportLogs 接口
   * @param isForce 是否强制上报，在非白名单时，必须指定强制上报，否则什么也不做
   * @param from 用于管理台区分上报来源
   */ function report(isForce, from, onProgress) {
                var _this = this;
                return _$e(function() {
                    var err;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // 不是强制上报，也不在白名单中时，不上报数据
                                if (!isForce) {
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.remoteStorage.report({
                                        // 白名单上报时，不要触发上报失败下载日志到本地逻辑
                                        downloadOnFailed: isForce,
                                        reportSource: from,
                                        onlyCurrent: false
                                    }, onProgress)
                                ];
                            case 2:
                                _state.sent();
                                // 兼容老的接口调用
                                return [
                                    2,
                                    {
                                        status: true,
                                        msg: ''
                                    }
                                ];
                            case 3:
                                err = _state.sent();
                                return [
                                    2,
                                    {
                                        status: false,
                                        msg: err.message
                                    }
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "reportLogs",
            value: /**
   * 上报离线日志，默认上报当前播放的日志
   * @param config 日志上报配置
   * @param onProgress 上报进度回调函数
   */ function reportLogs(config, onProgress) {
                var _this = this;
                return _$e(function() {
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    ,
                                    2,
                                    3
                                ]);
                                // 先立即把日志缓存同步到 DB 中
                                return [
                                    4,
                                    _this.storeLogs()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                return [
                                    2,
                                    _this.remoteStorage.report(_$b({}, DEFAULT_REPORT_OPTIONS, config), onProgress)
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "downloadLogs",
            value: /**
   * 下载日志到本地
   */ function downloadLogs() {
                return this.remoteStorage.downloadLogs();
            }
        },
        {
            key: "logEnvInfo",
            value: /**
   * 打印一些环境相关信息放到 Logger 中
   * 每次 SessionStart 都打印一次，用于区隔播放列表中的播放项
   */ function logEnvInfo() {
                try {
                    this.logger.log("URL: ".concat(location.href));
                    this.logger.log("TOP URL: ".concat(urlTool.getTopFrameUrl()));
                    this.logger.log("Kernel List: ".concat(Object.keys(KernelFactory.kernelMap).join(',')));
                    this.logger.log("PlayItem: ".concat(jsonTool.safelyStringify(this.player.currentPlayItem)));
                } catch (e) {
                // do nothing
                }
            }
        },
        {
            key: "initStorage",
            value: /**
   * 创建 iframe 存储实例
   * 完成后开始轮询写日志
   */ function initStorage() {
                var _this = this;
                return _$e(function() {
                    var _this_config, _this_config_loadStrategy, loadStrategy, _this_config_iframePath, iframePath, err;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_config = _this.config, _this_config_loadStrategy = _this_config.loadStrategy, loadStrategy = _this_config_loadStrategy === void 0 ? offlineLogEagerLoadStrategy : _this_config_loadStrategy, _this_config_iframePath = _this_config.iframePath, iframePath = _this_config_iframePath === void 0 ? RECORDER_DEPLOY_URL : _this_config_iframePath;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                // 外部可配置的延迟加载策略，先等待它 resolve
                                return [
                                    4,
                                    loadStrategy(_this.player).promise
                                ];
                            case 2:
                                _state.sent();
                                _this.remoteStorage = new RemoteStorageBridge(iframePath, _this.instanceId);
                                return [
                                    4,
                                    RemoteStorageBridge.storageDefer.promise
                                ];
                            case 3:
                                _state.sent();
                                _this.storageDefer.resolve();
                                // 如果在等待 ready 的过程中，有调用 destroy 方法，则不进行后续操作
                                if (_this.isDestroy) return [
                                    2
                                ];
                                _this.downloadOnQuery();
                                _this.setPollLogger();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                err = _state.sent();
                                _this.storageDefer.reject(new StorageInitError((err === null || err === void 0 ? void 0 : err.message) || ''));
                                _this.logger.error("Error occur when init DB: ".concat(err));
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "downloadOnQuery",
            value: /**
   * 当页面的 url 存在特定 query 参数，下载日志
   * 同时使用一个 static 变量保证这个自动下载的操作只进行一次
   */ function downloadOnQuery() {
                var useDownload = location.search.includes(DOWNLOAD_LOGS_QUERY);
                // 如果没有下载过日志，且 url 中设置播放器创建后下载日志
                if (!OfflineLogPlugin.hasDownloadOnInit && useDownload) {
                    // 则开始下载日志
                    this.downloadLogs();
                    // 并设置状态，防止重复下载
                    OfflineLogPlugin.hasDownloadOnInit = true;
                }
            }
        },
        {
            key: "checkWhiteList",
            value: /**
   * 校验白名单，如果命中白名单则调用白名单上报
   * 使用一个变量保证只获取一次白名单，且在白名单时仅上报一次
   */ function checkWhiteList() {
                var _this = this;
                return _$e(function() {
                    var platform, _ref, whiteList, err;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                platform = _this.config.platform;
                                // 如果已经获取过，则不再尝试获取
                                if (OfflineLogPlugin.whiteListLoadDefer) return [
                                    2
                                ];
                                OfflineLogPlugin.whiteListLoadDefer = new SimpleDefer();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    fetchWhiteList(platform)
                                ];
                            case 2:
                                _ref = _state.sent(), whiteList = _ref.data;
                                // 把自定义的 JSON 上报配置取出来
                                OfflineLogPlugin.whiteList = whiteList;
                                OfflineLogPlugin.whiteListLoadDefer.resolve();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                err = _state.sent();
                                OfflineLogPlugin.whiteListLoadDefer.reject();
                                _this.logger.error("@OfflineLogPlugin.checkWhiteList(), err=".concat(err));
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setPollLogger",
            value: /**
   * 设置 Logger 轮询，隔一段时间从 Logger 中获取日志并写入
   */ function setPollLogger() {
                var enable = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var _this_config = this.config, _this_config_pollTime = _this_config.pollTime, pollTime = _this_config_pollTime === void 0 ? 3000 : _this_config_pollTime;
                clearInterval(this.pollTimer);
                if (enable) {
                    this.pollTimer = window.setInterval(this.storeLogs, pollTime);
                }
            }
        },
        {
            key: "setPageWatcher",
            value: /** 添加监听，当页面 unload 或者 hide 时，把日志写入，防止日志丢失 */ function setPageWatcher() {
                var isBind = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var watcher = this.pageWatcher;
                var binder = isBind ? watcher.on.bind(watcher) : watcher.off.bind(watcher);
                binder(PageWatcher$1.PageWatcherEvent.PageLeave, this.onPageLeave);
                binder(PageWatcher$1.PageWatcherEvent.UNLOAD, this.onPageLeave);
            }
        },
        {
            key: "setPlayerEvt",
            value: /**
   * 监听播放器出错，出错时写入日志
   */ function setPlayerEvt() {
                var isBind = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var binder = isBind ? this.player.on.bind(this.player) : this.player.off.bind(this.player);
                binder(PLAY_EVENT.ERROR, this.onPlayerError);
            }
        },
        {
            key: "hookVideoReqInfoEnd",
            value: /**
   * GetInfo 出错时写入状态码，正常情况下写入视频标题
   */ function hookVideoReqInfoEnd(param) {
                var _param_data_error, _param_data;
                var code = (_param_data = param.data) === null || _param_data === void 0 ? void 0 : (_param_data_error = _param_data.error) === null || _param_data_error === void 0 ? void 0 : _param_data_error.code;
                if (code) {
                    this.logInfoChange.code = code;
                }
                this.logInfoChange.videoName = this.player.dataset.commonMap.videoName;
                this.storeLogs();
            }
        },
        {
            key: "hookPlaySessionStart",
            value: /**
   * SessionStart 时先收集一次静态数据，打印环境信息
   */ function hookPlaySessionStart() {
                var _this = this;
                return _$e(function() {
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.logInfoChange = _this.collectLogInfo();
                                _this.logEnvInfo();
                                return [
                                    4,
                                    _this.storeLogs()
                                ];
                            case 1:
                                _state.sent();
                                // 查询自定义 json 白名单上报情况，命中则上报
                                _this.triggerReportIfHit(WhiteListReportHook.PLAY_SESSION_START);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "hookPlaySessionEnd",
            value: /**
   * 播放结束后收集播放状态码并存储
   */ function hookPlaySessionEnd(param) {
                var _this = this;
                return _$e(function() {
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.logInfoChange.code = param.code;
                                return [
                                    4,
                                    _this.storeLogs({
                                        clearInfoCache: true
                                    })
                                ];
                            case 1:
                                _state.sent();
                                // 查询自定义 json 白名单上报情况，命中则上报
                                _this.triggerReportIfHit(WhiteListReportHook.PLAY_SESSION_END, param.code);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "triggerReportIfHit",
            value: /**
   * 检查自定义 JSON 上报白名单是否命中，如果命中了，则触发对应的上报规则
   */ function triggerReportIfHit(hook, code) {
                var _this = this;
                return _$e(function() {
                    var err, commonMap, conf;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // 先判断爬虫，如果是的话，不触发上报
                                // 或者 Defer 不知道怎么消失了，也不上报（逻辑有错误）
                                if (uaTool.spider || !OfflineLogPlugin.whiteListLoadDefer) return [
                                    2
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                // 等白名单拉下来
                                return [
                                    4,
                                    OfflineLogPlugin.whiteListLoadDefer.promise
                                ];
                            case 2:
                                _state.sent();
                                // 如果等到白名单拉下来了，插件被 destroy 了，没必要上报
                                if (_this.isDestroy) return [
                                    2
                                ];
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                err = _state.sent();
                                // 失败了，兜住错误
                                _this.logger.error("@OfflineLogPlugin.triggerReportIfHitCustom(), err=".concat(err));
                                return [
                                    2
                                ];
                            case 4:
                                commonMap = _this.player.dataset.commonMap;
                                conf = OfflineLogPlugin.whiteList.filter(function(conf) {
                                    return conf.hook === hook;
                                }).find(function(conf) {
                                    return validateWhiteListItem(conf, _$c(_$b({}, commonMap), {
                                        code: code
                                    }));
                                });
                                if (!(conf && Math.random() <= conf.rate)) return [
                                    3,
                                    8
                                ];
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                // 等 iframe 创建
                                return [
                                    4,
                                    _this.storageDefer.promise
                                ];
                            case 6:
                                _state.sent();
                                // 开始上报
                                return [
                                    2,
                                    _this.remoteStorage.report({
                                        onlyCurrent: conf.action === WhiteListReportType.Single,
                                        downloadOnFailed: false,
                                        reportSource: conf.reason || ReportSource.WHITE_LIST
                                    })
                                ];
                            case 7:
                                _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "collectLogInfo",
            value: /**
   * 从数据中心收集本次播放的静态数据
   */ function collectLogInfo() {
                var commonMap = this.player.dataset.commonMap;
                var guid = commonMap.guid, drm = commonMap.drm, videoName = commonMap.videoName, vid = commonMap.vid, hcVuserid = commonMap.hc_vuserid, flowid = commonMap.flowid, platform = commonMap.platform;
                return {
                    code: '',
                    drm: Boolean(drm),
                    startTime: Date.now(),
                    endTime: Date.now(),
                    guid: guid,
                    ua: navigator.userAgent,
                    url: location.href,
                    videoName: videoName,
                    vid: vid,
                    platform: platform,
                    vuid: hcVuserid,
                    instanceId: this.instanceId,
                    id: flowid
                };
            }
        },
        {
            key: "instanceId",
            get: function get() {
                // 注意：有可能被异步回调取值，如果此时插件销毁，会抛出异常，因此需要 optional
                return this.player.config.instanceId;
            }
        }
    ], [
        {
            key: "isEnvSupport",
            get: function get() {
                return typeof window.Proxy === 'function';
            }
        }
    ]);
    return OfflineLogPlugin;
}(_$d(Plugin));
_$2(OfflineLogPlugin, "pluginName", 'offlineLog');
/** 白名单数据拉取的 Defer，同时作为一个 Lock 来防止重复拉白名单 */ _$2(OfflineLogPlugin, "whiteListLoadDefer", void 0);
/** 是否初始化时，就已经下载过日志，保证多个播放器时，不会重复下载日志 */ _$2(OfflineLogPlugin, "hasDownloadOnInit", false);
/** 自定义 JSON 上报映射表，当 */ _$2(OfflineLogPlugin, "whiteList", []);
var DEFAULT_CONFIG = {
    platform: '1',
    disable: false,
    pollTime: 3000
};
/** 离线日志 iframe 页部署地址，部署项目 https://git.woa.com/vfe/v.qq.com_static，默认 1h 强缓存 */ var RECORDER_DEPLOY_URL = 'https://v.qq.com/thumbplayer-offline-log.html?max_age=3600';
/** 播放器页面中，如果存在这个 query，则创建离线日志 iframe 时，自动下载日志到本地 */ var DOWNLOAD_LOGS_QUERY = 'thumbplayer_download_logs=1';

var CoreType;
(function(CoreType) {
    CoreType["VIDEO"] = "video";
    CoreType["AD"] = "ad";
})(CoreType || (CoreType = {}));
var CorePool = /*#__PURE__*/ function() {
    function CorePool() {
        _$1(this, CorePool);
        _$2(this, "coreInstanceMap", {});
    }
    _(CorePool, [
        {
            key: "destroy",
            value: function destroy() {
                var _this = this;
                Object.keys(this.coreInstanceMap).forEach(function(key) {
                    return _this.coreInstanceMap[key].destroy();
                });
                this.coreInstanceMap = null;
            }
        },
        {
            key: "create",
            value: /**
   * 创建core实例（目前一种类型仅创建一个core实例）
   */ function create(type, config) {
                if (!this.coreInstanceMap[type] && config) {
                    this.coreInstanceMap[type] = this.newCore(config);
                }
                return this.coreInstanceMap[type];
            }
        },
        {
            key: "get",
            value: /**
   * 获取core实例（如果没有返回空值）
   */ function get(type) {
                return this.coreInstanceMap[type];
            }
        },
        {
            key: "newCore",
            value: /**
   * 新创建core对象
   */ function newCore(config) {
                // 移动端默认启用单video模式
                var useSingleVideoElement = config.useSingleVideoElement;
                config.maxVideoNodeCount = useSingleVideoElement ? 1 : config === null || config === void 0 ? void 0 : config.maxVideoNodeCount;
                config.createVideoNodeWhenLoad = useSingleVideoElement;
                return new KernelProxy(config);
            }
        }
    ]);
    return CorePool;
}();
var poolMap = {};
function getCorePool(h5PlayerInstanceId) {
    if (!poolMap[h5PlayerInstanceId]) {
        poolMap[h5PlayerInstanceId] = new CorePool();
    }
    return poolMap[h5PlayerInstanceId];
}
function destroyCorePool(h5PlayerInstanceId) {
    if (poolMap[h5PlayerInstanceId]) {
        var _poolMap_h5PlayerInstanceId;
        (_poolMap_h5PlayerInstanceId = poolMap[h5PlayerInstanceId]) === null || _poolMap_h5PlayerInstanceId === void 0 ? void 0 : _poolMap_h5PlayerInstanceId.destroy();
        poolMap[h5PlayerInstanceId] = null;
    }
}
var FlowNodeUseCoreMap = /*#__PURE__*/ function() {
    function FlowNodeUseCoreMap() {
        _$1(this, FlowNodeUseCoreMap);
    }
    _(FlowNodeUseCoreMap, null, [
        {
            key: "use",
            value: /**
   * 注册core被某个FlowNode占用
   */ function use(coreInstanceId, uid) {
                if (!this.coreHoldCountMap[coreInstanceId]) {
                    this.coreHoldCountMap[coreInstanceId] = [];
                }
                this.coreHoldCountMap[coreInstanceId].push(uid);
            }
        },
        {
            key: "free",
            value: /**
   * 释放core被某个FlowNode占用
   */ function free(coreInstanceId, uid) {
                if (!this.coreHoldCountMap[coreInstanceId]) {
                    return;
                }
                var idx = this.coreHoldCountMap[coreInstanceId].indexOf(uid);
                if (idx !== -1) {
                    this.coreHoldCountMap[coreInstanceId].splice(idx, 1);
                }
            }
        },
        {
            key: "isHoldByOther",
            value: /** 判断core是否被其他FlowNode占用 */ function isHoldByOther(coreInstanceId, uid) {
                if (!this.coreHoldCountMap[coreInstanceId]) {
                    return false;
                }
                var count = 0;
                this.coreHoldCountMap[coreInstanceId].forEach(function(u) {
                    if (u !== uid) {
                        count++;
                    }
                });
                return count > 0;
            }
        }
    ]);
    return FlowNodeUseCoreMap;
}();
/** 引用计数来确定core实例被占用的情况：instanceId对应一组FlowNode的uid */ _$2(FlowNodeUseCoreMap, "coreHoldCountMap", {});

/** 必须要session开始了才能调用的函数守卫 */ var sessionStarted = function(_target, propertyKey, desc) {
    var func = desc.value;
    desc.value = function sessionStarted() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (this.flowManager.isCurrentSessionEmpty) {
            this.logger.warn("session not started, cannot call ".concat(propertyKey));
            return;
        }
        return func.apply(this, args);
    };
};

/** 用局部变量保存getinfo模块实例 */ var getinfoModuleMap = {};
/**
* 创建getinfo模块
*/ function createGetinfoModule(GetinfoModule, config, extra) {
    var instanceId = config.instanceId;
    var getinfoModule = getinfoModuleMap[instanceId];
    if (!getinfoModule) {
        getinfoModule = new GetinfoModule(config, extra);
        getinfoModuleMap[instanceId] = getinfoModule;
    }
    return getinfoModule;
}
/**
* 销毁getinfo模块
*/ function destroyGetinfoModule(instanceId) {
    var _getinfoModuleMap_instanceId;
    (_getinfoModuleMap_instanceId = getinfoModuleMap[instanceId]) === null || _getinfoModuleMap_instanceId === void 0 ? void 0 : _getinfoModuleMap_instanceId.destroy();
    delete getinfoModuleMap[instanceId];
}
function getGetinfoModule(instanceId) {
    return getinfoModuleMap[instanceId];
}
function hasGetinfoModule(instanceId) {
    return instanceId in getinfoModuleMap;
}

/** 将传入二维数组里的插件类转换成插件名，同时提供类型校验 */ function definePlugins(plugins) {
    return plugins.map(function(p) {
        return [
            p[0].pluginName,
            p[1]
        ];
    });
}
/**
 * 自动监听player事件
 * @param {string} [name] 要监听的事件名，默认会使用函数名.slice(2)
 * @returns {Function}
 */ function autobind(name) {
    return function(_target, key, desc) {
        var evtName = name;
        // 没传入name时从函数名推断事件名
        if (!evtName) {
            // onPlayerEvent, onXX
            var nameOffset = 'on'.length;
            var evt = key.slice(nameOffset).toLowerCase();
            var evtKey = Object.keys(PLAY_EVENT).find(function(key) {
                return PLAY_EVENT[key].toLowerCase() === evt;
            });
            if (evtKey) {
                evtName = PLAY_EVENT[evtKey];
            } else {
                evtKey = Object.keys(H5_PLAY_EVENT).find(function(key) {
                    return H5_PLAY_EVENT[key].toLowerCase() === evt;
                });
                evtName = H5_PLAY_EVENT[evtKey];
            }
        }
        var rawValue = desc.value;
        desc.value = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (evtName && this.player) {
                this.player.on(evtName, rawValue.bind(this));
            } else {
                rawValue.apply(this, args);
            }
        };
    };
}
/**
 * 记录接口调用和调用参数到离线日志
 * !注意：此装饰器会JSON.stringify参数，如果有高频调用、超大参数可能导致性能问题。
 */ var logApiInvoke = function(_target, name, desc) {
    var rawValue = desc.value;
    desc.value = function logApiInvoke() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var argString = '';
        try {
            argString = JSON.stringify(args);
        } catch (e) {
            argString = 'parse arg failed';
        }
        this.setStateKv(name, {
            type: LogType.API_INVOKE,
            ftime: Date.now(),
            ext: {
                from: 'thumbplayer-h5',
                // stringify是为了过滤函数属性，避免indexedDB报错
                args: argString
            }
        });
        return rawValue.apply(this, args);
    };
};
function tryEmit(emitFunc, logger) {
    try {
        emitFunc();
    } catch (err) {
        logger === null || logger === void 0 ? void 0 : logger.error(err);
    }
}
function getEnvVals() {
    var VERSION = '';
    try {
        // @ts-ignore
        VERSION = "1.39.6";
    } catch (e) {}
    var BUILD_TIME = '';
    try {
        // @ts-ignore
        BUILD_TIME = 1741242058678;
    } catch (e) {}
    return {
        VERSION: VERSION,
        BUILD_TIME: BUILD_TIME
    };
}
/** 请求广告服务，获取指定类型的广告订单 */ function getAdInfo(instanceId, vid, adType, adParam) {
    var getinfoModule = getGetinfoModule(instanceId);
    if (!getinfoModule) {
        // TODO: 应该抛出错误？
        return Promise.resolve(undefined);
    }
    var adParams = getAdReqParams(instanceId, _$b({
        adType: adType,
        vid: vid
    }, adParam));
    return getinfoModule.requestAd(adParams);
}

/**
 * 一个播放流程的上下文，流程中每个节点拥有此上下文引用。
 */ var FlowContext = /*#__PURE__*/ function() {
    function FlowContext(opts) {
        _$1(this, FlowContext);
        _$2(this, "configInner", void 0);
        _$2(this, "playItemInner", void 0);
        _$2(this, "flowidInner", void 0);
        _$2(this, "playParamInner", void 0);
        _$2(this, "sessionActiveDeferInner", void 0);
        _$2(this, "remainTimeGetterInner", void 0);
        _$2(this, "logger", void 0);
        this.logger = new Logger(opts.config.instanceId, 'FlowContext');
        this.configInner = opts.config;
        this.playItemInner = opts.playItem;
        this.flowidInner = opts.flowid;
        this.playParamInner = opts.playParam || {};
        if (opts.isPreload) {
            this.sessionActiveDeferInner = new SimpleDefer();
        }
    }
    _(FlowContext, [
        {
            key: "destroy",
            value: function destroy() {
                this.configInner = null;
                this.playItemInner = null;
                this.flowidInner = null;
                this.playParamInner = null;
                this.sessionActiveDeferInner = null;
                this.remainTimeGetterInner = null;
                this.logger = null;
            }
        },
        {
            key: "getActiveDefer",
            value: function getActiveDefer() {
                var _this_sessionActiveDeferInner;
                return (_this_sessionActiveDeferInner = this.sessionActiveDeferInner) === null || _this_sessionActiveDeferInner === void 0 ? void 0 : _this_sessionActiveDeferInner.promise;
            }
        },
        {
            key: "active",
            value: function active() {
                if (this.sessionActiveDeferInner) {
                    this.sessionActiveDeferInner.resolve();
                    this.sessionActiveDeferInner = null;
                }
            }
        },
        {
            key: "isActive",
            get: /** 是否被激活，未激活代表是在预加载session中 */ function get() {
                return !this.sessionActiveDeferInner;
            }
        },
        {
            key: "config",
            get: function get() {
                return this.configInner;
            }
        },
        {
            key: "instanceId",
            get: /**
   * 播放器的实例id
   */ function get() {
                return this.configInner.instanceId;
            }
        },
        {
            key: "isUrlMode",
            get: /**
   * 是否是urlConfig播放（否则是vid播放模式，需要请求后台获取url）
   */ function get() {
                return !isVideoId(this.playItemInner);
            }
        },
        {
            key: "isLive",
            get: function get() {
                return this.configInner.type === PLAY_MODE.LIVE;
            }
        },
        {
            key: "playItem",
            get: function get() {
                return this.playItemInner;
            },
            set: function set(value) {
                this.playItemInner = value;
            }
        },
        {
            key: "remainTimeGetter",
            get: /**
   * 获取剩余时间信息。这个回调跟节点的预加载相关，预加载可能需要参考其他节点的剩余时间信息。
   */ function get() {
                return this.remainTimeGetterInner;
            },
            set: function set(value) {
                this.remainTimeGetterInner = value;
            }
        },
        {
            key: "vid",
            get: function get() {
                return this.playItemInner;
            }
        },
        {
            key: "playParam",
            get: function get() {
                return this.playParamInner;
            }
        },
        {
            key: "flowid",
            get: function get() {
                return this.flowidInner;
            }
        },
        {
            key: "updatePlayParam",
            value: function updatePlayParam() {
                var playParam = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                // 补齐一下，否则更新字段可能报错
                if (!this.playParamInner.videoLoadParam) {
                    this.playParamInner.videoLoadParam = {};
                }
                if (!this.playParamInner.videoReqInfoParam) {
                    this.playParamInner.videoReqInfoParam = {};
                }
                var _this_playParamInner_videoLoadParam = this.playParamInner.videoLoadParam, assignKernelNameByUser = _this_playParamInner_videoLoadParam.kernelName;
                var videoReqInfoParam = playParam.videoReqInfoParam, videoLoadParam = playParam.videoLoadParam;
                if (videoLoadParam) {
                    Object.assign(this.playParamInner.videoLoadParam, videoLoadParam);
                }
                if (videoReqInfoParam) {
                    Object.assign(this.playParamInner.videoReqInfoParam, videoReqInfoParam);
                }
                if (assignKernelNameByUser) {
                    // 如果用户最开始就指定了kernelName，那么需要保留这个kernelName并且传入core的load接口的第二个参数。
                    // 第二个参数的kernelName相比urlConfig中的kernelName优先级更高）
                    this.playParamInner.videoLoadParam.kernelName = assignKernelNameByUser;
                }
            }
        },
        {
            key: "corePlayParam",
            get: function get() {
                return this.playParamInner.videoLoadParam;
            }
        },
        {
            key: "getUrlConfigByPlayItem",
            value: /**
   * 根据h5player层传入的playItem播放参数换成core播放需要的urlConfig
   * @param getinfoCtx 可能是未解析的getinfo结果
   */ function getUrlConfigByPlayItem(getinfoCtx) {
                var _this = this;
                return _$e(function() {
                    var urlConfig, ret;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isVideoId(_this.playItemInner)) return [
                                    3,
                                    4
                                ];
                                if (!(getinfoCtx === null || getinfoCtx === void 0 ? void 0 : getinfoCtx.urlConfig)) return [
                                    3,
                                    1
                                ];
                                _this.logger.log('get urlConfig, exist');
                                // 这个数据是解析过的
                                urlConfig = getinfoCtx.urlConfig;
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                _this.logger.log('get urlConfig, need req');
                                return [
                                    4,
                                    _this.getVideoInfo(getinfoCtx)
                                ];
                            case 2:
                                ret = _state.sent();
                                urlConfig = ret === null || ret === void 0 ? void 0 : ret.urlConfig;
                                _state.label = 3;
                            case 3:
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                urlConfig = _this.playItemInner;
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    urlConfig
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getVideoInfo",
            value: function getVideoInfo(getinfoCtx) {
                var _this = this;
                return _$e(function() {
                    var getinfoModule, ret, _this_sessionActiveDeferInner, _ret_resData;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                getinfoModule = getGetinfoModule(_this.config.instanceId);
                                if (!getinfoModule) {
                                    // TODO: 应该抛出错误？
                                    return [
                                        2,
                                        Promise.resolve(undefined)
                                    ];
                                }
                                ret = undefined;
                                if (!(getinfoCtx === null || getinfoCtx === void 0 ? void 0 : getinfoCtx.resData)) return [
                                    3,
                                    2
                                ];
                                _this.logger.log('has resData, parse');
                                return [
                                    4,
                                    getinfoModule.parseResData(_this.vid, getinfoCtx)
                                ];
                            case 1:
                                // 这个数据是有服务端返回结果，但是没有经过解析的
                                ret = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                _this.logger.log('getVideoInfo, request vinfo');
                                return [
                                    4,
                                    getinfoModule.request(_this.vid, {
                                        // bugfix:
                                        // 如果走GetVideoInfoFlowNode节点请求getvinfo数据时，请求参数有用当前context（无论时当前播放还是预加载下一集的）覆盖flowid。
                                        // 但是有一种情况可能走到这里：
                                        // 预加载下一集的session开始执行，但是GetVideoInfoFlowNode节点预加载失败，于是继续预加载广告，没有广告继续预加载正片，此时就会走到
                                        // 这个分支。但是由于是预加载session，因此flowid一定要用当前的context的flowid，bug修复前并没有强行传入flowid参数，导致getinfo
                                        // 模块内部自己去数据中心取了错误的flowid去请求
                                        vinfoParams: _$c(_$b({}, _this.playParamInner.videoReqInfoParam), {
                                            flowid: _this.flowidInner
                                        }),
                                        emitEvtDefer: (_this_sessionActiveDeferInner = _this.sessionActiveDeferInner) === null || _this_sessionActiveDeferInner === void 0 ? void 0 : _this_sessionActiveDeferInner.promise
                                    })
                                ];
                            case 3:
                                ret = _state.sent();
                                _this.logger.log('getVideoInfo, request vinfo over, code=', (_ret_resData = ret.resData) === null || _ret_resData === void 0 ? void 0 : _ret_resData.code);
                                _state.label = 4;
                            case 4:
                                if (ret.error) {
                                    throw ret.error;
                                }
                                return [
                                    2,
                                    ret
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAdInfo",
            value: function getAdInfo1(adType, adParam) {
                return getAdInfo(this.configInner.instanceId, this.playItemInner, adType, adParam);
            }
        }
    ]);
    return FlowContext;
}();

/** 用于FlowNode实例的uid自增 */ var uidBase = 0;
var BaseFlowNode = /*#__PURE__*/ function(EvtEmitter) {
    _$4(BaseFlowNode, EvtEmitter);
    var _super = _$5(BaseFlowNode);
    function BaseFlowNode(ctx) {
        _$1(this, BaseFlowNode);
        var _this;
        _this = _super.call(this);
        _$2(_$6(_this), "isDestroyed", false);
        _$2(_$6(_this), "curState", FlowNodeState.IDLE);
        _$2(_$6(_this), "preState", FlowNodeState.IDLE);
        _$2(_$6(_this), "context", void 0);
        _$2(_$6(_this), "flowid", void 0);
        _$2(_$6(_this), "uid", void 0);
        _$2(_$6(_this), "logger", void 0);
        /** 等待预加载完成的defer */ _$2(_$6(_this), "preloadOverDefer", void 0);
        _this.uid = uidBase++;
        _this.context = ctx;
        _this.flowid = ctx.flowid;
        _this.logger = new Logger(ctx.instanceId, _this.getName());
        return _this;
    }
    _(BaseFlowNode, [
        {
            key: "destroy",
            value: function destroy() {
                if (this.isDestroyed) {
                    // 基类这里最好不要用once装饰器，如果子类和基类都用once装饰器会有问题！
                    return;
                }
                this.isDestroyed = true;
                this.context = null;
                this.preloadOverDefer = null;
            }
        },
        {
            key: "getIsContiguous",
            value: function getIsContiguous() {
                return false;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_logger;
                (_this_logger = this.logger).log.apply(_this_logger, [
                    "[".concat(this.flowid.slice(-6), "]")
                ].concat(_$8(args)));
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_logger;
                (_this_logger = this.logger).error.apply(_this_logger, [
                    "[".concat(this.flowid.slice(-6), "]")
                ].concat(_$8(args)));
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_logger;
                (_this_logger = this.logger).warn.apply(_this_logger, [
                    "[".concat(this.flowid.slice(-6), "]")
                ].concat(_$8(args)));
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.curState;
            }
        },
        {
            key: "getContext",
            value: function getContext() {
                return this.context;
            }
        },
        {
            key: "preload",
            value: // @once 预加载并非只能调用一次，因为如果预加载出错，正式播放时候可能还会调用预加载。
            function preload() {
                var _this = this;
                return _$e(function() {
                    var ret, error;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ret = _this.setState(FlowNodeState.PRELOADING);
                                if (!ret) {
                                    // 这里是可能重复调用的，状态扭转通不过。
                                    return [
                                        2
                                    ];
                                }
                                _this.preloadOverDefer = new SimpleDefer();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.preloadImpl()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                _this.error('preloadImpl err, ', error);
                                _this.onPreloadFail(error);
                                return [
                                    2
                                ];
                            case 4:
                                _this.onPreloadSucc();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "start",
            value: function start() {
                var _this = this;
                return _$e(function() {
                    var data;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.curState === FlowNodeState.IDLE) {
                                    // 没有调用过preload()或者preload阶段出错，都重新走一下预加载
                                    _this.preload();
                                }
                                return [
                                    4,
                                    _this.preloadOverDefer.promise
                                ];
                            case 1:
                                data = _state.sent();
                                if (data === null || data === void 0 ? void 0 : data.error) {
                                    _this.error('start(), preload defer err, ', data.error);
                                    _this.abort(data.error);
                                    return [
                                        2
                                    ];
                                }
                                _this.doStart();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "stop",
            value: function stop(opts) {
                var ret = this.setState(FlowNodeState.STOPPED);
                if (!ret) {
                    return;
                }
                this.stopImpl(opts);
                this.emitEnded();
            }
        },
        {
            key: "pause",
            value: function pause(opts) {
                var ret = this.setState(FlowNodeState.PAUSED);
                if (!ret) {
                    return;
                }
                this.pauseImpl(opts);
            }
        },
        {
            key: "resume",
            value: function resume() {
                var ret = this.setState(FlowNodeState.STARTED);
                if (!ret) {
                    return;
                }
                this.resumeImpl();
            }
        },
        {
            key: "reset",
            value: function reset() {
                var ret = this.setState(FlowNodeState.IDLE);
                if (!ret) {
                    return;
                }
                this.resetImpl();
            }
        },
        {
            key: "setState",
            value: /**
   * 扭转状态。
   * [注意] 需要在对应函数的最开始就扭转状态，例如在preload函数第一行调用setState(FlowNodeState.PRELOADING)。这样做的目的是如果状态扭转
   * 检查不通过，需要直接跳过后续的逻辑执行
   */ function setState(value, data) {
                var isValidChange = value === this.curState || FlowNodeStateTransitionMap[this.curState].indexOf(value) !== -1;
                if (!isValidChange) {
                    this.warn("[".concat(this.getName(), "] can not transit state from ").concat(this.curState, " to ").concat(value));
                    return false;
                }
                this.log("setState from ".concat(this.curState, " to ").concat(value));
                this.preState = this.curState;
                this.curState = value;
                this.onStateChange(data);
                return true;
            }
        },
        {
            key: "onStateChange",
            value: function onStateChange(data) {
                this.emit(FlowNodeEvt.STATE_CHANGE, {
                    preState: this.preState,
                    curState: this.curState,
                    data: data
                });
            }
        },
        {
            key: "abort",
            value: /** 终止整个流程 */ function abort(error) {
                this.emit(FlowNodeEvt.ABORT, error);
            }
        },
        {
            key: "triggerPreloadNext",
            value: function triggerPreloadNext() {
                this.emit(FlowNodeEvt.TRIGGER_PRELOAD_NEXT);
            }
        },
        {
            key: "finishImpl",
            value: /**
   * 当前节点结束
   */ function finishImpl(opts) {
                var ret = this.setState(FlowNodeState.STOPPED, opts);
                if (!ret) {
                    return false;
                }
                this.emitEnded();
                return true;
            }
        },
        {
            key: "emitEnded",
            value: function emitEnded() {
                this.emit(FlowNodeEvt.ENDED);
            }
        },
        {
            key: "onPreloadSucc",
            value: function onPreloadSucc() {
                var ret = this.setState(FlowNodeState.PRELOADED);
                if (!ret) {
                    return;
                }
                this.preloadOverDefer.resolve(null);
            }
        },
        {
            key: "onPreloadFail",
            value: function onPreloadFail(error) {
                // 预加载失败的话，回退
                this.reset();
                this.preloadOverDefer.resolve({
                    error: error
                });
            }
        },
        {
            key: "doStart",
            value: function doStart() {
                var ret = this.setState(FlowNodeState.STARTED);
                if (!ret) {
                    return;
                }
                this.startImpl();
            }
        }
    ]);
    return BaseFlowNode;
}(EvtEmitter);
_$i([
    onceDecorator,
    _$j("design:type", Function),
    _$j("design:paramtypes", []),
    _$j("design:returntype", Promise)
], BaseFlowNode.prototype, "start", null);
_$i([
    onceDecorator,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        Object
    ]),
    _$j("design:returntype", void 0)
], BaseFlowNode.prototype, "stop", null);
_$i([
    onceDecorator,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        typeof IVideoError === "undefined" ? Object : IVideoError
    ]),
    _$j("design:returntype", void 0)
], BaseFlowNode.prototype, "abort", null);
_$i([
    onceDecorator,
    _$j("design:type", Function),
    _$j("design:paramtypes", []),
    _$j("design:returntype", void 0)
], BaseFlowNode.prototype, "triggerPreloadNext", null);
_$i([
    onceDecorator,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        Object
    ]),
    _$j("design:returntype", void 0)
], BaseFlowNode.prototype, "finishImpl", null);
_$i([
    onceDecorator,
    _$j("design:type", Function),
    _$j("design:paramtypes", []),
    _$j("design:returntype", void 0)
], BaseFlowNode.prototype, "emitEnded", null);
_$i([
    destroyProtectDecorator,
    _$j("design:type", Function),
    _$j("design:paramtypes", []),
    _$j("design:returntype", void 0)
], BaseFlowNode.prototype, "onPreloadSucc", null);
_$i([
    destroyProtectDecorator,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        Object
    ]),
    _$j("design:returntype", void 0)
], BaseFlowNode.prototype, "onPreloadFail", null);
_$i([
    destroyProtectDecorator,
    _$j("design:type", Function),
    _$j("design:paramtypes", []),
    _$j("design:returntype", void 0)
], BaseFlowNode.prototype, "doStart", null);

/**
 * 提前从后台获取广告和正片的信息，但是并不解析数据。
 */ var GetVideoInfoFlowNode = /*#__PURE__*/ function(BaseFlowNode) {
    _$4(GetVideoInfoFlowNode, BaseFlowNode);
    var _super = _$5(GetVideoInfoFlowNode);
    function GetVideoInfoFlowNode(ctx, opts) {
        _$1(this, GetVideoInfoFlowNode);
        var _this;
        _this = _super.call(this, ctx);
        _$2(_$6(_this), "getinfoModule", void 0);
        _$2(_$6(_this), "getinfoCtx", void 0);
        _$2(_$6(_this), "getinfoOpts", void 0);
        _$2(_$6(_this), "pausedDefer", void 0);
        _$2(_$6(_this), "hasError", false);
        _this.getinfoOpts = opts;
        _this.getinfoModule = getGetinfoModule(ctx.instanceId);
        return _this;
    }
    _(GetVideoInfoFlowNode, [
        {
            key: "destroy",
            value: function destroy() {
                this.getinfoCtx = null;
                this.pausedDefer = null;
                _$g(_$h(GetVideoInfoFlowNode.prototype), "destroy", this).call(this);
            }
        },
        {
            key: "getName",
            value: function getName() {
                return FlowNodeName.GET_INFO;
            }
        },
        {
            key: "getOutput",
            value: function getOutput() {
                return {
                    getinfoCtx: this.getinfoCtx
                };
            }
        },
        {
            key: "setInput",
            value: function setInput() {
            // not implement
            }
        },
        {
            key: "startImpl",
            value: function startImpl() {
                var _this = this;
                return _$e(function() {
                    var _this_pausedDefer, _this_getinfoCtx;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.hasError) {
                                    // 没有用this.getinfoCtx.error而是用preload记录的一个hasError来判断，getinfo的node只关心自己这个节点时是不是有出错。因为在getinfo
                                    // 节点运行时，videoFlowNode可能已经执行预加载并解析getinfo数据，并在解析出error时赋值error给getinfoCtx.error，导致这里被感知到。
                                    // 然后直接abort整个播放流程。这样的逻辑带来的问题是PLAY_SESSION_END事件会在VIDEO_REQ_INFO_END之前就被抛出来了，不符合预期。而
                                    // 根据hasError判断的话，就是相当于videoFlowNode解析数据以后，发现错误再abort整个流程。事件时序就对了。
                                    // 按一般播放逻辑，getinfo出错了就直接结束流程报错。
                                    // （但实际上腾讯视频不走这里，它有自己的逻辑，getinfo请求出错也并没有错误信息，会走到VideoFlowNode解析数据时尝试重新请求）
                                    _this.abort((_this_getinfoCtx = _this.getinfoCtx) === null || _this_getinfoCtx === void 0 ? void 0 : _this_getinfoCtx.error);
                                    return [
                                        2
                                    ];
                                }
                                // 可能在这个节点过程中调用了播放器的pause，但是请求服务器的逻辑并没有pause的能力。因此pause以后记录一个defer，我们等待这个defer去模拟
                                // pause状态。等待defer完成时，相当于节点重新启动
                                return [
                                    4,
                                    (_this_pausedDefer = _this.pausedDefer) === null || _this_pausedDefer === void 0 ? void 0 : _this_pausedDefer.promise
                                ];
                            case 1:
                                _state.sent();
                                _this.finishImpl();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "preloadImpl",
            value: function preloadImpl() {
                var _this = this;
                return _$e(function() {
                    var _this_getinfoOpts, vid, _this_context_playParam, videoReqInfoParam, adParam, srvData, reqParams;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                vid = _this.context.playItem;
                                _this_context_playParam = _this.context.playParam, videoReqInfoParam = _this_context_playParam.videoReqInfoParam, adParam = _this_context_playParam.adParam, srvData = _this_context_playParam.srvData;
                                reqParams = {
                                    adParams: getAdReqParams(_this.context.instanceId, _$b({
                                        adType: AdType.PRE,
                                        vid: vid
                                    }, adParam)),
                                    // vinfoParams的flowid比较特殊，一定要每次请求都写入。
                                    // 原因是在getinfo模块里面，只取了数据中心的flowid，但是getinfo可能发生在当前session，也可能发生在预加载的session。因此这里覆盖一下
                                    vinfoParams: _$c(_$b({}, videoReqInfoParam), {
                                        flowid: _this.flowid
                                    }),
                                    srvData: srvData,
                                    emitEvtOpaque: true,
                                    emitEvtDefer: _this.context.getActiveDefer()
                                };
                                if (!((_this_getinfoOpts = _this.getinfoOpts) === null || _this_getinfoOpts === void 0 ? void 0 : _this_getinfoOpts.isDelayParse)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.getinfoModule.requestResData(vid, reqParams)
                                ];
                            case 1:
                                _this.getinfoCtx = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.getinfoModule.request(vid, reqParams)
                                ];
                            case 3:
                                _this.getinfoCtx = _state.sent();
                                _state.label = 4;
                            case 4:
                                _this.hasError = !!_this.getinfoCtx.error;
                                if (!_this.hasError) {
                                    _this.triggerPreloadNext();
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "pauseImpl",
            value: function pauseImpl() {
                this.pausedDefer = new SimpleDefer();
            }
        },
        {
            key: "resumeImpl",
            value: function resumeImpl() {
                var _this_pausedDefer;
                (_this_pausedDefer = this.pausedDefer) === null || _this_pausedDefer === void 0 ? void 0 : _this_pausedDefer.resolve();
            }
        },
        {
            key: "stopImpl",
            value: function stopImpl(_opts) {
                this.getinfoModule.abort();
            }
        },
        {
            key: "resetImpl",
            value: function resetImpl() {
                this.getinfoModule.abort();
                this.getinfoCtx = null;
                this.pausedDefer = null;
            }
        }
    ]);
    return GetVideoInfoFlowNode;
}(BaseFlowNode);

/**
 * 播放广告的节点基类，可能是前贴、后贴。
 */ var BaseAdFlowNode = /*#__PURE__*/ function(BaseFlowNode) {
    _$4(BaseAdFlowNode, BaseFlowNode);
    var _super = _$5(BaseAdFlowNode);
    function BaseAdFlowNode(ctx) {
        _$1(this, BaseAdFlowNode);
        var _this;
        _this = _super.call(this, ctx);
        _$2(_$6(_this), "adPlugin", void 0);
        _$2(_$6(_this), "adEvtMap", void 0);
        _$2(_$6(_this), "adLoadStatus", AD_LOAD_STATUS.OTHER_SKIP);
        _$2(_$6(_this), "onAdEvtHandler", function(e) {
            var type = e.type, data = e.data;
            if (data.adType !== _this.getAdType()) {
                // 触发事件的非当前广告
                return;
            }
            _this.adEvtMap[type].apply(_$6(_this), [
                e
            ]);
        });
        _this.adPlugin = getAdPlugin(_this.context.instanceId);
        var _obj;
        _this.adEvtMap = (_obj = {}, _$2(_obj, H5_PLAY_EVENT.AD_END, _this.onAdEnd), _$2(_obj, H5_PLAY_EVENT.AD_PAUSE, _this.onAdPause), _$2(_obj, H5_PLAY_EVENT.AD_ASSETS_LOADED, _this.onAdAssetsLoaded), _$2(_obj, H5_EXT_EVENT.AD_COUNTDOWN_CHANGE, _this.onAdCountdown), _$2(_obj, H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED, _this.onAdAutoPlayBlocked), _obj);
        return _this;
    }
    _(BaseAdFlowNode, [
        {
            key: "destroy",
            value: function destroy() {
                this.setAdEvents(false);
                this.stopImpl();
                this.adPlugin = null;
                this.adEvtMap = null;
                _$g(_$h(BaseAdFlowNode.prototype), "destroy", this).call(this);
            }
        },
        {
            key: "getName",
            value: function getName() {
                return "".concat(FlowNodeName.PLAY_AD, ".").concat(this.getAdType());
            }
        },
        {
            key: "setVolume",
            value: function setVolume(value) {
                try {
                    this.adPlugin.setAdVolume(value);
                } catch (e) {
                    this.error('call adPlugin::setAdVolume', e);
                }
            }
        },
        {
            key: "getVolume",
            value: function getVolume() {
                return this.adPlugin.getAdVolume();
            }
        },
        {
            key: "startImpl",
            value: function startImpl() {
                var _this = this;
                // 非空单、空单两种情况，都需要继续播放广告。其他情况全部跳过广告节点
                if (this.adLoadStatus !== AD_LOAD_STATUS.OK && this.adLoadStatus !== AD_LOAD_STATUS.EMPTY_OK) {
                    this.finishImpl();
                    return;
                }
                // 开始播放以后，再开始监听广告插件的事件，这是为了避免当前播放的广告节点和预加载的广告节点的事件串了
                // 而且看起来预加载过程，并没有什么事件发出来，因此预加载过程不会错过什么事件
                this.setAdEvents(true);
                this.log('play ad');
                // playAd后如果没有广告内容会进入catch，需要手动结束当前节点
                // 其他情况（广告播放结束、播放异常、cgi未返回等）则会自己触发ad_end
                this.adPlugin.playAd({
                    adType: this.getAdType()
                }).catch(function() {
                    return _this.finishImpl();
                });
            }
        },
        {
            key: "pauseImpl",
            value: function pauseImpl() {
                try {
                    this.adPlugin.pauseAd(this.getAdType());
                } catch (e) {}
            }
        },
        {
            key: "resumeImpl",
            value: function resumeImpl() {
                try {
                    this.adPlugin.resumeAd(this.getAdType());
                } catch (e) {}
            }
        },
        {
            key: "stopImpl",
            value: function stopImpl() {
                try {
                    this.adPlugin.stopAd({
                        adType: this.getAdType()
                    });
                } catch (e) {}
            }
        },
        {
            key: "resetImpl",
            value: function resetImpl() {
                try {
                    this.adPlugin.stopAd({
                        adType: this.getAdType()
                    });
                } catch (e) {}
                this.adLoadStatus = AD_LOAD_STATUS.OTHER_SKIP;
            }
        },
        {
            key: "adPluginLoadAd",
            value: /**
   * 给广告插件传入广告数据
   */ function adPluginLoadAd(getinfoCtx) {
                var _this = this;
                return _$e(function() {
                    var adInfo, _getinfoCtx_adInfo, _tmp, isSucc, hasAd, error;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    ,
                                    5
                                ]);
                                if (!((_getinfoCtx_adInfo = getinfoCtx === null || getinfoCtx === void 0 ? void 0 : getinfoCtx.adInfo) !== null && _getinfoCtx_adInfo !== void 0)) return [
                                    3,
                                    1
                                ];
                                _tmp = _getinfoCtx_adInfo;
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.context.getAdInfo(_this.getAdType())
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                adInfo = _tmp;
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _state.sent();
                                _this.error('get adinfo err');
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                if (!adInfo) {
                                    _this.log('no adinfo');
                                    _this.adLoadStatus = AD_LOAD_STATUS.NO_ADINFO;
                                    return [
                                        2
                                    ];
                                }
                                // 再设置广告信息给广告插件
                                isSucc = _this.setAdInfo(adInfo);
                                if (!isSucc) {
                                    _this.error('set adinfo err');
                                    _this.adLoadStatus = AD_LOAD_STATUS.SET_ADINFO_ERR;
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 6;
                            case 6:
                                _state.trys.push([
                                    6,
                                    8,
                                    ,
                                    9
                                ]);
                                return [
                                    4,
                                    _this.adPlugin.loadAd({
                                        adType: _this.getAdType()
                                    })
                                ];
                            case 7:
                                hasAd = _state.sent();
                                // 这里跟广告插件约定是返回true/false，因此精确判断true/false，而不是直接if(hasAd)。如果结果不是true/false，一律归为没有广告
                                if (hasAd === true) {
                                    _this.log('loadad ok');
                                    _this.adLoadStatus = AD_LOAD_STATUS.OK;
                                    return [
                                        2
                                    ];
                                }
                                if (hasAd === false) {
                                    _this.log('loadad ok, empty');
                                    _this.adLoadStatus = AD_LOAD_STATUS.EMPTY_OK;
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                error = _state.sent();
                                _this.error('loadad err', error);
                                return [
                                    3,
                                    9
                                ];
                            case 9:
                                _this.adLoadStatus = AD_LOAD_STATUS.OTHER_SKIP;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onAdAssetsLoaded",
            value: function onAdAssetsLoaded(_e) {
            // tobe override
            }
        },
        {
            key: "onAdCountdown",
            value: function onAdCountdown(_e) {
            // tobe override
            }
        },
        {
            key: "onAdAutoPlayBlocked",
            value: function onAdAutoPlayBlocked(_e) {
            // tobe override
            }
        },
        {
            key: "setAdInfo",
            value: /** 返回是否可播广告。不可播时直接进入下一流程 */ function setAdInfo(adInfo) {
                try {
                    this.adPlugin.setAdInfo(adInfo);
                } catch (e) {
                    return false;
                }
                return true;
            }
        },
        {
            key: "setAdEvents",
            value: function setAdEvents() {
                var _this = this;
                var isBind = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var func = isBind ? this.adPlugin.on : this.adPlugin.off;
                Object.keys(this.adEvtMap).forEach(function(evtName) {
                    func.call(_this.adPlugin, evtName, _this.onAdEvtHandler);
                });
            }
        },
        {
            key: "onAdEnd",
            value: function onAdEnd() {
                this.finishImpl();
            }
        },
        {
            key: "onAdPause",
            value: function onAdPause() {
                // 广告节点被暂停，可能是外部调用的（这种情况已经在节点的pause接口扭转状态）
                // 但是也可能是广告节点的<video/>内部暂停！例如移动端某些app切换页面，会被webview暂停播放。这个事件主要是处理这种场景的扭转
                this.setState(FlowNodeState.PAUSED);
            }
        }
    ]);
    return BaseAdFlowNode;
}(BaseFlowNode);
_$i([
    onceDecorator,
    _$j("design:type", Function),
    _$j("design:paramtypes", []),
    _$j("design:returntype", void 0)
], BaseAdFlowNode.prototype, "destroy", null);

var PostAdFlowNode = /*#__PURE__*/ function(BaseAdFlowNode) {
    _$4(PostAdFlowNode, BaseAdFlowNode);
    var _super = _$5(PostAdFlowNode);
    function PostAdFlowNode() {
        _$1(this, PostAdFlowNode);
        return _super.apply(this, arguments);
    }
    _(PostAdFlowNode, [
        {
            key: "getOutput",
            value: function getOutput() {
                // 这个hasAd是代表有真正的广告素材播放，空单等都不为true
                return {
                    hasAd: this.adLoadStatus === AD_LOAD_STATUS.OK
                };
            }
        },
        {
            key: "setInput",
            value: function setInput() {
            // not implement
            }
        },
        {
            key: "getAdType",
            value: function getAdType() {
                return AdType.POST;
            }
        },
        {
            key: "preloadImpl",
            value: function preloadImpl() {
                var _this = this;
                return _$e(function() {
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.adPluginLoadAd()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return PostAdFlowNode;
}(BaseAdFlowNode);

/**
 * 前贴节点
 */ var PreAdFlowNode = /*#__PURE__*/ function(BaseAdFlowNode) {
    _$4(PreAdFlowNode, BaseAdFlowNode);
    var _super = _$5(PreAdFlowNode);
    function PreAdFlowNode(ctx, opts) {
        _$1(this, PreAdFlowNode);
        var _this;
        _this = _super.call(this, ctx);
        _$2(_$6(_this), "adOpts", void 0);
        _$2(_$6(_this), "inputGetinfoCtx", void 0);
        _$2(_$6(_this), "remainTime", -1);
        _this.adOpts = opts;
        return _this;
    }
    _(PreAdFlowNode, [
        {
            key: "destroy",
            value: function destroy() {
                this.inputGetinfoCtx = null;
                _$g(_$h(PreAdFlowNode.prototype), "destroy", this).call(this);
            }
        },
        {
            key: "getOutput",
            value: function getOutput() {
                // 这个hasAd是代表有真正的广告素材播放，空单等都不为true
                return {
                    getinfoCtx: this.inputGetinfoCtx,
                    hasAd: this.adLoadStatus === AD_LOAD_STATUS.OK
                };
            }
        },
        {
            key: "setInput",
            value: function setInput(opts) {
                this.inputGetinfoCtx = opts === null || opts === void 0 ? void 0 : opts.getinfoCtx;
            }
        },
        {
            key: "getAdType",
            value: function getAdType() {
                return AdType.PRE;
            }
        },
        {
            key: "startImpl",
            value: function startImpl() {
                var _this = this;
                this.context.remainTimeGetter = function() {
                    return _this.remainTime;
                };
                _$g(_$h(PreAdFlowNode.prototype), "startImpl", this).call(this);
            }
        },
        {
            key: "finishImpl",
            value: function finishImpl(opts) {
                this.context.remainTimeGetter = null;
                return _$g(_$h(PreAdFlowNode.prototype), "finishImpl", this).call(this, opts);
            }
        },
        {
            key: "resetImpl",
            value: function resetImpl() {
                this.inputGetinfoCtx = null;
                this.remainTime = -1;
                _$g(_$h(PreAdFlowNode.prototype), "resetImpl", this).call(this);
            }
        },
        {
            key: "stopImpl",
            value: function stopImpl() {
                this.context.remainTimeGetter = null;
                _$g(_$h(PreAdFlowNode.prototype), "stopImpl", this).call(this);
            }
        },
        {
            key: "preloadImpl",
            value: function preloadImpl() {
                var _this = this;
                return _$e(function() {
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.adPluginLoadAd(_this.inputGetinfoCtx)
                                ];
                            case 1:
                                _state.sent();
                                if (_this.adLoadStatus !== AD_LOAD_STATUS.OK) {
                                    _this.log('no ad 2 play, preloadNext');
                                    // 如果广告没预加载ok，继续下一个节点的预加载
                                    _this.triggerPreloadNext();
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onAdAssetsLoaded",
            value: function onAdAssetsLoaded() {
                // 这个事件回调是前贴广告的所有素材加载ok的时候（无论几片广告）
                this.triggerPreloadNext();
            }
        },
        {
            key: "onAdCountdown",
            value: function onAdCountdown(param) {
                var data = param.data;
                var defaultPreloadTime = this.context.isLive ? 10 : 60; // 直播缓冲区很小，不需要很早就开始预加载
                var _ref = this.adOpts || {}, _ref_preloadTime = _ref.preloadTime, preloadTime = _ref_preloadTime === void 0 ? defaultPreloadTime : _ref_preloadTime;
                this.remainTime = data.countdown;
                if (data.countdown <= preloadTime) {
                    this.triggerPreloadNext();
                }
            }
        },
        {
            key: "onAdAutoPlayBlocked",
            value: function onAdAutoPlayBlocked() {
                // 广告被自动播放拦截时，实际上是pause状态的。等待外部调用play以后重播
                this.setState(FlowNodeState.PAUSED);
            }
        }
    ]);
    return PreAdFlowNode;
}(BaseAdFlowNode);

var BaseCheck = /*#__PURE__*/ function() {
    function BaseCheck(virtualPlayer) {
        _$1(this, BaseCheck);
        _$2(this, "checkEvt", null);
        _$2(this, "config", void 0);
        /** 当次连续重试的重试次数，只要重试成功就重置为0 */ _$2(this, "retryTimes", 0);
        _$2(this, "logger", void 0);
        this.config = virtualPlayer.config;
        this.logger = new Logger(this.config.instanceId, this.constructor.checkerName);
    }
    _(BaseCheck, [
        {
            key: "destroy",
            value: function destroy() {
                this.config = null;
                this.logger = null;
            }
        },
        {
            key: "onRetrySucc",
            value: function onRetrySucc() {
                // 每次重试成功，都重置重试次数
                this.retryTimes = 0;
            }
        },
        {
            key: "check",
            value: function check(_evt) {
                // to be override
                return null;
            }
        },
        {
            key: "getRetryConfig",
            value: function getRetryConfig(videoInfo) {
                var playtime = videoInfo.playtime, error = videoInfo.error;
                var updatePlayParam = {
                    videoReqInfoParam: {},
                    videoLoadParam: {
                        startTime: playtime,
                        // VideoFlowNode缓存了上一次kernelName，后续重构loadParam这一块
                        kernelName: void 0
                    }
                };
                return {
                    error: error,
                    updatePlayParam: updatePlayParam,
                    retryTimes: this.retryTimes
                };
            }
        }
    ]);
    return BaseCheck;
}();
_$2(BaseCheck, "checkerName", 'BaseCheck');

/** 在出错时记录播放时间点的初始值 */ var REC_PLAY_TIME_INIT_VALUE = -1;
var RetryNames = {
    CheckNormalError: 'CheckNormalError'
};

var CheckNormalError = /*#__PURE__*/ function(BaseCheck) {
    _$4(CheckNormalError, BaseCheck);
    var _super = _$5(CheckNormalError);
    function CheckNormalError(virtualPlayer) {
        _$1(this, CheckNormalError);
        var _this;
        _this = _super.call(this, virtualPlayer);
        _$2(_$6(_this), "checkEvt", PLAY_EVENT.ERROR);
        /** 在出错时记录播放时间点 */ _$2(_$6(_this), "playtimeWhenErrorHappen", REC_PLAY_TIME_INIT_VALUE);
        return _this;
    }
    _(CheckNormalError, [
        {
            key: "check",
            value: function check(evt) {
                var videoInfo = evt.data.videoInfo;
                var error = videoInfo.error;
                var maxRetryGetinfoTimes = this.config.maxRetryGetinfoTimes;
                // 如果是加密模块的报错，不需要进行getinfo重试
                if (error.type === TpCoreError.Encryption) {
                    return {
                        outOfTimes: true,
                        error: error,
                        retryTimes: this.retryTimes
                    };
                }
                if (this.retryTimes >= maxRetryGetinfoTimes) {
                    // 超过最大重试次数，重试结束
                    return {
                        outOfTimes: true,
                        error: error,
                        retryTimes: this.retryTimes
                    };
                }
                return this.checkNormalErrorCode(evt);
            }
        },
        {
            key: "onRetrySucc",
            value: function onRetrySucc() {
                _$g(_$h(CheckNormalError.prototype), "onRetrySucc", this).call(this);
                this.playtimeWhenErrorHappen = REC_PLAY_TIME_INIT_VALUE;
            }
        },
        {
            key: "updateRetryTimes",
            value: function updateRetryTimes() {
                this.retryTimes += 1;
            }
        },
        {
            key: "checkNormalErrorCode",
            value: /**
   * 一般的错误码的检查，getinfo级别的重试也是从这里发起
   */ function checkNormalErrorCode(evt) {
                var _retryConfig_updatePlayParam;
                var videoInfo = evt.data.videoInfo;
                var inheritedStartTimeS = videoInfo.inheritedStartTimeS;
                if (this.playtimeWhenErrorHappen === REC_PLAY_TIME_INIT_VALUE) {
                    // 避免连续getinfo重试时候被覆盖，只记录一次
                    // 考虑以下case:
                    // 切清晰度从A内核（已经播放到中间）切换到B内核。B内核未起播前发生重试，videoInfo.playtime并未更新，值为0。
                    // 因此，这里需要拿播放内核的“被继承起播时间”，而不是B内核的playtime
                    this.playtimeWhenErrorHappen = inheritedStartTimeS;
                }
                this.updateRetryTimes();
                var retryConfig = this.getRetryConfig(videoInfo);
                // 出错时候带上`playtimeWhenErrorHappen`到VideoNode层，告知出错时的播放时间点
                if (this.playtimeWhenErrorHappen !== REC_PLAY_TIME_INIT_VALUE && (retryConfig === null || retryConfig === void 0 ? void 0 : (_retryConfig_updatePlayParam = retryConfig.updatePlayParam) === null || _retryConfig_updatePlayParam === void 0 ? void 0 : _retryConfig_updatePlayParam.videoLoadParam) && this.config.type === PLAY_MODE.VOD) {
                    retryConfig.updatePlayParam.videoLoadParam.startTime = this.playtimeWhenErrorHappen;
                }
                return retryConfig;
            }
        }
    ]);
    return CheckNormalError;
}(BaseCheck);
_$2(CheckNormalError, "checkerName", RetryNames.CheckNormalError);

/**
 * 当使用vid播放时的重试请求getinfo后台逻辑管理器。
 */ var RetryManager = /*#__PURE__*/ function() {
    function RetryManager(opts) {
        var _this = this;
        _$1(this, RetryManager);
        _$2(this, "retryCheckers", void 0);
        _$2(this, "logger", void 0);
        _$2(this, "opts", void 0);
        /** session内已经重试的次数 */ _$2(this, "retryTimesInSessionInner", 0);
        _$2(this, "checkerEvtHandler", function(evt) {
            var _retryConfig_error;
            var retryConfig = _this.getHitChecker(evt);
            if (!retryConfig) {
                // 没有命中任何重试逻辑
                return;
            }
            var _retryConfig_outOfTimes = retryConfig.outOfTimes, outOfTimes = _retryConfig_outOfTimes === void 0 ? false : _retryConfig_outOfTimes;
            _this.logger.log("retry on ".concat(evt.type, ",\n    outOfTimes=").concat(outOfTimes, ",\n    retryTimes=").concat(retryConfig.retryTimes, ", retryTimesInSession=").concat(_this.retryTimesInSessionInner, ",\n    playParam=").concat(jsonTool.safelyStringify(retryConfig.updatePlayParam), ",\n    error=").concat((_retryConfig_error = retryConfig.error) === null || _retryConfig_error === void 0 ? void 0 : _retryConfig_error.code));
            if (retryConfig.outOfTimes || _this.checkOutOfTimesInSession()) {
                // 超过两种重试次数
                return;
            }
            _this.opts.retryCallback(retryConfig).then(function() {
                _this.retryCheckers.forEach(function(checker) {
                    return checker.onRetrySucc();
                });
            });
        });
        this.opts = opts;
        this.retryCheckers = opts.retryCheckers;
        this.logger = new Logger(opts.config.instanceId, 'RetryManager');
        this.setCheckEvents(true);
    }
    _(RetryManager, [
        {
            key: "destroy",
            value: function destroy() {
                this.setCheckEvents(false);
                this.retryCheckers.forEach(function(checker) {
                    return checker.destroy();
                });
                this.retryCheckers = null;
                this.opts = null;
            }
        },
        {
            key: "checkError",
            value: /**
   * 检查错误事件，看看是否有命中某个错误重试逻辑。
   * 注意：这里是为了逻辑更顺畅，错误检测逻辑在VideoFlowNode的错误处理函数中单独处理，不通过这里的事件监听。
   */ function checkError(e) {
                return this.getHitChecker(e);
            }
        },
        {
            key: "checkOutOfTimesInSession",
            value: /**
   * 是否超过session内错误重试最大次数。
   *
   * 注意：和某种重试检查逻辑中的outOfTimes不同的是，outOfTimes是当次连续重试的最大次数。而这个函数是检查一次session内只能重试多少次，避免
   * 出现某种临界状态（retry -> playing -> retry...）导致播放器无限重试
   */ function checkOutOfTimesInSession() {
                var _this_opts_config = this.opts.config, playMode = _this_opts_config.type, maxLiveTimes = _this_opts_config.maxRetryGetinfoTimesInLiveSession, maxVodTimes = _this_opts_config.maxRetryGetinfoTimesInVodSession;
                if (this.retryTimesInSessionInner >= (playMode === PLAY_MODE.LIVE ? maxLiveTimes : maxVodTimes)) {
                    return true;
                }
                return false;
            }
        },
        {
            key: "updateRetryTimesInSession",
            value: function updateRetryTimesInSession() {
                this.retryTimesInSessionInner++;
            }
        },
        {
            key: "getHitChecker",
            value: /**
   * 根据事件查找命中了哪个检查逻辑
   */ function getHitChecker(evt) {
                // for循环保证每种重试逻辑的检查顺序
                for(var i = 0; i < this.retryCheckers.length; i++){
                    var checker = this.retryCheckers[i];
                    if (checker.checkEvt !== evt.type) {
                        continue;
                    }
                    var retryConfig = checker.check(evt);
                    if (retryConfig) {
                        this.logger.log("checker hit ".concat(checker.constructor.checkerName));
                        return retryConfig;
                    }
                }
                return null;
            }
        },
        {
            key: "setCheckEvents",
            value: /**
   * 设置每个检查逻辑需要监听的事件
   */ function setCheckEvents() {
                var _this = this;
                var isBind = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var player = this.opts.corePlayer;
                var func = isBind ? player.on : player.off;
                var checkerEvts = [];
                for(var i = 0; i < this.retryCheckers.length; i++){
                    if (this.retryCheckers[i].checkEvt === PLAY_EVENT.ERROR) {
                        continue;
                    }
                    if (checkerEvts.indexOf(this.retryCheckers[i].checkEvt) === -1) {
                        checkerEvts.push(this.retryCheckers[i].checkEvt);
                    }
                }
                checkerEvts.forEach(function(evt) {
                    func.call(player, evt, _this.checkerEvtHandler);
                });
            }
        }
    ]);
    return RetryManager;
}();

var VideoFlowNode = /*#__PURE__*/ function(BaseFlowNode) {
    _$4(VideoFlowNode, BaseFlowNode);
    var _super = _$5(VideoFlowNode);
    function VideoFlowNode(ctx, opts) {
        _$1(this, VideoFlowNode);
        var _this;
        _this = _super.call(this, ctx);
        _$2(_$6(_this), "corePlayer", void 0);
        _$2(_$6(_this), "evtMap", void 0);
        /** 正在进行内部重播流程 */ _$2(_$6(_this), "isReplaying", false);
        _$2(_$6(_this), "inputGetinfoCtx", void 0);
        _$2(_$6(_this), "setLevelDeferWhenReplaying", null);
        _$2(_$6(_this), "setAudioTrackDefer", null);
        _$2(_$6(_this), "setAudioTrackId", null);
        _$2(_$6(_this), "retryManager", void 0);
        _$2(_$6(_this), "retryDefer", null);
        _$2(_$6(_this), "coreEventsBound", false);
        _$2(_$6(_this), "corePlayerInstance", void 0);
        _$2(_$6(_this), "volumeInner", 1);
        _$2(_$6(_this), "onVideoTimeUpdate", function() {
            _this.checkPreloadPostAd();
        });
        _$2(_$6(_this), "onVideoStop", function(param) {
            var data = param.data;
            var _data_videoInfo;
            if (_this.isReplaying) {
                // 如果是在VideoFlowNode中内部重播，可能会停掉上一次的core中的播放流程，但我们不需要发出事件导致flow-manager中结束当前节点
                return;
            }
            var error = (_data_videoInfo = data.videoInfo) === null || _data_videoInfo === void 0 ? void 0 : _data_videoInfo.error;
            if (error) {
                return;
            }
            _this.finishImpl({
                endState: data.endState,
                videoEndState: data.endState
            });
        });
        _$2(_$6(_this), "onVideoError", function(e) {
            var _e_data_videoInfo, _e_data;
            var error = (_e_data = e.data) === null || _e_data === void 0 ? void 0 : (_e_data_videoInfo = _e_data.videoInfo) === null || _e_data_videoInfo === void 0 ? void 0 : _e_data_videoInfo.error;
            if (_this.context.isUrlMode) {
                // 结束整个流程
                _this.abort(error);
            } else {
                var _this_retryManager;
                // 这里由RetryManager检查错误重试
                var retryConfig = (_this_retryManager = _this.retryManager) === null || _this_retryManager === void 0 ? void 0 : _this_retryManager.checkError(e);
                if (retryConfig && !retryConfig.outOfTimes && !_this.retryManager.checkOutOfTimesInSession()) {
                    // 如果需要重试，则内部重试
                    _this.retry(retryConfig);
                } else {
                    // 否则结束整个流程
                    _this.abort(error);
                }
            }
            // 如果正在切音轨的时候，内部 videoError，则认为切换音轨失败
            if (_this.setAudioTrackDefer) {
                _this.setAudioTrackDefer.reject();
                _this.setAudioTrackDefer = null;
            }
        });
        _$2(_$6(_this), "onVideoStateChange", function(param) {
            var data = param.data;
            if (data.new === VIDEO_STATE.PLAYING) {
                var _this_retryDefer;
                if (_this.isReplaying) {
                    var // 如果发生了切换清晰度，切换完成
                    _this_setLevelDeferWhenReplaying, // 如果是正在切音轨，则音轨切换完成
                    _this_setAudioTrackDefer;
                    _this.log('play retry succ');
                    _this.isReplaying = false; // 进入playing状态后反转标记,表示结束内部重试流程
                    (_this_setLevelDeferWhenReplaying = _this.setLevelDeferWhenReplaying) === null || _this_setLevelDeferWhenReplaying === void 0 ? void 0 : _this_setLevelDeferWhenReplaying.resolve();
                    _this.setLevelDeferWhenReplaying = null;
                    (_this_setAudioTrackDefer = _this.setAudioTrackDefer) === null || _this_setAudioTrackDefer === void 0 ? void 0 : _this_setAudioTrackDefer.resolve({
                        fail: false,
                        id: _this.setAudioTrackId,
                        userTrigger: true
                    });
                    _this.setAudioTrackId = null;
                    _this.setAudioTrackDefer = null;
                }
                (_this_retryDefer = _this.retryDefer) === null || _this_retryDefer === void 0 ? void 0 : _this_retryDefer.resolve();
            } else if (data.new === VIDEO_STATE.PAUSE) {
                // 视频的暂停状态是可能内部触发的，例如画中画模式播放中点击退出画中画模式，视频可能变成pause状态
                _this.setState(FlowNodeState.PAUSED);
            }
        });
        _$2(_$6(_this), "onVideoAutoPlayBlocked", function() {
            // 正片被自动播放拦截时，实际上是pause状态的。等待外部调用play以后重播
            _this.setState(FlowNodeState.PAUSED);
        });
        // chain上已经获取core实例并占用，因此chain的VideoFlowNode只需要获取下引用
        _this.corePlayer = getCorePool(ctx.instanceId).get(CoreType.VIDEO);
        _this.corePlayerInstance = _this.corePlayer.config.instanceId;
        FlowNodeUseCoreMap.use(_this.corePlayerInstance, _this.uid);
        var _obj;
        _this.evtMap = (_obj = {}, _$2(_obj, PLAY_EVENT.TIME_UPDATE, _this.onVideoTimeUpdate), _$2(_obj, PLAY_EVENT.STOPED, _this.onVideoStop), _$2(_obj, PLAY_EVENT.ERROR, _this.onVideoError), _$2(_obj, PLAY_EVENT.STATE_CHANGE, _this.onVideoStateChange), _$2(_obj, PLAY_EVENT.AUTOPLAY_BLOCKED, _this.onVideoAutoPlayBlocked), _obj);
        if (!_this.context.isUrlMode) {
            // url播放不需要重试管理
            _this.retryManager = new RetryManager({
                config: _this.context.config,
                corePlayer: _this.corePlayer,
                retryCheckers: (opts === null || opts === void 0 ? void 0 : opts.retryCheckers) || [
                    new CheckNormalError({
                        config: _this.context.config
                    })
                ],
                retryCallback: _this.retry.bind(_$6(_this))
            });
        }
        return _this;
    }
    _(VideoFlowNode, [
        {
            key: "destroy",
            value: function destroy() {
                var _this_retryManager;
                FlowNodeUseCoreMap.free(this.corePlayerInstance, this.uid);
                this.setCoreEvents(false);
                (_this_retryManager = this.retryManager) === null || _this_retryManager === void 0 ? void 0 : _this_retryManager.destroy();
                this.retryManager = null;
                this.evtMap = null;
                this.inputGetinfoCtx = null;
                this.setLevelDeferWhenReplaying = null;
                this.retryDefer = null;
                this.corePlayer = null;
                this.corePlayerInstance = null;
                this.setAudioTrackDefer = null;
                _$g(_$h(VideoFlowNode.prototype), "destroy", this).call(this);
            }
        },
        {
            key: "getName",
            value: function getName() {
                return FlowNodeName.PLAY_VIDEO;
            }
        },
        {
            key: "getOutput",
            value: function getOutput() {
                return null;
            }
        },
        {
            key: "setInput",
            value: function setInput(opts) {
                this.inputGetinfoCtx = opts === null || opts === void 0 ? void 0 : opts.getinfoCtx;
            }
        },
        {
            key: "setVolume",
            value: function setVolume(value) {
                this.volumeInner = value;
                this.corePlayer.volume = value;
            }
        },
        {
            key: "getVolume",
            value: function getVolume() {
                return this.corePlayer.volume;
            }
        },
        {
            key: "setPlaybackRate",
            value: function setPlaybackRate(value) {
                this.corePlayer.playbackRate = value;
            }
        },
        {
            key: "setAudioTrack",
            value: function setAudioTrack(id) {
                var _this = this;
                return _$e(function() {
                    return _$f(this, function(_state) {
                        // string 处理成需要请求 getinfo 的情况，目前简单走重播逻辑
                        if (typeof id === 'string') {
                            _this.context.updatePlayParam({
                                videoReqInfoParam: {
                                    track: id,
                                    // TODO: 目前 getVodBuiltInVideoReqInfoParam 里面才会判断参数互斥，但是重播并不会走到那个逻辑...
                                    // 因此一旦切 getinfo 的音轨，就不请求 vvc 吧
                                    spvvc: 0
                                },
                                videoLoadParam: {
                                    startTime: _this.corePlayer.playtime
                                }
                            });
                            _this.setAudioTrackDefer = new SimpleDefer();
                            _this.replay(_this.context.playItem);
                            return [
                                2,
                                _this.setAudioTrackDefer.promise
                            ];
                        }
                        return [
                            2,
                            _this.corePlayer.setAudioTrack(id)
                        ];
                    });
                })();
            }
        },
        {
            key: "setLevel",
            value: function setLevel(level, extra) {
                var _this = this;
                return _$e(function() {
                    var urlConfig;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(typeof level === 'string')) return [
                                    3,
                                    1
                                ];
                                urlConfig = {
                                    url: level
                                };
                                return [
                                    3,
                                    4
                                ];
                            case 1:
                                if (!(typeof level.url === 'string')) return [
                                    3,
                                    2
                                ];
                                urlConfig = level;
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.getLevelUrlConfig(level, extra)
                                ];
                            case 3:
                                // level 为 object 时，为请求 cgi的参数
                                urlConfig = _state.sent();
                                // 如果正在进行内部重播流程中，在此时切换清晰度直接重新播放（而不是走切换清晰度流程）。相当于用户主动使用新的清晰度重播
                                if (_this.isReplaying) {
                                    _this.warn('setLevel when replaying');
                                    _this.setLevelDeferWhenReplaying = new SimpleDefer();
                                    _this.replay(urlConfig);
                                    return [
                                        2,
                                        _this.setLevelDeferWhenReplaying.promise
                                    ];
                                }
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    _this.corePlayer.setLevel(urlConfig.url, urlConfig.backupUrls, urlConfig)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "replay",
            value: function replay(playItem, playParam) {
                var _this = this;
                return _$e(function() {
                    var isReplayVideoId, getinfoRet, urlConfig, isKeepPause;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                isReplayVideoId = isVideoId(playItem);
                                if (_this.context.config.type === PLAY_MODE.LIVE && isVideoId(_this.context.playItem) && !isReplayVideoId) {
                                    // TODO:
                                    // 这个if条件是说，如果playitem是从chid切换到urlConfig的条件下。目前是纯兼容直播回看的情况。
                                    // 加这个条件的原因是
                                    // 1. 直播状态切换到直播回看状态，是 腾讯视频chid播放 -> 腾讯视频chid播放（带上回看时间）
                                    // 2. 然后回看状态下seek，是 腾讯视频chid播放（带上回看时间）-> urlConfig播放
                                    // 如果按照1，2的操作流程，这里的playItem会从一个chid变成urlConfig。但是直播回看状态切换清晰度又需要重新请求后台。如果playItem变成
                                    // urlConfig，切换清晰度会误使用这个urlConfig去请求后台，导致请求错误。
                                    // 临时的目前的解决就是1，2的操作流程时，不记录playItem，跟老的逻辑对齐（老的逻辑直接调用了core的播放去播放url）。后续可能需要新开一个
                                    // 接口专门处理直播回看时seek的场景
                                    _this.log('replay(), seek on live playback do not record playitem');
                                } else {
                                    _this.context.playItem = playItem;
                                    _this.context.updatePlayParam(playParam);
                                }
                                // a) url地址重播
                                if (!isReplayVideoId) {
                                    _this.log('replay(), start replay urlConfig: ', playItem);
                                    _this.isReplaying = true;
                                    return [
                                        2,
                                        _this.corePlayer.play(playItem, _this.context.corePlayParam)
                                    ];
                                }
                                // b) 腾讯视频的点播或直播重播
                                _this.log('replay(), start request video info');
                                return [
                                    4,
                                    _this.context.getVideoInfo()
                                ];
                            case 1:
                                getinfoRet = _state.sent();
                                if (_this.isDestroyed) {
                                    // 避免stop等调用后流程都结束了还在继续往下执行
                                    return [
                                        2
                                    ];
                                }
                                _this.isReplaying = true;
                                urlConfig = (getinfoRet || {}).urlConfig;
                                isKeepPause = [
                                    FlowNodeState.IDLE,
                                    FlowNodeState.PRELOADING,
                                    FlowNodeState.PRELOADED,
                                    FlowNodeState.PAUSED
                                ].includes(_this.curState);
                                _this.log("keep pause when replay(), ".concat(isKeepPause));
                                if (isKeepPause) {
                                    return [
                                        2,
                                        _this.coreLoadOrPlay('load', urlConfig)
                                    ];
                                }
                                return [
                                    2,
                                    _this.coreLoadOrPlay('play', urlConfig)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "retry",
            value: function retry(retryConfig) {
                var _this = this;
                return _$e(function() {
                    var // 本函数只更新了retryTimesInSession，并没有用此值拦截调用，因为retry不仅发生在播放器内部，外部也可能有接口调用。
                    // 而外部的调用不能拦截
                    _this_retryManager, e;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isVideoId(_this.context.playItem)) {
                                    return [
                                        2
                                    ];
                                }
                                _this.emit(FlowNodeEvt.RETRY_PLAY, retryConfig);
                                _this.beforePrepareRetry(retryConfig);
                                _this.retryDefer = new SimpleDefer();
                                (_this_retryManager = _this.retryManager) === null || _this_retryManager === void 0 ? void 0 : _this_retryManager.updateRetryTimesInSession();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.replay(_this.context.playItem, retryConfig.updatePlayParam)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                _this.abort(e);
                                return [
                                    2
                                ];
                            case 4:
                                if (_this.isDestroyed) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    _this.retryDefer.promise
                                ];
                            case 5:
                                _state.sent();
                                _this.emit(FlowNodeEvt.RETRY_PLAY_SUCC);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "preloadImpl",
            value: function preloadImpl() {
                var _this = this;
                return _$e(function() {
                    var urlConfig, e;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.context.getUrlConfigByPlayItem(_this.inputGetinfoCtx)
                                ];
                            case 1:
                                urlConfig = _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                // 视频节点在预加载时候如果就出现请求后台服务错误，直接结束流程。
                                // 这是为了避免用户需要在播放完广告流程以后走到视频节点的start才出现错误界面，对用户并不友好
                                _this.abort(e);
                                return [
                                    2
                                ];
                            case 3:
                                if (_this.isDestroyed) {
                                    return [
                                        2
                                    ];
                                }
                                if (_this.context.isLive) {
                                    return [
                                        2,
                                        _this.preloadLive(urlConfig)
                                    ];
                                }
                                return [
                                    2,
                                    _this.preloadVod(urlConfig)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "startImpl",
            value: function startImpl() {
                var _this = this;
                // 开始播放以后，再开始监听core的事件，这是为了避免当前播放的正片节点和预加载的正片节点的事件串了
                this.setCoreEvents(true);
                this.context.remainTimeGetter = function() {
                    var endTime = _this.corePlayer.duration;
                    var remainTime = Math.floor(Math.max(endTime - _this.corePlayer.playtime, 0));
                    return remainTime;
                };
                if (this.context.isLive) {
                    this.startLive();
                } else {
                    this.startVod();
                }
            }
        },
        {
            key: "pauseImpl",
            value: function pauseImpl(opts) {
                this.corePlayer.pause(opts === null || opts === void 0 ? void 0 : opts.pauseType);
            }
        },
        {
            key: "resumeImpl",
            value: function resumeImpl() {
                this.corePlayer.play();
            }
        },
        {
            key: "stopImpl",
            value: function stopImpl(opts) {
                var _ref = opts || {}, _ref_endState = _ref.endState, endState = _ref_endState === void 0 ? END_STATE.INTERRUPT : _ref_endState;
                this.context.remainTimeGetter = null;
                //  这个调用以后可能走到onVideoStop->整个流程结束->本对象被destroy，所以最后调用
                this.corePlayer.stop(endState);
            }
        },
        {
            key: "resetImpl",
            value: function resetImpl() {
                // 因为目前core对象是可能多个VideoNode共用的，例如你在预加载下一个视频时候可能和当前播放是同一个core，那预加载下一个视频时如果出现错误
                // 可能会重置节点，那此时不能直接停止core对象，这样会把当前正在播放的视频停掉了！
                if (!FlowNodeUseCoreMap.isHoldByOther(this.corePlayerInstance, this.uid)) {
                    this.corePlayer.stop();
                } else {
                    this.log('reset, cannot stop video because of core hold by other vn');
                }
                this.isReplaying = false;
                this.inputGetinfoCtx = null;
                this.setLevelDeferWhenReplaying = null;
                this.retryDefer = null;
                this.context.remainTimeGetter = null;
            }
        },
        {
            key: "checkPreloadPostAd",
            value: /**
   * 检查何时加载后贴广告
   */ function checkPreloadPostAd() {
                var _this_corePlayer = this.corePlayer, playtime = _this_corePlayer.playtime, duration = _this_corePlayer.duration;
                var _this_context_playParam = this.context.playParam, _this_context_playParam_postAdReqLeftTime = _this_context_playParam.postAdReqLeftTime, postAdReqLeftTime = _this_context_playParam_postAdReqLeftTime === void 0 ? 10 : _this_context_playParam_postAdReqLeftTime;
                if (duration > postAdReqLeftTime && playtime + postAdReqLeftTime >= duration) {
                    this.triggerPreloadNext();
                }
            }
        },
        {
            key: "getLevelUrlConfig",
            value: function getLevelUrlConfig(level, _extra) {
                var _this = this;
                return _$e(function() {
                    var getinfoRet, urlConfig;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.context.updatePlayParam({
                                    videoReqInfoParam: level
                                });
                                return [
                                    4,
                                    _this.context.getVideoInfo()
                                ];
                            case 1:
                                getinfoRet = _state.sent();
                                urlConfig = (getinfoRet || {}).urlConfig;
                                return [
                                    2,
                                    urlConfig
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "beforePrepareRetry",
            value: /**
   * 在重试前的准备工作
   */ function beforePrepareRetry(_retryConfig) {
            // tobe override
            }
        },
        {
            key: "preloadLive",
            value: /**
   * 直播时预加载逻辑比较特殊，目前的设定是在后台静音播放正片（等状态为started时再显示出来）
   */ function preloadLive(urlConfig) {
                var _this = this;
                return _$e(function() {
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // 直播开始使用core了
                                _this.setCoreEvents(true);
                                _this.corePlayer.volume = 0;
                                return [
                                    4,
                                    _this.coreLoadOrPlay('play', urlConfig)
                                ];
                            case 1:
                                _state.sent();
                                if (_this.isDestroyed) {
                                    return [
                                        2
                                    ];
                                }
                                _this.corePlayer.resize({
                                    width: 0
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "preloadVod",
            value: /**
   * 点播预加载。
   *
   * 这个预加载分为以下几种场景
   * 1. url播放模式调用load接口
   * 2. 前贴广告节点播放时，预加载正片
   * 3. 当前正片节点播放时，预加载下一个session的正片节点
   */ function preloadVod(urlConfig) {
                var _this = this;
                return _$e(function() {
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!FlowNodeUseCoreMap.isHoldByOther(_this.corePlayerInstance, _this.uid)) return [
                                    3,
                                    2
                                ];
                                _this.log('preload vod by core');
                                // 开始使用core了，那就得开始监听core的事件了。因为load过程中也可能出现重试等。
                                _this.setCoreEvents(true);
                                return [
                                    4,
                                    _this.coreLoadOrPlay('load', urlConfig)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                // core并不空闲也无法走纯数据加载模式，无法预加载（抛出错误，基类catch到错误后回退到idle状态）
                                throw new Error('can not preload item!');
                        }
                    });
                })();
            }
        },
        {
            key: "startLive",
            value: function startLive() {
                // 直播在预加载时，设置过音量为0，开播以后再恢复一下原始音量。
                this.corePlayer.volume = this.volumeInner;
                this.corePlayer.resize({
                    width: '100%'
                });
            }
        },
        {
            key: "startVod",
            value: function startVod() {
                this.corePlayer.play();
            }
        },
        {
            key: "setCoreEvents",
            value: function setCoreEvents() {
                var _this = this;
                var isBind = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                if (this.coreEventsBound === isBind) {
                    return;
                }
                this.coreEventsBound = isBind;
                var func = isBind ? this.corePlayer.on : this.corePlayer.off;
                Object.keys(this.evtMap).forEach(function(evtName) {
                    // 如果是自动播放被阻止事件，优先级调高。这个FlowNode里面先收到事件以后扭转state，然后外部的autoplay策略模块收到事件开始静音重播，
                    // 按照这个时序state判断才能通过。
                    var listenerPriority = isBind && evtName === PLAY_EVENT.AUTOPLAY_BLOCKED ? 1 : void 0;
                    func.call(_this.corePlayer, evtName, _this.evtMap[evtName], listenerPriority);
                });
            }
        },
        {
            key: "coreLoadOrPlay",
            value: function coreLoadOrPlay(methodName, urlConfig) {
                var _this = this;
                return _$e(function() {
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // TODO: 第二个参数有个videoLoadParamModifier回调逻辑还没有补齐，跟vvip有关的参数修改，来自更上层的回调函数传入
                                return [
                                    4,
                                    _this.corePlayer[methodName](urlConfig, _this.context.corePlayParam)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return VideoFlowNode;
}(BaseFlowNode);
_$i([
    onceDecorator,
    _$j("design:type", Function),
    _$j("design:paramtypes", []),
    _$j("design:returntype", void 0)
], VideoFlowNode.prototype, "destroy", null);

/**
 * 内置创建节点的逻辑
 * (h5player层模拟了一个虚拟的广告插件存在时的广告+正片播放流程。)
 */ function createFlowNodes(context) {
    if (context.config.createFlowNodesCallback) {
        // 外部有创建节点数组的回调
        return context.config.createFlowNodesCallback(context);
    }
    var nodes = [];
    var adPlugin = getAdPlugin(context.config.instanceId);
    // getinfo
    if (isVideoId(context.playItem)) {
        nodes.push(new GetVideoInfoFlowNode(context));
    }
    // 前贴广告
    if (!!adPlugin) {
        nodes.push(new PreAdFlowNode(context));
    }
    // 正片
    nodes.push(new VideoFlowNode(context));
    // 后贴广告
    if (!!adPlugin && !context.isLive) {
        // 点播才有后贴广告
        nodes.push(new PostAdFlowNode(context));
    }
    return nodes;
}

/**
 * 播放流程的节点链。这里对播放器的`H5_PLAY_EVENT`和`H5_EXT_EVENT`事件进行了转发。同时播放器调用这个链里面正片节点所拥有的
 * thumbplayer-core对象实现一些对外接口（例如player.duration等）
 */ var FlowNodeChain = /*#__PURE__*/ function() {
    function FlowNodeChain(flowConfig, emitters, flowNodeEvtCallback) {
        var _this = this;
        _$1(this, FlowNodeChain);
        _$2(this, "flowNodeEvtCallback", void 0);
        _$2(this, "isDestroyed", false);
        _$2(this, "nodes", []);
        _$2(this, "instanceId", void 0);
        _$2(this, "emitters", void 0);
        /** 是否是正片首次播放（区别于core中的首次播放，在h5player这里需要考虑发生重试等情况） */ _$2(this, "isFirstPlaying", true);
        _$2(this, "corePlayer", void 0);
        _$2(this, "handleVideoCoreEvts", function(e) {
            if (!_this.context.isActive) {
                // 当前播放和预加载使用的是同一个core对象，预加载时的chain不能监听core对象的事件并进行转发
                return;
            }
            _this.emitPlayerEvts(e);
        });
        var _this1 = this;
        _$2(this, "handlerFlowNodeEvts", function() {
            var _ref = _$e(function(e) {
                var flowNode, context;
                return _$f(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            flowNode = e.target;
                            context = flowNode.getContext();
                            if (!!context.isActive) return [
                                3,
                                2
                            ];
                            // 不是当前session的节点发出的事件，都等到此节点所属的session真正开播以后处理。这是为了避免预加载的session如果派发出abort事件等，可能
                            // 会影响到正在播放的session！
                            return [
                                4,
                                context.getActiveDefer()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            _this1.emitExtEvts(e);
                            _this1.flowNodeEvtCallback(e);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }());
        this.emitters = emitters;
        this.flowNodeEvtCallback = flowNodeEvtCallback;
        this.corePlayer = getCorePool(flowConfig.config.instanceId).create(CoreType.VIDEO, flowConfig.config);
        this.instanceId = flowConfig.config.instanceId;
        this.nodes = createFlowNodes(new FlowContext(flowConfig));
        this.nodes.forEach(function(node) {
            return _this.setFlowNodeEvent(node, true);
        });
        this.setVideoCoreEvts(true);
    }
    _(FlowNodeChain, [
        {
            key: "destroy",
            value: function destroy() {
                if (this.isDestroyed) {
                    return;
                }
                this.isDestroyed = true;
                this.clear();
                this.setVideoCoreEvts(false);
                this.corePlayer = null;
                this.flowNodeEvtCallback = null;
                this.emitters = null;
            }
        },
        {
            key: "core",
            get: /**
   * 获取这次播放使用的thumbplayer-core对象
   *
   * 注意：这个core对象必须绑定在chain上（不能在VideoFlowNode上，因为在其他节点运行时也可能使用这个core），当创建播放流程以后，chain上一
   * 定有这个core对象。当流程结束以后，释放这个core对象
   */ function get() {
                return this.corePlayer;
            }
        },
        {
            key: "context",
            get: function get() {
                return this.current.getContext();
            }
        },
        {
            key: "flowNodes",
            get: function get() {
                return this.nodes;
            }
        },
        {
            key: "current",
            get: function get() {
                return this.nodes[0];
            }
        },
        {
            key: "currentName",
            get: /** 当前节点的名称 */ function get() {
                var _this_current;
                return (_this_current = this.current) === null || _this_current === void 0 ? void 0 : _this_current.getName();
            }
        },
        {
            key: "currentState",
            get: function get() {
                var _this_current;
                return (_this_current = this.current) === null || _this_current === void 0 ? void 0 : _this_current.getState();
            }
        },
        {
            key: "isEmpty",
            get: function get() {
                return this.nodes.length <= 0;
            }
        },
        {
            key: "length",
            get: function get() {
                return this.nodes.length;
            }
        },
        {
            key: "active",
            value: function active() {
                this.context.active();
            }
        },
        {
            key: "push",
            value: function push(callback) {
                var node = callback(this);
                this.flowNodes.push(node);
                this.setFlowNodeEvent(node, true);
            }
        },
        {
            key: "indexOf",
            value: function indexOf(node) {
                return this.nodes.indexOf(node);
            }
        },
        {
            key: "getNext",
            value: function getNext(node) {
                var idx = this.flowNodes.indexOf(node);
                if (idx === -1) {
                    return null;
                }
                return this.flowNodes[idx + 1];
            }
        },
        {
            key: "shift",
            value: function shift() {
                return this.nodes.shift();
            }
        },
        {
            key: "abort",
            value: function abort() {
                if (!this.current) {
                    return;
                }
                this.setFlowNodeEvent(this.current, false);
                this.current.stop();
            }
        },
        {
            key: "videoNode",
            get: function get() {
                return this.find(FlowNodeName.PLAY_VIDEO);
            }
        },
        {
            key: "preAdNode",
            get: function get() {
                return this.find("".concat(FlowNodeName.PLAY_AD, ".").concat(AdType.PRE));
            }
        },
        {
            key: "postAdNode",
            get: function get() {
                return this.find("".concat(FlowNodeName.PLAY_AD, ".").concat(AdType.POST));
            }
        },
        {
            key: "getinfoNode",
            get: function get() {
                return this.find(FlowNodeName.GET_INFO);
            }
        },
        {
            key: "find",
            value: function find(name) {
                return this.nodes.find(function(node) {
                    return node.getName() === name;
                });
            }
        },
        {
            key: "forEach",
            value: function forEach(callback) {
                this.nodes.forEach(callback);
            }
        },
        {
            key: "resetFollowingPreloadFlowNodes",
            value: /**
   * 重置当前节点后续已经执行预加载的节点
   */ function resetFollowingPreloadFlowNodes() {
                for(var i = 1; i < this.nodes.length; i++){
                    var state = this.nodes[i].getState();
                    if (state === FlowNodeState.PRELOADING || state === FlowNodeState.PRELOADED) {
                        this.nodes[i].reset();
                    }
                }
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this = this;
                this.nodes.forEach(function(node) {
                    node.destroy();
                    _this.setFlowNodeEvent(node, false);
                });
                this.nodes.length = 0;
            }
        },
        {
            key: "setFlowNodeEvent",
            value: /**
   * FlowNode节点的事件处理
   */ function setFlowNodeEvent(node, isBind) {
                var _this = this;
                var func = isBind ? node.on : node.off;
                Object.keys(FlowNodeEvt).forEach(function(key) {
                    func.call(node, FlowNodeEvt[key], _this.handlerFlowNodeEvts);
                });
            }
        },
        {
            key: "setVideoCoreEvts",
            value: /**
   * video节点使用的thumbplayer-core对象的事件处理
   */ function setVideoCoreEvts(isBind) {
                var _this = this;
                Object.keys(PLAY_EVENT).forEach(function(v) {
                    if (isBind) {
                        _this.corePlayer.on(PLAY_EVENT[v], _this.handleVideoCoreEvts);
                    } else {
                        _this.corePlayer.off(PLAY_EVENT[v], _this.handleVideoCoreEvts);
                    }
                });
            }
        },
        {
            key: "emitExtEvts",
            value: /**
   * 转发`H5_EXT_EVENT`事件
   */ function emitExtEvts(e) {
                var emitter = e.target;
                var name = emitter.getName();
                var isContiguous = emitter.getIsContiguous();
                var _emitter_getContext = emitter.getContext(), flowid = _emitter_getContext.flowid, playItem = _emitter_getContext.playItem;
                if (e.type === FlowNodeEvt.STATE_CHANGE) {
                    var _e_data = e.data, preState = _e_data.preState, curState = _e_data.curState, data = _e_data.data;
                    if (curState === FlowNodeState.PRELOADING) {
                        this.emitters.emitExtEvts(H5_EXT_EVENT.FLOW_NODE_PRELOAD, {
                            name: name,
                            isContiguous: isContiguous
                        });
                    } else if (preState === FlowNodeState.PRELOADED && curState === FlowNodeState.STARTED) {
                        this.emitters.emitExtEvts(H5_EXT_EVENT.FLOW_NODE_START, {
                            name: name,
                            isContiguous: isContiguous,
                            flowid: flowid,
                            playItem: playItem
                        });
                    } else if (curState === FlowNodeState.STOPPED) {
                        this.emitters.emitExtEvts(H5_EXT_EVENT.FLOW_NODE_END, _$b({
                            name: name,
                            isContiguous: isContiguous
                        }, data));
                    }
                } else if (e.type === FlowNodeEvt.ABORT) {
                    this.emitters.emitExtEvts(H5_EXT_EVENT.FLOW_NODE_ABORT, _$b({
                        name: name,
                        isContiguous: isContiguous
                    }, e.data));
                } else if (e.type === FlowNodeEvt.RETRY_PLAY) {
                    this.emitters.emitExtEvts(H5_EXT_EVENT.RETRY_PLAY, e.data);
                } else if (e.type === FlowNodeEvt.RETRY_PLAY_SUCC) {
                    this.emitters.emitExtEvts(H5_EXT_EVENT.RETRY_PLAY_SUCC, e.data);
                }
            }
        },
        {
            key: "emitPlayerEvts",
            value: function emitPlayerEvts(e) {
                var type = e.type, data = e.data;
                // 1. 所有PLAY_EVENT在上层播放器转发（旧逻辑），因为转发的PLAY_EVENT而不是H5_PLAY_EVENT，因此as any
                this.emitters.emitPlayerEvts(type, _$c(_$b({}, data), {
                    isContiguous: this.current.getIsContiguous()
                }));
                // 2. 按状态转发
                if (type === PLAY_EVENT.STATE_CHANGE) {
                    var state = data.new;
                    if (coreStateToPlayerEvtMap[state]) {
                        this.emitters.emitPlayerEvts(coreStateToPlayerEvtMap[state], {});
                    } else if (state === VIDEO_STATE.PLAYING) {
                        var isFirst = this.isFirstPlaying;
                        this.isFirstPlaying = false;
                        // todo: 直播播放广告时，直播可能在后台静音播放，此时也不广播?
                        this.emitters.emitPlayerEvts(H5_PLAY_EVENT.VIDEO_PLAYING, {
                            isFirst: isFirst
                        });
                    } else if (state === VIDEO_STATE.PAUSE) {
                        this.emitters.emitPlayerEvts(H5_PLAY_EVENT.VIDEO_PAUSE, {
                            pauseType: data.pauseType
                        });
                    }
                } else if (type === PLAY_EVENT.STOPED) {
                    var _data_videoInfo;
                    var error = data === null || data === void 0 ? void 0 : (_data_videoInfo = data.videoInfo) === null || _data_videoInfo === void 0 ? void 0 : _data_videoInfo.error;
                    var evtData = _$c(_$b({}, data), {
                        code: (error === null || error === void 0 ? void 0 : error.code) || ErrorCode.SUC
                    });
                    this.emitters.emitPlayerEvts(H5_PLAY_EVENT.VIDEO_END, evtData);
                }
                // 3. 按映射关系转发
                if (evtTransformMap[type]) {
                    var _evtTransformMap_type = evtTransformMap[type], evt = _evtTransformMap_type.evt, getParam = _evtTransformMap_type.getParam;
                    this.emitters.emitPlayerEvts(evt, getParam(data));
                }
            }
        }
    ]);
    return FlowNodeChain;
}();

/**
 * 播放流程节点的管理器。管理器维护了一组当前播放的流程节点。同时，如果用户调用了播放器预加载下一个视频，也可能存在一组正在预加载的播放节点数组。
 */ var FlowManager = /*#__PURE__*/ function(EvtEmitter) {
    _$4(FlowManager, EvtEmitter);
    var _super = _$5(FlowManager);
    function FlowManager(config, emitters) {
        _$1(this, FlowManager);
        var _this;
        _this = _super.call(this);
        _$2(_$6(_this), "logger", void 0);
        /** 当前播放流程的节点链 */ _$2(_$6(_this), "currentFlowNodeChain", void 0);
        /** 预加载播放流程的节点链（未激活状态） */ _$2(_$6(_this), "preloadFlowNodeChain", void 0);
        _$2(_$6(_this), "config", void 0);
        _$2(_$6(_this), "flowNodeEvtMap", void 0);
        _$2(_$6(_this), "volumeInner", 1);
        _$2(_$6(_this), "playbackRateInner", 1);
        _$2(_$6(_this), "emitters", void 0);
        _$2(_$6(_this), "handlerFlowNodeEvts", function(e) {
            var _this_flowNodeEvtMap_evtName;
            var evtName = e.type;
            (_this_flowNodeEvtMap_evtName = _this.flowNodeEvtMap[evtName]) === null || _this_flowNodeEvtMap_evtName === void 0 ? void 0 : _this_flowNodeEvtMap_evtName.apply(_$6(_this), [
                e
            ]);
        });
        _this.config = config;
        _this.emitters = emitters;
        _this.logger = new Logger(config.instanceId, 'FlowManager');
        var _obj;
        _this.flowNodeEvtMap = (_obj = {}, _$2(_obj, FlowNodeEvt.ENDED, _this.onFlowNodeEnded), _$2(_obj, FlowNodeEvt.ABORT, _this.onFlowNodeAbort), _$2(_obj, FlowNodeEvt.TRIGGER_PRELOAD_NEXT, _this.onTriggerPreloadNext), _$2(_obj, FlowNodeEvt.RETRY_PLAY, _this.onRetryPlayEvts), _$2(_obj, FlowNodeEvt.RETRY_PLAY_SUCC, _this.onRetryPlayEvts), _obj);
        return _this;
    }
    _(FlowManager, [
        {
            key: "destroy",
            value: function destroy() {
                this.clearCurrentSession();
                this.clearPreloadSession();
                this.config = null;
                this.emitters = null;
                this.flowNodeEvtMap = null;
            }
        },
        {
            key: "isCurrentSessionEmpty",
            get: /** 当前流程是否是空的 */ function get() {
                return !this.currentFlowNodeChain || this.currentFlowNodeChain.isEmpty;
            }
        },
        {
            key: "chain",
            get: /**
   * 当前播放流程的节点链
   */ function get() {
                return this.currentFlowNodeChain;
            }
        },
        {
            key: "getVolume",
            value: function getVolume() {
                return this.volumeInner;
            }
        },
        {
            key: "setVolume",
            value: function setVolume(val) {
                var _this_currentFlowNode_setVolume, _this_currentFlowNode;
                this.volumeInner = val;
                (_this_currentFlowNode = this.currentFlowNode) === null || _this_currentFlowNode === void 0 ? void 0 : (_this_currentFlowNode_setVolume = _this_currentFlowNode.setVolume) === null || _this_currentFlowNode_setVolume === void 0 ? void 0 : _this_currentFlowNode_setVolume.call(_this_currentFlowNode, this.volumeInner);
            }
        },
        {
            key: "getPlaybackRate",
            value: function getPlaybackRate() {
                return this.playbackRateInner;
            }
        },
        {
            key: "setPlaybackRate",
            value: function setPlaybackRate(val) {
                var _this_currentFlowNodeChain_current_setPlaybackRate, _this_currentFlowNodeChain_current, _this_currentFlowNodeChain;
                if (this.playbackRateInner === val) {
                    return;
                }
                this.playbackRateInner = val;
                (_this_currentFlowNodeChain = this.currentFlowNodeChain) === null || _this_currentFlowNodeChain === void 0 ? void 0 : (_this_currentFlowNodeChain_current = _this_currentFlowNodeChain.current) === null || _this_currentFlowNodeChain_current === void 0 ? void 0 : (_this_currentFlowNodeChain_current_setPlaybackRate = _this_currentFlowNodeChain_current.setPlaybackRate) === null || _this_currentFlowNodeChain_current_setPlaybackRate === void 0 ? void 0 : _this_currentFlowNodeChain_current_setPlaybackRate.call(_this_currentFlowNodeChain_current, this.playbackRateInner);
            }
        },
        {
            key: "stopCurFlowNode",
            value: function stopCurFlowNode(opts) {
                this.currentFlowNode.stop(opts);
            }
        },
        {
            key: "replayCurFlowNode",
            value: function replayCurFlowNode(playItem, playParam) {
                var _this_currentFlowNode_replay, _this_currentFlowNode;
                return (_this_currentFlowNode_replay = (_this_currentFlowNode = this.currentFlowNode).replay) === null || _this_currentFlowNode_replay === void 0 ? void 0 : _this_currentFlowNode_replay.call(_this_currentFlowNode, playItem, playParam);
            }
        },
        {
            key: "updatePlayParam",
            value: function updatePlayParam(playParam) {
                var _this_currentFlowNode;
                (_this_currentFlowNode = this.currentFlowNode) === null || _this_currentFlowNode === void 0 ? void 0 : _this_currentFlowNode.getContext().updatePlayParam(playParam);
            }
        },
        {
            key: "pause",
            value: /**
   * 暂停当前节点，并记录整个流程的暂停状态。某些节点在运行时需要检查当前是否是暂停状态。
   */ function pause(pauseType) {
                this.currentFlowNode.pause({
                    pauseType: pauseType
                });
            }
        },
        {
            key: "resume",
            value: function resume() {
                this.currentFlowNode.resume();
            }
        },
        {
            key: "abortCurFlowNode",
            value: /**
   * 马上停止当前节点的播放（并且不再监听节点事件，不会触发接下来的节点动作）
   */ function abortCurFlowNode() {
                var _this_currentFlowNodeChain;
                (_this_currentFlowNodeChain = this.currentFlowNodeChain) === null || _this_currentFlowNodeChain === void 0 ? void 0 : _this_currentFlowNodeChain.abort();
            }
        },
        {
            key: "setAudioTrack",
            value: function setAudioTrack(id) {
                var _this_currentFlowNode_setAudioTrack, _this_currentFlowNode;
                return (_this_currentFlowNode_setAudioTrack = (_this_currentFlowNode = this.currentFlowNode).setAudioTrack) === null || _this_currentFlowNode_setAudioTrack === void 0 ? void 0 : _this_currentFlowNode_setAudioTrack.call(_this_currentFlowNode, id);
            }
        },
        {
            key: "setLevel",
            value: /**
   * 切换清晰度，这个行为目前作用在视频节点上。
   * 需要注意的是，`setLevel`行为会清空后续已经预加载的所有节点！
   */ function setLevel(level, extra) {
                var _this_currentFlowNode_setLevel, _this_currentFlowNode;
                // 切清晰度可能会影响到后续已经预加载的节点，因为视频分辨率已经变了
                // （切清晰度只从外部触发，所以这里调用重置）
                this.resetFollowingPreloadFlowNodes();
                return (_this_currentFlowNode_setLevel = (_this_currentFlowNode = this.currentFlowNode).setLevel) === null || _this_currentFlowNode_setLevel === void 0 ? void 0 : _this_currentFlowNode_setLevel.call(_this_currentFlowNode, level, extra);
            }
        },
        {
            key: "retry",
            value: /**
   * 重试正片，这个行为作用在视频节点上。
   * 需要注意的是，`retry`行为可能会清空后续已经预加载的所有节点！
   */ function retry(retryConfig) {
                var _this_currentFlowNode_retry, _this_currentFlowNode;
                return (_this_currentFlowNode_retry = (_this_currentFlowNode = this.currentFlowNode).retry) === null || _this_currentFlowNode_retry === void 0 ? void 0 : _this_currentFlowNode_retry.call(_this_currentFlowNode, retryConfig);
            }
        },
        {
            key: "getPreloadSessionFlowidByVid",
            value: /**
   * 根据播放参数查找预加载session的flowid
   */ function getPreloadSessionFlowidByVid(nextVid) {
                if (!this.preloadFlowNodeChain) {
                    return null;
                }
                var _this_preloadFlowNodeChain_context = this.preloadFlowNodeChain.context, vid = _this_preloadFlowNodeChain_context.vid, flowid = _this_preloadFlowNodeChain_context.flowid;
                if (vid === nextVid) {
                    return flowid;
                }
                return null;
            }
        },
        {
            key: "createSession",
            value: /**
   * 创建一个session的播放流程节点。可能是新创建一个播放流程的节点数组并开始预加载。也可能是启用一个已经被提前创建的预加载的播放流程（激活）。
   */ function createSession(playItem, playParam, flowid) {
                var _this = this;
                return _$e(function() {
                    var preloadSessionFlowid, flowConfig, error;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                preloadSessionFlowid = _this.getPreloadSessionFlowidByVid(playItem);
                                if (preloadSessionFlowid) {
                                    // 有命中的预加载的播放流程
                                    _this.currentFlowNodeChain = _this.preloadFlowNodeChain;
                                    _this.currentFlowNodeChain.active();
                                    // 预加载的时候调用的preload接口，传入了IPlayParam。但是真正开始play的时候，调用方可能还会从play接口传入新的IPlayParam，这里合并下
                                    _this.currentFlowNodeChain.context.updatePlayParam(playParam);
                                    _this.preloadFlowNodeChain = null;
                                    return [
                                        2
                                    ];
                                }
                                // 可能存在没有命中的预加载节点数组，需要清理（preload一个vid，但是随后play的并不是这个vid）
                                _this.clearPreloadSession();
                                flowConfig = {
                                    isPreload: false,
                                    playItem: playItem,
                                    playParam: playParam,
                                    flowid: flowid,
                                    config: _this.config
                                };
                                _this.currentFlowNodeChain = new FlowNodeChain(flowConfig, _this.emitters, _this.handlerFlowNodeEvts);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                // 从起始节点开始预加载整个流程
                                // （节点可能会自动触发下一个节点的预加载行为，因此调用此函数以后可能有多个节点扭转到`PRELOADED`状态，然后等待触发运行状态）
                                return [
                                    4,
                                    _this.currentFlowNode.preload()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                _this.logger.error('flowManager preload err', error);
                                // 按照重构前的逻辑，调用播放器load接口时发生错误，马上会抛出sessionEnd结束播放
                                _this.emit(FlowManagerEvt.FLOW_OVER, error);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "preloadSession",
            value: /**
   * 预加载下一个播放流程。首先创建一组播放流程的节点，然后马上开始依次触发节点预加载（某些节点无法预加载可能跳过）。
   */ function preloadSession(playItem, playParam, flowid, videoEndTime) {
                var _this = this;
                return _$e(function() {
                    var flowConfig, e;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.isCurrentSessionEmpty || _this.currentFlowNodeChain.currentName !== FlowNodeName.PLAY_VIDEO) {
                                    // 只支持在正片播放时提前插入下一个播放流程（后贴广告很短，插入实际上也没太大意义）
                                    _this.logger.warn("preloaSession on <".concat(_this.currentFlowNode, ">, return"));
                                    return [
                                        2
                                    ];
                                }
                                // 如果已经有预加载session，需要删除相关节点。因为播放器仅支持追加唯一一个预加载session（不支持连续preload多次vid）
                                _this.clearPreloadSession();
                                flowConfig = {
                                    isPreload: true,
                                    playItem: playItem,
                                    playParam: playParam,
                                    flowid: flowid,
                                    config: _this.config
                                };
                                _this.preloadFlowNodeChain = new FlowNodeChain(flowConfig, _this.emitters, _this.handlerFlowNodeEvts);
                                if (!(typeof _this.config.preloadFlowNodesCallback === 'function')) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.config.preloadFlowNodesCallback(_this.currentFlowNodeChain, _this.preloadFlowNodeChain, videoEndTime)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                // 预加载下一个session这个过程比较漫长，如果发生播放器被销毁，或者调用了`clearPreloadSession`清理了预加载节点，可能报错？
                                _this.logger.error('preloadSession err, ', e);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "firstFlowNodeTriggerPreloadNext",
            value: /**
   * 当关闭预加载时，节点之间不会触发预加载。但是用户调用load()接口时，又需要触发广告 / 视频节点的预加载，否则调用以后无任何逻辑，黑屏状态。
   * 因此这种场景下，在管理器预加载第一个节点以后调用，手动触发后续节点的预加载。
   */ function firstFlowNodeTriggerPreloadNext() {
                var _this = this;
                return _$e(function() {
                    var getinfoFlowNode, getinfoCtx, preAdFlowNode, videoFlowNode, hasPreAd, hasAd;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.logger.log('ffntrpn start');
                                getinfoFlowNode = _this.currentFlowNodeChain.getinfoNode;
                                getinfoCtx = ((getinfoFlowNode === null || getinfoFlowNode === void 0 ? void 0 : getinfoFlowNode.getOutput()) || {}).getinfoCtx;
                                preAdFlowNode = _this.currentFlowNodeChain.preAdNode;
                                videoFlowNode = _this.currentFlowNodeChain.videoNode;
                                if (preAdFlowNode && preAdFlowNode.getState() !== FlowNodeState.IDLE || videoFlowNode.getState() !== FlowNodeState.IDLE) {
                                    // 调用方调用load接口以后，马上在某个瞬间调用play接口。这样就触发了每个flownode的start接口（start接口调用时如果是idle状态也可能触
                                    // 发preload）。那么这种情况会在这个函数之前触发广告/正片节点的预加载。如果继续走这个函数的逻辑，会导致再次执行广告/正片节点的预加载，然
                                    // 后start接口await的preloadDefer被二次替换掉了，start接口就卡住了。
                                    // 因此，这个判断的目的是为了避免已经走了start接口又重复调用广告/正片的preload。
                                    _this.logger.log('ffntrpn cancel because of preload has been triggered');
                                    return [
                                        2
                                    ];
                                }
                                // 前贴预加载
                                hasPreAd = false;
                                if (!(preAdFlowNode && getinfoCtx)) return [
                                    3,
                                    2
                                ];
                                // 有前贴节点并且有getinfo数据，才执行前贴预加载
                                preAdFlowNode.setInput({
                                    getinfoCtx: getinfoCtx
                                });
                                return [
                                    4,
                                    preAdFlowNode.preload()
                                ];
                            case 1:
                                _state.sent();
                                _this.logger.log('ffntrpn, preAd preloaded');
                                hasAd = preAdFlowNode.getOutput().hasAd;
                                hasPreAd = hasAd;
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                _this.logger.log("ffntrpn, skip preload preAd, hasCtx=".concat(!!getinfoCtx));
                                _state.label = 3;
                            case 3:
                                if (!!hasPreAd) return [
                                    3,
                                    5
                                ];
                                // 没有前贴广告，继续正片预加载了。（如果有，那就等前贴广告正式开播以后，按广告倒计时触发正片预加载）
                                videoFlowNode.setInput({
                                    getinfoCtx: getinfoCtx
                                });
                                _this.logger.log('ffntrpn, exec preload video');
                                return [
                                    4,
                                    videoFlowNode.preload()
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                _this.logger.log('ffntrpn, skip preload video, hasPreAd=', hasPreAd);
                                _state.label = 6;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "start",
            value: /**
   * 从起始节点开始整个流程的运行
   */ function start() {
                if (this.isCurrentSessionEmpty) {
                    return;
                }
                return this.startCurFlowNode();
            }
        },
        {
            key: "clearCurrentSession",
            value: /**
   * 清理当前播放流程的节点数组
   */ function clearCurrentSession() {
                var _this_currentFlowNodeChain;
                (_this_currentFlowNodeChain = this.currentFlowNodeChain) === null || _this_currentFlowNodeChain === void 0 ? void 0 : _this_currentFlowNodeChain.destroy();
                this.currentFlowNodeChain = null;
            }
        },
        {
            key: "clearPreloadSession",
            value: /**
   * 清理预加载session的节点数组
   */ function clearPreloadSession() {
                var _this_preloadFlowNodeChain;
                (_this_preloadFlowNodeChain = this.preloadFlowNodeChain) === null || _this_preloadFlowNodeChain === void 0 ? void 0 : _this_preloadFlowNodeChain.destroy();
                this.preloadFlowNodeChain = null;
            }
        },
        {
            key: "currentFlowNode",
            get: /** @inner */ function get() {
                var _this_currentFlowNodeChain;
                return (_this_currentFlowNodeChain = this.currentFlowNodeChain) === null || _this_currentFlowNodeChain === void 0 ? void 0 : _this_currentFlowNodeChain.current;
            }
        },
        {
            key: "onFlowNodeEnded",
            value: function onFlowNodeEnded() {
                // 如果是节点结束，看看需不需要继续播放下一个节点
                this.playNextFlowNode();
            }
        },
        {
            key: "onFlowNodeAbort",
            value: function onFlowNodeAbort(e) {
                var name = e.target.getName();
                this.logger.log("flow aborted by <".concat(name, ">"));
                this.emit(FlowManagerEvt.FLOW_OVER, e.data);
            }
        },
        {
            key: "onTriggerPreloadNext",
            value: function onTriggerPreloadNext(e) {
                if (!this.config.enablePreload) {
                    return;
                }
                var flowNode = e.target;
                var preloadFlowNode = this.currentFlowNodeChain.getNext(flowNode);
                if (!preloadFlowNode) {
                    // 没有下一个节点可以触发预加载了
                    return;
                }
                preloadFlowNode.setInput(flowNode.getOutput());
                var flowid = flowNode.getContext().flowid.slice(-6);
                this.logger.log("[".concat(flowid, "]<").concat(flowNode.getName(), "> trigger preload <").concat(preloadFlowNode.getName(), ">"));
                preloadFlowNode.preload();
            }
        },
        {
            key: "onRetryPlayEvts",
            value: function onRetryPlayEvts(e) {
                var flowNode = e.target;
                if (flowNode.getState() !== FlowNodeState.STARTED) {
                    // bugfix:
                    // 调用load接口出现重试，这个过程如果走到了`resetFollowingPreloadFlowNodes`，会扭转VideoFlowNode的状态为idle。即使重试成功了，
                    // VideoFlowNode仍然是idle状态，再调用播放时，仍然会重新走一遍预加载等，而不是使用重试成功的数据。
                    // 因此，未起播过程(只调用load接口未开播)发生的重试，这种重试并不需要清掉什么数据。
                    return;
                }
                if (e.type === FlowNodeEvt.RETRY_PLAY) {
                    // 如果是换编码播放等重试，需要扭转后续已经预加载的节点的状态，因为已经预加载的数据 / 视频已经不适用
                    // （重试可能从内部也可能从外部触发，从事件重置）
                    this.resetFollowingPreloadFlowNodes();
                }
            }
        },
        {
            key: "playNextFlowNode",
            value: function playNextFlowNode() {
                if (this.isCurrentSessionEmpty) {
                    return;
                }
                if (this.currentFlowNodeChain.length <= 1) {
                    // 没有后续节点了
                    this.emit(FlowManagerEvt.FLOW_OVER, null);
                    return;
                }
                // 这里`this.currentFlowNode`的指向变了
                var preFlowNode = this.currentFlowNodeChain.shift();
                this.startCurFlowNode(preFlowNode);
            }
        },
        {
            key: "startCurFlowNode",
            value: function startCurFlowNode(preFlowNode) {
                var _preFlowNode_getVolume, // 切换节点需要继承一下当前音量 / 倍速
                // （音量的传递先获取上一个节点的音量，再获取缓存的音量值。因为有历史原因，广告播放时音量调节仅改动了广告插件音量而未设置播放器音量）
                _this_currentFlowNode_setVolume, _this_currentFlowNode, _this_currentFlowNode_setPlaybackRate, _this_currentFlowNode1;
                var _preFlowNode_getVolume1;
                var preFlowNodeVolume = (_preFlowNode_getVolume1 = preFlowNode === null || preFlowNode === void 0 ? void 0 : (_preFlowNode_getVolume = preFlowNode.getVolume) === null || _preFlowNode_getVolume === void 0 ? void 0 : _preFlowNode_getVolume.call(preFlowNode)) !== null && _preFlowNode_getVolume1 !== void 0 ? _preFlowNode_getVolume1 : this.volumeInner;
                this.logger.log("preFlowNode<".concat(preFlowNode === null || preFlowNode === void 0 ? void 0 : preFlowNode.getName(), "> volume=").concat(preFlowNodeVolume));
                (_this_currentFlowNode_setVolume = (_this_currentFlowNode = this.currentFlowNode).setVolume) === null || _this_currentFlowNode_setVolume === void 0 ? void 0 : _this_currentFlowNode_setVolume.call(_this_currentFlowNode, preFlowNodeVolume);
                (_this_currentFlowNode_setPlaybackRate = (_this_currentFlowNode1 = this.currentFlowNode).setPlaybackRate) === null || _this_currentFlowNode_setPlaybackRate === void 0 ? void 0 : _this_currentFlowNode_setPlaybackRate.call(_this_currentFlowNode1, this.playbackRateInner);
                // 这里把上一个节点的输出传递到下一个节点的输入
                this.currentFlowNode.setInput(preFlowNode === null || preFlowNode === void 0 ? void 0 : preFlowNode.getOutput());
                // 上一个节点没用了
                preFlowNode === null || preFlowNode === void 0 ? void 0 : preFlowNode.destroy();
                var _preFlowNode_getName;
                this.logger.log("<".concat((_preFlowNode_getName = preFlowNode === null || preFlowNode === void 0 ? void 0 : preFlowNode.getName()) !== null && _preFlowNode_getName !== void 0 ? _preFlowNode_getName : '', "> jump to <").concat(this.currentFlowNode.getName(), ">"));
                return this.currentFlowNode.start();
            }
        },
        {
            key: "resetFollowingPreloadFlowNodes",
            value: /**
   * 重置当前节点后续已经执行预加载的节点
   */ function resetFollowingPreloadFlowNodes() {
                this.currentFlowNodeChain.resetFollowingPreloadFlowNodes();
                // 预加载的播放流程也销毁
                this.clearPreloadSession();
            }
        }
    ]);
    return FlowManager;
}(EvtEmitter);

var FlowPlayer = /*#__PURE__*/ function(EvtEmitter) {
    _$4(FlowPlayer, EvtEmitter);
    var _super = _$5(FlowPlayer);
    function FlowPlayer(config) {
        _$1(this, FlowPlayer);
        var _this;
        _this = _super.call(this);
        _$2(_$6(_this), "logger", void 0);
        /** 播放器已经被销毁 */ // eslint-disable-next-line @typescript-eslint/naming-convention
        _$2(_$6(_this), "_destroyed", false);
        _$2(_$6(_this), "configInner", void 0);
        _$2(_$6(_this), "flowManager", void 0);
        /** 是否正在切换清晰度 */ _$2(_$6(_this), "isSettingLevel", false);
        /** 是否正在切音轨 */ _$2(_$6(_this), "isSettingAudioTrack", false);
        /** 播放器实例id，这个id播放器销毁也保持 */ _$2(_$6(_this), "flowPlayerInstanceId", void 0);
        _$2(_$6(_this), "onFlowManagerEvts", function(e) {
            if (e.type === FlowManagerEvt.FLOW_OVER) {
                var error = e.data;
                _this.onSessionStop(error ? END_STATE.ERROR : END_STATE.NORMAL, error);
            }
        });
        _this.configInner = config;
        _this.flowPlayerInstanceId = _this.configInner.instanceId;
        _this.logger = new Logger(_this.instanceId, 'FlowPlayer');
        _this.flowManager = new FlowManager(config, {
            emitPlayerEvts: _this.emitPlayerEvts.bind(_$6(_this)),
            emitExtEvts: _this.emitExtEvts.bind(_$6(_this))
        });
        // TODO：这里提前创建视频core，目的是提前在播放器container中插入video标签组的节点，跟老的逻辑保持一致。因为后续有部分播放器元素的
        // zIndex是auto，如果晚于这些元素创建视频core，video标签组会覆盖在这些zIndex是auto的元素的上层。最好的解决办法是在插件层固定好播
        // 放器所有元素的zIndex，而使用默认的auto去指定zIndex并不可控
        getCorePool(_this.instanceId).create(CoreType.VIDEO, _this.configInner);
        return _this;
    }
    _(FlowPlayer, [
        {
            key: "destroy",
            value: function destroy() {
                if (this._destroyed) {
                    return;
                }
                this._destroyed = true;
                this.setFlowManagerEvts(false);
                this.flowManager.destroy();
                destroyCorePool(this.instanceId);
                this.flowManager = null;
                this.logger = null;
                this.configInner = null;
            }
        },
        {
            key: "config",
            get: function get() {
                return this.configInner;
            }
        },
        {
            key: "container",
            get: function get() {
                var _this_configInner;
                return (_this_configInner = this.configInner) === null || _this_configInner === void 0 ? void 0 : _this_configInner.container;
            }
        },
        {
            key: "instanceId",
            get: /**
   * 播放器实例id
   */ function get() {
                return this.flowPlayerInstanceId;
            }
        },
        {
            key: "isFakeLive",
            get: /**
   * 是否是伪直播
   */ function get() {
                return this.configInner.isFakeLive;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_logger;
                return (_this_logger = this.logger).log.apply(_this_logger, _$8(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_logger;
                (_this_logger = this.logger).warn.apply(_this_logger, _$8(args));
            }
        },
        {
            key: "load",
            value: function load(playItem, playParam) {
                var _this = this;
                return _$e(function() {
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.configInner.enablePreload) return [
                                    3,
                                    2
                                ];
                                // 不启用预加载时，用户调用load接口，也要走[getinfo加载->preAd加载]或者[getinfo加载->video加载]。否则调用load无任何操作不符合预期。
                                return [
                                    4,
                                    _this.loadInner(playItem, playParam)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this.flowManager.firstFlowNodeTriggerPreloadNext()
                                ];
                            case 2:
                                return [
                                    2,
                                    _this.loadInner(playItem, playParam)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "play",
            value: function play(playItem, playParam) {
                var _this = this;
                return _$e(function() {
                    var _this_flowManager, _this_flowManager_chain;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!playItem) {
                                    // 调用play接口不传参数时，可能是两种情况
                                    if (((_this_flowManager_chain = _this.flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.currentState) === FlowNodeState.PAUSED) {
                                        // 1. 调用了pause()以后调用
                                        return [
                                            2,
                                            _this.flowManager.resume()
                                        ];
                                    }
                                    // 2. 调用了load(playItem)以后调用
                                    return [
                                        2,
                                        _this.flowManager.start()
                                    ];
                                }
                                return [
                                    4,
                                    _this.loadInner(playItem, playParam, {
                                        showLoading: true
                                    })
                                ];
                            case 1:
                                _state.sent();
                                // loadInner的过程中播放器被销毁，可选符做一个保护
                                return [
                                    2,
                                    (_this_flowManager = _this.flowManager) === null || _this_flowManager === void 0 ? void 0 : _this_flowManager.start()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "preload",
            value: /**
   * 预加载下一个视频，由外部触发。
   */ // TODO: 这个_videoEndTime参数很奇怪，看起来是页面传入的减去片头片尾的播放时长，但是旧的逻辑里面预加载后贴的倒计时也并没有使用这种时长，而是
            // 直接用的视频完整时长。因此是不是应该在播放开始就传入实际时长，然后预加载后贴广告，预加载下一个视频所需要的倒计时信息，都用这个统一值？
            function preload(playItem, playParam, videoEndTime) {
                if (!this.configInner.enablePreload) {
                    return;
                }
                return this.flowManager.preloadSession(playItem, playParam, commonTool.createGUID(), videoEndTime);
            }
        },
        {
            key: "setLevel",
            value: function setLevel(level, extra) {
                var _this = this;
                return _$e(function() {
                    var canSetLevel, _this_config, _this_config_onBeforeLevelSelection, onBeforeLevelSelection, error, err;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                canSetLevel = _this.checkCanSetLevel().canSetLevel;
                                if (!canSetLevel) {
                                    throw new Error('setLevel can\'t start');
                                }
                                _this_config = _this.config, _this_config_onBeforeLevelSelection = _this_config.onBeforeLevelSelection, onBeforeLevelSelection = _this_config_onBeforeLevelSelection === void 0 ? function() {
                                    return true;
                                } : _this_config_onBeforeLevelSelection;
                                if (!onBeforeLevelSelection(level)) {
                                    _this.logger.log('onBeforeLevelSelection return false, stop level switching level=', level);
                                    return [
                                        2
                                    ];
                                }
                                _this.isSettingLevel = true;
                                _this.emitPlayerEvts(H5_PLAY_EVENT.VIDEO_SETLEVEL_START, {
                                    level: level
                                });
                                error = {
                                    code: ErrorCode.SUC,
                                    level: level
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    4,
                                    5
                                ]);
                                return [
                                    4,
                                    _this.flowManager.setLevel(level, extra)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                err = _state.sent();
                                error.code = (err === null || err === void 0 ? void 0 : err.code) || ErrorCode.UNKNOWN;
                                error.message = (err === null || err === void 0 ? void 0 : err.message) || '';
                                // 抛出异常，让外部不要更新UI
                                throw err;
                            case 4:
                                _this.isSettingLevel = false;
                                _this.emitPlayerEvts(H5_PLAY_EVENT.VIDEO_SETLEVEL_END, error);
                                return [
                                    7
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "pause",
            value: function pause(pauseType) {
                this.flowManager.pause(pauseType);
            }
        },
        {
            key: "stop",
            value: function stop() {
                var endState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : END_STATE.INTERRUPT;
                // 先停止当前节点（这个调用时序很重要，如果是广告播放时需要先停掉当前节点，再走到下面的stopAd，否则先走stopAd会继续触发下一个节点的播放）
                this.flowManager.abortCurFlowNode();
                // TODO：目前只有主动调用停止时，调用停止所有广告。旧的逻辑在所有停止逻辑上（onSessionStop）都有调用。
                // 没有沿用旧逻辑是因为并不是所有情况都需要停掉所有广告，因为重构后的flowplayer支持广告预加载，而预加载session和播放中session用的同一个
                // 广告插件，如果任何停止状态都干掉广告，可能会干掉已经预加载好的广告数据。
                // 但是，不确定会不会有某些播放器内部停止的情况某些类型广告没干掉？
                try {
                    var _getAdPlugin;
                    (_getAdPlugin = getAdPlugin(this.instanceId)) === null || _getAdPlugin === void 0 ? void 0 : _getAdPlugin.stopAd();
                } catch (e) {
                    this.logger.error('stop, call adPlugin::stopAd', e);
                }
                this.onSessionStop(endState);
            }
        },
        {
            key: "startGetinfoRetry",
            value: function startGetinfoRetry(retryConfig) {
                return this.flowManager.retry(retryConfig);
            }
        },
        {
            key: "canGetinfoRetry",
            value: /** @deprecated */ function canGetinfoRetry() {
                return false;
            }
        },
        {
            key: "getRetryCheckClasses",
            value: /** @deprecated */ function getRetryCheckClasses() {
                return [];
            }
        },
        {
            key: "stopCurFlowNode",
            value: function stopCurFlowNode(opts) {
                this.flowManager.stopCurFlowNode(opts);
            }
        },
        {
            key: "pushFlowNode",
            value: function pushFlowNode(callback) {
                this.flowManager.chain.push(callback);
            }
        },
        {
            key: "volume",
            get: // 由于引入了广告等节点，因此获取/设置播放器的音量逻辑需要单独处理（而不是直接设置正片core的音量）
            function get() {
                var _this_flowManager;
                return ((_this_flowManager = this.flowManager) === null || _this_flowManager === void 0 ? void 0 : _this_flowManager.getVolume()) || 0;
            },
            set: function set(val) {
                var checkRet = checkVolumeValidWithMessage(val);
                if (!checkRet.valid) {
                    this.logger.warn(checkRet.message);
                    return;
                }
                if (!this.flowManager) {
                    return;
                }
                this.logger.log('set volume', val);
                this.flowManager.setVolume(val);
                // 沿用旧逻辑：单独设置广告插件的音量。实际上在流程中的前贴后贴广告会自动继承音量，猜测这里不强行设置广告插件音量可能会影响到中插等其他广告
                // 类型的音量？
                try {
                    var _getAdPlugin;
                    (_getAdPlugin = getAdPlugin(this.instanceId)) === null || _getAdPlugin === void 0 ? void 0 : _getAdPlugin.setAdVolume(val);
                } catch (e) {
                    this.logger.error('call adPlugin::setAdVolume', e);
                }
            }
        },
        {
            key: "playbackRate",
            get: function get() {
                return this.flowManager.getPlaybackRate();
            },
            set: function set(val) {
                this.flowManager.setPlaybackRate(val);
            }
        },
        {
            key: "replayCurFlowNode",
            value: function replayCurFlowNode(playItem, playParam) {
                return this.flowManager.replayCurFlowNode(playItem, playParam);
            }
        },
        {
            key: "updateReqInfo",
            value: function updateReqInfo(playPram) {
                this.flowManager.updatePlayParam(playPram);
            }
        },
        {
            key: "videoElementsContainer",
            get: // **************************************************************************************************************
            // 以下这些接口为了实现iplayer接口，并且只针对正片节点有效。如果未起播时节点不存在，可能获取到的是空值或默认值。
            // **************************************************************************************************************
            function get() {
                var _getCorePool_get;
                // 这个属性，无论是否起播都可能被外部访问的。因此这个不使用当前chain的core属性来获取:
                // `return this.flowManager?.chain?.core.videoElementsContainer`
                // 而是直接拿corePool中的video的core对象获取。
                return (_getCorePool_get = getCorePool(this.instanceId).get(CoreType.VIDEO)) === null || _getCorePool_get === void 0 ? void 0 : _getCorePool_get.videoElementsContainer;
            }
        },
        {
            key: "useWorker",
            get: function get() {
                var _this_flowManager_chain;
                return (_this_flowManager_chain = this.flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.useWorker;
            }
        },
        {
            key: "kernelName",
            get: function get() {
                var _this_flowManager_chain, _this_flowManager;
                return (_this_flowManager = this.flowManager) === null || _this_flowManager === void 0 ? void 0 : (_this_flowManager_chain = _this_flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.kernelName;
            }
        },
        {
            key: "videoElements",
            get: function get() {
                var _getCorePool_get;
                // 这个属性，无论是否起播都可能被外部访问的。例如引用方可能对video标签提前做一些样式处理。
                // 因此这个不使用当前chain的core属性来获取:
                // `return this.flowManager?.chain?.core.videoElements`
                // 而是直接拿corePool中的video的core对象获取。
                return ((_getCorePool_get = getCorePool(this.instanceId).get(CoreType.VIDEO)) === null || _getCorePool_get === void 0 ? void 0 : _getCorePool_get.videoElements) || [];
            }
        },
        {
            key: "currentVideoElement",
            get: function get() {
                var _this_flowManager_chain, _this_flowManager;
                return (_this_flowManager = this.flowManager) === null || _this_flowManager === void 0 ? void 0 : (_this_flowManager_chain = _this_flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.currentVideoElement;
            }
        },
        {
            key: "supportPreload",
            get: function get() {
                var _this_flowManager_chain, _this_flowManager;
                return (_this_flowManager = this.flowManager) === null || _this_flowManager === void 0 ? void 0 : (_this_flowManager_chain = _this_flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.supportPreload;
            }
        },
        {
            key: "duration",
            get: function get() {
                var _this_flowManager_chain, _this_flowManager;
                return ((_this_flowManager = this.flowManager) === null || _this_flowManager === void 0 ? void 0 : (_this_flowManager_chain = _this_flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.duration) || 0;
            }
        },
        {
            key: "playtime",
            get: function get() {
                var _this_flowManager_chain, _this_flowManager;
                return ((_this_flowManager = this.flowManager) === null || _this_flowManager === void 0 ? void 0 : (_this_flowManager_chain = _this_flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.playtime) || 0;
            }
        },
        {
            key: "videoInfos",
            get: function get() {
                var _this_flowManager_chain, _this_flowManager;
                return ((_this_flowManager = this.flowManager) === null || _this_flowManager === void 0 ? void 0 : (_this_flowManager_chain = _this_flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.videoInfos) || [];
            }
        },
        {
            key: "preloadVideoInfos",
            get: function get() {
                var _this_flowManager_chain, _this_flowManager;
                return (_this_flowManager = this.flowManager) === null || _this_flowManager === void 0 ? void 0 : (_this_flowManager_chain = _this_flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.preloadVideoInfos;
            }
        },
        {
            key: "currentVideoInfo",
            get: function get() {
                var _this_flowManager_chain, _this_flowManager;
                return (_this_flowManager = this.flowManager) === null || _this_flowManager === void 0 ? void 0 : (_this_flowManager_chain = _this_flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.currentVideoInfo;
            }
        },
        {
            key: "currentVideoInfoIdx",
            get: function get() {
                var _this_flowManager_chain, _this_flowManager;
                return ((_this_flowManager = this.flowManager) === null || _this_flowManager === void 0 ? void 0 : (_this_flowManager_chain = _this_flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.currentVideoInfoIdx) || 0;
            }
        },
        {
            key: "totalVideoInfoCount",
            get: function get() {
                var _this_flowManager_chain, _this_flowManager;
                return ((_this_flowManager = this.flowManager) === null || _this_flowManager === void 0 ? void 0 : (_this_flowManager_chain = _this_flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.totalVideoInfoCount) || 0;
            }
        },
        {
            key: "supportPlaybackRate",
            get: function get() {
                var _this_flowManager_chain, _this_flowManager;
                return (_this_flowManager = this.flowManager) === null || _this_flowManager === void 0 ? void 0 : (_this_flowManager_chain = _this_flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.supportPlaybackRate;
            }
        },
        {
            key: "played",
            get: function get() {
                var _this_flowManager_chain, _this_flowManager;
                return (_this_flowManager = this.flowManager) === null || _this_flowManager === void 0 ? void 0 : (_this_flowManager_chain = _this_flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.played;
            }
        },
        {
            key: "state",
            get: function get() {
                var _this_flowManager_chain, _this_flowManager;
                return ((_this_flowManager = this.flowManager) === null || _this_flowManager === void 0 ? void 0 : (_this_flowManager_chain = _this_flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.state) || VIDEO_STATE.IDLE;
            }
        },
        {
            key: "videoSize",
            get: function get() {
                return this.getCoreVideoSize();
            }
        },
        {
            key: "videoBuffered",
            get: function get() {
                var _this_flowManager_chain, _this_flowManager;
                return ((_this_flowManager = this.flowManager) === null || _this_flowManager === void 0 ? void 0 : (_this_flowManager_chain = _this_flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.videoBuffered) || [];
            }
        },
        {
            key: "volumeGain",
            get: function get() {
                var _this_flowManager_chain, _this_flowManager;
                return ((_this_flowManager = this.flowManager) === null || _this_flowManager === void 0 ? void 0 : (_this_flowManager_chain = _this_flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.volumeGain) || 0;
            },
            set: function set(val) {
                if (this.flowManager.chain) {
                    this.flowManager.chain.core.volumeGain = val;
                }
            }
        },
        {
            key: "audioEffect",
            get: function get() {
                var _this_flowManager_chain, _this_flowManager;
                return (_this_flowManager = this.flowManager) === null || _this_flowManager === void 0 ? void 0 : (_this_flowManager_chain = _this_flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.audioEffect;
            },
            set: function set(val) {
                if (this.flowManager.chain) {
                    this.flowManager.chain.core.audioEffect = val;
                }
            }
        },
        {
            key: "getAudioTrackList",
            value: function getAudioTrackList() {
                var _this_flowManager_chain;
                return (_this_flowManager_chain = this.flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.getAudioTrackList();
            }
        },
        {
            key: "getCurrentAudioTrack",
            value: function getCurrentAudioTrack() {
                var _this_flowManager_chain;
                return (_this_flowManager_chain = this.flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.getCurrentAudioTrack();
            }
        },
        {
            key: "resizeVideoElements",
            value: function resizeVideoElements(value) {
                var _this_flowManager_chain;
                return (_this_flowManager_chain = this.flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.resizeVideoElements(value);
            }
        },
        {
            key: "resize",
            value: function resize(value) {
                var _this_flowManager_chain;
                return (_this_flowManager_chain = this.flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.resize(value);
            }
        },
        {
            key: "playNext",
            value: function playNext(opts) {
                var _this_flowManager_chain;
                return (_this_flowManager_chain = this.flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.playNext(opts);
            }
        },
        {
            key: "captureVideo",
            value: function captureVideo(dx, dy, dw, dh, extra) {
                var _this_flowManager_chain;
                return (_this_flowManager_chain = this.flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.captureVideo(dx, dy, dw, dh, extra);
            }
        },
        {
            key: "appendNext",
            value: function appendNext(value) {
                var _this_flowManager_chain;
                return (_this_flowManager_chain = this.flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.appendNext(value);
            }
        },
        {
            key: "preloadNext",
            value: function preloadNext() {
                for(var _len = arguments.length, configs = new Array(_len), _key = 0; _key < _len; _key++){
                    configs[_key] = arguments[_key];
                }
                var _this_flowManager_chain_core;
                var _this_flowManager_chain;
                return (_this_flowManager_chain = this.flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : (_this_flowManager_chain_core = _this_flowManager_chain.core).preloadNext.apply(_this_flowManager_chain_core, _$8(configs));
            }
        },
        {
            key: "clearAllPreload",
            value: function clearAllPreload() {
                var _this_flowManager_chain;
                return (_this_flowManager_chain = this.flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.clearAllPreload();
            }
        },
        {
            key: "triggerAutoplay",
            value: function triggerAutoplay() {
                // 这个接口很特殊，在没有调用play前就可以被调用，并且需要触发core实例的自动播放
                return getCorePool(this.instanceId).create(CoreType.VIDEO, this.configInner).triggerAutoplay();
            }
        },
        {
            key: "hasAppended",
            value: function hasAppended(value) {
                var _this_flowManager_chain;
                return (_this_flowManager_chain = this.flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.hasAppended(value);
            }
        },
        {
            key: "hasPreloaded",
            value: function hasPreloaded(value) {
                var _this_flowManager_chain;
                return (_this_flowManager_chain = this.flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.hasPreloaded(value);
            }
        },
        {
            key: "seek",
            value: function seek(time) {
                var _this_flowManager_chain;
                return (_this_flowManager_chain = this.flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.seek(time);
            }
        },
        {
            key: "setAudioTrack",
            value: function setAudioTrack(id) {
                var _this = this;
                return _$e(function() {
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.checkCanSetAudioTrack()) {
                                    throw new Error('setAudioTrack is not allowed because setLevel is processing');
                                }
                                _this.isSettingAudioTrack = true;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    3,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.flowManager.setAudioTrack(id)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                _this.isSettingAudioTrack = false;
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "corePlayer",
            get: /**
   * 用于访问正片节点的core对象(KernelProxy)
   *
   * 注意：用于兼容旧版本的调用访问，慎用!!!
   * @inner
   * @deprecated
   */ function get() {
                var _this_flowManager_chain;
                // TODO: 外部可能在起播前就调用??感觉这样调用是非法的
                // return getCorePool(this.instanceId).create(CoreType.VIDEO, this.configInner);
                return (_this_flowManager_chain = this.flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core;
            }
        },
        {
            key: "videoNode",
            get: /**
   * TODO: 待删除
   * ctrlbar插件中有个逻辑判断（getIsInAd），通过player as any拿到了flowManager和videoNode节点进行操作（并且看起来判断并不准确）。
   * @inner
   * @deprecated
   */ function get() {
                var _this_flowManager_chain;
                return (_this_flowManager_chain = this.flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.videoNode;
            }
        },
        {
            key: "checkCanSetLevel",
            value: // **************************************************************************************************************
            // 以上这些接口为了实现iplayer接口，并且只针对正片节点有效。如果未起播时节点不存在，可能获取到的是空值或默认值。
            // **************************************************************************************************************
            /** 判断是否可以执行切换清晰度的逻辑 */ function checkCanSetLevel() {
                if (!this.played) {
                    return {
                        canSetLevel: false,
                        message: t(i18nConfig.core.ERROR_STATUS_NOT_PLAYING) + t(i18nConfig.core.ERROR_SETLEVEL_INPLAYING)
                    };
                }
                // TODO：切换清晰度/音轨过程中，再次切换清晰度目前逻辑是没有任何提示给到用户的（不确定tips展示出来会不会打扰用户），这里先保持这种状态吧。
                if (this.isSettingLevel) {
                    return {
                        canSetLevel: false
                    };
                }
                if (this.isSettingAudioTrack) {
                    return {
                        canSetLevel: false
                    };
                }
                return {
                    canSetLevel: true
                };
            }
        },
        {
            key: "checkCanSetAudioTrack",
            value: function checkCanSetAudioTrack() {
                return !this.isSettingLevel && !this.isSettingAudioTrack;
            }
        },
        {
            key: "onSessionStart",
            value: function onSessionStart(playItem, playParam) {
                var _playParam_srvData, _this_flowManager;
                // 首先是重置上一次播放的变量
                this.isSettingLevel = false;
                // 开始新的播放流程，监听manager事件
                this.setFlowManagerEvts(true);
                // 如果已经有预加载的播放流程流程的流水id，先取以前的
                var preloadSessionFlowid = this.flowManager.getPreloadSessionFlowidByVid(playItem);
                var flowid = preloadSessionFlowid || ((_playParam_srvData = playParam.srvData) === null || _playParam_srvData === void 0 ? void 0 : _playParam_srvData.flowid) || commonTool.createGUID();
                // 派发出去的isPreload这个属性代表命中了预加载（上报有用）
                this.emitPlayerEvts(H5_PLAY_EVENT.PLAY_SESSION_START, {
                    flowid: flowid,
                    playItem: playItem,
                    isPreload: !!preloadSessionFlowid
                });
                // 事件发出去了可能播放器直接被destroy，可选符保护下
                return (_this_flowManager = this.flowManager) === null || _this_flowManager === void 0 ? void 0 : _this_flowManager.createSession(playItem, playParam, flowid);
            }
        },
        {
            key: "onSessionStop",
            value: function onSessionStop(endState, error) {
                var _this_flowManager_chain;
                var curFlowNodeName = (_this_flowManager_chain = this.flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.currentName;
                this.setFlowManagerEvts(false);
                this.flowManager.clearCurrentSession();
                this.emit(PLAY_EVENT.SET_LOADING, {
                    show: false
                });
                this.emitSessionEndEvent(curFlowNodeName, endState, error);
            }
        },
        {
            key: "emitExtEvts",
            value: /**
   * 派发`H5_EXT_EVENT`
   */ function emitExtEvts(type, data) {
                this.logger.log("H5_EXT_EVENT, type=".concat(type, ", data="), data);
            // 这里因为还没有定义pluginManager，拿不到pluginMsg对象，因此需要在更上层重写。
            }
        },
        {
            key: "emitPlayerEvts",
            value: /**
   * 派发`H5_PLAY_EVENT`或`PLAY_EVENT`
   */ function emitPlayerEvts(type) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                // 过滤一下频繁的事件打印
                var skipLogEvts = [
                    H5_PLAY_EVENT.AD_TIME_UPDATE,
                    H5_PLAY_EVENT.VIDEO_TIMEUPDATE,
                    H5_PLAY_EVENT.AD_TIME_UPDATE,
                    H5_PLAY_EVENT.VIDEO_LOAD_PROGRESS,
                    PLAY_EVENT.LOAD_PROGRESS,
                    PLAY_EVENT.TIME_UPDATE
                ];
                if (type in H5_PLAY_EVENT && skipLogEvts.indexOf(type) === -1) {
                    this.logger.log("H5_PLAY_EVENT, type=".concat(type, ", data="), args);
                }
                this.emit.apply(this, [
                    type
                ].concat(_$8(args)));
            }
        },
        {
            key: "getCoreVideoSize",
            value: /**
   * @inner
   */ function getCoreVideoSize() {
                var _this_flowManager_chain;
                return ((_this_flowManager_chain = this.flowManager.chain) === null || _this_flowManager_chain === void 0 ? void 0 : _this_flowManager_chain.core.videoSize) || {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "loadInner",
            value: function loadInner(playItem, playParam, opts) {
                var _this = this;
                return _$e(function() {
                    var // 清除video画面，这里的原因是core播放器有一个特性，停止播放以后需要保留视频画面，因此并没有清除video组件上的数据。
                    // 所以重新起播以后马上得清除这些数据，否则在getinfo等起播过程中会一直保留上一次播放视频的画面
                    _getCorePool_get, errorNotMeetPrerequisite;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // 外部传入的播放条件检查
                                errorNotMeetPrerequisite = _this.doPrerequisiteCheck(playItem);
                                if (errorNotMeetPrerequisite) {
                                    _this.onSessionStop(END_STATE.ERROR, errorNotMeetPrerequisite);
                                    return [
                                        2
                                    ];
                                }
                                (_getCorePool_get = getCorePool(_this.instanceId).get(CoreType.VIDEO)) === null || _getCorePool_get === void 0 ? void 0 : _getCorePool_get.load();
                                if (!_this.flowManager.isCurrentSessionEmpty) {
                                    // TODO: 如果流程还在运行，需要停止当前流程。但是按之前遇到的问题，这并不是一个很好的做法。最好是需要调用方先显式的调用stop，
                                    // 再调用播放器的load/play方法
                                    _this.flowManager.abortCurFlowNode();
                                    _this.onSessionStop(END_STATE.INTERRUPT);
                                // TODO: 是否有必要等一下？因为停止时还有事件等抛出去，马上执行起播可能存在时序问题
                                // await new Promise(resolve => setTimeout(resolve));
                                }
                                if (opts === null || opts === void 0 ? void 0 : opts.showLoading) {
                                    // 起播需要展示加载动画
                                    _this.emit(PLAY_EVENT.SET_LOADING, {
                                        show: true
                                    });
                                }
                                return [
                                    4,
                                    _this.onSessionStart(playItem, playParam)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setFlowManagerEvts",
            value: function setFlowManagerEvts(isBind) {
                var _this = this;
                Object.keys(FlowManagerEvt).forEach(function(evt) {
                    if (isBind) {
                        _this.flowManager.on(FlowManagerEvt[evt], _this.onFlowManagerEvts);
                    } else {
                        _this.flowManager.off(FlowManagerEvt[evt], _this.onFlowManagerEvts);
                    }
                });
            }
        },
        {
            key: "doPrerequisiteCheck",
            value: /**
   * 播放条件的前置检查
   * @param playItem
   * @returns
   */ function doPrerequisiteCheck(playItem) {
                var _this_configInner_prerequisiteCheck, _this_configInner;
                var errorNotMeetPrerequisite = (_this_configInner_prerequisiteCheck = (_this_configInner = this.configInner).prerequisiteCheck) === null || _this_configInner_prerequisiteCheck === void 0 ? void 0 : _this_configInner_prerequisiteCheck.call(_this_configInner, playItem);
                return errorNotMeetPrerequisite;
            }
        },
        {
            key: "emitSessionEndEvent",
            value: function emitSessionEndEvent(curFlowNodeName, endState, error) {
                var code = ErrorCode.SUC;
                var message = '';
                var errorData = undefined;
                var stack = '';
                if (error) {
                    if (error.code) {
                        // 如果有code理解为播放器内部产生的错误信息，而不是js的异常，这种错误信息跟着事件带出去
                        errorData = error;
                    }
                    // 可能是js的异常等情况，需要补齐code
                    code = error.code || ErrorCode.UNKNOWN;
                    message = error.message || '';
                    stack = error.stack || '';
                }
                this.emitPlayerEvts(H5_PLAY_EVENT.PLAY_SESSION_END, _$c(_$b({}, errorData), {
                    curFlowNodeName: curFlowNodeName,
                    code: code,
                    message: message,
                    endState: endState
                }));
                this.logger.log("************************************************\nsessionEnd, code=".concat(code, ", msg=").concat(message, ", stack=").concat(stack, "\n***********************************************"));
            }
        }
    ]);
    return FlowPlayer;
}(EvtEmitter);
_$i([
    sessionStarted,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        typeof PlayItem === "undefined" ? Object : PlayItem,
        typeof IPlayParam === "undefined" ? Object : IPlayParam,
        Number
    ]),
    _$j("design:returntype", void 0)
], FlowPlayer.prototype, "preload", null);
_$i([
    sessionStarted,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        Object,
        Object
    ]),
    _$j("design:returntype", Promise)
], FlowPlayer.prototype, "setLevel", null);
_$i([
    sessionStarted,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        typeof H5PauseType === "undefined" ? Object : H5PauseType
    ]),
    _$j("design:returntype", void 0)
], FlowPlayer.prototype, "pause", null);
_$i([
    sessionStarted,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        Object
    ]),
    _$j("design:returntype", void 0)
], FlowPlayer.prototype, "stop", null);
_$i([
    sessionStarted,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        typeof RetryConfig === "undefined" ? Object : RetryConfig
    ]),
    _$j("design:returntype", void 0)
], FlowPlayer.prototype, "startGetinfoRetry", null);
_$i([
    sessionStarted,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        Object
    ]),
    _$j("design:returntype", void 0)
], FlowPlayer.prototype, "stopCurFlowNode", null);
_$i([
    sessionStarted,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        Function
    ]),
    _$j("design:returntype", void 0)
], FlowPlayer.prototype, "pushFlowNode", null);
_$i([
    sessionStarted,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        typeof PlayItem === "undefined" ? Object : PlayItem,
        typeof IPlayParam === "undefined" ? Object : IPlayParam
    ]),
    _$j("design:returntype", void 0)
], FlowPlayer.prototype, "replayCurFlowNode", null);
_$i([
    sessionStarted,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        typeof IPlayParam === "undefined" ? Object : IPlayParam
    ]),
    _$j("design:returntype", void 0)
], FlowPlayer.prototype, "updateReqInfo", null);
FlowPlayer = _$i([
    stepTimerClassDecorator,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        typeof IH5PlayerConfig === "undefined" ? Object : IH5PlayerConfig
    ])
], FlowPlayer);

// 未赋值 priority 属性时，默认的 priority 优先级
var DEFAULT_PRIORITY = 0;
/* 默认结束事件 -> 正常结束 */ var DEFAULT_END_STATE = END_STATE.NORMAL;
// 默认播放时长边界，播放开始 startTime 不为负，播放 endTime 不作限制
var DEFAULT_PLAYTIME_BOUNDARY = {
    startTime: 0,
    startPriority: DEFAULT_PRIORITY,
    endTime: Infinity,
    endPriority: DEFAULT_PRIORITY,
    endState: END_STATE.NORMAL
};
/** 内置校验规则，当设置 PlayTimeLimitConfig 时遍历所有规则校验，符合所有规则才会继续设置操作 */ var ruleValidator = {
    // 绕过类型系统，直接传入一个空的配置 null / undefined
    emptyConfigCheck: function(config) {
        if (!config) return t(i18nConfig.h5player.ERROR_PLAY_LIMIT_EMPTY_CONFIG);
    },
    // 传入 {}
    emptyStartAndEndCheck: function(param) {
        var startPoint = param.startPoint, endPoint = param.endPoint;
        if (!startPoint && !endPoint) return t(i18nConfig.h5player.ERROR_PLAY_LIMIT_POINTS_BOTH_EMPTY);
    },
    // 传入的 startPoint.value < 0
    startBelowZero: function(param) {
        var startPoint = param.startPoint;
        if (startPoint && startPoint.value < 0) {
            return t(i18nConfig.h5player.ERROR_PLAY_LIMIT_START_TIME_BELOW_ZERO);
        }
    },
    // 传入的 endPoint.value <= startPoint.value
    endBelowStart: function(param) {
        var startPoint = param.startPoint, endPoint = param.endPoint;
        if (startPoint && endPoint && startPoint.value >= endPoint.value) {
            return t(i18nConfig.h5player.ERROR_PLAY_LIMIT_END_TIME_BELOW_START_TIME);
        }
    }
};
var CONFIG_ID_START = 0;

/**
 * 播放保护逻辑，可以不断向其添加时长限制，这些时长限制数组最终会合并成一个播放区间，
 * SuperPlayer 只会在这个区间时长内播放
 */ var PlaytimeLimiterPlugin = /*#__PURE__*/ function(Plugin) {
    _$4(PlaytimeLimiterPlugin, Plugin);
    var _super = _$5(PlaytimeLimiterPlugin);
    function PlaytimeLimiterPlugin() {
        _$1(this, PlaytimeLimiterPlugin);
        var _this;
        _this = _super.apply(this, arguments);
        // 时长配置校验规则
        _$2(_$6(_this), "configRules", ruleValidator);
        // TimeRange ID 自增，该变量为下一个产生的 id 值
        _$2(_$6(_this), "nextId", CONFIG_ID_START);
        // 所有添加进来的 PlayTimeLimitConfig 点配置
        _$2(_$6(_this), "limitConfigMap", {});
        // 计算的最终 PlaytimeLimitRange 结果存入此 Cache 中，让每次 getter 取值无需重复计算
        _$2(_$6(_this), "limitRange", void 0);
        // 是否已经产生 CANPLAY 事件，起播前再去添加配置，记录下 SEEK 的时间，起播后 SEEK 到相应位置
        _$2(_$6(_this), "isCanplayEmitted", false);
        // 记录的 SEEK 位置
        _$2(_$6(_this), "canplaySeekPos", null);
        /**
   * 之前讨论过在 Core 中添加 endTime 动态修改不合适，因此结束相关逻辑放置到 playTimeLimiter 中
   * 监听播放器 TIME_UPDATE 事件，当播放时长 > 播放保护时长时，stop
   * @param playtime
   */ _$2(_$6(_this), "hookVideoTimeupdate", function(param) {
            var playtime = param.playtime;
            if (playtime < _this.range.endTime) return;
            if (_this.isUsingNativeLoop) {
                _this.player.seek(_this.range.startTime);
                return;
            }
            _this.player.stopCurFlowNode({
                endState: _this.range.endState
            });
            // 避免执行player.stop以后还有后续的timeupdate事件监听回调继续执行。
            return EvtEmitter.STOP_IMMEDIATE_PROPAGATION;
        });
        /**
   * 当播放结束后，清理掉 getInfo 标志
   */ _$2(_$6(_this), "hookPlaySessionEnd", function() {
            _this.isCanplayEmitted = null;
            _this.canplaySeekPos = null;
        });
        return _this;
    }
    _(PlaytimeLimiterPlugin, [
        {
            key: "isUsingNativeLoop",
            get: // 原生loop模式
            function get() {
                var _this_player_config = this.player.config, loop = _this_player_config.loop, loopMode = _this_player_config.loopMode;
                return loop && loopMode === VideoLoopMode.native;
            }
        },
        {
            key: "range",
            get: function get() {
                if (!this.limitRange) {
                    this.limitRange = this.mergePlaytimeLimitConfigs(Object.values(this.limitConfigMap));
                }
                // 返回一个拷贝，防止外部意外修改
                return _$b({}, this.limitRange);
            }
        },
        {
            key: "addLimitConfig",
            value: /**
   * 添加播放保护规则，并更新最终可播放时长
   * @param limitConfig
   * @return id 播放保护规则 ID
   */ function addLimitConfig(limitConfig) {
                // 先检查传入值的合法性
                if (!this.validatePlayTimeConfig(limitConfig)) {
                    return null;
                }
                var _limitConfig_id;
                // 如果外部没有指定 id，则使用内置的规则自增 id
                var id = (_limitConfig_id = limitConfig.id) !== null && _limitConfig_id !== void 0 ? _limitConfig_id : this.generateID();
                // 当配置添加进来，添加上配置所对应的 vid，高层清理配置时需要用到
                this.limitConfigMap[id] = _$c(_$b({}, limitConfig), {
                    vidOrUrl: this.player.vid || this.player.url
                });
                this.onConfigChange();
                // 返回 id
                return id;
            }
        },
        {
            key: "deleteLimitConfig",
            value: /**
   * 根据传入的 ID，删除某一条播放保护规则
   * @param id 播放保护 ID
   */ function deleteLimitConfig(id) {
                delete this.limitConfigMap[id];
                this.onConfigChange();
            }
        },
        {
            key: "clearAllConfig",
            value: /**
   * 清理所有时长配置
   */ function clearAllConfig(excludeVidOrUrl) {
                var _this = this;
                Object.entries(this.limitConfigMap).forEach(function(param) {
                    var _param = _$9(param, 2), key = _param[0], value = _param[1];
                    if (value.vidOrUrl !== excludeVidOrUrl) {
                        delete _this.limitConfigMap[key];
                    }
                });
                this.limitRange = null;
            }
        },
        {
            key: "getLimitConfig",
            value: /**
   * 通过 ID 获取对应的播放保护规则配置
   * @param id 播放保护规则 ID
   */ function getLimitConfig(id) {
                return this.limitConfigMap[id];
            }
        },
        {
            key: "setLimitConfig",
            value: /**
   * 根据 ID 重新设置某个播放保护规则配置
   * @param id 播放保护规则 ID
   * @param limitConfig 播放保护规则
   */ function setLimitConfig(id, limitConfig) {
                if (!(this.getLimitConfig(id) && this.validatePlayTimeConfig(limitConfig))) return false;
                this.limitConfigMap[id] = limitConfig;
                this.onConfigChange();
                return true;
            }
        },
        {
            key: "generateID",
            value: /** 播放保护规则的 ID 生成器，目前使用简单自增逻辑 */ function generateID() {
                return this.nextId++;
            }
        },
        {
            key: "validatePlayTimeConfig",
            value: /**
   * 检查设置的播放保护规则是否合规
   * @param limitConfig
   */ function validatePlayTimeConfig(limitConfig) {
                var _this = this;
                return Object.values(this.configRules).every(function(ruleFunc) {
                    var err = ruleFunc(limitConfig);
                    if (err) {
                        _this.player.log(err);
                        return false;
                    }
                    return true;
                });
            }
        },
        {
            key: "mergePlaytimeLimitConfigs",
            value: /**
   * 合并所有已传入的 LimitConfig 信息，并根据范围 / 优先级情况，得到最终的播放范围
   * @param limitConfigs 需要合并的 LimitConfig 数组
   */ function mergePlaytimeLimitConfigs(limitConfigs) {
                var _this = this;
                var mergeResult = _$b({}, DEFAULT_PLAYTIME_BOUNDARY);
                // 优先级高的配置点覆盖掉优先级低的配置，最终合并成一个 startTime + endTime 的配置结果
                limitConfigs.forEach(function(config) {
                    var startPoint = config.startPoint, endPoint = config.endPoint;
                    mergeResult = _this.mergeStartPoint(mergeResult, startPoint);
                    mergeResult = _this.mergeEndPoint(mergeResult, endPoint);
                });
                // 返回最终合并结果
                return mergeResult;
            }
        },
        {
            key: "mergeStartPoint",
            value: /** 判断是否需要合并 StartPoint，返回合并后的 Range 或原值 */ function mergeStartPoint(currMergeResult, startPoint) {
                if (this.shouldUpdateStartTime(currMergeResult, startPoint)) {
                    return _$c(_$b({}, currMergeResult), {
                        startTime: startPoint.value,
                        startPriority: startPoint.priority || DEFAULT_PRIORITY
                    });
                }
                return currMergeResult;
            }
        },
        {
            key: "shouldUpdateStartTime",
            value: /**
   * 判断是否需要合并：
   * 1. 配置的 startTime 必须小于当前 mergeResult.endTime，否则合并出一个矛盾的配置
   * 2. 优先级更高的配置点: 高优先级配置覆盖
   * 3. 优先级相同，但 startTime > before: 合并产生一个更小的播放范围
   */ function shouldUpdateStartTime(currMergeResult, startPoint) {
                if (!startPoint) return false;
                var value = startPoint.value, _startPoint_priority = startPoint.priority, priority = _startPoint_priority === void 0 ? DEFAULT_PRIORITY : _startPoint_priority;
                var currStartTime = currMergeResult.startTime, currStartPriority = currMergeResult.startPriority, currEndTime = currMergeResult.endTime;
                return value < currEndTime && (priority > currStartPriority || priority === currStartPriority && value > currStartTime);
            }
        },
        {
            key: "mergeEndPoint",
            value: /** 判断是否需要合并 endPoint，返回合并后的 Range 或原值 */ function mergeEndPoint(currMergeResult, endPoint) {
                if (this.shouldUpdateEndTime(currMergeResult, endPoint)) {
                    return _$c(_$b({}, currMergeResult), {
                        endTime: endPoint.value,
                        endPriority: endPoint.priority || DEFAULT_PRIORITY,
                        endState: endPoint.endState || DEFAULT_END_STATE
                    });
                }
                return currMergeResult;
            }
        },
        {
            key: "shouldUpdateEndTime",
            value: /**
   * 判断是否需要合并，规则类似
   * @see shouldUpdateStartTime
   */ function shouldUpdateEndTime(currMergeResult, endPoint) {
                if (!endPoint) return false;
                var value = endPoint.value, _endPoint_priority = endPoint.priority, priority = _endPoint_priority === void 0 ? DEFAULT_PRIORITY : _endPoint_priority;
                var currStartTime = currMergeResult.startTime, currEndPriority = currMergeResult.endPriority, currEndTime = currMergeResult.endTime;
                return value > currStartTime && (priority > currEndPriority || priority === currEndPriority && value < currEndTime);
            }
        },
        {
            key: "onConfigChange",
            value: /** 更新播放范围保护，重设缓存 */ function onConfigChange() {
                this.limitRange = this.mergePlaytimeLimitConfigs(Object.values(this.limitConfigMap));
                // 如果播放器处于播放范围内播放，或者没有起播，则什么都不做
                if (this.player.playtime >= this.range.startTime) return;
                this.seekPlayer(this.range.startTime);
                // 返回一个拷贝防止意外修改
                return _$b({}, this.limitRange);
            }
        },
        {
            key: "hookVideoCanplay",
            value: /** 当播放器第一次 CANPLAY 时，取出先前记下的 SEEK 时间并 SEEK */ function hookVideoCanplay() {
                if (!this.isCanplayEmitted && this.canplaySeekPos) {
                    this.player.seek(this.canplaySeekPos);
                    this.canplaySeekPos = null;
                }
                this.isCanplayEmitted = true;
            }
        },
        {
            key: "seekPlayer",
            value: /** 根据情况 SEEK 播放器，如果当前状态下可以 SEEK 就去 SEEK，否则记下来等 CANPLAY 再去 SEEK */ function seekPlayer(point) {
                if (this.isCanplayEmitted) {
                    this.player.seek(this.canplaySeekPos);
                } else {
                    this.canplaySeekPos = point;
                }
            }
        }
    ]);
    return PlaytimeLimiterPlugin;
}(_$d(Plugin));
_$2(PlaytimeLimiterPlugin, "pluginName", 'playtimeLimiter');

/** 附加插件化功能，并直接对外暴露插件化接口 */ var PluginManager = /*#__PURE__*/ function() {
    function PluginManager(player) {
        _$1(this, PluginManager);
        _$2(this, "player", void 0);
        /** 挂载所有插件实例 */ _$2(this, "plugins", {});
        _$2(this, "pluginMsg", new EvtEmitter());
        /** 作为私有变量（用户不需要监听）提供给插件，只允许监听/解除监听，不允许广播事件 */ _$2(this, "pluginMsgProxy", {
            on: this.pluginMsg.on.bind(this.pluginMsg),
            off: this.pluginMsg.off.bind(this.pluginMsg),
            once: this.pluginMsg.once.bind(this.pluginMsg)
        });
        /** 播放器已经被销毁 */ _$2(this, "isDestroyed", false);
        this.player = player;
    }
    _(PluginManager, [
        {
            key: "createPlugin",
            value: /** 创建插件实例，并挂载到 player.plugins[insName] */ function createPlugin(insName) {
                var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _option_pluginName = option.pluginName, pluginName = _option_pluginName === void 0 ? insName : _option_pluginName;
                var pluginFunction = getPlugin(pluginName);
                if (!pluginFunction) throw new Error("Cannot find plugin: ".concat(pluginName));
                if (this.isDestroyed) throw new Error("Create plugin '".concat(pluginName, "' failed because player has destroyed."));
                this.triggerSetupEvent({
                    name: insName,
                    plugin: pluginFunction,
                    instance: null
                }, true);
                createPluginFactory(insName, pluginFunction, this.player, option, {
                    msg: this.pluginMsgProxy,
                    api: {
                        replayInCurFlowNode: this.player.replayCurFlowNode.bind(this.player)
                    }
                });
                if (pluginName === AD_PLUGIN_NAME) {
                    // 特殊处理，隐藏广告插件
                    setAdPlugin(this.player.config.instanceId, this.plugins[AD_PLUGIN_NAME]);
                    delete this.plugins[AD_PLUGIN_NAME];
                }
                this.triggerSetupEvent({
                    name: insName,
                    plugin: pluginFunction,
                    instance: null
                });
            }
        },
        {
            key: "loadPlugin",
            value: /**
   * 异步加载插件
   */ function loadPlugin(option) {
                var _this = this;
                // 这里赋值有先后顺序要求。默认使用全局变量名作为插件名，使用插件名作为实例名
                var timeout = option.timeout, crossOrigin = option.crossOrigin, globalName = option.globalName;
                var _option_pluginName = option.pluginName, pluginName = _option_pluginName === void 0 ? globalName : _option_pluginName, url = option.url;
                if (!url) {
                    throw new Error(t(i18nConfig.h5player.ERROR_UNOFFICIAL_PLUGIN_NEEDS_URL));
                }
                // 暂时不指定script标签的tag属性 每次都重新加载js
                return domTool.loadScript(url, undefined, timeout, {
                    crossOrigin: crossOrigin
                }).then(function() {
                    if (_this.isDestroyed) {
                        return null;
                    }
                    if (!getPlugin(pluginName)) {
                        // script没有自己注册的话，帮它注册
                        registerPlugin(pluginName, window[globalName]);
                    }
                    return {
                        pluginName: pluginName
                    };
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.pluginMsg.removeAllListeners();
                this.isDestroyed = true;
            }
        },
        {
            key: "triggerSetupEvent",
            value: /** 创建插件时广播事件 */ function triggerSetupEvent(data) {
                var _this = this;
                var before = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var eventName = "".concat(before ? 'before' : '', "pluginsetup");
                // setTimeout让监听的插件周期事件可以触发
                setTimeout(function() {
                    _this.pluginMsg.emit("".concat(eventName, ":").concat(data.name), data);
                });
            }
        }
    ]);
    return PluginManager;
}();

var report = function(param) {
    var _param_data = param.data, data = _param_data === void 0 ? {} : _param_data, _param_url = param.url, url = _param_url === void 0 ? '' : _param_url, _param_forceImage = param.forceImage, forceImage = _param_forceImage === void 0 ? false : _param_forceImage;
    var payload = constructPayload(data);
    if (!forceImage && payload.length > MAX_LENGTH_OF_PAYLOAD) {
        netTool.xhr({
            method: 'POST',
            url: url,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: payload
        }).catch(function() {});
        return;
    }
    var img = new Image();
    img.src = "".concat(url, "&").concat(payload);
};
var constructPayload = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var encodedData = Object.keys(data).reduce(function(acc, cur) {
        var _data_cur;
        acc[cur] = encodeURIComponent((_data_cur = data[cur]) !== null && _data_cur !== void 0 ? _data_cur : '');
        return acc;
    }, {
        _dc: Math.random()
    });
    return urlTool.object2string(encodedData, '&');
};
var MAX_LENGTH_OF_PAYLOAD = 2048;

// 历史原因，某些变量命名不符合tslint规范，但变量名可能已被子类使用。
var BaseReporter = /*#__PURE__*/ function(Plugin) {
    _$4(BaseReporter, Plugin);
    var _super = _$5(BaseReporter);
    function BaseReporter(player, config, extra) {
        _$1(this, BaseReporter);
        var _this;
        _this = _super.call(this, player, config, extra);
        _$2(_$6(_this), "RELEASE_DELAY", 300000);
        /** 配置信息，id是boss/attaid，token是pwd/token */ _$2(_$6(_this), "config", void 0);
        /** 上报请求方式 */ _$2(_$6(_this), "reporter", report);
        /** 页面消失时使用的上报方式 */ _$2(_$6(_this), "reporterForPageHide", void 0);
        /** 已经上报的事件 */ _$2(_$6(_this), "reportedEvt", {});
        /** 本地ls的缓存key */ _$2(_$6(_this), "FLOW_DATA_KEY", '');
        /** 上报地址 */ _$2(_$6(_this), "REPORT_URL", '');
        /** 上报key(灯塔或其他sdk使用) */ _$2(_$6(_this), "REPORT_KEY", '');
        _this.config = config;
        return _this;
    }
    _(BaseReporter, [
        {
            key: "saveToLS",
            value: function saveToLS(key, data) {
                var prevData = this.getPrevData();
                prevData[key] = {
                    data: data,
                    ts: Date.now()
                };
                lsTool.setData(this.FLOW_DATA_KEY, JSON.stringify(prevData));
            }
        },
        {
            key: "removeFromLS",
            value: function removeFromLS(key) {
                var prevData = this.getPrevData();
                delete prevData[key];
                lsTool.setData(this.FLOW_DATA_KEY, JSON.stringify(prevData));
            }
        },
        {
            key: "reportPrev",
            value: /** 从ls中提取缓存数据上报 */ function reportPrev() {
                var _this = this;
                var prevData = this.getPrevData();
                Object.keys(prevData).forEach(function(key) {
                    // check ts and report then delete
                    if (prevData[key].ts + _this.RELEASE_DELAY < Date.now()) {
                        _this.report(prevData[key].data);
                        delete prevData[key];
                    }
                });
                lsTool.setData(this.FLOW_DATA_KEY, JSON.stringify(prevData));
            }
        },
        {
            key: "report",
            value: function report() {
                var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this_config;
                if (uaTool.spider) return;
                var reportData = _$b({}, this.reportHeader, data);
                this.reporter({
                    data: reportData,
                    url: this.REPORT_URL,
                    key: this.REPORT_KEY,
                    forceImage: this.config.forceImage
                });
                if (typeof ((_this_config = this.config) === null || _this_config === void 0 ? void 0 : _this_config.onAfterReport) === 'function') {
                    try {
                        this.config.onAfterReport(reportData);
                    } catch (e) {}
                }
            }
        },
        {
            key: "handlePageHide",
            value: function handlePageHide() {
                var lastData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                if (uaTool.spider || !this.reporterForPageHide) return;
                var reportData = _$b({}, this.reportHeader, lastData);
                this.reporterForPageHide({
                    data: reportData,
                    url: this.REPORT_URL,
                    key: this.REPORT_KEY
                });
            }
        },
        {
            key: "getPrevData",
            value: function getPrevData() {
                var prevDataString = lsTool.getData(this.FLOW_DATA_KEY) || '{}';
                var prevData;
                try {
                    prevData = JSON.parse(prevDataString);
                } catch (e) {
                    prevData = {};
                }
                return prevData;
            }
        },
        {
            key: "getKvWithDefault",
            value: function getKvWithDefault(key, defaultVal) {
                var getCommonKv = this.player.getCommonKv;
                return getCommonKv(key) || defaultVal;
            }
        }
    ]);
    return BaseReporter;
}(_$d(Plugin));

var VOD_QA_RPT_BEACON_APP_KEY = '0WEB0QEJW44KW5A5';
var LIVE_QA_RPT_BEACON_APP_KEY = '0WEB0CN7W9446C2I';
var VOD_QA_RPT_CACHE_KEY = '__thumbplayer_vod_qa_report__';
var BEACON_SDK_PATH = 'https://beacon.cdn.qq.com/sdk/4.5.30/beacon_web.min.js';
var REQ_MAX_RETRY = 3;

var BeaconRequest = /*#__PURE__*/ function() {
    function BeaconRequest() {
        _$1(this, BeaconRequest);
    }
    _(BeaconRequest, null, [
        {
            key: "loadBeaconSDK",
            value: function loadBeaconSDK() {
                if (typeof window.BeaconAction === 'function') return Promise.resolve();
                if (!BeaconRequest.sdkLoadingDefer) {
                    BeaconRequest.sdkLoadingDefer = new Promise(function() {
                        var _ref = _$e(function(resolve, reject) {
                            var err, i, e;
                            return _$f(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        i = 0;
                                        _state.label = 1;
                                    case 1:
                                        if (!(i < REQ_MAX_RETRY)) return [
                                            3,
                                            6
                                        ];
                                        _state.label = 2;
                                    case 2:
                                        _state.trys.push([
                                            2,
                                            4,
                                            ,
                                            5
                                        ]);
                                        return [
                                            4,
                                            domTool.loadScript(BEACON_SDK_PATH)
                                        ];
                                    case 3:
                                        _state.sent();
                                        resolve();
                                        return [
                                            3,
                                            6
                                        ];
                                    case 4:
                                        e = _state.sent();
                                        err = e;
                                        return [
                                            3,
                                            5
                                        ];
                                    case 5:
                                        i++;
                                        return [
                                            3,
                                            1
                                        ];
                                    case 6:
                                        reject(err);
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(resolve, reject) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                }
                return BeaconRequest.sdkLoadingDefer;
            }
        },
        {
            key: "flushQueue",
            value: function flushQueue(appKey) {
                // 避免意外情况，flush的时候依然没有实例
                if (!BeaconRequest.queues[appKey] || !BeaconRequest.instances[appKey]) return;
                BeaconRequest.queues[appKey].forEach(function(param) {
                    BeaconRequest.report(param);
                });
                BeaconRequest.queues[appKey] = [];
            }
        },
        {
            key: "clear",
            value: function clear(appKey) {
                BeaconRequest.queues[appKey] = [];
            }
        },
        {
            key: "report",
            value: /** 上报方法，会使用对应app key的灯塔实例 */ function report(param) {
                var data = param.data, appKey = param.key;
                var instance = BeaconRequest.instances[appKey];
                var stepname = (data || {}).stepname;
                if (!instance) {
                    if (BeaconRequest.queues[appKey].length >= MAX_QUEUE_SIZE) BeaconRequest.clear(appKey);
                    BeaconRequest.queues[appKey].push(param);
                    return;
                }
                instance.onDirectUserAction(stepname, data);
            }
        },
        {
            key: "reportWhenPageHide",
            value: /** pagehide上报方法，会使用对应app key的灯塔实例 */ function reportWhenPageHide(param) {
                var data = param.data, appKey = param.key;
                var instance = BeaconRequest.instances[appKey];
                var stepname = (data || {}).stepname;
                if (!instance) {
                    return;
                }
                if (typeof instance.onSendBeacon === 'function') {
                    instance.onSendBeacon(stepname, data);
                    return;
                }
                instance.onDirectUserAction(stepname, data);
            }
        },
        {
            key: "register",
            value: /** 注册一个新的app key */ function register(appConfig, externalBeacon) {
                var _this = this;
                return _$e(function() {
                    var appKey, isOversea, BeaconAction, instance, e;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // 默认使用string，兼容已有旧版本
                                appKey = appConfig;
                                isOversea = false;
                                if ((typeof appConfig === "undefined" ? "undefined" : _$3(appConfig)) === 'object') {
                                    appKey = appConfig.appKey;
                                    isOversea = !!appConfig.isOversea;
                                }
                                // 这里用queue是否被初始化作为标记，避免重复初始化
                                if (BeaconRequest.queues[appKey]) return [
                                    2
                                ];
                                BeaconRequest.queues[appKey] = [];
                                // 允许外部指定BeaconSDK的加载
                                if (externalBeacon) BeaconRequest.sdkLoadingDefer = externalBeacon;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    BeaconRequest.loadBeaconSDK()
                                ];
                            case 2:
                                _state.sent();
                                BeaconRequest.sdkLoadingDefer = null;
                                return [
                                    4,
                                    _this.requireBeaconModule()
                                ];
                            case 3:
                                BeaconAction = _state.sent();
                                instance = new BeaconAction({
                                    needQueryConfig: false,
                                    appkey: appKey,
                                    strictMode: false,
                                    isOversea: isOversea
                                });
                                BeaconRequest.instances[appKey] = instance;
                                BeaconRequest.flushQueue(appKey);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e = _state.sent();
                                console.error(e);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "requireBeaconModule",
            value: function requireBeaconModule() {
                return requireModule(BEACON_MODULE_NAME, BEACON_GLOBAL_NAME);
            }
        }
    ]);
    return BeaconRequest;
}();
_$2(BeaconRequest, "instances", {});
_$2(BeaconRequest, "queues", {});
_$2(BeaconRequest, "sdkLoadingDefer", void 0);
// Todo: 现在 Beacon SDK 还是个匿名包，后续改好这里也同步修改下
var BEACON_MODULE_NAME = 'BeaconAction';
var BEACON_GLOBAL_NAME = 'BeaconAction';
var MAX_QUEUE_SIZE = 30;

var getQQFromCookie = function() {
    var uin = cookieTool.get('luin') || cookieTool.get('uin');
    if (uin) uin = uin.replace(/\D/g, '').replace(/^0+/, '');
    return uin;
};
var BUFFER_THRESHOLDS = 1.2 * 1e3;

var PlatCode;
/** 平台类型 */ (function(PlatCode) {
    PlatCode["Web"] = "web";
    PlatCode["H5"] = "h5";
})(PlatCode || (PlatCode = {}));
var DEFAULT_KEYS$1 = {
    cdnuip: '',
    iqq: '',
    pvid: '',
    qqopen_id: COMMON_DATA_KEY.hc_openid,
    playno: COMMON_DATA_KEY.flowid,
    cdnid: COMMON_DATA_KEY.cdnid,
    guid: COMMON_DATA_KEY.guid,
    fplayerver: COMMON_DATA_KEY.playerver,
    dsip: '',
    sstrength: '',
    devtype: '',
    nettype: '',
    freetype: '',
    platform: COMMON_DATA_KEY.platform,
    vplatform: COMMON_DATA_KEY.platform,
    codec: COMMON_DATA_KEY.codec,
    device: COMMON_DATA_KEY.device,
    resolution: COMMON_DATA_KEY.resolution,
    osver: COMMON_DATA_KEY.osver,
    playertype: COMMON_DATA_KEY.playertype,
    appver: COMMON_DATA_KEY.appVer,
    use_p2p: COMMON_DATA_KEY.p2p,
    p2p_play: COMMON_DATA_KEY.p2p,
    p2pver: COMMON_DATA_KEY.p2pver,
    playtype: '',
    scenesid: COMMON_DATA_KEY.sid,
    sid: COMMON_DATA_KEY.vid,
    livepid: COMMON_DATA_KEY.livepid,
    contentid: COMMON_DATA_KEY.cid,
    drm: COMMON_DATA_KEY.drmtype,
    videocapability: COMMON_DATA_KEY.videoCapability,
    playtime: '',
    isuserpay: '',
    live_type: '',
    xserverip: '',
    durl: '',
    lookback: '',
    live_tag: '',
    extraInfo: '',
    spanId: '',
    tuid: '',
    ext1: '',
    ext2: '',
    ext3: ''
};
var LiveQaReporterPlugin = /*#__PURE__*/ function(BaseReporter) {
    _$4(LiveQaReporterPlugin, BaseReporter);
    var _super = _$5(LiveQaReporterPlugin);
    function LiveQaReporterPlugin(player, config, extra) {
        _$1(this, LiveQaReporterPlugin);
        var _this;
        _this = _super.call(this, player, config, extra);
        // codecc扫描无法通过，但是子类有引用，无法修改
        // eslint-disable-next-line @typescript-eslint/naming-convention
        _$2(_$6(_this), "REPORT_KEY", LIVE_QA_RPT_BEACON_APP_KEY);
        /** 插件配置 */ _$2(_$6(_this), "config", void 0);
        /** 自增值 */ _$2(_$6(_this), "seq", 0);
        /** 心跳计时 */ _$2(_$6(_this), "period", void 0);
        /** 上一个周期时的用户播放总时长 */ _$2(_$6(_this), "lastPlayDuration", 0);
        /** 缓冲记录 */ _$2(_$6(_this), "bufferHistory", []);
        _$2(_$6(_this), "flowHeader", {
            cnntime: 0,
            maxspeed: 0,
            testspeed: 0,
            downspeed: 0,
            recnncount: 0,
            loadingtime: 0,
            blockcount: 0,
            blocktime: 0,
            errorcode: 0,
            geturltime: 0,
            fullecode: '',
            prdlength: 0,
            get_stream_data_duration: 0,
            get_sync_frame_duration: 0,
            live_delay: 0
        });
        _$2(_$6(_this), "isSettingLevel", false);
        /** 事件监听 */ _$2(_$6(_this), "setEvtHandler", function() {
            _this.msg.on(H5_EXT_EVENT.DATASET_STATE_UPDATE, _this.onStateChange);
            _this.player.on(PLAY_EVENT.RETRY_BACKURL, _this.onRetryUrl);
        });
        _$2(_$6(_this), "onRetryUrl", function() {
            // 跳过下一次load上报
            _this.flowHeader.recnncount = _this.flowHeader.recnncount + 1;
        });
        /** 数据中心stateMap更新 */ _$2(_$6(_this), "onStateChange", function(evt) {
            var data = evt.data;
            var key = data.key;
            var _obj;
            var handlers = (_obj = {}, _$2(_obj, DataState.LOAD_END, _this.onLoad), _$2(_obj, DataState.BUFFER_END, _this.onBuffer), _$2(_obj, DataState.GET_INFO_END, _this.onGetinfoEnd), _$2(_obj, DataState.SET_LEVEL_START, _this.onSetLevel), _$2(_obj, DataState.SESSION_START, _this.onSessionStart), _$2(_obj, DataState.SESSION_END, _this.onSessionEnd), _$2(_obj, DataState.CODEC_DEGRADE, _this.onCodecDegrade), _obj);
            if (handlers[key]) handlers[key](data);
        });
        _$2(_$6(_this), "onSessionStart", function() {
            _this.resetLoopData();
            _this.seq = 0;
        });
        _$2(_$6(_this), "onSessionEnd", function(data) {
            var _data_newVal = data.newVal, newVal = _data_newVal === void 0 ? {} : _data_newVal;
            var code = newVal.code;
            _this.onPeriod({
                code: code
            });
            _this.seq = 0;
            _this.endPeriodReport();
            _this.reportedEvt = {};
        });
        _$2(_$6(_this), "startPeriodReport", function() {
            _this.endPeriodReport();
            _this.period = setInterval(_this.onPeriod, 60000);
        });
        _$2(_$6(_this), "endPeriodReport", function() {
            if (_this.period) {
                clearInterval(_this.period);
                _this.period = null;
            }
        });
        _$2(_$6(_this), "onSetLevel", function() {
            _this.isSettingLevel = true;
            _this.onPeriod();
            _this.endPeriodReport();
        });
        _$2(_$6(_this), "onBuffer", function(data) {
            var _data_newVal = data.newVal, newVal = _data_newVal === void 0 ? {} : _data_newVal, _data_startEvent = data.startEvent, startEvent = _data_startEvent === void 0 ? {} : _data_startEvent;
            var etime = newVal.ftime;
            var stime = startEvent.ftime;
            // 1.2s以内的缓冲不记录
            if (etime - stime <= BUFFER_THRESHOLDS) return;
            _this.bufferHistory.push({
                stime: stime,
                etime: etime
            });
        });
        _$2(_$6(_this), "onGetinfoEnd", function(data) {
            var newVal = data.newVal, startEvent = data.startEvent;
            var etime = newVal.ftime;
            var stime = startEvent.ftime;
            _this.flowHeader.geturltime = etime - stime;
        });
        _$2(_$6(_this), "onCodecDegrade", function(data) {
            var _data_newVal = data.newVal, newVal = _data_newVal === void 0 ? {} : _data_newVal;
            var etime = newVal.ftime, code = newVal.code;
            _this.report({
                step: 701,
                stepname: "codec_degrade",
                etime: etime,
                code: code
            });
        });
        /** load事件回调 */ _$2(_$6(_this), "onLoad", function(data) {
            if (_this.reportedEvt[205] && !_this.isSettingLevel) return;
            _this.reportedEvt[205] = true;
            _this.isSettingLevel = false;
            var _data_startEvent = data.startEvent, startEvent = _data_startEvent === void 0 ? {} : _data_startEvent, _data_newVal = data.newVal, newVal = _data_newVal === void 0 ? {} : _data_newVal;
            var code = newVal.code;
            // 这里数据中心会抛出一个load事件，如果有报错的话跳过这次上报等候error事件
            if (code !== ErrorCode.SUC) return;
            _this.flowHeader.loadingtime = newVal.ftime - startEvent.ftime;
            _this.flowHeader.errorcode = code;
            _this.flowHeader.fullecode = code;
            _this.report({
                step: 205,
                stepname: "live_loading",
                code: code
            });
            _this.startPeriodReport();
        });
        /** 周期上报 */ _$2(_$6(_this), "onPeriod", function(error) {
            var _ref = error || {
                code: ErrorCode.SUC
            }, _ref_code = _ref.code, code = _ref_code === void 0 ? ErrorCode.SUC : _ref_code;
            // 计算本周期内的二次缓冲数据
            var _this_bufferHistory_reduce = _$9(_this.bufferHistory.reduce(function(acc, cur) {
                var _acc = _$9(acc, 2), b = _acc[0], bt = _acc[1];
                var etime = cur.etime, stime = cur.stime;
                var duration = etime - stime;
                return [
                    b + 1,
                    bt + duration
                ];
            }, [
                0,
                0
            ]), 2), block = _this_bufferHistory_reduce[0], blocktime = _this_bufferHistory_reduce[1];
            // 计算本周期时长，正常为60s，打断为实际时长
            var _this_player_dataset_getStats = _this.player.dataset.getStats(), prd = _this_player_dataset_getStats.playDuration;
            _this.flowHeader.blockcount = block;
            _this.flowHeader.blocktime = blocktime;
            _this.flowHeader.prdlength = prd - _this.lastPlayDuration;
            _this.flowHeader.errorcode = code;
            _this.flowHeader.fullecode = code;
            var rptData = {
                step: code === ErrorCode.SUC ? 263 : 150,
                stepname: code === ErrorCode.SUC ? "live_period" : "live_error",
                code: code
            };
            _this.report(rptData);
            _this.resetLoopData();
            _this.lastPlayDuration = prd;
        });
        /** 重置一些状态 */ _$2(_$6(_this), "resetLoopData", function() {
            _this.bufferHistory = [];
            _this.flowHeader = _$c(_$b({}, _this.flowHeader), {
                blockcount: 0,
                blocktime: 0,
                errorcode: 0,
                loadingtime: 0,
                fullecode: '',
                prdlength: 0,
                recnncount: 0,
                downspeed: 0,
                live_delay: 0
            });
        });
        var liveQaReporterConfig = player.config.liveQaReporterConfig;
        _this.config = {
            paramsKey: _$b({}, DEFAULT_KEYS$1, (liveQaReporterConfig === null || liveQaReporterConfig === void 0 ? void 0 : liveQaReporterConfig.paramsKey) || {}),
            onAfterReport: liveQaReporterConfig === null || liveQaReporterConfig === void 0 ? void 0 : liveQaReporterConfig.onAfterReport,
            onBeforeReport: liveQaReporterConfig === null || liveQaReporterConfig === void 0 ? void 0 : liveQaReporterConfig.onBeforeReport
        };
        _this.setEvtHandler();
        // 初始化beacon sdk
        BeaconRequest.register({
            appKey: _this.REPORT_KEY,
            isOversea: !!(liveQaReporterConfig === null || liveQaReporterConfig === void 0 ? void 0 : liveQaReporterConfig.isOversea)
        }, liveQaReporterConfig === null || liveQaReporterConfig === void 0 ? void 0 : liveQaReporterConfig.externalBeaconDefer);
        _this.log("live-qa-reporter registered to ".concat(_this.REPORT_KEY, ", oversea: ").concat(!!(liveQaReporterConfig === null || liveQaReporterConfig === void 0 ? void 0 : liveQaReporterConfig.isOversea)));
        _this.reporter = BeaconRequest.report;
        return _this;
    }
    _(LiveQaReporterPlugin, [
        {
            key: "reportHeader",
            get: function get() {
                var _this_player_currentVideoInfo, _this_player;
                var _this_config = this.config, _this_config_paramsKey = _this_config.paramsKey, paramsKey = _this_config_paramsKey === void 0 ? {} : _this_config_paramsKey;
                var header = _$b({
                    videocapability: this.getKvWithDefault(paramsKey.videocapability, ''),
                    cdnuip: this.getKvWithDefault(paramsKey.cdnuip, ''),
                    iqq: this.getKvWithDefault(paramsKey.iqq, getQQFromCookie()),
                    qqopen_id: this.getKvWithDefault(paramsKey.qqopen_id, ''),
                    pvid: cookieTool.get('pgv_pvid') || '',
                    playno: this.getKvWithDefault(paramsKey.playno, ''),
                    cdnid: this.getKvWithDefault(paramsKey.cdnid, ''),
                    guid: this.getKvWithDefault(paramsKey.guid, ''),
                    fplayerver: this.getKvWithDefault(paramsKey.fplayerver, ''),
                    dsip: this.getKvWithDefault(paramsKey.dsip, ''),
                    sstrength: this.getKvWithDefault(paramsKey.sstrength, 0),
                    devtype: this.getKvWithDefault(paramsKey.devtype, 0),
                    nettype: this.getKvWithDefault(paramsKey.nettype, 100),
                    codec: this.getKvWithDefault(paramsKey.codec, CODEC.H264),
                    freetype: this.getKvWithDefault(paramsKey.freetype, 0),
                    platform: this.getKvWithDefault(paramsKey.platform, ''),
                    vplatform: this.getKvWithDefault(paramsKey.platform, ''),
                    device: this.getKvWithDefault(paramsKey.device, ''),
                    resolution: this.getKvWithDefault(paramsKey.resolution, ''),
                    osver: this.getKvWithDefault(paramsKey.osver, ''),
                    playertype: this.getKvWithDefault(paramsKey.playertype, 0),
                    appver: this.getKvWithDefault(paramsKey.appver, ''),
                    use_p2p: this.getKvWithDefault(paramsKey.use_p2p, 0),
                    p2p_play: this.getKvWithDefault(paramsKey.p2p_play, 0),
                    p2pver: this.getKvWithDefault(paramsKey.p2pver, ''),
                    playtype: this.getKvWithDefault(paramsKey.playtype, 1),
                    scenesid: this.getKvWithDefault(paramsKey.scenesid, 0),
                    drm: this.getKvWithDefault(paramsKey.drm, 0),
                    sid: this.getKvWithDefault(paramsKey.sid, 0),
                    livepid: this.getKvWithDefault(paramsKey.livepid, 0),
                    contentid: this.getKvWithDefault(paramsKey.contentid, 0),
                    playtime: this.getKvWithDefault(paramsKey.playtime, 0),
                    isuerpay: this.getKvWithDefault(paramsKey.isuserpay, 0),
                    live_type: this.getKvWithDefault(paramsKey.live_type, 0),
                    xserverip: this.getKvWithDefault(paramsKey.xserverip, ''),
                    durl: this.getKvWithDefault(paramsKey.durl, ((_this_player = this.player) === null || _this_player === void 0 ? void 0 : (_this_player_currentVideoInfo = _this_player.currentVideoInfo) === null || _this_player_currentVideoInfo === void 0 ? void 0 : _this_player_currentVideoInfo.loadingUrl) || ''),
                    lookback: this.getKvWithDefault(paramsKey.lookback, 0),
                    live_tag: this.getKvWithDefault(paramsKey.live_tag, 0),
                    extraInfo: this.getKvWithDefault(paramsKey.extraInfo, ''),
                    spanId: this.getKvWithDefault(paramsKey.spanId, ''),
                    tuid: this.getKvWithDefault(paramsKey.tuid, ''),
                    kernel: this.player.kernelName,
                    plat_code: uaTool.mobile ? "h5" : "web",
                    domain: urlTool.getDomainOfURL(urlTool.getTopFrameUrl()),
                    seq: this.seq,
                    ext1: this.getKvWithDefault(paramsKey.ext1, ''),
                    ext2: this.getKvWithDefault(paramsKey.ext2, ''),
                    ext3: this.getKvWithDefault(paramsKey.ext3, '')
                }, this.flowHeader);
                return header;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.endPeriodReport();
                BeaconRequest.clear(this.REPORT_KEY);
                _$g(_$h(LiveQaReporterPlugin.prototype), "destroy", this).call(this);
            }
        },
        {
            key: "report",
            value: function report(data) {
                _$g(_$h(LiveQaReporterPlugin.prototype), "report", this).call(this, data);
                this.seq = this.seq + 1;
            }
        }
    ]);
    return LiveQaReporterPlugin;
}(BaseReporter);
/** 插件名 */ _$2(LiveQaReporterPlugin, "pluginName", 'live-qa-reporter');

var AdReportHelper = /*#__PURE__*/ function() {
    function AdReportHelper(reporter) {
        var _this = this;
        _$1(this, AdReportHelper);
        _$2(this, "reportData", {});
        _$2(this, "currentBufferHistory", []);
        _$2(this, "adPlayer", void 0);
        _$2(this, "adType", void 0);
        _$2(this, "reporterPlugin", void 0);
        // event handlers
        _$2(this, "onStateChange", function(e) {
            var data = e.data;
            var newState = data.new, oldState = data.old;
            var _obj;
            var handlerMap = (_obj = {}, _$2(_obj, VIDEO_STATE.CANPLAY, _this.onCanPlay), _$2(_obj, VIDEO_STATE.BUFFERING, _this.onBuffering), _$2(_obj, VIDEO_STATE.END, _this.onEnd), _obj);
            if (handlerMap[newState]) {
                handlerMap[newState](e.data.videoInfo, oldState);
            }
        });
        _$2(this, "onError", function(e) {
            var data = e.data;
            var videoInfo = data.videoInfo;
            if (!videoInfo) return;
            var uid = videoInfo.uid, error = videoInfo.error;
            var record = _this.reportData[uid];
            if (!record) {
                return;
            }
            if (record.load >= 0) {
                var _videoInfo_config_backupUrls, _videoInfo_config;
                _this.emitToMainReporter({
                    code: error.code,
                    step: '30',
                    stime: record.load,
                    stepname: STEP_NAME.FIRST_LOAD,
                    etime: Date.now(),
                    url: videoInfo.loadingUrl,
                    urlIndex: ((_videoInfo_config = videoInfo.config) === null || _videoInfo_config === void 0 ? void 0 : (_videoInfo_config_backupUrls = _videoInfo_config.backupUrls) === null || _videoInfo_config_backupUrls === void 0 ? void 0 : _videoInfo_config_backupUrls.findIndex(function(url) {
                        return url === videoInfo.loadingUrl;
                    })) || -1
                }, record);
                record.load = -1;
            }
            _this.emitToMainReporter({
                step: '50',
                playDuration: videoInfo.playtime,
                code: error.code,
                stepname: STEP_NAME.END,
                tbcount: 0,
                tbduration: 0,
                scount: 0,
                etime: Date.now(),
                bcount: _this.currentBufferHistory.length,
                tduration: _this.currentBufferHistory.reduce(function(acc, cur) {
                    return acc + (cur.etime - cur.stime);
                }, 0)
            }, record);
        });
        _$2(this, "onFirstPlaying", function(e) {
            var data = e.data;
            var videoInfo = data.videoInfo;
            if (!videoInfo) return;
            var record = _this.reportData[videoInfo.uid];
            if (record) {
                if (record.load >= 0) {
                    _this.reportFirstLoad(videoInfo, record);
                }
                var now = Date.now();
                var reportData = {
                    step: '32',
                    stepname: STEP_NAME.FIRST_RENDERING,
                    stime: now,
                    etime: now,
                    code: ErrorCode.SUC
                };
                _this.emitToMainReporter(reportData, record);
                return;
            }
        });
        /**
   * 这里以videonode change作为加载的标志。如果此时视频已经预加载好了，会很快的再出发playing
   * 如果视频还需要加载，则从这个时间开始计算首缓，因为这是用户感知到的部分
   */ _$2(this, "onVideoNodeChange", function(e) {
            var data = e.data;
            var videoInfo = data.videoInfo;
            // 如果同一个video info已经被记录过了 则跳过
            if (!videoInfo || _this.reportData[videoInfo.uid]) return;
            _this.reportData[videoInfo.uid] = {
                seq: 0,
                flowidSuffix: "_ad".concat(_this.getAdClipNumber()),
                load: Date.now()
            };
        });
        // state handlers
        _$2(this, "reportFirstLoad", function(videoInfo, record) {
            var _this_adPlayer_currentVideoInfo, _videoInfo_config_backupUrls, _videoInfo_config;
            var _this_adPlayer_currentVideoInfo_cacheSize;
            var cachesize = (_this_adPlayer_currentVideoInfo_cacheSize = (_this_adPlayer_currentVideoInfo = _this.adPlayer.currentVideoInfo) === null || _this_adPlayer_currentVideoInfo === void 0 ? void 0 : _this_adPlayer_currentVideoInfo.cacheSize) !== null && _this_adPlayer_currentVideoInfo_cacheSize !== void 0 ? _this_adPlayer_currentVideoInfo_cacheSize : 0;
            var reportData = {
                step: '30',
                stepname: STEP_NAME.FIRST_LOAD,
                stime: record.load,
                etime: Date.now(),
                url: videoInfo.loadingUrl,
                urlIndex: ((_videoInfo_config = videoInfo.config) === null || _videoInfo_config === void 0 ? void 0 : (_videoInfo_config_backupUrls = _videoInfo_config.backupUrls) === null || _videoInfo_config_backupUrls === void 0 ? void 0 : _videoInfo_config_backupUrls.findIndex(function(url) {
                    return url === videoInfo.loadingUrl;
                })) || -1,
                code: ErrorCode.SUC,
                cachesize: cachesize
            };
            _this.emitToMainReporter(reportData, record);
            record.load = -1;
            return;
        });
        _$2(this, "onCanPlay", function(videoInfo) {
            if (!videoInfo) return;
            var record = _this.reportData[videoInfo.uid];
            if (record) {
                if (record.load >= 0) {
                    _this.reportFirstLoad(videoInfo, record);
                    return;
                }
                if (record.buffer >= 0) {
                    var now = Date.now();
                    var stime = record.buffer;
                    record.buffer = -1;
                    if (now - stime <= 1200) return;
                    _this.currentBufferHistory.push({
                        stime: stime,
                        etime: Date.now()
                    });
                    var reportData = {
                        step: '35',
                        stime: stime,
                        stepname: STEP_NAME.BUFFERING,
                        etime: Date.now(),
                        ptime: _this.adPlayer.playtime,
                        code: ErrorCode.SUC
                    };
                    _this.emitToMainReporter(reportData, record);
                    return;
                }
            }
        });
        _$2(this, "onEnd", function(videoInfo) {
            if (!videoInfo) return;
            var record = _this.reportData[videoInfo.uid];
            if (record) {
                var reportData = {
                    step: '50',
                    playDuration: videoInfo.playtime,
                    code: ErrorCode.SUC,
                    stepname: STEP_NAME.END,
                    tbcount: 0,
                    tbduration: 0,
                    scount: 0,
                    etime: Date.now(),
                    bcount: _this.currentBufferHistory.length,
                    tduration: _this.currentBufferHistory.reduce(function(acc, cur) {
                        return acc + (cur.etime - cur.stime);
                    }, 0)
                };
                _this.emitToMainReporter(reportData, record);
            }
        });
        _$2(this, "onBuffering", function(videoInfo) {
            if (!videoInfo) return;
            var record = _this.reportData[videoInfo.uid];
            if (record) {
                record.buffer = Date.now();
            }
        });
        this.reporterPlugin = reporter;
    }
    _(AdReportHelper, [
        {
            key: "destroy",
            value: function destroy() {
                this.unbindCoreEvents();
            }
        },
        {
            key: "init",
            value: function init(adPlayer, adType) {
                if (this.adPlayer) {
                    this.unbindCoreEvents();
                }
                var vinfo = adPlayer.currentVideoInfo;
                if (!vinfo) return;
                this.adPlayer = adPlayer;
                this.adType = adType;
                this.bindCoreEvents();
                this.reportData = {};
                // 这里主要是第一次进来之后，loadstart已经开始了。
                this.reportData[vinfo.uid] = {
                    seq: 0,
                    flowidSuffix: "ad".concat(this.getAdClipNumber()),
                    load: Date.now()
                };
            }
        },
        {
            key: "getAdClipNumber",
            value: function getAdClipNumber() {
                return Object.keys(this.reportData).length;
            }
        },
        {
            key: "bindCoreEvents",
            value: function bindCoreEvents() {
                this.adPlayer.on(PLAY_EVENT.STATE_CHANGE, this.onStateChange);
                this.adPlayer.on(PLAY_EVENT.ERROR, this.onError);
                this.adPlayer.on(PLAY_EVENT.VIDEONODE_FIRST_PLAYING, this.onFirstPlaying);
                this.adPlayer.on(PLAY_EVENT.VIDEONODE_CHANGE, this.onVideoNodeChange);
            }
        },
        {
            key: "unbindCoreEvents",
            value: function unbindCoreEvents() {
                this.adPlayer.off(PLAY_EVENT.STATE_CHANGE, this.onStateChange);
                this.adPlayer.off(PLAY_EVENT.ERROR, this.onError);
                this.adPlayer.off(PLAY_EVENT.VIDEONODE_FIRST_PLAYING, this.onFirstPlaying);
                this.adPlayer.off(PLAY_EVENT.VIDEONODE_CHANGE, this.onVideoNodeChange);
            }
        },
        {
            key: "emitToMainReporter",
            value: // helper
            function emitToMainReporter(data, record) {
                var payload = _$c(_$b({
                    code: ErrorCode.SUC
                }, data), {
                    // 这里在外部拼接到原flowid上
                    flowid: record.flowidSuffix,
                    seq: record.seq,
                    scenesid: SCENES_ID[this.adType] || SCENES_ID.otherAd,
                    duration: this.adPlayer.duration,
                    kernel: this.adPlayer.kernelName,
                    // ! 这里把一些参数置空，防止取到header中的正片参数
                    vid: '',
                    fmt: '',
                    rate: '',
                    cdnid: '',
                    cdnip: '',
                    drm: '',
                    definition: '',
                    dltype: ''
                });
                record.seq += 1;
                this.reporterPlugin.emit('adReport', payload);
            }
        }
    ]);
    return AdReportHelper;
}();

var STEP_NAME;
(function(STEP_NAME) {
    STEP_NAME["INIT"] = "init_player";
    STEP_NAME["GETINFO"] = "get_cdn_url";
    STEP_NAME["FIRST_LOAD"] = "first_load";
    STEP_NAME["FIRST_RENDERING"] = "first_rendering";
    STEP_NAME["BUFFERING"] = "second_buffering";
    STEP_NAME["SEEKING"] = "user_seek";
    STEP_NAME["END"] = "play_done";
    STEP_NAME["CODEC_DEGRADE"] = "codec_degrade";
    /** 是否正在打开调试面板（检测到一次报一次） */ STEP_NAME["DT_OPEN"] = "dt_open";
})(STEP_NAME || (STEP_NAME = {}));
var SCENES_ID;
(function(SCENES_ID) {
    SCENES_ID[SCENES_ID["preAd"] = 400] = "preAd";
    SCENES_ID[SCENES_ID["ZT"] = 401] = "ZT";
    SCENES_ID[SCENES_ID["postAd"] = 402] = "postAd";
    SCENES_ID[SCENES_ID["otherAd"] = 403] = "otherAd";
    SCENES_ID[SCENES_ID["video"] = 421] = "video";
})(SCENES_ID || (SCENES_ID = {}));
var DEFAULT_KEYS = {
    platform: COMMON_DATA_KEY.platform,
    vplatform: COMMON_DATA_KEY.platform,
    flowid: COMMON_DATA_KEY.flowid,
    uin: '',
    QQopenid: COMMON_DATA_KEY.hc_openid,
    WXopenid: COMMON_DATA_KEY.hc_openid,
    logintype: COMMON_DATA_KEY.hc_main_login,
    guid: COMMON_DATA_KEY.guid,
    uip: '',
    cdnuip: COMMON_DATA_KEY.cdnuip,
    codec: COMMON_DATA_KEY.codec,
    cdnip: COMMON_DATA_KEY.cdnip,
    online: COMMON_DATA_KEY.online,
    p2p: COMMON_DATA_KEY.p2p,
    sstrength: COMMON_DATA_KEY.sstrength,
    network: COMMON_DATA_KEY.network,
    speed: COMMON_DATA_KEY.speed,
    device: COMMON_DATA_KEY.device,
    resolution: COMMON_DATA_KEY.resolution,
    testid: COMMON_DATA_KEY.testid,
    osver: COMMON_DATA_KEY.osver,
    p2pver: COMMON_DATA_KEY.p2pver,
    appver: COMMON_DATA_KEY.appVer,
    playerver: COMMON_DATA_KEY.playerver,
    playertype: COMMON_DATA_KEY.playertype,
    confid: COMMON_DATA_KEY.confid,
    cdnid: COMMON_DATA_KEY.cdnid,
    drm: COMMON_DATA_KEY.drmtype,
    scenesid: '',
    playtype: '',
    dltype: COMMON_DATA_KEY.dltype,
    vid: COMMON_DATA_KEY.vid,
    pid: COMMON_DATA_KEY.fakeLivePid,
    chid: COMMON_DATA_KEY.fakeLiveChid,
    definition: COMMON_DATA_KEY.currentDefn,
    fmt: COMMON_DATA_KEY.fmt,
    rate: COMMON_DATA_KEY.rate,
    videocapability: COMMON_DATA_KEY.videoCapability,
    ckeytime: COMMON_DATA_KEY.ckeytime,
    ckeydg: COMMON_DATA_KEY.ckeydg,
    dmkopen: COMMON_DATA_KEY.dmkState,
    dmkeng: COMMON_DATA_KEY.dmkEngine,
    dmkdg: COMMON_DATA_KEY.dmkDegraded,
    isad: '',
    duration: '',
    kernel: '',
    ext1: '',
    ext2: '',
    ext3: ''
};
/**
 * 飞天2.0 点播播放质量上报
 * https://iwiki.woa.com/pages/viewpage.action?pageId=40649252
 */ var VodQaReporterPlugin = /*#__PURE__*/ function(BaseReporter) {
    _$4(VodQaReporterPlugin, BaseReporter);
    var _super = _$5(VodQaReporterPlugin);
    function VodQaReporterPlugin(player, config, extra) {
        _$1(this, VodQaReporterPlugin);
        var _this;
        _this = _super.call(this, player, config, extra);
        _$2(_$6(_this), "REPORT_KEY", VOD_QA_RPT_BEACON_APP_KEY);
        _$2(_$6(_this), "FLOW_DATA_KEY", VOD_QA_RPT_CACHE_KEY);
        /** 配置 */ _$2(_$6(_this), "config", void 0);
        /** 广告上报注入 */ _$2(_$6(_this), "adReportHelper", void 0);
        /** 自增值 */ _$2(_$6(_this), "seq", 0);
        /** 缓冲记录 */ _$2(_$6(_this), "bufferHistory", []);
        /** 用户拖拽记录 */ _$2(_$6(_this), "seekHistory", []);
        /** 整个流程中不会重写的字段（首次xxx） */ _$2(_$6(_this), "initData", {
            fmt: '',
            rate: '',
            cdnid: ''
        });
        /** 缓冲计数，切换清晰度后重置 */ _$2(_$6(_this), "bufferCount", 0);
        /** 拖拽计数，切换清晰度后重置 */ _$2(_$6(_this), "seekCount", 0);
        _$2(_$6(_this), "adReportHelperInitTimeoutId", 0);
        /** 事件监听 */ _$2(_$6(_this), "setEvtHandler", function() {
            _this.msg.on(H5_EXT_EVENT.DATASET_STATE_UPDATE, _this.onStateChange);
            _this.player.on(PLAY_EVENT.SETLEVEL_OVER, function() {
                _this.bufferCount = 0;
                _this.seekCount = 0;
            });
            window.addEventListener('pagehide', _this.onPageHide);
        });
        _$2(_$6(_this), "onPageHide", function() {
            _this.handlePageHide(_this.collectFinalData());
        });
        /** 数据中心stateMap更新 */ _$2(_$6(_this), "onStateChange", function(evt) {
            var data = evt.data;
            var key = data.key;
            var _obj;
            var handlers = (_obj = {}, _$2(_obj, DataState.INIT, _this.onPlayerInit), _$2(_obj, DataState.LOAD_END, _this.onLoad), _$2(_obj, DataState.BUFFER_END, _this.onBuffer), _$2(_obj, DataState.GET_INFO_END, _this.onGetinfoEnd), _$2(_obj, DataState.SEEK_END, _this.onSeek), _$2(_obj, DataState.SESSION_END, _this.onPlaySessionEnd), _$2(_obj, DataState.FIRST_PLAY, _this.onFirstPlay), _$2(_obj, DataState.SESSION_START, _this.reset), _$2(_obj, DataState.CODEC_DEGRADE, _this.onCodecDegrade), _$2(_obj, DataState.RETRY_BACKURL, function() {
                _this.bufferCount = 0;
                _this.seekCount = 0;
            }), _$2(_obj, DataState.DT_OPEN, _this.onDtOpen), _obj);
            if (handlers[key]) handlers[key](data);
        });
        _$2(_$6(_this), "onPlayerInit", function(data) {
            var newVal = data.newVal;
            var ftime = newVal.ftime, _newVal_ext = newVal.ext, ext = _newVal_ext === void 0 ? {} : _newVal_ext;
            var stime = ext.stime;
            _this.report({
                stepname: "init_player",
                step: "5",
                stime: stime,
                etime: ftime,
                code: ErrorCode.SUC
            });
        });
        /** step15: 获取CDN地址 结束并上报 */ _$2(_$6(_this), "onGetinfoEnd", function(data) {
            var newVal = data.newVal, startEvent = data.startEvent;
            var etime = newVal.ftime, code = newVal.code;
            var stime = startEvent.ftime;
            _this.report({
                stepname: "get_cdn_url",
                step: "15",
                stime: stime,
                etime: etime,
                code: code
            });
        });
        /** step30: 视频首次加载 */ _$2(_$6(_this), "onLoad", function(data) {
            var _this_player_config_vodQaReporterConfig;
            var _data_newVal = data.newVal, newVal = _data_newVal === void 0 ? {} : _data_newVal, _data_startEvent = data.startEvent, startEvent = _data_startEvent === void 0 ? {} : _data_startEvent;
            var etime = newVal.ftime, currentUrl = newVal.currentUrl, urlIndex = newVal.urlIndex, code = newVal.code, ext = newVal.ext;
            // 广告过程中加载耗时设置为 0
            var stime = (ext === null || ext === void 0 ? void 0 : ext.isAdPlaying) ? etime : startEvent.ftime;
            // !FIXME: 这里比较尴尬，由于初始化时序的问题，只能从config上通过引用获取到值
            var videoUrl = ((_this_player_config_vodQaReporterConfig = _this.player.config.vodQaReporterConfig) === null || _this_player_config_vodQaReporterConfig === void 0 ? void 0 : _this_player_config_vodQaReporterConfig.obfuscate) ? urlTool.obfuscatePathComponent(currentUrl) : currentUrl;
            _this.report({
                stepname: "first_load",
                step: "30",
                stime: stime,
                etime: etime,
                url: videoUrl || '',
                urlindex: urlIndex + 1,
                fileopenedtime: 0,
                firstpacketreadtime: 0,
                ext1: _this.player.getCommonKv(COMMON_DATA_KEY.isPreload) || 0,
                ext2: Number(ext === null || ext === void 0 ? void 0 : ext.isAdPlaying),
                code: code
            });
        });
        /** step32 首帧渲染 */ _$2(_$6(_this), "onFirstPlay", function() {
            if (_this.reportedEvt["first_rendering"]) return;
            _this.reportedEvt["first_rendering"] = true;
            var now = +new Date();
            _this.report({
                step: "32",
                stepname: "first_rendering",
                stime: now,
                etime: now,
                code: ErrorCode.SUC
            });
        });
        /** step35 二次缓冲 */ _$2(_$6(_this), "onBuffer", function(data) {
            var _data_newVal = data.newVal, newVal = _data_newVal === void 0 ? {} : _data_newVal, _data_startEvent = data.startEvent, startEvent = _data_startEvent === void 0 ? {} : _data_startEvent;
            var etime = newVal.ftime, ptime = newVal.playtime, currentUrl = newVal.currentUrl, code = newVal.code;
            var stime = startEvent.ftime, prevState = startEvent.prevState;
            var levent = prevState === VIDEO_STATE.SEEKING ? 1 : 0; // seek触发为1，其他为0
            var scene = _this.player.playbackRate > 1 ? 2 : 1;
            // 1.2s以内的缓冲不记录
            if (etime - stime <= BUFFER_THRESHOLDS) return;
            _this.bufferHistory.push({
                stime: stime,
                etime: etime
            });
            if (_this.bufferCount < 20) {
                _this.report({
                    step: "35",
                    stepname: "second_buffering",
                    ptime: ptime,
                    levent: levent,
                    stime: stime,
                    etime: etime,
                    scene: scene,
                    format: _this.player.getCommonKv(_this.config.paramsKey.fmt) || 0,
                    url: currentUrl || '',
                    reason: 0,
                    code: code,
                    vt: _this.player.getCommonKv(_this.config.paramsKey.cdnid) || 0
                });
                _this.bufferCount += 1;
            }
        });
        /** step40 用户拖拽 */ _$2(_$6(_this), "onSeek", function(data) {
            var _data_newVal = data.newVal, newVal = _data_newVal === void 0 ? {} : _data_newVal, _data_startEvent = data.startEvent, startEvent = _data_startEvent === void 0 ? {} : _data_startEvent;
            var letime = newVal.ftime, petime = newVal.playtime, code = newVal.code, _newVal_ext = newVal.ext, ext = _newVal_ext === void 0 ? {} : _newVal_ext;
            var lstime = startEvent.ftime, pstime = startEvent.playtime;
            if (!ext.isUserSeek) return;
            _this.seekHistory.push({
                lstime: lstime,
                letime: letime
            });
            if (_this.seekCount < 20) {
                _this.report({
                    step: "40",
                    stepname: "user_seek",
                    lstime: lstime,
                    letime: letime,
                    pstime: pstime,
                    petime: petime,
                    format: _this.player.getCommonKv(_this.config.paramsKey.fmt) || 0,
                    code: code
                });
                _this.seekCount += 1;
            }
        });
        _$2(_$6(_this), "onPlaySessionEnd", function(data) {
            if (_this.reportedEvt["play_done"]) return;
            _this.reportedEvt["play_done"] = true;
            var _data_newVal = data.newVal, newVal = _data_newVal === void 0 ? {} : _data_newVal;
            var ftime = newVal.ftime, code = newVal.code;
            var _this_player_dataset_getStats = _this.player.dataset.getStats(), playduration = _this_player_dataset_getStats.playDuration;
            var ignoreErrorCode = [
                // 服务端错误
                code.indexOf(ErrorCode.GETINFO_SERVER_CODE_PREFIX) === 0,
                // getinfo插件相关错误
                code.indexOf('70014') === 0,
                // 广告及未知错误
                code.indexOf('7004') === 0,
                // 传参错误
                code === '70011112',
                code === '70011113'
            ].some(function(i) {
                return i;
            });
            var finalCode = ignoreErrorCode ? ErrorCode.SUC : code;
            _this.report(_$b({
                step: "50",
                stepname: "play_done",
                etime: ftime,
                playduration: playduration,
                code: finalCode
            }, _this.seekStat, _this.bufferStat));
            _this.removeFromLS(_this.player.getCommonKv(COMMON_DATA_KEY.flowid));
            _this.seq = 0;
        });
        _$2(_$6(_this), "onCodecDegrade", function(data) {
            var _data_newVal = data.newVal, newVal = _data_newVal === void 0 ? {} : _data_newVal;
            var etime = newVal.ftime, code = newVal.code;
            _this.report({
                step: "701",
                stepname: "codec_degrade",
                etime: etime,
                code: code
            });
        });
        _$2(_$6(_this), "onDtOpen", function(data) {
            var _data_newVal = data.newVal, newVal = _data_newVal === void 0 ? {} : _data_newVal;
            var stime = newVal.ftime, code = newVal.code;
            _this.report({
                step: "702",
                stepname: "dt_open",
                stime: stime,
                etime: +new Date(),
                code: code
            });
        });
        _$2(_$6(_this), "onInit", function() {
            _this.reportPrev(); // 上报缓存的step50事件
        });
        _$2(_$6(_this), "collectFinalData", function() {
            var now = +new Date();
            var flowid = _this.player.getCommonKv(COMMON_DATA_KEY.flowid);
            if (!flowid || _this.reportedEvt["play_done"]) return;
            var _this_player_dataset_getStats = _this.player.dataset.getStats(), playduration = _this_player_dataset_getStats.playDuration;
            var data = _$b({
                step: "50",
                stepname: "play_done",
                etime: now,
                code: ErrorCode.SUC,
                playduration: playduration
            }, _this.seekStat, _this.bufferStat);
            return data;
        });
        _$2(_$6(_this), "reset", function() {
            _this.reportedEvt = {};
            _this.initData.fmt = '';
            _this.initData.rate = '';
            _this.initData.cdnid = '';
            _this.bufferHistory = [];
            _this.seekHistory = [];
            _this.bufferCount = 0;
            _this.seekCount = 0;
        });
        var vodQaReporterConfig = player.config.vodQaReporterConfig;
        _this.config = _$c(_$b({}, vodQaReporterConfig), {
            paramsKey: _$b({}, DEFAULT_KEYS, (vodQaReporterConfig === null || vodQaReporterConfig === void 0 ? void 0 : vodQaReporterConfig.paramsKey) || {}),
            onAfterReport: vodQaReporterConfig === null || vodQaReporterConfig === void 0 ? void 0 : vodQaReporterConfig.onAfterReport,
            onBeforeReport: vodQaReporterConfig === null || vodQaReporterConfig === void 0 ? void 0 : vodQaReporterConfig.onBeforeReport
        });
        _this.setEvtHandler();
        // 初始化beacon sdk
        BeaconRequest.register({
            appKey: _this.REPORT_KEY,
            isOversea: !!(vodQaReporterConfig === null || vodQaReporterConfig === void 0 ? void 0 : vodQaReporterConfig.isOversea)
        }, vodQaReporterConfig === null || vodQaReporterConfig === void 0 ? void 0 : vodQaReporterConfig.externalBeaconDefer);
        _this.log("vod-qa-reporter registered to ".concat(_this.REPORT_KEY, ", oversea: ").concat(!!(vodQaReporterConfig === null || vodQaReporterConfig === void 0 ? void 0 : vodQaReporterConfig.isOversea)));
        _this.reporter = BeaconRequest.report;
        _this.reporterForPageHide = BeaconRequest.reportWhenPageHide;
        _this.onInit();
        // 初始化广告上报
        _this.adReportHelper = new AdReportHelper(_$6(_this));
        _this.player.on(H5_PLAY_EVENT.AD_REQ_ASSETS_START, function(param) {
            var data = param.data;
            _this.adReportHelperInitTimeoutId = window.setTimeout(function() {
                var _player_config, _adPlugin_getPlayerInstance;
                var instanceId = player === null || player === void 0 ? void 0 : (_player_config = player.config) === null || _player_config === void 0 ? void 0 : _player_config.instanceId;
                if (!instanceId) {
                    // 可能播放器已销毁
                    return;
                }
                var adPlugin = getAdPlugin(instanceId);
                var adPlayer = adPlugin === null || adPlugin === void 0 ? void 0 : (_adPlugin_getPlayerInstance = adPlugin.getPlayerInstance) === null || _adPlugin_getPlayerInstance === void 0 ? void 0 : _adPlugin_getPlayerInstance.call(adPlugin, data.adType);
                // ! 只支持特定的广告插件。
                if (!adPlayer) return;
                _this.adReportHelper.init(adPlayer, data.adType);
            });
        });
        _this.on('adReport', function(payload) {
            _$g((_$6(_this), _$h(VodQaReporterPlugin.prototype)), "report", _this).call(_this, _$c(_$b({}, payload.data), {
                flowid: "".concat(_this.reportHeader.flowid, "_").concat(payload.data.flowid),
                isad: 1
            }));
        });
        return _this;
    }
    _(VodQaReporterPlugin, [
        {
            key: "seekStat",
            get: /** 拖拽总计数据 */ function get() {
                var _this_seekHistory_reduce = _$9(this.seekHistory.reduce(function(acc, cur) {
                    var _acc = _$9(acc, 2), count = _acc[0], duration = _acc[1];
                    var wait = cur.letime - cur.lstime;
                    // 1200ms以下的不计入拖动缓冲
                    if (wait > BUFFER_THRESHOLDS) {
                        return [
                            count + 1,
                            duration + wait
                        ];
                    }
                    return acc;
                }, [
                    0,
                    0
                ]), 2), tbcount = _this_seekHistory_reduce[0], tbduration = _this_seekHistory_reduce[1];
                return {
                    tbcount: tbcount,
                    tbduration: tbduration,
                    scount: this.seekHistory.length
                };
            }
        },
        {
            key: "bufferStat",
            get: /** 缓冲总计数据 */ function get() {
                var tduration = this.bufferHistory.reduce(function(acc, cur) {
                    return acc + (cur.etime - cur.stime);
                }, 0);
                return {
                    tduration: tduration,
                    bcount: this.bufferHistory.length
                };
            }
        },
        {
            key: "reportHeader",
            get: function get() {
                var _this = this;
                var paramsKey = this.config.paramsKey;
                var _this_player_dataset_getStats = this.player.dataset.getStats(), averageDecodeTimeInMs = _this_player_dataset_getStats.averageDecodeTimeInMs, frameDroppedInPercentage = _this_player_dataset_getStats.frameDroppedInPercentage;
                Object.entries(this.initData).forEach(function(param) {
                    var _param = _$9(param, 2), key = _param[0], value = _param[1];
                    if (!value) {
                        _this.initData[key] = _this.getKvWithDefault(paramsKey[key], '');
                    }
                });
                var _this_player_kernelName;
                var header = {
                    videocapability: this.getKvWithDefault(paramsKey.videocapability, ''),
                    platform: this.getKvWithDefault(paramsKey.platform, ''),
                    vplatform: this.getKvWithDefault(paramsKey.platform, ''),
                    flowid: this.getKvWithDefault(paramsKey.flowid, ''),
                    uin: this.getKvWithDefault(paramsKey.uin, getQQFromCookie()),
                    QQopenid: this.getKvWithDefault(paramsKey.QQopenid, ''),
                    WXopenid: this.getKvWithDefault(paramsKey.WXopenid, ''),
                    logintype: this.getKvWithDefault(paramsKey.logintype, 0),
                    guid: this.getKvWithDefault(paramsKey.guid, ''),
                    uip: this.getKvWithDefault(paramsKey.uip, ''),
                    cdnuip: this.getKvWithDefault(paramsKey.cdnuip, ''),
                    cdnip: this.getKvWithDefault(paramsKey.cdnip, ''),
                    online: this.getKvWithDefault(paramsKey.online, 1),
                    p2p: this.getKvWithDefault(paramsKey.p2p, 0),
                    sstrength: this.getKvWithDefault(paramsKey.sstrength, 0),
                    network: this.getKvWithDefault(paramsKey.network, 0),
                    speed: this.getKvWithDefault(paramsKey.speed, 0),
                    device: this.getKvWithDefault(paramsKey.device, ''),
                    resolution: this.getKvWithDefault(paramsKey.resolution, ''),
                    testid: this.getKvWithDefault(paramsKey.testid, 0),
                    codec: this.getKvWithDefault(paramsKey.codec, CODEC.H264),
                    osver: this.getKvWithDefault(paramsKey.osver, ''),
                    p2pver: this.getKvWithDefault(paramsKey.p2pver, ''),
                    appver: this.getKvWithDefault(paramsKey.appver, ''),
                    playerver: this.getKvWithDefault(paramsKey.playerver, ''),
                    confid: this.getKvWithDefault(paramsKey.confid, 0),
                    playertype: this.getKvWithDefault(paramsKey.playertype, 0),
                    cdnid: this.initData.cdnid,
                    scenesid: this.getKvWithDefault(paramsKey.scenesid, 421),
                    playtype: 0,
                    dltype: this.getKvWithDefault(paramsKey.dltype, 0),
                    vid: this.getKvWithDefault(paramsKey.vid, ''),
                    pid: this.getKvWithDefault(paramsKey.pid, ''),
                    chid: this.getKvWithDefault(paramsKey.chid, ''),
                    fmt: this.initData.fmt,
                    rate: this.initData.rate,
                    drm: this.getKvWithDefault(paramsKey.drm, 0),
                    definition: this.getKvWithDefault(paramsKey.definition, ''),
                    duration: Math.round(this.getKvWithDefault(paramsKey.duration, this.player.duration)),
                    seq: this.seq,
                    dmkopen: this.getKvWithDefault(paramsKey.dmkopen, -1),
                    dmkeng: this.getKvWithDefault(paramsKey.dmkeng, -1),
                    dmkdg: this.getKvWithDefault(paramsKey.dmkdg, 0),
                    kernel: (_this_player_kernelName = this.player.kernelName) !== null && _this_player_kernelName !== void 0 ? _this_player_kernelName : 'unknown',
                    // 对于iframe嵌入播放而言，大多数情况腾讯视频的iframe页无法跨域获得顶级页面的完整url，这里有两个字段来上报顶级页面域名和当前页面地址：
                    // 1. domain字段为顶级页面或当前页面的域名
                    // 2. pageurl字段为当前页面的完整地址（删除查询参数，如果是iframe嵌入播放则为http://v.qq.com/txp/iframe/player.html）
                    domain: urlTool.getDomainOfURL(urlTool.getTopFrameUrl()),
                    pageurl: urlTool.removeSearchParams(location.href),
                    isad: 0,
                    ext1: this.getKvWithDefault(paramsKey.ext1, ''),
                    ext2: this.getKvWithDefault(paramsKey.ext2, ''),
                    ext3: this.getKvWithDefault(paramsKey.ext3, ''),
                    ckeytime: this.getKvWithDefault(paramsKey.ckeytime, -1),
                    ckeydg: this.getKvWithDefault(paramsKey.ckeydg, 0),
                    framedrop: frameDroppedInPercentage,
                    avgdecodecost: averageDecodeTimeInMs,
                    deved: this.getKvWithDefault(COMMON_DATA_KEY.deved, 0),
                    vuid: this.getKvWithDefault(COMMON_DATA_KEY.hc_vuserid, ''),
                    cid: this.getKvWithDefault(COMMON_DATA_KEY.cid, ''),
                    ip: this.getKvWithDefault(COMMON_DATA_KEY.hh_ip, ''),
                    devicescore: this.getKvWithDefault(COMMON_DATA_KEY.deviceScore, 0)
                };
                return header;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                if (this.adReportHelperInitTimeoutId > 0) {
                    window.clearTimeout(this.adReportHelperInitTimeoutId);
                    this.adReportHelperInitTimeoutId = 0;
                }
                window.removeEventListener('pagehide', this.onPageHide);
                BeaconRequest.clear(this.REPORT_KEY);
                _$g(_$h(VodQaReporterPlugin.prototype), "destroy", this).call(this);
            }
        },
        {
            key: "report",
            value: function report(data) {
                _$g(_$h(VodQaReporterPlugin.prototype), "report", this).call(this, data);
                this.seq = this.seq + 1;
            }
        }
    ]);
    return VodQaReporterPlugin;
}(BaseReporter);
/** 插件名 */ _$2(VodQaReporterPlugin, "pluginName", 'vod-qa-reporter');

var StatsCollector = /*#__PURE__*/ function() {
    function StatsCollector(player) {
        var _this = this;
        _$1(this, StatsCollector);
        _$2(this, "player", void 0);
        _$2(this, "collectors", void 0);
        _$2(this, "stats", void 0);
        _$2(this, "handlerCollectEvt", void 0);
        this.player = player;
        this.stats = {};
        this.handlerCollectEvt = function(e) {
            var evtName = e.type, dispatcher = e.target;
            var collectInfos = [];
            _this.collectors.forEach(function(collect) {
                var _collect_listeners;
                (_collect_listeners = collect.listeners) === null || _collect_listeners === void 0 ? void 0 : _collect_listeners.forEach(function(listener) {
                    if (listener.event === evtName && listener.dispatcher === dispatcher) {
                        collectInfos.push(listener.cb(e));
                    }
                });
            });
            _this.updateInfos(collectInfos);
        };
        this.initCollects();
        this.setCollectEvts(true);
    }
    _(StatsCollector, [
        {
            key: "destroy",
            value: function destroy() {
                this.setCollectEvts(false);
                this.collectors.length = 0;
                this.stats = {};
            }
        },
        {
            key: "getStats",
            value: function getStats() {
                this.updateInfos(this.collectors.map(function(collector) {
                    var _collector_updater;
                    return (_collector_updater = collector.updater) === null || _collector_updater === void 0 ? void 0 : _collector_updater.call(collector);
                }));
                return this.stats;
            }
        },
        {
            key: "initCollects",
            value: function initCollects() {
                var _this = this;
                var _obj;
                var key2Creator = (_obj = {}, _$2(_obj, "vid", this.createVidCollect), _$2(_obj, "flowid", this.createFlowidCollect), _$2(_obj, "guid", this.createGuidCollect), _$2(_obj, "kernelName", this.createKernelNameCollect), _$2(_obj, "cdnInfo", this.createCdnCollect), _$2(_obj, "playerSize", this.createResolutionCollect), _$2(_obj, "frameRate", this.createFrameRateCollect), _$2(_obj, "bufferHealth", this.createBufferHealthCollect), _$2(_obj, "bufferRange", this.createBufferRangeCollect), _$2(_obj, "net", this.createNetCollect), _$2(_obj, "videoSize", this.createVideoSizeCollect), _$2(_obj, "codec", this.createCodecCollect), _obj);
                this.collectors = Object.keys(key2Creator).map(function(key) {
                    return key2Creator[key].apply(_this, [
                        key
                    ]);
                });
            }
        },
        {
            key: "setCollectEvts",
            value: function setCollectEvts(isBind) {
                var _this = this;
                // 先收集下有哪些事件需要监听，重复监听事件不重复监听，统一处理
                var playerEvtMap = {};
                var extEvtMap = {};
                this.collectors.forEach(function(collect) {
                    var _collect_listeners;
                    (_collect_listeners = collect.listeners) === null || _collect_listeners === void 0 ? void 0 : _collect_listeners.forEach(function(listener) {
                        // 分开监听，怕`H5_PLAY_EVENT`, `H5_EXT_EVENT`和`PLAY_EVENT`里面有重复的事件名
                        if (listener.dispatcher === _this.player) {
                            playerEvtMap[listener.event] = listener.dispatcher;
                        } else if (listener.dispatcher === _this.player.pluginMsg) {
                            extEvtMap[listener.event] = listener.dispatcher;
                        }
                    });
                });
                [
                    playerEvtMap,
                    extEvtMap
                ].forEach(function(evtMap) {
                    Object.keys(evtMap).forEach(function(evtName) {
                        if (isBind) {
                            evtMap[evtName].on(evtName, _this.handlerCollectEvt);
                        } else {
                            evtMap[evtName].off(evtName, _this.handlerCollectEvt);
                        }
                    });
                });
            }
        },
        {
            key: "updateInfos",
            value: function updateInfos(collectInfos) {
                var _this = this;
                var infos = collectInfos.filter(function(info) {
                    return info && _this.stats[info.key] !== info.value;
                });
                if (infos.length <= 0) {
                    return;
                }
                infos.forEach(function(info) {
                    return _this.stats[info.key] = info.value;
                });
                this.player.pluginMsg.emit(H5_EXT_EVENT.STATS_CHANGE, infos);
            }
        },
        {
            key: "getUpdateInfo",
            value: function getUpdateInfo(key, value) {
                return {
                    key: key,
                    value: value
                };
            }
        },
        {
            key: "createVidCollect",
            value: function createVidCollect(key) {
                var _this = this;
                var updater = function() {
                    var player = _this.player;
                    var datasetVid = player.getCommonKv(COMMON_DATA_KEY.vid);
                    // 1. 如果没有 vid，则什么都不展示
                    if (!datasetVid) {
                        return _this.getUpdateInfo(key, '');
                    }
                    // 要展示的字符串，用于拼接，默认用 - 占位
                    var playItemInfo = '-';
                    // 2. 有 vid，把 VID 信息覆盖掉 - 占位
                    if (datasetVid) {
                        if (player.config.type === PLAY_MODE.LIVE) {
                            playItemInfo = "".concat(datasetVid, "-").concat(player.getCommonKv(COMMON_DATA_KEY.livepid) || 0) || '-';
                        } else {
                            playItemInfo = datasetVid || '-';
                        }
                    }
                    return _this.getUpdateInfo(key, playItemInfo);
                };
                return {
                    key: key,
                    updater: updater,
                    listeners: [
                        {
                            dispatcher: this.player.pluginMsg,
                            event: H5_EXT_EVENT.DATASET_UPDATE,
                            cb: function(e) {
                                if (e.data.key === COMMON_DATA_KEY.vid) {
                                    return updater();
                                }
                            }
                        }
                    ]
                };
            }
        },
        {
            key: "createFlowidCollect",
            value: function createFlowidCollect(key) {
                var _this = this;
                var updater = function() {
                    var suffixStrForSrvData = _this.player.getCommonKv(COMMON_DATA_KEY.isUseSrvData) ? ' (sd)' : '';
                    return _this.getUpdateInfo(key, "".concat(_this.player.getCommonKv(COMMON_DATA_KEY.flowid)).concat(suffixStrForSrvData));
                };
                return {
                    key: key,
                    updater: updater,
                    listeners: [
                        {
                            dispatcher: this.player.pluginMsg,
                            event: H5_EXT_EVENT.DATASET_UPDATE,
                            cb: function(e) {
                                if (e.data.key === COMMON_DATA_KEY.flowid || e.data.key === COMMON_DATA_KEY.isUseSrvData) {
                                    return updater();
                                }
                            }
                        }
                    ]
                };
            }
        },
        {
            key: "createGuidCollect",
            value: function createGuidCollect(key) {
                var _this = this;
                return {
                    key: key,
                    updater: function() {
                        return _this.getUpdateInfo(key, _this.player.getCommonKv(COMMON_DATA_KEY.guid));
                    }
                };
            }
        },
        {
            key: "createKernelNameCollect",
            value: function createKernelNameCollect(key) {
                var _this = this;
                var updater = function() {
                    var _this_player_currentVideoInfo, _this_player;
                    var _urlTool_getFileExtension;
                    var extName = (_urlTool_getFileExtension = urlTool.getFileExtension((_this_player = _this.player) === null || _this_player === void 0 ? void 0 : (_this_player_currentVideoInfo = _this_player.currentVideoInfo) === null || _this_player_currentVideoInfo === void 0 ? void 0 : _this_player_currentVideoInfo.loadingUrl)) !== null && _urlTool_getFileExtension !== void 0 ? _urlTool_getFileExtension : '-';
                    var _this_player_getCommonKv;
                    var kernelName = (_this_player_getCommonKv = _this.player.getCommonKv(COMMON_DATA_KEY.curcore)) !== null && _this_player_getCommonKv !== void 0 ? _this_player_getCommonKv : '-';
                    var _this_player_getCommonKv1;
                    var kernelVersion = (_this_player_getCommonKv1 = _this.player.getCommonKv(COMMON_DATA_KEY.curcorever)) !== null && _this_player_getCommonKv1 !== void 0 ? _this_player_getCommonKv1 : VERSION;
                    var p2pVer = _this.player.getCommonKv(COMMON_DATA_KEY.p2pver);
                    var p2pVerText = p2pVer ? "-p2p-".concat(p2pVer) : '';
                    return _this.getUpdateInfo(key, "".concat(extName, "/").concat(kernelName, " (").concat(kernelVersion).concat(p2pVerText, ")"));
                };
                return {
                    key: key,
                    updater: updater,
                    listeners: [
                        {
                            dispatcher: this.player.pluginMsg,
                            event: H5_EXT_EVENT.DATASET_UPDATE,
                            cb: function(e) {
                                var keys = [
                                    COMMON_DATA_KEY.curcorever,
                                    COMMON_DATA_KEY.curcore,
                                    COMMON_DATA_KEY.p2pver
                                ];
                                if (keys.indexOf(e.data.key) > -1) {
                                    return updater();
                                }
                            }
                        }
                    ]
                };
            }
        },
        {
            key: "createCdnCollect",
            value: function createCdnCollect(key) {
                var _this = this;
                var updater = function() {
                    var _this_player_currentVideoInfo;
                    if (!_this.player.getCommonKv(COMMON_DATA_KEY.vid)) {
                        return _this.getUpdateInfo(key, '');
                    }
                    return _this.getUpdateInfo(key, urlTool.getDomainOfURL(((_this_player_currentVideoInfo = _this.player.currentVideoInfo) === null || _this_player_currentVideoInfo === void 0 ? void 0 : _this_player_currentVideoInfo.loadingUrl) || ''));
                };
                return {
                    key: key,
                    listeners: [
                        {
                            event: H5_PLAY_EVENT.VIDEO_LOAD_START,
                            dispatcher: this.player,
                            cb: updater
                        },
                        {
                            event: PLAY_EVENT.RETRY_BACKURL,
                            dispatcher: this.player,
                            cb: updater
                        },
                        {
                            event: H5_PLAY_EVENT.VIDEO_SETLEVEL_END,
                            dispatcher: this.player,
                            cb: updater
                        }
                    ]
                };
            }
        },
        {
            key: "createResolutionCollect",
            value: function createResolutionCollect(key) {
                var _this = this;
                var updater = function() {
                    var _window_screen;
                    var _this_player = _this.player, container = _this_player.container, getCommonKv = _this_player.getCommonKv;
                    var containerSize = "".concat(container.clientWidth, "*").concat(container.clientHeight);
                    var screenSize = getCommonKv(COMMON_DATA_KEY.resolution);
                    var _window_screen_isExtended;
                    var isExtended = (_window_screen_isExtended = (_window_screen = window.screen) === null || _window_screen === void 0 ? void 0 : _window_screen.isExtended) !== null && _window_screen_isExtended !== void 0 ? _window_screen_isExtended : false;
                    return _this.getUpdateInfo(key, "".concat(containerSize, " / ").concat(screenSize, " (ext:").concat(isExtended, ")"));
                };
                return {
                    key: key,
                    updater: updater
                };
            }
        },
        {
            key: "createFrameRateCollect",
            value: function createFrameRateCollect(key) {
                var _this = this;
                var updater = function() {
                    var _this_player_currentVideoInfo, _this_player;
                    var _ref = ((_this_player = _this.player) === null || _this_player === void 0 ? void 0 : (_this_player_currentVideoInfo = _this_player.currentVideoInfo) === null || _this_player_currentVideoInfo === void 0 ? void 0 : _this_player_currentVideoInfo.qualityInfo) || {}, _ref_totalVideoFrames = _ref.totalVideoFrames, totalVideoFrames = _ref_totalVideoFrames === void 0 ? 0 : _ref_totalVideoFrames, _ref_droppedVideoFrames = _ref.droppedVideoFrames, droppedVideoFrames = _ref_droppedVideoFrames === void 0 ? 0 : _ref_droppedVideoFrames;
                    var per = droppedVideoFrames / totalVideoFrames * 100;
                    return _this.getUpdateInfo(key, "".concat(droppedVideoFrames, "/").concat(totalVideoFrames, "; ").concat(isNaN(per) ? 0 : per.toFixed(2), "%"));
                };
                return {
                    key: key,
                    updater: updater,
                    listeners: [
                        {
                            event: H5_PLAY_EVENT.VIDEO_TIMEUPDATE,
                            dispatcher: this.player,
                            cb: updater
                        }
                    ]
                };
            }
        },
        {
            key: "createBufferHealthCollect",
            value: function createBufferHealthCollect(key) {
                var _this = this;
                var updater = function() {
                    var _this_player = _this.player, videoBuffered = _this_player.videoBuffered, playtime = _this_player.playtime;
                    var bufferEnd = videoBuffered.find(function(range) {
                        return range.start <= playtime && range.end >= playtime;
                    });
                    if (!bufferEnd) {
                        return _this.getUpdateInfo(key, '');
                    }
                    var health = bufferEnd.end - playtime;
                    return _this.getUpdateInfo(key, isNaN(health) ? '-' : "".concat(health.toFixed(2), "s"));
                };
                return {
                    key: key,
                    updater: updater,
                    listeners: [
                        {
                            event: H5_PLAY_EVENT.VIDEO_TIMEUPDATE,
                            dispatcher: this.player,
                            cb: updater
                        },
                        {
                            event: H5_PLAY_EVENT.VIDEO_LOAD_PROGRESS,
                            dispatcher: this.player,
                            cb: updater
                        }
                    ]
                };
            }
        },
        {
            key: "createBufferRangeCollect",
            value: function createBufferRangeCollect(key) {
                var _this = this;
                var updater = function() {
                    var bufferRange = _this.player.videoBuffered.map(function(range) {
                        return "".concat(range.start.toFixed(3), "-").concat(range.end.toFixed(3));
                    }).join(',');
                    return _this.getUpdateInfo(key, bufferRange);
                };
                return {
                    key: key,
                    updater: updater,
                    listeners: [
                        {
                            event: H5_PLAY_EVENT.VIDEO_LOAD_PROGRESS,
                            dispatcher: this.player,
                            cb: updater
                        }
                    ]
                };
            }
        },
        {
            key: "createNetCollect",
            value: function createNetCollect(key) {
                var _this = this;
                var updater = function() {
                    var currentVideoInfo = _this.player.currentVideoInfo;
                    if (!(currentVideoInfo === null || currentVideoInfo === void 0 ? void 0 : currentVideoInfo.performance)) {
                        return _this.getUpdateInfo(key, '');
                    }
                    var _currentVideoInfo_performance = currentVideoInfo.performance, _currentVideoInfo_performance_speed = _currentVideoInfo_performance.speed, speed = _currentVideoInfo_performance_speed === void 0 ? 0 : _currentVideoInfo_performance_speed, _currentVideoInfo_performance_p2pStats = _currentVideoInfo_performance.p2pStats, p2pStats = _currentVideoInfo_performance_p2pStats === void 0 ? '' : _currentVideoInfo_performance_p2pStats;
                    return _this.getUpdateInfo(key, "".concat(speed, " KB/s ").concat(p2pStats));
                };
                return {
                    key: key,
                    updater: updater,
                    listeners: [
                        {
                            event: H5_PLAY_EVENT.VIDEO_TIMEUPDATE,
                            dispatcher: this.player,
                            cb: updater
                        }
                    ]
                };
            }
        },
        {
            key: "createVideoSizeCollect",
            value: function createVideoSizeCollect(key) {
                var _this = this;
                var updater = function() {
                    var _this_player;
                    var _this_player_currentVideoInfo;
                    var _ref = (_this_player_currentVideoInfo = (_this_player = _this.player) === null || _this_player === void 0 ? void 0 : _this_player.currentVideoInfo) !== null && _this_player_currentVideoInfo !== void 0 ? _this_player_currentVideoInfo : {}, _ref_videoHeight = _ref.videoHeight, videoHeight = _ref_videoHeight === void 0 ? 0 : _ref_videoHeight, _ref_videoWidth = _ref.videoWidth, videoWidth = _ref_videoWidth === void 0 ? 0 : _ref_videoWidth;
                    return _this.getUpdateInfo(key, "".concat(videoWidth, "*").concat(videoHeight));
                };
                return {
                    key: key,
                    updater: updater,
                    listeners: [
                        {
                            event: PLAY_EVENT.METADATA_CHANGE,
                            dispatcher: this.player,
                            cb: updater
                        },
                        {
                            event: H5_PLAY_EVENT.VIDEO_SETLEVEL_END,
                            dispatcher: this.player,
                            cb: updater
                        }
                    ]
                };
            }
        },
        {
            key: "createCodecCollect",
            value: /**
   * 编码codecs字符串
   */ function createCodecCollect(key) {
                var _this = this;
                var updater = function() {
                    var currentVideoInfo = _this.player.currentVideoInfo;
                    if (!currentVideoInfo) {
                        return _this.getUpdateInfo(key, '');
                    }
                    var vinfoCodec = "(".concat(_this.player.getCommonKv(COMMON_DATA_KEY.codec) || '-', ")");
                    return _this.getUpdateInfo(key, "".concat(vinfoCodec).trim());
                };
                return {
                    key: key,
                    updater: updater,
                    listeners: [
                        {
                            event: PLAY_EVENT.METADATA_CHANGE,
                            dispatcher: this.player,
                            cb: updater
                        },
                        {
                            event: H5_PLAY_EVENT.VIDEO_SETLEVEL_END,
                            dispatcher: this.player,
                            cb: updater
                        }
                    ]
                };
            }
        }
    ]);
    return StatsCollector;
}();
var StatsName;
(function(StatsName) {
    StatsName["VID"] = "vid";
    StatsName["FLOW_ID"] = "flowid";
    StatsName["GUID"] = "guid";
    StatsName["KERNEL_NAME"] = "kernelName";
    StatsName["CDN_INFO"] = "cdnInfo";
    StatsName["PLAYER_SIZE"] = "playerSize";
    StatsName["FRAME_RATE"] = "frameRate";
    StatsName["BUFFER_HEALTH"] = "bufferHealth";
    StatsName["BUFFER_RANGE"] = "bufferRange";
    StatsName["NET"] = "net";
    StatsName["VIDEO_SIZE"] = "videoSize";
    StatsName["CODEC"] = "codec";
})(StatsName || (StatsName = {}));

var StepKey;
(function(StepKey) {
    StepKey["CREATE_PLUGIN_PREFIX"] = "cp";
    StepKey["SESSION_START_EVT"] = "startEvt";
    StepKey["CREATE_FLOW_NODES"] = "createFlow";
    StepKey["GETINFO"] = "infoReq";
    StepKey["GETINFO_END"] = "infoEndEvt";
    /** 整个前贴广告flowNode从开始到结束（没有前贴广告的情况） */ StepKey["PRE_AD_FLOW_NODE"] = "preAdFlow";
    /** 广告cdn加载 */ StepKey["AD_CDN_REQ"] = "adCdnReq";
    /** 正片cdn加载 */ StepKey["V_CDN_REQ"] = "cdnReq";
})(StepKey || (StepKey = {}));

var logMethodCall = logMethodCallDecoratorCreator('H5Player');
var performanceCost = performanceCostDecoratorCreator('H5Player');
var _obj;
var rotateTransformValue = (_obj = {}, _$2(_obj, PictureDirection.VERTICAL, 'rotateX(180deg)'), _$2(_obj, PictureDirection.HORIZON, 'rotateY(180deg)'), _$2(_obj, PictureDirection.NORMAL, 'none'), _obj);
/**
  * H5player引用上报
  */ function collectUsage() {
    var channel = 'npm';
    try {
        // @ts-ignore
        channel = "npm";
    } catch (e) {}
    // 采集引用上报信息，from定义1标识为H5player使用
    ReferenceReport.getReporter().collectUsage(1, channel);
}
var _PlaytimeLimiterPlugin_pluginName = PlaytimeLimiterPlugin.pluginName, _DataSet_pluginName = DataSet.pluginName, _OfflineLogPlugin_pluginName = OfflineLogPlugin.pluginName;
var H5Player = /*#__PURE__*/ function(FlowPlayer) {
    _$4(H5Player, FlowPlayer);
    var _super = _$5(H5Player);
    function H5Player(config) {
        _$1(this, H5Player);
        var _this;
        var _screen, _screen1;
        if (!config.isPrivateDeployment) {
            // 采集引用上报信息, 私有部署时不进行上报
            collectUsage();
        }
        config = patchConfig(config);
        _this = _super.call(this, config);
        /** 交互蒙层，点击后 toggle 播放 / 暂停状态 */ _$2(_$6(_this), "interactMod", null);
        /** 当前播放调用参数 */ _$2(_$6(_this), "loadParam", void 0);
        /** 是否正在播放广告 */ _$2(_$6(_this), "isPlayingAd", void 0);
        _$2(_$6(_this), "getCommonKv", function(key) {
            return _this.dataset.commonMap[key];
        });
        _$2(_$6(_this), "getStateKv", function(key) {
            return _this.dataset.stateMap[key];
        });
        /** 当前播放对象 */ _$2(_$6(_this), "currentPlayItem", void 0);
        _$2(_$6(_this), "autoplayLogics", void 0);
        /** 静音前的音量 */ _$2(_$6(_this), "mutedVolume", 1);
        _$2(_$6(_this), "mouseMoveTimer", void 0);
        /** video当前旋转角度 */ _$2(_$6(_this), "rotateDegree", void 0);
        _$2(_$6(_this), "containerResizeObserver", void 0);
        _$2(_$6(_this), "fullscreenLogics", void 0);
        /** 画面镜像 */ _$2(_$6(_this), "pictureDirection", void 0);
        _$2(_$6(_this), "statsCollector", void 0);
        _$2(_$6(_this), "pluginManager", void 0);
        /**
   * 混入方法到player实例上
   * @param {Function |  Object} mix 要混入的方法，通过函数或对象传入
   */ _$2(_$6(_this), "mixin", function(mix) {
            var mixinObject = typeof mix === 'function' ? mix() : mix;
            Object.keys(mixinObject).forEach(function(method) {
                if (method in _$6(_this)) {
                    throw new Error("cannot override existing player method: ".concat(method));
                }
                var func = mixinObject[method];
                // 限制只能混入方法，属性建议挂在数据中心
                if (typeof func !== 'function') {
                    console.error("mixin ".concat(func, " is not a function"));
                    return;
                }
                _this[method] = func;
            });
        });
        /**
   * 移动鼠标的回调函数
   * 这里必须 throttle 下，防止状态跳变，并节省性能开销
   */ _$2(_$6(_this), "mouseMoveHandler", lodash_throttle(function() {
            // 在 throttle threshold 的延迟内，播放器可能已经销毁掉了
            // 这时候就不要再去 setTimeout 来设置鼠标隐藏了
            if (_this._destroyed) {
                return;
            }
            // 当鼠标移动时，立即清除掉鼠标的隐藏状态
            _this.setMouseState(false);
            // 延迟判断，设置鼠标隐藏状态
            clearTimeout(_this.mouseMoveTimer);
            _this.mouseMoveTimer = setTimeout(_this.setMouseState, AUTO_HIDE_MOUSE_DELAY);
        }, HIDE_MOUSE_THROTTLE));
        _$2(_$6(_this), "setMouseState", function(isHide) {
            var mouseHideState = isHide !== null && isHide !== void 0 ? isHide : _this.shouldHideMouse();
            _this.container.style.cursor = mouseHideState ? 'none' : 'auto';
        });
        _this.log('new H5Player(), input config=', config);
        /** 记录播放器初始化时间 */ var playerInitTime = Date.now();
        var plugins = config.plugins, mixins = config.mixins;
        _this.pluginManager = new PluginManager(_$6(_this));
        _this.fullscreenLogics = new FullScreenLogics(_$6(_this), _this.config.fullscreenContainer);
        _this.statsCollector = new StatsCollector(_$6(_this));
        // 设置事件监听数量上限
        var maxListeners = 100;
        _this.setMaxListeners(maxListeners);
        _this.createClickMask();
        _this.createInnerPlugins();
        // 创建插件，挂载mixins
        if (_$7(plugins, Array)) {
            _this.createPlugins(plugins);
        }
        _this.initGetinfoModule(_this.config);
        if (_$7(mixins, Array)) mixins.forEach(_this.mixin);
        _this.autoplayLogics = new AutoPlayLogics(_$6(_this));
        _this.initPlayerResizeObserver();
        _this.forwardPluginEvents();
        _this.forwardPlayerEvents();
        _this.initContainerStyle();
        _this.setupEventFlagData();
        _this.setupLoopPlay();
        _this.setupMouseAutoHide();
        _this.applyStyleOnVideoNodeChange();
        // 统计播放器初始化耗时
        _this.setStateKv(DataState.INIT, {
            type: LogType.CORE_EVENT,
            ftime: Date.now(),
            ext: {
                stime: playerInitTime
            }
        });
        var _screen_width, _screen_height, _window_devicePixelRatio;
        // TEE workaround: 为TEE提供请求全屏前的屏幕信息
        _this.setCommonKv(COMMON_DATA_KEY.TEE_screen, {
            width: (_screen_width = (_screen = screen) === null || _screen === void 0 ? void 0 : _screen.width) !== null && _screen_width !== void 0 ? _screen_width : -1,
            height: (_screen_height = (_screen1 = screen) === null || _screen1 === void 0 ? void 0 : _screen1.height) !== null && _screen_height !== void 0 ? _screen_height : -1,
            dpr: (_window_devicePixelRatio = window.devicePixelRatio) !== null && _window_devicePixelRatio !== void 0 ? _window_devicePixelRatio : -1
        });
        return _this;
    }
    _(H5Player, [
        {
            key: "plugins",
            get: /** 插件实例 */ function get() {
                var _this_pluginManager;
                return ((_this_pluginManager = this.pluginManager) === null || _this_pluginManager === void 0 ? void 0 : _this_pluginManager.plugins) || {}; // 空对象是兼容销毁后获取报错报错
            }
        },
        {
            key: "pluginMsg",
            get: function get() {
                var _this_pluginManager;
                return (_this_pluginManager = this.pluginManager) === null || _this_pluginManager === void 0 ? void 0 : _this_pluginManager.pluginMsg;
            }
        },
        {
            key: "createPlugins",
            value: /** 批量创建插件 */ function createPlugins(configs) {
                var _this = this;
                configs.forEach(function(val) {
                    // 避免插件创建失败时影响后面的插件
                    try {
                        if (typeof val === 'string') {
                            _this.createPlugin(val);
                        } else {
                            _this.createPlugin.apply(_this, _$8(val));
                        }
                    } catch (err) {
                        _this.logger.error(err);
                    }
                });
            }
        },
        {
            key: "loadPlugin",
            value: function loadPlugin(option) {
                var _this = this;
                return _$e(function() {
                    var ret, _this_pluginManager, e, config, pluginName, insName;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ret = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    (_this_pluginManager = _this.pluginManager) === null || _this_pluginManager === void 0 ? void 0 : _this_pluginManager.loadPlugin(option)
                                ];
                            case 2:
                                ret = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                _this.logger.error("loadPlugin err: ".concat(e === null || e === void 0 ? void 0 : e.message));
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                if (!ret) {
                                    return [
                                        2
                                    ];
                                }
                                config = option.config;
                                pluginName = ret.pluginName;
                                insName = option.insName || pluginName;
                                if (!_this.plugins[insName]) {
                                    // 避免重复实例化
                                    _this.createPlugin(insName, _$c(_$b({}, config), {
                                        pluginName: pluginName
                                    }));
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "load",
            value: /** 加载，并缓存加载对象和加载参数 */ function load(urlOrVid, param) {
                return this.startLoadOrPlay(urlOrVid, param, 'load');
            }
        },
        {
            key: "play",
            value: /** 播放，并缓存播放对象和播放参数 */ function play(urlOrVid, param) {
                return this.startLoadOrPlay(urlOrVid, param, 'play');
            }
        },
        {
            key: "createPlugin",
            value: /** 创建插件，并自动转发广告插件的事件 */ function createPlugin(insName) {
                var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.timeStart("".concat(StepKey.CREATE_PLUGIN_PREFIX, "_").concat(insName));
                var _option_pluginName = option.pluginName, pluginName = _option_pluginName === void 0 ? insName : _option_pluginName;
                if (pluginName === AD_PLUGIN_NAME) {
                    option.requestProxyHttp = this.requestAdCallbackForAdPlugin.bind(this);
                }
                this.pluginManager.createPlugin(insName, option);
                if (pluginName === AD_PLUGIN_NAME) {
                    // 创建广告插件时，自动监听/代理广告事件
                    proxyAdEvent(AD_EVTS_EMIT_ON_PLAYER, this.instanceId, this);
                    proxyAdEvent(AD_EVTS_EMIT_ON_PLUGIN, this.instanceId, this.pluginMsg);
                }
                this.timeEnd("".concat(StepKey.CREATE_PLUGIN_PREFIX, "_").concat(insName));
            }
        },
        {
            key: "replay",
            value: function replay() {
                var _this_loadParam_videoLoadParam, _this_loadParam, _this_loadParam1;
                var vid = this.vid;
                var url = this.playUrl;
                // 重播时不保留startTime
                (_this_loadParam = this.loadParam) === null || _this_loadParam === void 0 ? true : (_this_loadParam_videoLoadParam = _this_loadParam.videoLoadParam) === null || _this_loadParam_videoLoadParam === void 0 ? true : delete _this_loadParam_videoLoadParam.startTime;
                (_this_loadParam1 = this.loadParam) === null || _this_loadParam1 === void 0 ? true : delete _this_loadParam1.srvData;
                // 先尝试用vid播放，然后再尝试用url播放
                if (vid) return this.play(vid, this.loadParam);
                if (url) {
                    // 去除url中的hashtag部分，对应url中用#t=n指定startTime的情况
                    var idxHash = url.lastIndexOf('#');
                    if (idxHash > 0) {
                        url = url.slice(0, idxHash);
                    }
                    return this.play({
                        url: url
                    }, this.loadParam);
                }
                this.log('Current player has no available vid or url to replay');
            }
        },
        {
            key: "pause",
            value: function pause() {
                var pauseType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : H5PauseType.CALL_BY_API;
                return _$g(_$h(H5Player.prototype), "pause", this).call(this, pauseType);
            }
        },
        {
            key: "seek",
            value: /**
   * @param time 单位：秒
   */ function seek(time) {
                var _this_timeRange = this.timeRange, startTime = _this_timeRange.startTime, endTime = _this_timeRange.endTime;
                var seekTime = Math.min(endTime, Math.max(startTime, time));
                return _$g(_$h(H5Player.prototype), "seek", this).call(this, seekTime);
            }
        },
        {
            key: "setPictureImage",
            value: /** 设置视频画面镜像 */ function setPictureImage() {
                var direction = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : PictureDirection.NORMAL;
                this.pictureDirection = direction;
                if (this.isPlayingAd) {
                    this.setAdVideoStyle({
                        transform: rotateTransformValue[direction]
                    });
                } else {
                    this.setVideoStyle({
                        transform: rotateTransformValue[direction]
                    });
                }
                // 将旋转角度恢复为0
                if (direction === PictureDirection.NORMAL) {
                    this.rotateDegree = 0;
                }
            }
        },
        {
            key: "setRotate",
            value: /** 设置视频旋转角度 */ function setRotate(deg) {
                if (typeof deg !== 'number' || Number.isNaN(deg)) return;
                this.rotateDegree = deg;
                if (this.isPlayingAd) {
                    this.setAdVideoStyle({
                        transform: "rotate(".concat(deg, "deg)")
                    });
                } else {
                    this.setVideoStyle({
                        transform: "rotate(".concat(deg, "deg)")
                    });
                }
            }
        },
        {
            key: "getRotate",
            value: /** 获取视频旋转角度 */ function getRotate() {
                return this.rotateDegree;
            }
        },
        {
            key: "requestFullScreen",
            value: /**
   * 进入 / 退出全屏状态
   * @param isEnter 是否进入全屏，true 进入全屏，false 退出全屏
   * @param mode 指定全屏模式，分为系统全屏和 CSS 全屏。默认情况下会自动判断
   */ function requestFullScreen() {
                var isEnter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, mode = arguments.length > 1 ? arguments[1] : void 0;
                var _this = this;
                return _$e(function() {
                    var _screen, _screen1, _screen_width, _screen_height, _window_devicePixelRatio;
                    return _$f(this, function(_state) {
                        if (isEnter) {
                            // TEE workaround: 为TEE提供请求全屏前的屏幕信息
                            _this.setCommonKv(COMMON_DATA_KEY.TEE_screen, {
                                width: (_screen_width = (_screen = screen) === null || _screen === void 0 ? void 0 : _screen.width) !== null && _screen_width !== void 0 ? _screen_width : -1,
                                height: (_screen_height = (_screen1 = screen) === null || _screen1 === void 0 ? void 0 : _screen1.height) !== null && _screen_height !== void 0 ? _screen_height : -1,
                                dpr: (_window_devicePixelRatio = window.devicePixelRatio) !== null && _window_devicePixelRatio !== void 0 ? _window_devicePixelRatio : -1
                            });
                        }
                        return [
                            2,
                            _this.fullscreenLogics.requestFullScreen(isEnter, mode)
                        ];
                    });
                })();
            }
        },
        {
            key: "fullscreenMode",
            get: function get() {
                return this.fullscreenLogics.fullscreenMode;
            }
        },
        {
            key: "timeRange",
            get: function get() {
                return this.playtimeLimiter.range;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this = this;
                var _this_config, _this_config1, _this_containerResizeObserver, _this_statsCollector, _this_interactMod;
                if (this._destroyed) {
                    return;
                }
                this.stop();
                try {
                    this.pluginMsg.emit(H5_EXT_EVENT.DESTROY);
                } catch (e) {
                    this.warn(e);
                }
                if (this.plugins) {
                    // 调用插件实例的销毁
                    Object.keys(this.plugins).forEach(function(pluginKey) {
                        var // 多实例时目前会销毁最后挂载的实例，所以要判断plugins[pluginKey]是否存在
                        _this_plugins_pluginKey_destroy, _this_plugins_pluginKey;
                        (_this_plugins_pluginKey = _this.plugins[pluginKey]) === null || _this_plugins_pluginKey === void 0 ? void 0 : (_this_plugins_pluginKey_destroy = _this_plugins_pluginKey.destroy) === null || _this_plugins_pluginKey_destroy === void 0 ? void 0 : _this_plugins_pluginKey_destroy.call(_this_plugins_pluginKey);
                        delete _this.plugins[pluginKey];
                    });
                }
                destroyGetinfoModule((_this_config = this.config) === null || _this_config === void 0 ? void 0 : _this_config.instanceId);
                // 判断 config 是否存在是为了兼容多次销毁
                setAdPlugin((_this_config1 = this.config) === null || _this_config1 === void 0 ? void 0 : _this_config1.instanceId, null);
                (_this_containerResizeObserver = this.containerResizeObserver) === null || _this_containerResizeObserver === void 0 ? void 0 : _this_containerResizeObserver.disconnect();
                this.containerResizeObserver = null;
                this.autoplayLogics.destroy();
                this.fullscreenLogics.destroy();
                (_this_statsCollector = this.statsCollector) === null || _this_statsCollector === void 0 ? void 0 : _this_statsCollector.destroy();
                this.statsCollector = null;
                (_this_interactMod = this.interactMod) === null || _this_interactMod === void 0 ? void 0 : _this_interactMod.remove();
                this.interactMod = null;
                this.pluginManager.destroy();
                this.pluginManager = null;
                this.setupMouseAutoHide(false);
                // 移除鼠标自动隐藏的定时器
                clearTimeout(this.mouseMoveTimer);
                if (this.container.style.cursor === 'none') {
                    this.container.style.cursor = 'auto';
                }
                _$g(_$h(H5Player.prototype), "destroy", this).call(this);
            }
        },
        {
            key: "offlineLogPlugin",
            get: // 兼容旧版本的属性
            /** @deprecated 离线日志插件 */ function get() {
                return this.plugins[OfflineLogPlugin.pluginName];
            }
        },
        {
            key: "pluginInstances",
            get: /** @deprecated use plugins */ function get() {
                return this.plugins;
            }
        },
        {
            key: "player",
            get: /** @deprecated use this */ function get() {
                return this;
            }
        },
        {
            key: _PlaytimeLimiterPlugin_pluginName,
            get: // 内置的插件
            /** 播放时长限制器插件 */ function get() {
                return this.plugins[PlaytimeLimiterPlugin.pluginName];
            }
        },
        {
            key: _DataSet_pluginName,
            get: /** 数据中心插件 */ function get() {
                return this.plugins[DataSet.pluginName];
            }
        },
        {
            key: _OfflineLogPlugin_pluginName,
            get: /** 离线日志插件 */ function get() {
                return this.plugins[OfflineLogPlugin.pluginName];
            }
        },
        {
            key: "vid",
            get: // 播放相关属性
            /** 当前播放视频id */ function get() {
                return isVideoId(this.currentPlayItem) ? this.currentPlayItem : null;
            }
        },
        {
            key: "url",
            get: /** 当前播放地址 */ function get() {
                var _this_currentVideoInfo;
                return (_this_currentVideoInfo = this.currentVideoInfo) === null || _this_currentVideoInfo === void 0 ? void 0 : _this_currentVideoInfo.loadingUrl;
            }
        },
        {
            key: "paused",
            get: /** 当前播放器是否为暂停状态 */ function get() {
                return this.state === VIDEO_STATE.PAUSE;
            }
        },
        {
            key: "muted",
            get: /** 静音 */ function get() {
                return this.volume === 0;
            },
            set: function set(val) {
                this.logger.log('set muted', val);
                if (this.muted && !val) {
                    // case 1 当前为静音状态，操作解除
                    this.volume = this.mutedVolume || 1; // 如果因为任何原因this.mutedVolume为0，设置音量为1
                } else if (!this.muted && val) {
                    // case 2 当前不是静音状态，操作静音
                    this.mutedVolume = this.volume;
                    this.volume = 0;
                }
            // 除此之外的case都不做处理，避免连续调用的副作用
            }
        },
        {
            key: "setStateKv",
            value: /** 写入dataset的状态字段 */ function setStateKv(key, value, freezeKey) {
                this.dataset.writeState(key, value, freezeKey);
            }
        },
        {
            key: "setCommonKv",
            value: function setCommonKv(arg1, arg2, arg3) {
                var _this = this;
                if (typeof arg1 === 'string') {
                    this.dataset.writeCommon(arg1, arg2, arg3);
                } else {
                    Object.keys(arg1).forEach(function(i) {
                        return _this.dataset.writeCommon(i, arg1[i], arg2);
                    });
                }
            }
        },
        {
            key: "getStats",
            value: function getStats() {
                return this.statsCollector.getStats();
            }
        },
        {
            key: "videoReqParam",
            get: function get() {
                var _this_loadParam;
                return (_this_loadParam = this.loadParam) === null || _this_loadParam === void 0 ? void 0 : _this_loadParam.videoReqInfoParam;
            }
        },
        {
            key: "shouldHideMouse",
            value: /**
   * 是否应该隐藏鼠标，默认条件如下：
   *
   * 不需要判断 this.config.autoHideMouse 这个条件
   * 如果 autoHideMouse = false，连监听器都不会添加
   */ function shouldHideMouse() {
                return this.fullscreenMode !== null && this.state === VIDEO_STATE.PLAYING;
            }
        },
        {
            key: "selectGetinfoModule",
            value: /**
   * 选择getinfo模块，例如点播和直播分别使用不同的模块
   */ function selectGetinfoModule(config) {
                return config === null || config === void 0 ? void 0 : config.getinfoModule;
            }
        },
        {
            key: "getParamWithStartTime",
            value: function getParamWithStartTime(urlOrVid) {
                var param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _param_videoLoadParam;
                var playtimeLimiter = this.playtimeLimiter;
                if (!urlOrVid) return param;
                // 如果用户传入了 startTime，则直接使用 startTime，以兼容老的逻辑
                if ((_param_videoLoadParam = param.videoLoadParam) === null || _param_videoLoadParam === void 0 ? void 0 : _param_videoLoadParam.startTime) return param;
                if (typeof urlOrVid === 'string' || typeof urlOrVid === 'number') {
                    playtimeLimiter.clearAllConfig(urlOrVid);
                } else if (Array.isArray(urlOrVid)) {
                    // 不支持数组调用时设置
                    return param;
                } else {
                    playtimeLimiter.clearAllConfig(urlOrVid.url);
                }
                if (param.playTimeLimit) {
                    playtimeLimiter.addLimitConfig(param.playTimeLimit);
                }
                return _$c(_$b({}, param), {
                    videoLoadParam: _$c(_$b({}, param.videoLoadParam), {
                        startTime: this.timeRange.startTime
                    })
                });
            }
        },
        {
            key: "createClickMask",
            value: function createClickMask() {
                var _this = this;
                var _this_config = this.config, _this_config_enableInteractMod = _this_config.enableInteractMod, enableInteractMod = _this_config_enableInteractMod === void 0 ? true : _this_config_enableInteractMod, type = _this_config.type;
                // 如果用户关闭蒙层，或者在直播模式下，则什么也不做
                if (!enableInteractMod || type === PLAY_MODE.LIVE) return;
                var mod = document.createElement('div');
                mod.classList.add('thumbplayer-user-mod');
                domTool.css(mod, {
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    'z-index': 1
                });
                domTool.append(this.container, mod);
                mod.addEventListener('click', function() {
                    _this.log('click mask');
                    // 暂停 / 播放被阻止后点击播放，开始播放
                    if ([
                        VIDEO_STATE.PAUSE,
                        VIDEO_STATE.CANPLAY
                    ].includes(_this.state)) {
                        _this.play();
                    } else if ([
                        VIDEO_STATE.PLAYING,
                        VIDEO_STATE.BUFFERING
                    ].includes(_this.state)) {
                        _this.pause(H5PauseType.CLICK_MASK);
                    }
                });
                this.interactMod = mod;
            }
        },
        {
            key: "initContainerStyle",
            value: /** 给容器设置一些基础样式，方便UI插件挂载 */ function initContainerStyle() {
                var container = this.container;
                container.style.outline = '0 none';
                container.style.overflow = 'hidden';
                container.style.backgroundColor = '#000';
                if (getComputedStyle(container).position === 'static') {
                    container.style.position = 'relative';
                }
            }
        },
        {
            key: "forwardPluginEvents",
            value: /** 从插件转发二级事件 */ function forwardPluginEvents() {
                var _this = this;
                this[DataSet.pluginName].on(DataEvents.STATE_UPDATE, function(param) {
                    var data = param.data;
                    _this.pluginMsg.emit(H5_EXT_EVENT.DATASET_STATE_UPDATE, data);
                });
                this[DataSet.pluginName].on(DataEvents.UPDATE, function(param) {
                    var data = param.data;
                    _this.pluginMsg.emit(H5_EXT_EVENT.DATASET_UPDATE, data);
                });
                this.on(PLAY_EVENT.SET_LOADING, function(param) {
                    var data = param.data;
                    _this.pluginMsg.emit(H5_EXT_EVENT.SET_LOADING, {
                        value: data.show
                    });
                });
            }
        },
        {
            key: "forwardPlayerEvents",
            value: function forwardPlayerEvents() {
                var _this = this;
                var listener = function(param) {
                    var type = param.type, data = param.data;
                    if (!data.emitEvtOpaque) {
                        // 不需要转发
                        return;
                    }
                    var forwordType;
                    var forwordData = undefined;
                    if (type === H5_EXT_EVENT.GETINFO_START) {
                        forwordType = H5_PLAY_EVENT.VIDEO_REQ_INFO_START;
                    } else if (type === H5_EXT_EVENT.GETINFO_OVER) {
                        var _data_error;
                        forwordType = H5_PLAY_EVENT.VIDEO_REQ_INFO_END;
                        forwordData = {
                            code: (data === null || data === void 0 ? void 0 : (_data_error = data.error) === null || _data_error === void 0 ? void 0 : _data_error.code) || ErrorCode.SUC,
                            data: data
                        };
                    }
                    if (forwordType) {
                        tryEmit(function() {
                            return _this.emit(forwordType, forwordData);
                        }, _this.logger);
                    }
                };
                this.pluginMsg.on(H5_EXT_EVENT.GETINFO_START, listener);
                this.pluginMsg.on(H5_EXT_EVENT.GETINFO_OVER, listener);
            }
        },
        {
            key: "emitExtEvts",
            value: function emitExtEvts(type, data) {
                _$g(_$h(H5Player.prototype), "emitExtEvts", this).call(this, type, data);
                this.pluginMsg.emit(type, data);
            }
        },
        {
            key: "createInnerPlugins",
            value: // 初始化默认插件
            function createInnerPlugins() {
                var _this_config_offlineConfig;
                this.createPlugin(DataSet.pluginName);
                if (OfflineLogPlugin.isEnvSupport && !((_this_config_offlineConfig = this.config.offlineConfig) === null || _this_config_offlineConfig === void 0 ? void 0 : _this_config_offlineConfig.disable) && !this.config.isPrivateDeployment) {
                    this.createPlugin(OfflineLogPlugin.pluginName);
                }
                this.createPlugin(PlaytimeLimiterPlugin.pluginName);
                if (this.config.enableQAreporter && !this.config.isPrivateDeployment) {
                    this.createPlugin(this.config.type === PLAY_MODE.LIVE ? LiveQaReporterPlugin.pluginName : VodQaReporterPlugin.pluginName);
                }
            }
        },
        {
            key: "startLoadOrPlay",
            value: function startLoadOrPlay(playItem, playParam, funcName) {
                if (!playItem) return _$g(_$h(H5Player.prototype), funcName, this).call(this);
                this.cacheLoadParam(playItem, playParam);
                return _$g(_$h(H5Player.prototype), funcName, this).call(this, playItem, this.getParamWithStartTime(playItem, playParam));
            }
        },
        {
            key: "cacheLoadParam",
            value: function cacheLoadParam(urlOrVid, param) {
                if (!urlOrVid) return;
                if (isVideoId(urlOrVid)) {
                    this.pluginMsg.emit(H5_EXT_EVENT.VID_CHANGE, {
                        oldVal: this.vid,
                        newVal: urlOrVid
                    });
                }
                this.currentPlayItem = urlOrVid;
                if (param && Object.keys(param).length) this.loadParam = param;
            }
        },
        {
            key: "setupEventFlagData",
            value: function setupEventFlagData() {
                var _this = this;
                this.on(H5_PLAY_EVENT.AD_PLAYING, function() {
                    return _this.isPlayingAd = true;
                });
                this.on(H5_PLAY_EVENT.AD_END, function() {
                    return _this.isPlayingAd = false;
                });
            }
        },
        {
            key: "setupLoopPlay",
            value: function setupLoopPlay() {
                var _this = this;
                this.on(H5_PLAY_EVENT.PLAY_SESSION_END, function(param) {
                    var data = param.data;
                    var _this_config_loopMode;
                    var loopMode = (_this_config_loopMode = _this.config.loopMode) !== null && _this_config_loopMode !== void 0 ? _this_config_loopMode : VideoLoopMode.replay;
                    var endState = data.endState;
                    var canReplay = endState === END_STATE.NORMAL;
                    // 循环模式下视频播放结束时调用replay启动下一个播放流程
                    if (_this.config.loop && canReplay && loopMode === VideoLoopMode.replay) {
                        _this.replay();
                    }
                });
                // 起播后设置video.loop，在url模式播放mp4时设置true，其他设置false
                // loop之后不会触发ended事件，和上面session end是互斥的
                this.on(H5_PLAY_EVENT.VIDEO_PLAYING, function(param) {
                    var data = param.data;
                    if (!data.isFirst || !_this.config.loop) return;
                    var currentVideoElement = _this.currentVideoElement;
                    if (_$7(currentVideoElement, HTMLVideoElement)) {
                        var loopMode = _this.config.loopMode;
                        // 原有逻辑，默认情况下仅允许在原生内核url模式下开启native loop
                        if (!loopMode // 优先外部配置
                         && !isVideoId(_this.currentPlayItem) && _this.corePlayer.kernelName === KERNEL_NAME.ORIGIN) {
                            loopMode = VideoLoopMode.native;
                        }
                        currentVideoElement.loop = loopMode === VideoLoopMode.native;
                    }
                });
            }
        },
        {
            key: "playUrl",
            get: /** play时传入的地址 */ function get() {
                var currentPlayItem = this.currentPlayItem;
                if (isVideoId(currentPlayItem)) return;
                if (Array.isArray(currentPlayItem)) return;
                return currentPlayItem === null || currentPlayItem === void 0 ? void 0 : currentPlayItem.url;
            }
        },
        {
            key: "setupMouseAutoHide",
            value: function setupMouseAutoHide() {
                var isBind = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                // 默认开启自动隐藏鼠标功能
                var _ref = this.config || {}, _ref_autoHideMouse = _ref.autoHideMouse, autoHideMouse = _ref_autoHideMouse === void 0 ? true : _ref_autoHideMouse;
                if (!autoHideMouse) return;
                var binder = getEventTargetBinder(this.container, isBind);
                binder('mousemove', this.mouseMoveHandler);
            }
        },
        {
            key: "initPlayerResizeObserver",
            value: function initPlayerResizeObserver() {
                var _this = this;
                this.containerResizeObserver = new ResizeObserver(function() {
                    var _this_container = _this.container, clientWidth = _this_container.clientWidth, clientHeight = _this_container.clientHeight;
                    // 这里不在事件抛出时节流，而是由监听方自行实现回调节流
                    _this.emit(PLAY_EVENT.CONTAINER_RESIZE, {
                        width: clientWidth,
                        height: clientHeight
                    });
                });
                this.containerResizeObserver.observe(this.container);
            }
        },
        {
            key: "setVideoStyle",
            value: function setVideoStyle(style) {
                domTool.css(this.currentVideoElement, style);
            }
        },
        {
            key: "setAdVideoStyle",
            value: function setAdVideoStyle(style) {
                var _getAdPlugin_videoAdPlayer, _getAdPlugin, _this_config;
                var adVideos = (_getAdPlugin = getAdPlugin((_this_config = this.config) === null || _this_config === void 0 ? void 0 : _this_config.instanceId)) === null || _getAdPlugin === void 0 ? void 0 : (_getAdPlugin_videoAdPlayer = _getAdPlugin.videoAdPlayer) === null || _getAdPlugin_videoAdPlayer === void 0 ? void 0 : _getAdPlugin_videoAdPlayer.videoElements;
                if (adVideos) {
                    adVideos.forEach(function(v) {
                        return domTool.css(v, style);
                    });
                }
            }
        },
        {
            key: "applyStyleOnVideoNodeChange",
            value: function applyStyleOnVideoNodeChange() {
                var _this = this;
                var getRotateStyle = function() {
                    if (_this.pictureDirection === undefined && _this.rotateDegree === undefined) return;
                    return rotateTransformValue[_this.pictureDirection] || "rotate(".concat(_this.rotateDegree, "deg)");
                };
                this.on(PLAY_EVENT.VIDEONODE_CHANGE, function() {
                    var rotateStyle = getRotateStyle();
                    if (rotateStyle) {
                        _this.setVideoStyle({
                            transform: rotateStyle
                        });
                    }
                });
                this.on(H5_PLAY_EVENT.AD_REQ_ASSETS_START, function(param) {
                    var data = param.data;
                    if (!isPreOrPostAd(data)) return;
                    var rotateStyle = getRotateStyle();
                    if (rotateStyle) {
                        _this.setAdVideoStyle({
                            transform: rotateStyle
                        });
                    }
                });
                // 前后贴广告结束后删除旋转样式，避免影响暂停广告
                this.on(H5_PLAY_EVENT.AD_END, function(param) {
                    var data = param.data;
                    if (!isPreOrPostAd(data)) return;
                    var rotateStyle = getRotateStyle();
                    if (rotateStyle) {
                        _this.setAdVideoStyle({
                            transform: 'none'
                        });
                    }
                });
            }
        },
        {
            key: "initGetinfoModule",
            value: /**
   * 创建getinfo模块
   * @param config 播放器配置信息
   */ function initGetinfoModule(config) {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                var GetinfoModule = this.selectGetinfoModule(config);
                if (!GetinfoModule) {
                    return null;
                }
                var getinfoModule = createGetinfoModule(GetinfoModule, config, {
                    getCommonKv: this.getCommonKv.bind(this),
                    pluginMsg: this.pluginMsg
                });
                return getinfoModule;
            }
        },
        {
            key: "requestAdCallbackForAdPlugin",
            value: /**
   * 用于暂停等类型广告触发时，广告插件调用的请求广告、设置广告订单回调。
   */ function requestAdCallbackForAdPlugin(adType, adParam) {
                var _this = this;
                return _$e(function() {
                    var adPlugin, adInfo, e;
                    return _$f(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                adPlugin = getAdPlugin(_this.config.instanceId);
                                if (!adPlugin) {
                                    return [
                                        2
                                    ];
                                }
                                adInfo = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    getAdInfo(_this.config.instanceId, _this.currentPlayItem, adType, adParam)
                                ];
                            case 2:
                                adInfo = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                _this.logger.error('requestAd err, ', e);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                if (!adInfo) {
                                    return [
                                        2
                                    ];
                                }
                                // 请求到数据以后把广告订单设置到广告插件
                                try {
                                    adPlugin.setAdInfo(adInfo);
                                } catch (e) {
                                    _this.logger.error('setAdInfo err, ', e);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "registerSavedCommonKey",
            value: /** 注册一个需要记录在localStorage中的common key，这个函数需要在初始化thumbplayer前调用 */ function registerSavedCommonKey(key) {
                if (DataSet.SETTING_CONFIG[key]) {
                    console.warn("key ".concat(key, " already registered"));
                    return;
                }
                DataSet.SETTING_CONFIG.push({
                    dsKey: key,
                    lsKey: "__thumbplayer_custom_".concat(key, "__")
                });
            }
        }
    ]);
    return H5Player;
}(FlowPlayer);
// 插件化静态方法
_$2(H5Player, "registerPlugin", registerPlugin);
_$2(H5Player, "deregisterPlugin", deregisterPlugin);
_$2(H5Player, "getPlugins", getPlugins);
_$2(H5Player, "getPlugin", getPlugin);
_$2(H5Player, "isFunctionPlugin", isFunctionPlugin);
_$2(H5Player, "pluginExists", pluginExists);
/** @deprecated */ _$2(H5Player, "isBasicPlugin", isFunctionPlugin);
/** 注册播放内核 */ _$2(H5Player, "registerKernel", KernelFactory.registerKernel);
// codecc扫描无法通过，但是已经被外部引入
// eslint-disable-next-line @typescript-eslint/naming-convention
_$2(H5Player, "KernelFactory", KernelFactory);
_$i([
    destroyProtectDecorator,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        typeof PluginConfig === "undefined" ? Object : PluginConfig
    ]),
    _$j("design:returntype", void 0)
], H5Player.prototype, "createPlugins", null);
_$i([
    logMethodCall,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        typeof PlayItem === "undefined" ? Object : PlayItem,
        typeof IPlayParam === "undefined" ? Object : IPlayParam
    ]),
    _$j("design:returntype", void 0)
], H5Player.prototype, "load", null);
_$i([
    logMethodCall,
    performanceCost,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        typeof PlayItem === "undefined" ? Object : PlayItem,
        typeof IPlayParam === "undefined" ? Object : IPlayParam
    ]),
    _$j("design:returntype", void 0)
], H5Player.prototype, "play", null);
_$i([
    destroyProtectDecorator,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        String,
        typeof IPluginOption === "undefined" ? Object : IPluginOption
    ]),
    _$j("design:returntype", void 0)
], H5Player.prototype, "createPlugin", null);
_$i([
    logMethodCall,
    _$j("design:type", Function),
    _$j("design:paramtypes", []),
    _$j("design:returntype", void 0)
], H5Player.prototype, "replay", null);
_$i([
    logMethodCall,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        String
    ]),
    _$j("design:returntype", void 0)
], H5Player.prototype, "pause", null);
_$i([
    logMethodCall,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        Number
    ]),
    _$j("design:returntype", void 0)
], H5Player.prototype, "seek", null);
_$i([
    destroyProtectDecorator,
    _$j("design:type", Function),
    _$j("design:paramtypes", [
        Object,
        Object,
        String
    ]),
    _$j("design:returntype", void 0)
], H5Player.prototype, "setCommonKv", null);
var AUTO_HIDE_MOUSE_DELAY = 5 * 1000;
var HIDE_MOUSE_THROTTLE = 3 * 100;
H5Player.registerPlugin(DataSet.pluginName, DataSet);
H5Player.registerPlugin(PlaytimeLimiterPlugin.pluginName, PlaytimeLimiterPlugin);
H5Player.registerPlugin(OfflineLogPlugin.pluginName, OfflineLogPlugin);
H5Player.registerPlugin(VodQaReporterPlugin.pluginName, VodQaReporterPlugin);
H5Player.registerPlugin(LiveQaReporterPlugin.pluginName, LiveQaReporterPlugin);

function createH5Player(config) {
    return new H5Player(config);
}
var envVals = getEnvVals();

var ThumbPlayerH5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createH5Player: createH5Player,
  H5Player: H5Player,
  envVals: envVals,
  BaseReporter: BaseReporter,
  kernelEvtBus: kernelEvtBus,
  preloadEvtBus: preloadEvtBus,
  StepTimer: StepTimer,
  EvtEmitter: EvtEmitter,
  PLAY_EVENT: PLAY_EVENT,
  VIDEO_STATE: VIDEO_STATE,
  KERNEL_NAME: KERNEL_NAME,
  PLAY_MODE: PLAY_MODE,
  END_STATE: END_STATE,
  PRELOAD_TYPE: PRELOAD_TYPE,
  VIDEO_CODEC: VIDEO_CODEC,
  CONTAINER_FORMAT: CONTAINER_FORMAT,
  AUDIO_CODEC: AUDIO_CODEC,
  i18nConfig: i18nConfig,
  t: t,
  get ErrorCode () { return ErrorCode; },
  get ErrorMsg () { return ErrorMsg; },
  get FullScreenMode () { return FullScreenMode; },
  get STATS_NAME () { return StatsName; },
  get StepKey () { return StepKey; },
  getAdPlugin: getAdPlugin,
  getAdReqParams: getAdReqParams,
  adEvents: AD_EVTS_EMIT_ON_PLAYER,
  offlineLogLazyLoadStrategy: offlineLogLazyLoadStrategy,
  offlineLogEagerLoadStrategy: offlineLogEagerLoadStrategy,
  BaseFlowNode: BaseFlowNode,
  GetVideoInfoFlowNode: GetVideoInfoFlowNode,
  PreAdFlowNode: PreAdFlowNode,
  PostAdFlowNode: PostAdFlowNode,
  VideoFlowNode: VideoFlowNode,
  get FlowNodeName () { return FlowNodeName; },
  get FlowNodeState () { return FlowNodeState; },
  FlowContext: FlowContext,
  BeaconRequest: BeaconRequest,
  ImageRequest: report,
  definePlugins: definePlugins,
  autobind: autobind,
  logApiInvoke: logApiInvoke,
  tryEmit: tryEmit,
  getEnvVals: getEnvVals,
  getAdInfo: getAdInfo,
  get H5_EXT_EVENT () { return H5_EXT_EVENT; },
  get H5_PLAY_EVENT () { return H5_PLAY_EVENT; },
  Plugin: Plugin,
  isFunctionPlugin: isFunctionPlugin,
  createPluginFactory: createPluginFactory,
  getHookMethodName: getHookMethodName,
  registerPlugin: registerPlugin,
  deregisterPlugin: deregisterPlugin,
  getPlugin: getPlugin,
  getPlugins: getPlugins,
  pluginExists: pluginExists,
  AD_LOAD_STATUS: AD_LOAD_STATUS,
  AdPluginName: AD_PLUGIN_NAME,
  get AD_TYPE () { return AdType; },
  isPreOrPostAd: isPreOrPostAd,
  isVideoId: isVideoId,
  DRM_TYPE: DRM_TYPE,
  DRM_VALUE: DRM_VALUE,
  OFFICIAL_PLUGIN: OFFICIAL_PLUGIN,
  PLUGIN_MAP: PLUGIN_MAP,
  get H5_PAUSE_TYPE () { return H5PauseType; },
  get AUTO_PLAY_POLICY () { return AutoPlayPolicy; },
  get PictureDirection () { return PictureDirection; },
  get VideoLoopMode () { return VideoLoopMode; },
  get PersistedUserSettings () { return PersistedUserSettings; },
  DEFAULT_KEY: DEFAULT_KEY,
  COMMON_DATA_KEY: COMMON_DATA_KEY,
  get DATA_STATE () { return DataState; },
  get DATA_EVENTS () { return DataEvents; },
  get LOG_TYPE () { return LogType; },
  get BUFFER_REASON () { return BufferReason; },
  get LOCAL_KEY () { return LocalKey; }
});

// *************************************************************************
// 因为superplayer的npm包锁版本原因，以下两个导出名是为了兼容superplayer的旧版本
// *************************************************************************
var GETINFO_PLUGIN_NAME = '__thumbplayer-video-request';
// 只在 npm 下挂 window，用于 npm 播放器加载 cdn 插件时，插件获取 H5 模块
{
    // 挂载播放器所需要的全局变量
    mountGlobal({
        globalName: 'ThumbPlayerH5',
        target: ThumbPlayerH5,
        onDuplicate: function onDuplicate() {
            console.warn('Possible duplicated ThumbPlayerH5 detected. Avoid to import this package multiple times.');
        }
    });
}

export { AD_LOAD_STATUS, AdType as AD_TYPE, AutoPlayPolicy as AUTO_PLAY_POLICY, AD_PLUGIN_NAME as AdPluginName, BufferReason as BUFFER_REASON, BaseCheck, BaseFlowNode, BaseReporter, BeaconRequest, COMMON_DATA_KEY, CheckNormalError, DataEvents as DATA_EVENTS, DataState as DATA_STATE, DEFAULT_KEY, DRM_TYPE, DRM_VALUE, ErrorCode, ErrorMsg, FlowContext, FlowNodeName, FlowNodeState, FullScreenMode, GetVideoInfoFlowNode, H5Player, H5_EXT_EVENT, H5PauseType as H5_PAUSE_TYPE, H5_PLAY_EVENT, report as ImageRequest, LocalKey as LOCAL_KEY, LogType as LOG_TYPE, OFFICIAL_PLUGIN, PLUGIN_MAP, PersistedUserSettings, PictureDirection, Plugin, PostAdFlowNode, PreAdFlowNode, StatsName as STATS_NAME, StepKey, VideoFlowNode, VideoLoopMode, GETINFO_PLUGIN_NAME as VideoReqInfoPluginName, AD_EVTS_EMIT_ON_PLAYER as adEvents, autobind, createGetinfoModule, createH5Player, createPluginFactory, ThumbPlayerH5 as default, definePlugins, deregisterPlugin, destroyGetinfoModule, envVals, getAdInfo, getAdPlugin, getAdReqParams, getEnvVals, getGetinfoModule, getHookMethodName, getPlugin, getPlugins, hasGetinfoModule, isFunctionPlugin, isPreOrPostAd, isVideoId, logApiInvoke, offlineLogEagerLoadStrategy, offlineLogLazyLoadStrategy, pluginExists, registerPlugin, tryEmit };
